  var __CFG_TRIAL = (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.trialPhrase) || '30 дней';
  // ── State ───────────────────────────────────────
  // Режим Pro (карточки с кольцом E[R], таблица с раскрытием вариантов, «Сила
  // фундамента», сортировка колонок) вырезан 28.09.2026: с 08.06 он был скрыт
  // флагом, а его разметка мелькала при загрузке страницы. Вид у всех один —
  // карточки и список сетапов; роли различает только переключатель Admin / User.
  // COMPRESSION / BOS убраны 2026-07-19: оба отвергнуты random-baseline гейтом
  // (HYPOTHESES №126/№127 — ниже случайного входа во всех 7 окнах), в проде не
  // эмитятся и не вернутся. Держать их disabled-строками в сайдбаре = обещать
  // пользователю то, чего не будет.
  // ПОРЯДОК = порядок появления детектора в системе, старые сверху (решение
  // владельца 11.09.2026). Мерило — первая запись детектора в журнале сетапов
  // (trigger_sent_log.sent_at); сверху вниз число недель в «Истории недель» не
  // растёт. НОВЫЙ ДЕТЕКТОР ДОПИСЫВАТЬ В КОНЕЦ списка. Отсюда же берут порядок
  // попап уведомлений (TRIGGER_TYPES_ACTIVE выводится из этого списка) и график
  // «Детекторы» (он читает живые чекбоксы сайдбара).
  const TRIGGER_TYPES_ALL = [
    'FALSE_BREAKOUT',   // 11.05
    'STOP_HUNT',        // 16.05
    'DIVERGENCE',       // 16.05, на 5 ч позже STOP_HUNT
    'CLIMAX',           // 02.06
    'CLEAN_BOUNCE',     // 14.06 (живая эмиссия с 20.07, до неё — неделя бэкафилла)
    // ML-фигурные: журнал с 16.07, на /setups с 02.08 (display-скипы figure_skips на бэке)
    'BEARISH_FLAG',     // 16.07
    'DOUBLE_BOTTOM',    // 16.07, на 1 ч позже
    'DOUBLE_TOP',       // 16.07, на 5 ч позже
    // «Скрытый уровень» (гейт №140) и вход по продолжению на его геометрии (№143)
    'HIDDEN_LEVEL',     // 21.08
    'ELLIOTT_STEP',     // 27.08
    // «Откат к импульсу» (№177) и его поздний вариант (только 4Ч) — обкатка под админом, эмиссия с 07.10
    'IMPULSE_BACK',       // 07.10
    'IMPULSE_BACK_LATE',  // 07.10
  ];
  // VWAP_REV (M5) удалён из production 2026-06-02 — edge структурно < friction,
  // net убыточно на обоих тирах. См. CLAUDE.md changelog и HYPOTHESES.md.
  const STATE = {
    // Витрина использует боевую сборку и штатную минутную модель сервера
    // (settings.SETUPS_EXIT_M1_MODE). Старые параметры ссылки больше не выбирают модель.
    build: '',
    xm: '',
    window: 'day',
    daysBack: 14,   // окно «Последние N дней» (единственное live-окно ≈ макс. время-стоп 120 H1-баров ≈ ~2 недели)
    deals: false,     // «История сделок» (05.10.2026): все сделки счёта с начала ленты (volatile, не persist)
    detChart: false,  // вкладка «Детекторы» (volatile, не persist)
    unitsPct: false,  // режим «только проценты» (22.09.2026, админ): без денег и капитала
    // Режим «Акции / Фьючи» (11.10.2026, админ): витрина фьючерсов. Режим — в setups.ui (futMode), размер сделки и депозит
    // режима — там же (futSizes), фильтры и набор детекторов режима — в setups.filters (ключ fut, _modeFilters).
    futMode: false,
    // «Не торгуем» (20.10.2026): переключатель «Только торгуемые / Все» — сохраняется в prefs (setups.ui.showGated)
    showGated: false,
    // Период графика детекторов: 'all' | 'prev' (прошлая календарная неделя) | 'week'. Вкладка «Детекторы» и переход
    // «IMOEX → Детекторы» открывают «Всё» (решение владельца 16.10.2026; с 22.09 до того по умолчанию была прошлая неделя),
    // плашка лидера — прошлую неделю, за которую она считана (openDetLeader).
    detPeriod: 'all',
    // ТФ «Детекторов» вида «Сетапы» (27.10.2026, решение владельца): 'both' | '1h' | '4h' — переключатель вкладки
    // «1Ч · 4Ч · Оба», отдельно от ТФ сайдбара (тот отвечает за витрину); в setups.ui.detTf
    detTf: 'both',
    // Вид вкладки «Детекторы» (16.10.2026, переключатель «Детекторы / IMOEX» под табами — виден, когда сервер прислал
    // блок «Набор против IMOEX»): 'det' — кривые детекторов, 'imoex' — счёт против индекса за всю ленту. Volatile.
    detView: 'det',
    // Единицы вида «IMOEX» (16.10.2026, переключатель в строке легенды): 'dep' — % депозита (как /invest: что стало со
    // всеми деньгами счёта), 'inv' — % вложенного (доход на деньги, реально стоявшие в сделках, по дням). Volatile.
    benchUnit: 'dep',
    commission: null,   // поле «Комиссия брокера», % за одну сделку (admin, 08.09); null = дефолт SSOT (data-default поля)
    // Единый счёт — расчёт витрины ПО УМОЛЧАНИЮ для всех (28.08). Админский
    // чекбокс ИНВЕРСНЫЙ («Старый способ счёта», в дефолте снят): отмечен →
    // прежний способ (независимые сделки) для сравнения. Volatile, не persist —
    // после перезагрузки всегда основной расчёт.
    netting: true,
    posSize: 20000,   // ₽ на сделку в режиме неттинга
    // Депозит: null = auto (сервер берёт пик занятого — пропусков нет). Как только
    // человек двинул ползунок, сюда встаёт число и уходит на сервер: капитал-пул
    // начинает отсекать сделки, которым не хватило денег.
    rubDeposit: null,
    depoAuto: true, // ₽-режим без фрикшн (admin «14 дней Gross»); параметр gross=1 к API
    hideSkipped: false,   // admin «Выкл скип»: убрать скипнутые фигурные из выдачи — volatile
    oppSkipOnly: false,   // admin «Только пропущенные встречные» (24.09.2026) — volatile
    avgDownOff: false,    // admin «Выкл запрет усреднения шортов» (№194, 21.10.2026) — volatile
    onlyAtLevel: false,   // admin «От уровня»: только «стоп за уровнем» у DIV/STOP_HUNT — volatile
    weekly: false,    // «Нед» — доход Net по неделям (admin ₽, volatile, не persist)
    weeklyData: null, // последний ответ /api/setups?weekly=1 (для re-render при слайдере депо)
    dealsPage: 1,     // страница «Истории сделок» (листает сервер)
    dealsSort: 'exit',  // её сортировка (volatile): 'exit' — по закрытию (по умолчанию, решение владельца), 'entry' — по входу
    presetId: null,   // активный пресет (фаза 1): режим forward-журнала, volatile
    presetName: '',
    presetData: null,
    mode: 'user',   // 'user' | 'admin' | 'rubles' — канонизуется в applyMode; persisted в prefs.setups.ui.mode
    filters: {
      trigger_types: [],   // empty = all
      direction: null,
      min_turnover: 10000000,  // 10M ₽ — дефолт
      max_turnover: 0,         // 0 = без верхнего предела (∞)
    },
    data: null,                  // last API response
    sortedTable: [],             // cached sorted+paginated view
    expandedTriggerId: null,     // ID раскрытой карточки — переживает auto-refresh
  };
  // Quality-лейблы — единый SSOT для карточек и списка. Шкала надёжности:
  // Надёжный → Стабильный → Средний → Слабый → Мало данных. С 2026-06-01 список
  // фильтрует по avg_R>0, не по метке, поэтому lottery/small_n (если ячейка
  // плюсовая) тоже могут отображаться.
  const QUALITY_LABEL = {
    solid:    'Надёжный',
    balanced: 'Стабильный',
    lottery:  'Средний',
    fragile:  'Слабый',
    small_n:  'Мало данных',
  };
  // Исход закрытой сделки (Variant E) → русская подпись под R.
  // Дивидендная отсечка впереди — метка живого сетапа. Возвращает {short, human}
  // или null. Горизонт — settings.SETUPS_DIV_ALERT_DAYS (10 дней) через __SETUPS_CFG__.divAlertDays (06.10.2026:
  // /about пишет «предупредит за N дней» из той же настройки): дальше отсечка сделку уже не застанет (медиана
  // удержания 1.6 дня, самое длинное окно — фигурные, около трёх недель, но правило закроет их накануне).
  // Дата приходит с бэка (catalog_matcher), «через сколько дней» считаем здесь — иначе кэш ленты протухал бы
  // каждую полночь. Нет числа в конфиге (страница собрана без сервера) — прежние 10.
  const DIV_ALERT_DAYS = ((window.__SETUPS_CFG__ && window.__SETUPS_CFG__.divAlertDays) | 0) || 10;
  function _divAlert(t) {
    if (!t || !t.div_rd) return null;
    if (t.realized_r != null || t.r_outcome) return null;   // сделка уже закрыта
    const d = new Date(t.div_rd + 'T00:00:00Z');
    if (isNaN(d)) return null;
    const now = new Date();
    const today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    const left = Math.round((d - today) / 86400000);
    if (left < 0 || left > DIV_ALERT_DAYS) return null;
    const dd = String(d.getUTCDate()).padStart(2, '0');
    const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
    const human = left === 0 ? 'сегодня' : left === 1 ? 'завтра' : dd + '.' + mm;
    return {short: dd + '.' + mm, human: human === dd + '.' + mm ? human : human + ' (' + dd + '.' + mm + ')'};
  }

  const R_OUTCOME_RU = {
    // TRAIL_TIME ≠ TRAIL: трейл взведён, но закрыло истечение окна, не стоп (фикс 2026-07-18).
    TP: 'тейк', TRAIL: 'трейл', TRAIL_TIME: 'время',
    SL: 'стоп', EXPIRED: 'истёк',
    // BE — стоп переехал в безубыток (админское правило «Безубыток»): сделка
    // закрыта не по цели и не по стопу, и это должно быть видно в строке.
    BE: 'безубыток',
    // DIV — позицию закрыли накануне дивидендной отсечки (правило 30.08): держать
    // через реестр нельзя, шорт дивиденд платит, лонг получает, а симуляция видит
    // только падение цены.
    DIV: 'перед отсечкой',
    // MKT — «Разворот рынка» (галочка админа, обкатка №188, 16.10.2026): шорт закрыт, когда рынок откатил от лучшей
    // для шорта точки после входа на 1,5 % и больше (market_reversal.apply_exits)
    MKT: 'разворот рынка',
    // DELIST — бумага уходит с биржи (tickers_config.DELISTED, 20.10.2026): торгов нет, позиция закрыта по записи
    // делистинга (последняя сделка), датой прекращения торгов
    DELIST: 'делистинг',
  };

  // DE-версии удалены 2026-07-19 (легаси DOUBLE_EXTREME_MTF). Guard-ветки по
  // t.de_setup ниже мертвы (бэкенд поле больше не шлёт) — оставлены инертными.
  const _DE_SETUP_RU = {};

  // Расшифровка quality-маркера для hover-tooltip на колонке N.
  // Принимают oos_n как параметр для конкретного числа в подсказке.
  const QUALITY_TOOLTIP = {
    // ⚠ Тексты НЕ утверждают долю плюсовых: ярлык присваивается по WR ячейки
    // (доля выигранных среди дошедших до цели или стопа — истёкшие и неоткрытые
    // в знаменатель не идут), а строка «в плюсе ~N%» считает по ВСЕМ открытым.
    // Знаменатели разные, поэтому «большинство сделок плюсовые» соседствовало
    // с «47%» и выглядело ложью (репорт 17.08). Числа даются ниже отдельно.
    solid:   function(n) {
      return 'Устойчивый результат: преимущество подтверждается на длинной выборке, '
        + 'средний профит стабилен. Психологически удобная стратегия.<br>'
        + 'Проверено бэктестом на&nbsp;<b>' + n + '</b> сетапах.';
    },
    balanced: function(n) {
      return 'Преимущество есть, но профит формируется в&nbsp;основном за&nbsp;счёт '
        + 'подтягивания стопа после цели. Требует дисциплинированной торговли.<br>'
        + 'Проверено бэктестом на&nbsp;<b>' + n + '</b> сетапах.';
    },
    lottery: function(n) {
      return 'Редкие, но&nbsp;крупные профиты за&nbsp;счёт Trail-after-TP. '
        + 'В&nbsp;среднем результат положителен, но&nbsp;требует выдерживать просадки. '
        + 'Психологически тяжелее.<br>'
        + 'Проверено бэктестом на&nbsp;<b>' + n + '</b> сетапах.';
    },
    fragile: function(n) {
      return '<b style="color:#ff7a4a">Слабый</b><br>'
        + 'Combo прошёл валидацию, но близко к пороговым значениям '
        + '<span style="color:var(--text2)">(N 50-99 или AvgR < +0.10R при WR ≥ 53%)</span>. '
        + 'Стат. уверенность ниже — ревалидировать при росте выборки.<br>'
        + 'Выборка: <b>' + n + '</b>.';
    },
    small_n: function(n) {
      return '<b style="color:var(--text2)">Мало данных</b><br>'
        + 'N < 50 OR AvgR ≤ 0. '
        + 'Стат. ненадёжно или edge почти отсутствует — лучше не торговать.<br>'
        + 'Выборка: <b>' + n + '</b>.';
    },
  };
  // Русские названия типов триггеров — для hover-tooltip в сайдбаре + TOP cards.
  // На картоках используем lowercase ("сжатие", "ложный пробой") — feature-tag style.
  // Источник правды — _TRIGGER_RU в ta-chart.js; здесь Title Case для tooltip и
  // SHORT_RU для карточек.
  const TRIGGER_RU = {
    'FALSE_BREAKOUT':     'Ложный пробой',
    'FALSE_BREAKOUT_MTF': 'Ложный пробой',
    'STOP_HUNT':          'Сбор ликвидности',
    'STOP_HUNT_MTF':      'Сбор ликвидности',
    'VSA':                'Поглощение объёмом',
    'VSA_MTF':            'Поглощение объёмом',
    'DIVERGENCE':         'Дивергенция RSI',
    'CLEAN_BOUNCE':       'Отбой от уровня',
    'CLEAN_BOUNCE_MTF':   'Отбой от уровня',
    'COMPRESSION':        'Сжатие',
    'BOS':                'Слом структуры',
    'CLIMAX':             'Кульминация объёма',
    'CLIMAX_MTF':         'Кульминация объёма',
    'VWAP_REV':           'Возврат к VWAP',
    'VWAP_REV_MTF':       'Возврат к VWAP',
    'DOUBLE_TOP':         'Двойная вершина',
    'DOUBLE_BOTTOM':      'Двойное дно',
    'BEARISH_FLAG':       'Медвежий флаг',
    'HIDDEN_LEVEL':       'Скрытый уровень',
    'ELLIOTT_STEP':       'Шаг Эллиотта',
    'IMPULSE_BACK':      'Откат к импульсу',
    'IMPULSE_BACK_LATE': 'Поздний откат к импульсу',
  };
  // Богатое per-type описание для hover-тултипа в сайдбаре («Тип детектора»).
  // По одному типу за раз — общий пузырь на заголовке убран (не помещался
  // на экран при 6 типах). Только активные типы (TRIGGER_TYPES_ACTIVE);
  // у неактивных (в разработке) — нативный title.
  const TRIGGER_TOOLTIP = {
    'FALSE_BREAKOUT':
        '<strong>FALSE_BREAKOUT</strong> — ложный пробой уровня.<br>'
      + '<span class="tip-label">ТФ:</span> H1 и H4.<br>'
      + '<span class="tip-label">Паттерн:</span> 1–3 свечи закрылись за уровнем D1/W1, следующая свеча вернулась внутрь.<br>'
      + '<span class="tip-label">Уровни:</span> экстремумы дня и недели + зоны плотности.<br>'
      + '<span class="tip-label">Вход:</span> по цене открытия следующей свечи.<br>'
      + '<span class="tip-label">Идея:</span> участники пробоя в ловушке.',
    'STOP_HUNT':
        '<strong>STOP_HUNT</strong> — снятие стопов одной свечой с возвратом.<br>'
      + '<span class="tip-label">ТФ:</span> H1 и H4.<br>'
      + '<span class="tip-label">Паттерн:</span> тень свечи прокалывает уровень D1/W1, а закрытие возвращается внутрь в той же свече.<br>'
      + '<span class="tip-label">Уровни:</span> экстремумы дня и недели + зоны плотности.<br>'
      + '<span class="tip-label">Вход:</span> по цене открытия следующей свечи.<br>'
      + '<span class="tip-label">Идея:</span> мгновенное поглощение — крупные участники сметают стопы за уровнем.',
    'DIVERGENCE':
        '<strong>DIVERGENCE</strong> — расхождение цены и RSI у поворотного экстремума.<br>'
      + '<span class="tip-label">ТФ:</span> H1 и H4.<br>'
      + '<span class="tip-label">Паттерн:</span> обычная медвежья — цена ставит более высокий максимум, а RSI(14) в окне ±3 свечей вокруг него — более низкий; обычная бычья — зеркально у минимума. Скрытая — по тренду (относительно EMA50): цена ставит более низкий максимум при более высоком RSI или более высокий минимум при более низком RSI.<br>'
      + '<span class="tip-label">Вход:</span> по цене открытия следующей свечи.<br>'
      + '<span class="tip-label">Идея:</span> обычная — импульс истощается раньше цены, готовится разворот; скрытая — откат внутри тренда выдохся, тренд продолжается.',
    'CLIMAX':
        '<strong>CLIMAX</strong> — кульминация объёма (blow-off), истощение импульса.<br>'
      + '<span class="tip-label">ТФ:</span> H1 и H4.<br>'
      + '<span class="tip-label">Паттерн:</span> широкая свеча (диапазон ≥ 2,5 ATR, на H4 — ≥ 3 ATR) на объёме ≥ 2,5× медианы последних 50 свечей (на H4 — 13) со слабым закрытием: рост с закрытием в нижних 35% свечи → SHORT; падение с закрытием в верхних 35% → LONG. Уровень D1/W1 рядом с экстремумом — признак качества, но не обязателен.<br>'
      + '<span class="tip-label">Вход:</span> по цене открытия следующей свечи.<br>'
      + '<span class="tip-label">Идея:</span> толпа входит на излёте движения, импульс выдыхается — вероятен разворот.',
    'CLEAN_BOUNCE':
        '<strong>CLEAN_BOUNCE</strong> — отбой от сильного уровня D1/W1.<br>'
      + '<span class="tip-label">ТФ:</span> H1 и H4, уровни D1/W1.<br>'
      + '<span class="tip-label">Паттерн:</span> 1-й или 2-й подход к уровню с ≥ 3 касаниями (на H4 — только первый) + импульсная свеча отбоя (импульс ≥ 0,5 ATR): отбой от поддержки бычьей свечой → LONG; от сопротивления медвежьей → SHORT.<br>'
      + '<span class="tip-label">Вход:</span> по цене открытия следующей свечи.<br>'
      + '<span class="tip-label">Идея:</span> сильный уровень удерживается — рынок отбивает цену обратно.',
    // Фигуры (08.10.2026: тултипов не было — у пользователя флаг и двойное дно, у админа ещё двойная вершина).
    // Числа — из наборов детекторов: ta/bearish_flag.py, ta/double_bottom_ml.py, ta/double_top_ml.py
    'BEARISH_FLAG':
        '<strong>BEARISH_FLAG</strong> — медвежий флаг: резкое падение, короткая пауза и продолжение вниз.<br>'
      + '<span class="tip-label">ТФ:</span> H1 и H4.<br>'
      + '<span class="tip-label">Паттерн:</span> древко — направленное падение не меньше 3 ATR за 4–40 свечей; флаг — пауза или небольшой отскок вверх на 3–25 свечей: откат не выше 60% древка, ширина не больше половины его высоты, новых минимумов ниже древка нет. Сигнал — свеча закрылась ниже низа флага → SHORT.<br>'
      + '<span class="tip-label">Вход:</span> по цене открытия следующей свечи, стоп над вершиной флага.<br>'
      + '<span class="tip-label">Идея:</span> после резкого падения продавцы взяли паузу, а не сдались: пробой низа флага продолжает движение.',
    'DOUBLE_BOTTOM':
        '<strong>DOUBLE_BOTTOM</strong> — двойное дно: разворот вверх после второго теста минимума.<br>'
      + '<span class="tip-label">ТФ:</span> H1 и H4.<br>'
      + '<span class="tip-label">Паттерн:</span> после снижения две впадины на одном уровне — по закрытию разница не больше 1,5%, между ними не меньше 10 свечей и отскок («шея») не меньше 1,5 ATR. Сигнал — пробой шеи вверх в течение 30 свечей (на H4 — 8) → LONG. Закрытие ниже дна на 0,5 ATR до пробоя — третий минимум, фигура отменяется.<br>'
      + '<span class="tip-label">Вход:</span> лимитной заявкой на уровне шеи в свече пробоя (свеча открылась выше шеи гэпом — сделки нет), стоп чуть ниже нижней впадины.<br>'
      + '<span class="tip-label">Идея:</span> второй раз продавцы не продавили цену ниже — покупатели держат уровень, пробой шеи подтверждает разворот.',
    'DOUBLE_TOP':
        '<strong>DOUBLE_TOP</strong> — двойная вершина: разворот вниз после второго теста максимума.<br>'
      + '<span class="tip-label">ТФ:</span> H1 и H4.<br>'
      + '<span class="tip-label">Паттерн:</span> после роста две вершины на одном уровне — по закрытию разница не больше 1,5%, между ними не меньше 10 свечей и заметный откат («шея»). Сигнал — пробой шеи вниз в течение 10 свечей (на H4 — 8) → SHORT. Закрытие выше вершины на 0,5 ATR до пробоя — фигура отменяется.<br>'
      + '<span class="tip-label">Вход:</span> лимитной заявкой на уровне шеи в свече пробоя (свеча открылась ниже шеи гэпом — сделки нет), стоп чуть выше верхней вершины.<br>'
      + '<span class="tip-label">Идея:</span> второй раз покупатели не подняли цену выше — продавцы держат уровень, пробой шеи подтверждает разворот.',
    'ELLIOTT_STEP':
        '<strong>ELLIOTT_STEP</strong> — вход по продолжению движения после короткой паузы.<br>'
      + '<span class="tip-label">ТФ:</span> H1 и H4.<br>'
      + '<span class="tip-label">Паттерн:</span> сильный импульс из 3–10 свечей (≥ 3,5 ATR на H1, ≥ 2 ATR на H4) → пауза на 1–3 свечи (их диапазон и есть зона) → цена выходит из зоны в сторону импульса. Форма та же, что у HIDDEN_LEVEL, но вход не на возврате в зону, а на выходе из неё.<br>'
      + '<span class="tip-label">Вход:</span> по закрытию свечи выхода из зоны, стоп за дальний край зоны.<br>'
      + '<span class="tip-label">Фильтр:</span> сетап не показываем, если по ходу движения меньше 0,5 ATR простора до сильного уровня или на пути стоят «стены» из уровней.<br>'
      + '<span class="tip-label">Идея:</span> пауза внутри импульса — передышка, а не разворот: движение чаще продолжается.<br>'
      + '<span class="tip-label">Оговорка:</span> волновую разметку Эллиотта детектор не строит — имя описывает «шаг» внутри импульса.',
    'IMPULSE_BACK':
        '<strong>IMPULSE_BACK</strong> — вход на откате в сторону сильной свечи с большим объёмом.<br>'
      + '<span class="tip-label">ТФ:</span> H1 и H4.<br>'
      + '<span class="tip-label">Паттерн:</span> свеча с телом от 1,5 ATR, закрытием в сильной части размаха и объёмом от 3 медиан того же часа. Ждём отката к середине её тела до 6 свечей.<br>'
      + '<span class="tip-label">Вход:</span> лимитной заявкой на середине тела, стоп за открытием свечи.<br>'
      + '<span class="tip-label">Поздний откат:</span> на H4 та же галочка включает и поздний вариант — лимитка на 38% тела от закрытия свечи, без утренней сессии и без отката в первую же свечу.<br>'
      + '<span class="tip-label">Идея:</span> крупный участник продавил цену на объёме — откат против него чаще заканчивается продолжением движения.<br>'
      + '<span class="tip-label">Статус:</span> обкатка, видит только админ.',
    'IMPULSE_BACK_LATE':
        '<strong>IMPULSE_BACK_LATE</strong> — тот же вход, вариант для H4.<br>'
      + '<span class="tip-label">ТФ:</span> H4.<br>'
      + '<span class="tip-label">Отличия:</span> лимитка на 38% тела от закрытия свечи, свечи утренней сессии не берём, откат в первую же свечу после импульса — не входим.<br>'
      + '<span class="tip-label">Статус:</span> обкатка, видит только админ.',
    'HIDDEN_LEVEL':
        '<strong>HIDDEN_LEVEL</strong> — зона, где движение притормозило, а потом пошло дальше.<br>'
      + '<span class="tip-label">ТФ:</span> H1 и H4.<br>'
      + '<span class="tip-label">Паттерн:</span> импульс из 3–5 однонаправленных свечей → пауза на 1–3 свечи (их диапазон и есть уровень) → движение продолжается. Сигнал — когда цена ПОЗЖЕ возвращается в эту зону.<br>'
      + '<span class="tip-label">Уровни:</span> строит сам паттерн, история касаний не нужна.<br>'
      + '<span class="tip-label">Вход:</span> лимитной заявкой на границе зоны, стоп за её дальний край.<br>'
      + '<span class="tip-label">Идея:</span> в паузе крупный участник набирал позицию и не дал цене откатиться — при возврате он защищает свою зону.',
  };
  // Короткие имена для Light TOP-карточек (подзаголовок) — без «RSI», минимализм.
  // Где не задано — fallback на TRIGGER_RU.
  const TRIGGER_CARD_NAME = {
    'DIVERGENCE':         'Дивергенция',
    'CLIMAX_MTF':         'Кульминация',
    'CLEAN_BOUNCE_MTF':   'Отбой от уровня',
    'DOUBLE_TOP':         'Двойная вершина',
    'DOUBLE_BOTTOM':      'Двойное дно',
    'BEARISH_FLAG':       'Медвежий флаг',
    'HIDDEN_LEVEL':       'Скрытый уровень',
    'ELLIOTT_STEP':       'Шаг Эллиотта',
    'IMPULSE_BACK':      'Откат к импульсу',
    'IMPULSE_BACK_LATE': 'Поздний откат',
  };
  // NBSP   в верстке — типографика: предлоги (1-2 буквы) не висят в конце
  // строки, склеиваются со следующим словом ради переноса целым блоком.
  const NBSP = ' ';

  // ── Sidebar: build trigger-type checkboxes ───────
  // Активные = все строки сайдбара, кроме выключенных «в разработке»
  // (TRIGGER_TYPES_INACTIVE, сейчас пусто: такая строка рисуется серой и не
  // кликается). Порядок — из TRIGGER_TYPES_ALL: вторая копия имён здесь дала бы
  // второй источник порядка, и при перестановке попап уведомлений
  // (nwBuildTriggerChecks) разошёлся бы с сайдбаром (11.09.2026).
  const TRIGGER_TYPES_INACTIVE = new Set([]);
  const TRIGGER_TYPES_ACTIVE = new Set(TRIGGER_TYPES_ALL.filter(function (tt) {
    return !TRIGGER_TYPES_INACTIVE.has(tt);
  }));
  // Связки «детектор:ТФ», скрытые у пользователя (settings.SETUPS_USER_HIDDEN_PAIRS, 04.10.2026, решение владельца:
  // у пользователя 6 детекторов). Список приходит с сервера (__SETUPS_CFG__.userHidden), своей копии в JS нет. Сетапы
  // этих связок пользователю не отдаёт сам сервер (catalog_matcher, «Вся история», маркеры графика) — здесь только
  // сайдбар и окно уведомлений. Админ в своём виде видит все детекторы, в режиме User — набор пользователя.
  // Детектор на обкатке (видит только админ) — тот же список: заменил прежний ADMIN_ONLY_TRIGGERS.
  const USER_HIDDEN_PAIRS = new Set((window.__SETUPS_CFG__ && window.__SETUPS_CFG__.userHidden) || []);
  /** Скрыта ли связка в сайдбаре сейчас: у пользователя и у админа в режиме User. */
  function _pairHiddenNow(tt, tf) {
    return USER_HIDDEN_PAIRS.has(tt + ':' + tf) && !_adminView();
  }
  // Связки, которых у детектора нет вовсе (детектор не на всех ТФ витрины — settings.SETUPS_TYPE_TFS, 06.10.2026:
  // «поздний откат к импульсу» только на 4Ч): полный набор пар объявляет сервер (__SETUPS_CFG__.netPairsAll).
  // Скрытые у пользователя связки в его наборе тоже отсутствуют — их и так прячет _pairHiddenNow.
  const _PAIRS_DECLARED = new Set((window.__SETUPS_CFG__ && window.__SETUPS_CFG__.netPairsAll) || []);
  function _pairExists(tt, tf) {
    return !_PAIRS_DECLARED.size || _PAIRS_DECLARED.has(tt + ':' + tf) || USER_HIDDEN_PAIRS.has(tt + ':' + tf);
  }
  // Варианты детектора в одной строке сайдбара и «Детекторов» (27.10.2026, решение владельца; settings.SETUPS_DETECTOR_GROUPS
  // → __SETUPS_CFG__.detGroups: вариант → основной, имена журнала): «Поздний откат» — в «Откате к импульсу», как четыре
  // вида дивергенции — один детектор. Строки варианта в сайдбаре нет; галочка основного на ТФ включает и связки варианта
  // на этом ТФ (_expandPairs: запрос, фильтр таблицы и графика, настройки); «Детекторы» и плашку лидера складывает сервер.
  var DET_GROUPS = (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.detGroups) || {};
  function _detGroup(dbType) { return DET_GROUPS[dbType] || dbType; }
  function _isGroupVariantUi(uiType) { return !!DET_GROUPS[_UI_TO_DB_TT_MAP[uiType] || uiType]; }
  function _groupVariantsUi(uiType) {             // UI-имена вариантов основного детектора
    var db = _UI_TO_DB_TT_MAP[uiType] || uiType;
    return Object.keys(DET_GROUPS).filter(function (v) { return DET_GROUPS[v] === db; }).map(_dbToUiTT);
  }
  function _expandPairs(pairs) {                  // ['TT:tf'] → + связки вариантов на тех же ТФ (только существующие)
    var out = pairs.slice();
    pairs.forEach(function (p) {
      var tt = p.split(':')[0], tf = p.split(':')[1];
      _groupVariantsUi(tt).forEach(function (v) {
        if (_pairExists(v, tf) && out.indexOf(v + ':' + tf) < 0) out.push(v + ':' + tf);
      });
    });
    return out;
  }
  // Связки, которые были отмечены в настройках, но сейчас скрыты (чекбоксов нет): их кладёт в сохраняемые настройки
  // extractFiltersForPrefs — выбор человека не теряется, пока детектор скрыт (вернётся детектор — вернётся галочка).
  var _keptHiddenPairs = [];
  // Фильтры и набор детекторов — у каждого режима «Акции / Фьючи» свои (11.10.2026, решение владельца: настройки
  // фьючерсов затирали настройки акций). В сайдбаре — набор действующего режима, набор другого ждёт здесь. Хранятся в
  // setups.filters: верхние ключи — набор акций (его читают все роли и виды), набор «Фьючей» — ключом fut (_modeFilters,
  // applyFilters / extractFiltersForPrefs). Объявлены здесь: applyFilters зовётся раньше блока режима «Фьючи» ниже.
  var _modeFilters = { stock: null, fut: null };
  // Пользовательские «Сетапы» дополняют прежний набор, не меняя состав портфеля.
  // null — первый вход; [] — сохранённый ручной выбор без детекторов.
  var _setupsPairs = null;
  var _setupsPairsApplied = false;
  var _legacyFutLiquid = false;   // галочка «Фьюч-ликвид» в setups.ui до 11.10.2026 — для первого набора «Фьючей»

  // Витринные таймфреймы. Часовик был единственным до 19.08.2026; четырёхчасовые
  // сетапы добавлены после гейтов эджа — по умолчанию показываем оба.
  const TIMEFRAMES_ALL = ['1h', '4h'];


  // Набор строк сайдбара зависит от ВИДА (роль из разметки, режим Admin/User): при его смене (резолв auth,
  // переключатель вида) список пересобирается с восстановлением галочек. Снимок — extractFiltersForPrefs (массивы
  // и запомненные скрытые связки), а не currentFilters: тот отдаёт строки CSV, и applyFilters их не читает.
  function _syncHiddenTriggers() {
    const ctr = document.getElementById('f-triggers');
    if (!ctr || !USER_HIDDEN_PAIRS.size) return;
    if (ctr.dataset.view === _sidebarView()) return;   // уже в нужном виде
    const saved = extractFiltersForPrefs();
    buildTriggerFilters();
    applyFilters(saved);
  }
  function _sidebarView() { return _adminView() ? 'all' : 'user'; }

  // Чекбокс колонки ведомый: его состояние выводится из самих детекторов, а не
  // хранится отдельно. Иначе после восстановления сохранённых фильтров (или
  // клика по одному детектору) шапка врала бы о состоянии колонки.
  function _syncTtHeadChecks() {
    const ctr = document.getElementById('f-triggers');
    if (!ctr) return;
    ctr.querySelectorAll('.sb-tt-all').forEach(function (box) {
      const tf = box.dataset.tfAll;
      const boxes = Array.from(
        ctr.querySelectorAll('input[data-tf="' + tf + '"]:not(:disabled)'));
      const on = boxes.filter(function (i) { return i.checked; }).length;
      box.checked = boxes.length > 0 && on === boxes.length;
      box.indeterminate = on > 0 && on < boxes.length;
    });
  }

  function buildTriggerFilters() {
    const ctr = document.getElementById('f-triggers');
    ctr.innerHTML = '';
    // Сетка: два чекбокса слева, имя справа. Подписи ТФ вынесены в шапку —
    // повтор «1Ч/4Ч» в каждой строке съедал ширину, и имена обрезались.
    const tfs = TIMEFRAMES_ALL.slice();
    const head = document.createElement('div');
    head.className = 'sb-tt-head';
    // В шапке колонки — общий чекбокс «вся колонка» (29.08): включает/выключает
    // все детекторы этого ТФ разом. Состояние ведомое: галка, когда отмечены все
    // доступные, «частично» (indeterminate) — когда часть (см. _syncTtHeadChecks).
    head.innerHTML = tfs.map(function (tf) {
      return '<span class="sb-tt-h">'
           + '<span class="sb-tt-h-lbl">' + (TF_LABEL[tf] || tf) + '</span>'
           + '<input type="checkbox" class="sb-tt-all" data-tf-all="' + tf + '"'
           + ' title="Включить или выключить всю колонку"/>'
           + '</span>';
    }).join('') + '<span></span>';
    ctr.appendChild(head);
    head.querySelectorAll('.sb-tt-all').forEach(function (box) {
      box.addEventListener('change', function () {
        const tf = box.dataset.tfAll;
        // Выключенные детекторы (в разработке) не трогаем — они disabled.
        ctr.querySelectorAll('input[data-tf="' + tf + '"]:not(:disabled)')
           .forEach(function (i) { i.checked = box.checked; });
        onFilterChange();
      });
    });
    TRIGGER_TYPES_ALL.forEach(tt => {
      if (_isGroupVariantUi(tt)) return;       // вариант детектора — в строке основного (DET_GROUPS, 27.10.2026)
      // Связки, скрытые у пользователя (USER_HIDDEN_PAIRS): сервер их сетапы не отдаёт, поэтому и чекбокс прячем —
      // иначе человек включил бы фильтр и получил пустую таблицу. Скрыты все ТФ детектора — нет и строки.
      const visTfs = tfs.filter(function (tf) { return !_pairHiddenNow(tt, tf) && _pairExists(tt, tf); });
      if (!visTfs.length) return;
      const row = document.createElement('div');
      row.className = 'sb-tt-row';
      row.dataset.tt = tt;
      const isActive = TRIGGER_TYPES_ACTIVE.has(tt);
      // Цвет имени = цвет маркера сетапа на графике (общий SETUP_NAME_COLOR
      // через UI→DB маппинг), новой карты не заводим. DIVERGENCE там нет —
      // его стрелка белая → var(--text).
      const dbTt = _UI_TO_DB_TT_MAP[tt] || tt;
      const color = SETUP_NAME_COLOR[dbTt] || 'var(--text)';
      const boxes = tfs.map(function (tf) {
        const cls = 'sb-tf-cell';
        if (visTfs.indexOf(tf) < 0) return '<span class="' + cls + '"></span>';   // связка скрыта — пустая клетка
        return '<span class="' + cls + '">'
             + '<input type="checkbox" data-tt="' + tt + '" data-tf="' + tf + '"'
             + (isActive ? ' checked' : ' disabled') + ' title="' + (TF_LABEL[tf] || tf) + '"/>'
             + '</span>';
      }).join('');
      row.innerHTML = boxes
                    + '<span class="sb-tt-name" style="color:' + color + '">' + tt + '</span>';
      if (!isActive) {
        row.style.opacity = '0.4';
        row.style.cursor = 'not-allowed';
        row.title = 'В разработке (перевалидация по методологии v7)';
      }
      row.querySelectorAll('input').forEach(function (i) {
        i.addEventListener('change', onFilterChange);
      });
      row.addEventListener('mouseenter', _onTriggerHoverEnter);
      row.addEventListener('mouseleave', _onTriggerHoverLeave);
      ctr.appendChild(row);
    });
    _syncTtHeadChecks();
    ctr.dataset.view = _sidebarView();
    STATE.filters.trigger_types = Array.from(TRIGGER_TYPES_ACTIVE);
    STATE.filters.timeframes = TIMEFRAMES_ALL.slice();
  }

  var _DE_SETUP_TO_TYPE = {};   // пусто с 2026-07-19 (DE удалён); ключ нужен guard-веткам

  // ── Trigger hover tooltip (русское название) ──────
  // Один общий <div> создаётся лениво при первом hover и переиспользуется
  var _trigTooltipEl = null;
  function _ensureTrigTooltip() {
    if (_trigTooltipEl) return _trigTooltipEl;
    _trigTooltipEl = document.createElement('div');
    _trigTooltipEl.className = 'trig-tooltip';
    document.body.appendChild(_trigTooltipEl);
    return _trigTooltipEl;
  }
  function _onTriggerHoverEnter(e) {
    var tt = e.currentTarget.dataset.tt;
    var html = TRIGGER_TOOLTIP[tt];
    if (!html) return;            // неактивные типы — без rich-тултипа (есть native title)
    var el = _ensureTrigTooltip();
    el.innerHTML = html;
    el.style.display = 'block';
    _positionTrigTooltip(e.currentTarget);   // привязка к строке, не к курсору
  }
  // Позиционируем рядом со строкой типа (справа от сайдбара), с клампом по краям
  // экрана. Не следует за курсором — multi-line контент не должен «прыгать».
  function _positionTrigTooltip(rowEl) {
    if (!_trigTooltipEl) return;
    var r = rowEl.getBoundingClientRect();
    var tipW = _trigTooltipEl.offsetWidth || 340;
    var tipH = _trigTooltipEl.offsetHeight || 160;
    var gap = 12;
    var left = r.right + gap;                       // справа от сайдбара
    if (left + tipW > window.innerWidth - 8)        // не влезает справа → слева
      left = Math.max(8, r.left - tipW - gap);
    var top = r.top;
    if (top + tipH > window.innerHeight - 8) top = window.innerHeight - tipH - 8;
    if (top < 8) top = 8;
    _trigTooltipEl.style.left = left + 'px';
    _trigTooltipEl.style.top  = top + 'px';
  }
  function _onTriggerHoverLeave() {
    if (_trigTooltipEl) _trigTooltipEl.style.display = 'none';
  }

  // ── Quality tooltip (hover на N в таблице) ────────
  // Multi-line описание quality маркера: «Проверено / Мало данных / На грани»
  // плюс конкретное число наблюдений N. Позиционируется правее курсора с
  // clamp по краям viewport (на узких экранах перебрасывается влево/вверх).
  var _qTooltipEl = null;
  function _ensureQTooltip() {
    if (_qTooltipEl) return _qTooltipEl;
    _qTooltipEl = document.createElement('div');
    _qTooltipEl.className = 'q-tooltip';
    document.body.appendChild(_qTooltipEl);
    return _qTooltipEl;
  }
  function _onQualityHoverEnter(e) {
    var cell = e.currentTarget;
    var q = cell.dataset.q;
    var n = cell.dataset.n;
    var tipFn = QUALITY_TOOLTIP[q];
    if (!tipFn) return;
    var el = _ensureQTooltip();
    // Серийная вероятность (prob20 из setup_stats — тот же источник, что TOP-карточки
    // и TG). Отдельной строкой снизу; нет у ячеек с N < RDIST_MIN_N → просто не рисуем.
    // Две РАЗНЫЕ величины, и раньше они читались как противоречие (репорт 17.08:
    // «в строке 57%, в тултипе 68% — чему верить?»). Показываем рядом с явным
    // указанием горизонта: одна сделка против серии. Серийная выше не по ошибке —
    // при положительном ожидании сумма N сделок в плюсе чаще, чем отдельная.
    var p20 = cell.dataset.prob20, wp = cell.dataset.winp;
    var probLine = '';
    if (wp || p20) {
      probLine = '<div class="q-tip-prob">';
      if (wp)  probLine += 'Отдельная сделка в&nbsp;плюсе: ~' + wp + '%<br>';
      if (p20) probLine += 'Серия из&nbsp;' + _seriesN() + ' сделок в&nbsp;плюсе: ~' + p20 + '%';
      probLine += '</div>';
    }
    el.innerHTML = tipFn(n) + probLine;
    el.style.display = 'block';
    _onQualityHoverMove(e);
  }
  function _onQualityHoverMove(e) {
    if (!_qTooltipEl || _qTooltipEl.style.display === 'none') return;
    var ttW = _qTooltipEl.offsetWidth || 0;
    var ttH = _qTooltipEl.offsetHeight || 0;
    var x = e.clientX + 14;
    var y = e.clientY + 4;
    // Clamp: перенос за курсор если выпадает за viewport
    if (x + ttW + 10 > window.innerWidth)  x = e.clientX - ttW - 14;
    if (y + ttH + 10 > window.innerHeight) y = e.clientY - ttH - 4;
    _qTooltipEl.style.left = x + 'px';
    _qTooltipEl.style.top  = y + 'px';
  }
  function _onQualityHoverLeave() {
    if (_qTooltipEl) _qTooltipEl.style.display = 'none';
  }
  // Биндит quality-tooltip handlers на любые элементы с data-q+data-n внутри rootEl.
  // Используется в таблице — на N column (main rows) и на quality cell в variant rows.
  function _bindQualityTooltips(rootEl) {
    if (!rootEl) return;
    rootEl.querySelectorAll('[data-q][data-n]').forEach(function(el) {
      el.addEventListener('mouseenter', _onQualityHoverEnter);
      el.addEventListener('mousemove',  _onQualityHoverMove);
      el.addEventListener('mouseleave', _onQualityHoverLeave);
    });
  }

  // ── Format helpers ───────────────────────────────
  function fmtRub(n) {
    if (!n) return '0';
    if (n >= 1e9) return (n/1e9).toFixed(1) + ' млрд';
    if (n >= 1e6) return (n/1e6).toFixed(1) + ' млн';
    if (n >= 1e3) return (n/1e3).toFixed(0) + ' тыс';
    return n.toFixed(0);
  }

  // Слайдер мин. оборота — нелинейная шкала до 200М (шаг растёт):
  // 0-5М шаг 1, 5-50М шаг 5, 50-100М шаг 10, 100-200М шаг 50.
  // Слайдер хранит ИНДЕКС (0..21); значение в рублях берётся из TURNOVER_VALUES.
  // Двойной ползунок: нижняя граница (min) + верхняя (max). Топовый индекс
  // (TURNOVER_MAX_IDX) = «∞» — верхний предел снят (бэкенд получает max_turnover=0).
  // ⚠ Шкала начинается с 10 млн (владелец, 28.08): в интерфейсе показываем только
  // торгуемую полосу. На бэке вселенная НЕ сужена — обучение, детекторы и ячейки
  // по-прежнему считаются на всех тикерах.
  const TURNOVER_VALUES = [10,15,20,25,30,35,40,45,50,60,70,80,90,100,150,200]
                            .map(function(m){ return m * 1000000; });
  const TURNOVER_MAX_IDX = TURNOVER_VALUES.length - 1;  // 15 = 200М = без верхнего предела
  function fmtTurnover(rub) { return rub ? (rub / 1000000) + ' млн ₽' : '0 ₽'; }
  function _turnoverElMin() { return document.getElementById('f-turnover-min'); }
  function _turnoverElMax() { return document.getElementById('f-turnover-max'); }
  function turnoverToIndex(rub) {
    rub = parseInt(rub) || 0;
    var idx = TURNOVER_VALUES.findIndex(function(v){ return v >= rub; });
    return idx < 0 ? TURNOVER_VALUES.length - 1 : idx;
  }
  // Нижняя граница диапазона (₽).
  function turnoverFromSlider() {
    var i = parseInt(_turnoverElMin().value) || 0;
    return TURNOVER_VALUES[i] != null ? TURNOVER_VALUES[i] : 0;
  }
  // Верхняя граница (₽); 0 = ∞ (верхний предел снят — топовый индекс).
  function turnoverMaxFromSlider() {
    var i = parseInt(_turnoverElMax().value);
    if (isNaN(i) || i >= TURNOVER_MAX_IDX) return 0;
    return TURNOVER_VALUES[i] != null ? TURNOVER_VALUES[i] : 0;
  }
  function _fmtTurnoverRange(minI, maxI) {
    var minRub = TURNOVER_VALUES[minI] || 0;
    var hasMax = maxI < TURNOVER_MAX_IDX;
    var maxRub = TURNOVER_VALUES[maxI] || 0;
    if (!minRub && !hasMax) return 'любой';
    if (!minRub && hasMax)  return 'до ' + (maxRub / 1000000) + ' млн ₽';
    if (minRub && !hasMax)  return 'от ' + (minRub / 1000000) + ' млн ₽';
    return (minRub / 1000000) + '–' + (maxRub / 1000000) + ' млн ₽';
  }
  // Обновляет подпись + заливку трека между ползунками.
  function _updateTurnoverUI() {
    var minI = parseInt(_turnoverElMin().value) || 0;
    var maxI = parseInt(_turnoverElMax().value);
    if (isNaN(maxI)) maxI = TURNOVER_MAX_IDX;
    var lbl = document.getElementById('f-turnover-label');
    if (lbl) lbl.textContent = _fmtTurnoverRange(minI, maxI);
    var fill = document.getElementById('f-turnover-fill');
    if (fill) {
      var lo = (minI / TURNOVER_MAX_IDX) * 100;
      var hi = (maxI / TURNOVER_MAX_IDX) * 100;
      fill.style.left = lo + '%';
      fill.style.width = Math.max(0, hi - lo) + '%';
    }
  }
  // Clamp: ползунки не пересекаются (толкают друг друга).
  function _onTurnoverInput(e) {
    var minEl = _turnoverElMin(), maxEl = _turnoverElMax();
    var a = parseInt(minEl.value) || 0;
    var b = parseInt(maxEl.value);
    if (isNaN(b)) b = TURNOVER_MAX_IDX;
    if (a > b) {
      if (e && e.target === maxEl) minEl.value = b;
      else maxEl.value = a;
    }
    _updateTurnoverUI();
  }
  // setTurnoverSlider(minRub[, maxRub]) — maxRub undefined/0 → ∞ (топовый индекс).
  function setTurnoverSlider(minRub, maxRub) {
    var minIdx = turnoverToIndex(minRub);
    var maxIdx = (maxRub === undefined || !parseInt(maxRub))
                   ? TURNOVER_MAX_IDX : turnoverToIndex(maxRub);
    if (minIdx > maxIdx) minIdx = maxIdx;
    _turnoverElMin().value = minIdx;
    _turnoverElMax().value = maxIdx;
    _updateTurnoverUI();
  }
  // V2 формат времени для card.tc-time: "HH:MM" (если bar = today MSK)
  // или "DD.MM HH:MM" (cross-day fallback из вчерашней сессии).
  // bar_date_iso — ISO строка из API, todayDateMsk — "YYYY-MM-DD" (STATE.data.today_date).
  /** Первый ТОРГОВЫЙ час четырёхчасового блока — только для показа.
   *  Метка 4ч-бара это НАЧАЛО блока (00/04/08/12/16/20 МСК), а утренняя сессия
   *  MOEX открывается в 07:00 — значит в блоке 04:00–08:00 торгуется лишь
   *  последний час, и подпись «04:00» читается как «биржа закрыта»
   *  (репорт владельца 24.08; сам блок торгово здоров — 57% в плюсе, +0.36R).
   *  ⚠ Меняем ТОЛЬКО подпись: bar_date остаётся прежним, поэтому на графике,
   *  в solo-режиме и при матче строки с маркером этот бар по-прежнему 04:00. */
  const MSK_SESSION_OPEN_H = 7;
  function _dispBarDate(t) {
    const bd = t && t.bar_date;
    if (!bd || String((t && t.tf) || '1h') !== '4h') return bd;
    const m = String(bd).match(/^(\d{4}-\d{2}-\d{2})([T\s])(\d{2}):(\d{2})/);
    if (!m) return bd;
    if (parseInt(m[3], 10) >= MSK_SESSION_OPEN_H) return bd;
    const hh = String(MSK_SESSION_OPEN_H).padStart(2, '0');
    return m[1] + m[2] + hh + ':00' + String(bd).slice(m[0].length);
  }

  function fmtCardTime(barDateIso) {
    if (!barDateIso) return '';
    // bar_date в API приходит в naive ISO (без таймзоны) — это уже MSK
    // (psycopg2 timezone-aware → JSON-сериализатор web_app преобразует).
    // Защитный regex чтобы не зависеть от формата (с T или пробелом, с/без секунд).
    const m = String(barDateIso).match(/(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/);
    if (!m) return barDateIso;
    return m[3] + '.' + m[2] + ' ' + m[4] + ':' + m[5];
  }
  function fmtTime(s) {
    // 2 строки: DD.MM сверху, HH:MM снизу — ширина колонки не позволяет inline.
    if (!s) return '';
    const parts = s.split(' ');
    if (parts.length < 2) return s;
    const [yyyy, mm, dd] = parts[0].split('-');
    const hhmm = parts[1].slice(0, 5);  // HH:MM (отрезаем секунды если есть)
    return `<span class="date-line">${dd}.${mm}</span><span class="time-line">${hhmm}</span>`;
  }
  // fmtDayLabel / groupByDate удалены вместе с day-picker'ом — таблица
  // отображается как единая хронологическая лента, sortItems по time desc.

  // ── Session chip ─────────────────────────────────
  const _DOW_RU = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
  const _MONTH_RU = ['янв','фев','мар','апр','мая','июн','июл','авг','сен','окт','ноя','дек'];

  function fmtRussianDate(yyyymmdd) {
    if (!yyyymmdd) return '';
    const dt = new Date(yyyymmdd + 'T00:00:00Z');
    const dow = _DOW_RU[dt.getUTCDay()];
    const day = dt.getUTCDate();
    const mon = _MONTH_RU[dt.getUTCMonth()];
    return `${dow}, ${day} ${mon}`;
  }

  function renderSession(session, todayDate) {
    // Null-safe: после унификации topbar (APP_TOPBAR_HTML) старые
    // session/regime/stats elements удалены — рендеринг идёт через
    // APP_TOPBAR_JS на shared topbar. Здесь — no-op.
    const chip = document.getElementById('session-chip');
    if (!chip) return;
    const dot = chip.querySelector('.session-dot');
    const dateEl = chip.querySelector('.session-date');
    const info = chip.querySelector('.session-info');
    if (!dot || !dateEl || !info) return;
    dateEl.textContent = fmtRussianDate(todayDate);
    dot.className = 'session-dot ' + (session.is_active ? 'active' : 'inactive');
    if (session.is_active) {
      info.className = 'session-info';
      info.innerHTML = `${session.name} сессия<span class="session-time">${session.start} – ${session.end}</span>`;
    } else {
      info.className = 'session-info closed';
      info.textContent = 'Рынок закрыт';
    }
  }

  // Цветовое кодирование режима (повторяет ta-chart.js _REGIME_CLS)
  const _REGIME_CLS = {
    'TREND_UP': 'green', 'HYBRID_UP': 'green',
    'TREND_DOWN': 'red', 'HYBRID_DOWN': 'red',
    'SHOCK': 'gold',
    'RANGE': 'muted',
  };
  // Чекбокс «Голубые фишки» на бесплатном тарифе: отмечен, и снять нельзя — сервер всё
  // равно форсит blue-only (free_blue_only), и расхождение UI с выдачей читалось бы как
  // поломка («снял галочку, а список тот же»). Через disabled НЕ глушим: клик по нему —
  // заявленное намерение «хочу все бумаги», то есть лучший момент показать тариф.
  function _applyBlueChipsGate(locked) {
    const cb = document.getElementById('f-blue-chips');
    const lock = document.getElementById('blue-chips-lock');
    const label = document.getElementById('blue-chips-label');
    if (!cb) return;
    if (lock) lock.style.display = locked ? 'inline' : 'none';
    if (label) label.classList.toggle('is-locked', locked);
    STATE._blueLocked = locked;
    if (locked && !cb.checked) {
      cb.checked = true;            // UI = то, что реально отдаёт сервер
      STATE._blueForced = true;     // помним: галочку поставили МЫ, а не пользователь
    }
    if (!locked && STATE._blueForced) {
      // Ограничение снялось (оплата/триал). Возвращаем то состояние, которое мы
      // навязали, иначе человек оплатил, а видит те же 12 бумаг и думает, что
      // оплата не сработала. Свой выбор пользователя не трогаем — только свой.
      STATE._blueForced = false;
      cb.checked = false;
      if (typeof onFilterChange === 'function') onFilterChange();
    }
    if (!window._blueGateWired) {
      window._blueGateWired = true;
      // Слушаем на document в capture-фазе, а не на самом чекбоксе: обработчик,
      // навешенный прямо на input, до нас не доходил — его перебивал уже висевший
      // на элементе. Из document мы гарантированно первые.
      document.addEventListener('click', function (e) {
        if (!STATE._blueLocked) return;
        const t = e.target;
        if (!t || (t.id !== 'f-blue-chips' && !(t.closest && t.closest('#blue-chips-label')))) return;
        e.preventDefault();
        e.stopPropagation();                         // фильтры не перезапрашиваем
        const box = document.getElementById('f-blue-chips');
        if (box) box.checked = true;                 // галочка остаётся на месте
        if (typeof nwOpenPricingStep === 'function') nwOpenPricingStep('allstocks');
      }, true);
    }
  }

  function renderTopbarRegime(regime) {
    const root = document.getElementById('topbar-regime');
    if (!root) return;   // unified topbar — element removed
    if (!regime || !regime.regime) { root.innerHTML = ''; return; }
    // Класс берём по базовому regime (SHOCK_DOWN/SHOCK_UP оба → gold),
    // а отображаем regime_label с направлением (fallback на regime для совместимости).
    const cls = _REGIME_CLS[regime.regime] || 'muted';
    const label = regime.regime_label || regime.regime;
    root.innerHTML = `<span class="regime-badge ${cls}" title="Режим рынка">
        <span class="regime-badge-lbl">Режим рынка</span>
        <span class="regime-badge-val">${label}</span>
      </span>`;
  }

  // ── Stats (topbar) ─────────────────────────────────
  // Формат: "Найдено N стратегий · X тикеров · Y FALSE_BREAKOUT · ..."
  // Сокращения trigger names для шапки — длинные имена иногда не помещались
  // в 1 строку и съезжали (особенно на 1366-1440 viewport).
  const TRIGGER_SHORT_HDR = {
    'VWAP_REV':           'VWAP_REV',
    'VWAP_REV_MTF':       'VWAP_REV',
    'FALSE_BREAKOUT':     'FALSE_BRKT',
    'FALSE_BREAKOUT_MTF': 'FALSE_BRKT',
    'STOP_HUNT':          'STOP_HUNT',
    'STOP_HUNT_MTF':      'STOP_HUNT',
    'VSA':                'VSA',
    'VSA_MTF':            'VSA',
    'DIVERGENCE':         'RSI_DIV',
    'COMPRESSION':        'COMPRESS',
    'BOS':                'BOS',
    'CLEAN_BOUNCE':       'CLEAN_BNC',
    'CLEAN_BOUNCE_MTF':   'CLEAN_BNC',
    'CLIMAX':             'CLIMAX',
    'CLIMAX_MTF':         'CLIMAX',
    'DOUBLE_TOP':         'DBL_TOP',
    'DOUBLE_BOTTOM':      'DBL_BOT',
    'BEARISH_FLAG':       'BEAR_FLAG',
    'HIDDEN_LEVEL':       'HID_LVL',
    'ELLIOTT_STEP':       'ELLIOTT',
    'IMPULSE_BACK':      'IMP_BK',
    'IMPULSE_BACK_LATE': 'IMP_BK_L',
  };
  // Только день, без переключателя час/день (упрощено 2026-04-27).
  function renderSecCount(stats) {
    // «(N сегодня)» справа от заголовка «Все сетапы».
    // N = stats.total_today (matched setups за КАЛЕНДАРНЫЙ день МСК после фильтров).
    // НЕ total_matched (то — rolling 24h, захватывает вечер вчера → расходится
    // с таблицей). Fallback на total_matched для backtest-пути, где total_today нет.
    const el = document.getElementById('sec-count');
    if (!el) return;
    let n = 0;
    if (stats && typeof stats.total_today === 'number') n = stats.total_today;
    else if (stats && typeof stats.total_matched === 'number') n = stats.total_matched;
    el.textContent = ' (' + n + ' сегодня)';
    const navCount = document.getElementById('setups-today-count');
    if (navCount) navCount.textContent = el.textContent.trim();
  }

  // Подпись модели выхода снята 22.09.2026 (решение владельца): её место в
  // админском ряду занял переключатель единиц «₽ / %». Сама модель («стоп идёт
  // за ценой») работает как прежде — у всех ролей с 17.09; её сводка по-прежнему
  // приходит в ответе полем exit_model и видна в подсказке переключателя единиц.
  function renderExitModelNote() { /* удалено вместе с элементом */ }

  // ── Плашка «лучший детектор прошлой недели» (22.09.2026; с 25.09.2026 — всем) ──
  // Данные — netting.det_leader: сервер считает их на той же ленте, что сводку,
  // по настройкам того, кто смотрит, и отдаёт всем ролям. Величина —
  // деньги счёта за прошлую календарную неделю; процент — НА РАЗМЕР ПОЗИЦИИ
  // (владелец 22.09.2026), та же база, что у графика «Детекторы» и у строк
  // таблицы: одна и та же сделка больше не показывается в двух масштабах.
  // Неделя целиком бывает убыточной — тогда лидер «потерял меньше всех»
  // (решение владельца), иначе плашка врала бы про удачную неделю.
  function renderDetLeader() {
    const el = document.getElementById('det-leader');
    if (!el) return;
    // Вид «Сетапы» (27.10.2026): плашку считает страница по «Детекторам» вкладки — все детекторы и её ТФ (_ideasLeader);
    // пока их ответ за прошлую неделю в пути, плашка не меняется (заготовка первого кадра держит место)
    const _sv = _setupsView();
    if (_sv) _ideasLeaderRefresh();
    const L = _sv ? _ideasLeader() : (STATE.data && STATE.data.netting && STATE.data.netting.det_leader);
    if (_sv && !L && _ideasPrev.busy) return;
    // Заготовка первого кадра (класс det-leader-wait, 02.10.2026) живёт только до первых данных.
    el.classList.remove('det-leader-wait');
    el.removeAttribute('aria-hidden');
    if (!L || !L.type) { el.hidden = true; el.innerHTML = ''; return; }
    const name = TRIGGER_CARD_NAME[L.type] || TRIGGER_RU[L.type] || L.type;
    const pos = !!L.positive;
    const rub = Math.round(L.rub || 0);
    const pct = Number(L.pct || 0);
    // Деньги в плашке не показываем (владелец 22.09.2026): процент и подпись
    // читаются с одного взгляда, а рубли зависят от размера позиции и живут
    // в подсказке — там же, где период, число сделок и итог недели.
    el.innerHTML = '<span class="dl-ico">🏆</span>'
      + '<span class="dl-name">' + name + '</span>'
      + '<span class="dl-pct ' + (pos ? 'pos' : 'neg') + '">'
      + (pct >= 0 ? '+' : '−') + Math.abs(pct).toFixed(2) + '%</span>'
      + '<span class="dl-tag">'
      + (pos ? 'лучший детектор прошлой недели' : 'потерял меньше всех') + '</span>';
    const per = (L.since || '') + ' … ' + (L.until || '');
    // ⚠ В режиме «только проценты» денег нет вовсе: база плашки — 100 единиц
    // веса, и L.rub численно равен проценту. Рублёвую часть подсказки там не
    // печатаем, иначе получилось бы «заработал +28 ₽ на позицию 100 ₽».
    const _upct = !!STATE.unitsPct;
    const _money = _upct ? '' :
      ((rub >= 0 ? '+' : '−') + Math.abs(rub).toLocaleString('ru-RU') + ' ₽ (');
    // «Сетапы»: среди всех детекторов (как вкладка «Детекторы»), на ТФ её переключателя
    const _svWho = _sv ? ' среди всех детекторов' + (L.tf && L.tf !== 'both' ? ', ' + (TF_LABEL[L.tf] || L.tf) : '') : '';
    el.title = 'Лучший детектор прошлой недели (' + per + ')' + _svWho + ' при ТЕКУЩИХ настройках: '
      + name + ', ' + (pos ? 'заработал' : 'потерял меньше всех') + ' '
      + _money
      + (pct >= 0 ? '+' : '−') + Math.abs(pct).toFixed(2) + '%'
      + (_upct ? (L.inv ? ' — вклад в доход на вложенные' : ' — сумма процентов его сделок')
               : (' на размер позиции'
                  + (L.base_rub ? ' ' + Math.round(L.base_rub).toLocaleString('ru-RU') + ' ₽' : '') + ')'))
      + (L.trades ? ', сделок ' + L.trades : '') + '. '
      + 'Неделя целиком: '
      + (_upct ? '' : ((L.total_rub || 0) >= 0 ? '+' : '−')
                 + Math.abs(Math.round(L.total_rub || 0)).toLocaleString('ru-RU') + ' ₽ (')
      + ((L.total_pct || 0) >= 0 ? '+' : '−') + Math.abs(Number(L.total_pct || 0)).toFixed(2) + '%'
      + (_upct ? '. ' : '). ')
      + 'Клик — вкладка «Детекторы» за ту же неделю.';
    el.hidden = false;
  }

  // Клик по плашке: вкладка «Детекторы» на том же периоде, что показан в плашке.
  function openDetLeader(e) {
    if (e && e.preventDefault) e.preventDefault();
    STATE.detView = 'det';
    if (typeof setRangeDetectors === 'function') setRangeDetectors('prev');
  }

  function renderStats(stats) {
    renderExitModelNote();
    renderDetLeader();
    const root = document.getElementById('stats-items');
    if (!root) return;
    const parts = [];
    parts.push(`<span class="stats-text"><span class="matched-num">${stats.total_matched}</span> стратегий</span>`);
    const types = Object.entries(stats.by_trigger).sort((a,b) => b[1]-a[1]);
    for (const [tt, n] of types) {
      parts.push(`<span class="divider">·</span>`);
      const label = TRIGGER_SHORT_HDR[tt] || tt;
      parts.push(`<span><span class="hl">${n}</span> ${label}</span>`);
    }
    const html = parts.join('');
    if (window.innerWidth <= 900) {
      // Mobile: дублируем контент для бесшовного marquee loop, JS-driven scrollLeft
      root.innerHTML = `<div class="stats-marquee-inner">${html}<span class="stats-gap"></span>${html}<span class="stats-gap"></span></div>`;
      _setupMarqueeInteraction(root);
      _startMarquee(root);
    } else {
      _stopMarquee();
      root.innerHTML = html;
    }
  }

  // ── Marquee для mobile stats: JS-driven scrollLeft loop ──
  // Преимущества vs CSS animation: можно паузить на touch + ручной scroll
  // комбинируется естественно (scrollLeft — native scroll position).
  // Дубликат контента + reset scrollLeft на half = seamless loop.
  let _marqueeRAF = null;
  let _marqueeTouching = false;
  let _marqueeResumeTimer = null;
  const _MARQUEE_SPEED = 0.4;       // px per frame ≈ 24 px/sec на 60fps
  const _MARQUEE_RESUME_MS = 1500;  // пауза после release перед resume

  function _stopMarquee() {
    if (_marqueeRAF) cancelAnimationFrame(_marqueeRAF);
    _marqueeRAF = null;
  }
  function _startMarquee(root) {
    if (_marqueeRAF) return;  // already running
    function tick() {
      if (!_marqueeTouching && root.scrollWidth > root.clientWidth) {
        root.scrollLeft += _MARQUEE_SPEED;
        const half = root.scrollWidth / 2;
        if (root.scrollLeft >= half) root.scrollLeft -= half;
      }
      _marqueeRAF = requestAnimationFrame(tick);
    }
    _marqueeRAF = requestAnimationFrame(tick);
  }
  function _setupMarqueeInteraction(root) {
    if (root._marqueeListeners) return;
    root._marqueeListeners = true;
    function pause() {
      _marqueeTouching = true;
      if (_marqueeResumeTimer) { clearTimeout(_marqueeResumeTimer); _marqueeResumeTimer = null; }
    }
    function scheduleResume() {
      if (_marqueeResumeTimer) clearTimeout(_marqueeResumeTimer);
      _marqueeResumeTimer = setTimeout(() => { _marqueeTouching = false; }, _MARQUEE_RESUME_MS);
    }
    root.addEventListener('touchstart', pause, { passive: true });
    root.addEventListener('touchend', scheduleResume, { passive: true });
    root.addEventListener('touchcancel', scheduleResume, { passive: true });
    root.addEventListener('mousedown', pause);
    document.addEventListener('mouseup', scheduleResume);
    root.addEventListener('wheel', () => {
      pause();
      scheduleResume();
    }, { passive: true });
  }

  // ── Top cards ────────────────────────────────────
  // Сердечко избранного (guard: если favorites.js не загрузился — пусто).
  function _favHeart(tk) { return (window.Favorites && tk) ? Favorites.heartHtml(tk) : ''; }

  // ── Карточки и список — helpers + рендереры ───
  // Упрощённый consumer-facing вид: топ-карточки + горизонтальные карточки в листе.
  // Один вариант на сетап, без expand. Quality: солид/баланс/фрагиле через
  // border-color и мелкий text-label.

  // Префикс qual-* (не q-*) специально — глобальные .q-solid/.q-balanced/.q-fragile
  // выставляют background-color (это маленькие quality-кружки 7px). Light нужны
  // textual labels без background — изолируем через свой namespace.
  // Полное покрытие всех 5 категорий: с переходом filterForLight на avg_R>0
  // (2026-06-01) lottery/small_n с положительной ожидаемой доходностью теперь
  // могут попасть в Light (используется в fallback-пути renderListLight, когда
  // у ячейки нет r_distribution). Цвета — как у quality-точек.
  const LIGHT_QUALITY_CLASS = {
    solid:    'qual-solid',
    balanced: 'qual-balanced',
    lottery:  'qual-lottery',
    fragile:  'qual-fragile',
    small_n:  'qual-small_n',
  };

  /** Plain-language headline для строки списка.
   *  "Ложный пробой у 320.5 ₽ · с объёмом" / "Дивергенция RSI" / etc. */
  // Цвет имени сетапа = цвет стрелки входа на графике (web_app _TRIGGER_COLORS) —
  // для быстрой идентификации типа. DIVERGENCE → дефолт (белая стрелка = var(--text)).
  const SETUP_NAME_COLOR = {
    'FALSE_BREAKOUT_MTF': '#f48fb1',  // pink
    'STOP_HUNT_MTF':      '#90caf9',  // бледно-голубой
    'CLIMAX_MTF':         '#8c9eff',  // васильковый (17.09.2026: был amber #ffab40 — в одном тоне с фигурами и шагом Эллиотта)
    'CLEAN_BOUNCE_MTF':   '#a5d6a7',  // mint green — отбой от уровня
    // фигурные (журнал пресета): те же цвета, что у маркеров на графике,
    // иначе строка и стрелка одного сетапа выглядели бы разными сущностями
    'BEARISH_FLAG':       '#e040fb',  // пурпурный — медвежий флаг
    'DOUBLE_BOTTOM':      '#ffc107',  // amber — фигура двойного дна
    'DOUBLE_TOP':         '#ff8a65',  // коралловый — двойная вершина (17.09.2026: был #ffc107, тот же цвет, что у двойного дна)
    'HIDDEN_LEVEL':       '#26c6da',  // cyan — зона паузы внутри импульса
    'ELLIOTT_STEP':       '#d4e157',  // лаймовый — та же зона, вход по продолжению (17.09.2026: был orange #ffa726, неотличим от климакса)
    'IMPULSE_BACK':      '#1de9b6',  // аквамарин — откат к импульсной свече (06.10.2026)
    'IMPULSE_BACK_LATE': '#b388ff',  // лавандовый — поздний откат, 4Ч
    // DIVERGENCE в карте отсутствует намеренно → белый (как треугольник на графике)
  };
  // Цена входа сделки — тем же правилом, что деньги витрины и маркер входа на
  // графике (moex_lots.resolve_entry_price на сервере): ФАКТ из
  // trade_params.entry (`tp_entry`: у входа по рынку — открытие следующего бара,
  // резолвер дописывает его раз в час; у лимитных — цена заявки), и только если
  // его нет — прокси `entry_price` (закрытие сигнального бара). До 11.09 строка
  // показывала прокси, и серую цену читали как вход: у OZON HIDDEN_LEVEL 2519 при
  // фактических 2483, от которых и посчитан результат строки.
  function _entryPx(t) {
    if (!t) return null;
    const vals = [t.tp_entry, t.entry_price];
    for (let i = 0; i < vals.length; i++) {
      if (vals[i] == null || vals[i] === '') continue;
      const n = Number(vals[i]);
      if (isFinite(n) && n > 0) return n;
    }
    return null;
  }
  // Формат — общий с подписью «вход» на панели графика (TaChart.fmtPrice):
  // строка и график обязаны округлять одну цену одинаково.
  function _fmtEntryPx(p) {
    return (window.TaChart && TaChart.fmtPrice) ? TaChart.fmtPrice(p) : Number(p).toFixed(2);
  }
  // Подсказка выхода по правилу «Разворот рынка» (галочка админа, обкатка №188, 16.10.2026): к какому концу часа и
  // насколько рынок откатил от лучшей для шорта точки, где выход и чем кончилась бы сделка без правила
  // (t.mr_exit — market_reversal.apply_exits).
  function _mrevTip(t) {
    const m = t && t.mr_exit;
    if (!m) return 'Шорт закрыт правилом «Разворот рынка»';
    const o = m.orig || {};
    const pct = v => String(Number(v).toFixed(2)).replace('.', ',') + NBSP + '%';
    const was = (o.exit_price == null) ? 'без правила сделка ещё открыта'
      : 'без правила — выход' + (R_OUTCOME_RU[o.r_outcome] ? ' (' + R_OUTCOME_RU[o.r_outcome] + ')' : '')
        + (o.exit_at ? ' ' + fmtCardTime(o.exit_at) : '') + ' по' + NBSP + _fmtEntryPx(o.exit_price);
    return 'Разворот рынка: равновзвешенный рынок ликвидных бумаг к ' + fmtCardTime(m.T) + ' откатил от лучшей для шорта'
      + ' точки после входа на ' + pct(m.b) + ' (порог 1,5' + NBSP + '%) — выход по рынку ' + fmtCardTime(m.at)
      + ' по' + NBSP + _fmtEntryPx(m.px) + (m.src === 'h1' ? ' (пятиминутки нет — закрытие часа)' : '') + '; ' + was;
  }
  // Типы с ЛИМИТНЫМ входом внутри сигнального бара — зеркало moex_lots.LIMIT_ENTRY_TYPES
  // (двойные вершина/дно — по линии шеи) + «скрытый уровень» (заявка на границе зоны,
  // entry_intrabar в trade_params). Остальные входят по рынку на открытии следующего бара.
  const _LIMIT_ENTRY_TYPES = new Set(['DOUBLE_TOP', 'DOUBLE_BOTTOM', 'HIDDEN_LEVEL']);
  // Сигнальный бар строкой «DD.MM HH:00–HH:00» и момент его закрытия «DD.MM HH:00» — для подсказок у цены
  // и у времени входа (одно правило: у блока 04:00–08:00 начало — первый торговый час, _dispBarDate).
  function _sigBarParts(t) {
    const tfH = String((t && t.tf) || '1h') === '4h' ? 4 : 1;
    const raw = String((t && t.bar_date) || '');
    const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/);
    const disp = String(_dispBarDate(t) || raw).match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})/);
    let barTxt = '', closeTxt = '';
    if (m) {
      const closeH = (parseInt(m[4], 10) + tfH) % 24;
      const hh = h => String(h).padStart(2, '0') + ':00';
      closeTxt = m[3] + '.' + m[2] + ' ' + hh(closeH);
      barTxt = m[3] + '.' + m[2] + ' ' + (disp ? disp[4] : m[4]) + ':00–' + hh(closeH);
    }
    return { barTxt, closeTxt };
  }
  // Подсказка у цены входа. Главное в ней — МОМЕНТ входа (до 02.10.2026 колонка «Время» показывала
  // НАЧАЛО сигнального бара, и «08:00 · 46.10 ₽» читалось как «цена 46.10 в 08:00» — ABIO STOP_HUNT 4ч
  // 11.09: бар 08:00–12:00, вход 12:00; теперь колонка «Вход» показывает сам момент входа).
  function _entryPxTip(t, mi) {
    const { barTxt, closeTxt } = _sigBarParts(t);
    const tail = ' От входа считаются доходность и стоп.';
    if (mi && mi.r_outcome === 'CANCELED' && t && t.m1_skip_why) {
      return 'Сделка не открылась: ' + t.m1_skip_why + '. Показана плановая цена входа.';
    }
    if (t && t.m1_entry_at && !(mi && mi.r_outcome === 'CANCELED')) {
      return 'Цена входа по рынку на минуте после публикации сетапа (' + fmtCardTime(String(t.m1_entry_at).substring(0, 16))
        + '): открытие этой минуты.' + tail;
    }
    if (mi && mi.r_outcome === 'CANCELED') {
      return 'Сделка не открылась: гэп на открытии следующего бара' + (closeTxt ? ' (' + closeTxt + ')' : '')
        + '. Показана цена закрытия сигнального бара' + (barTxt ? ' ' + barTxt : '') + '.';
    }
    if (_LIMIT_ENTRY_TYPES.has(String((t && t.trigger_type) || '').replace('_MTF', ''))) {
      return 'Цена входа лимитной заявкой внутри сигнального бара' + (barTxt ? ' ' + barTxt : '')
        + ' (двойные вершина/дно — по линии шеи, скрытый уровень — на границе зоны).' + tail;
    }
    if (t && (t.tp_entry == null || t.tp_entry === '')) {
      return 'Сделка ещё не открылась: показана цена закрытия сигнального бара' + (barTxt ? ' ' + barTxt : '')
        + '. Вход будет по рынку на открытии следующего бара' + (closeTxt ? ' (' + closeTxt + ')' : '') + '.' + tail;
    }
    return 'Цена входа по рынку' + (closeTxt ? ' ' + closeTxt : '') + ': открытие бара, следующего за сигнальным'
      + (barTxt ? ' (' + barTxt + ')' : '') + '.' + tail;
  }
  // Подсказка у времени в колонке «Вход» (02.10.2026, решение владельца). Сервер присылает entry_time — момент
  // входа — и entry_how: fill — пятиминутка исполнения лимитки внутри сигнального бара; fill_bar — лимитка,
  // пятиминутка ещё не определена (показано начало бара); next — открытие бара после сигнального; next_session —
  // первые торги после перерыва (ночь, выходные); pending — свечи входа ещё нет, показано ожидаемое открытие.
  function _entryTimeTip(t, mi) {
    const { barTxt } = _sigBarParts(t);
    const tfL = String((t && t.tf) || '1h') === '4h' ? '4ч' : '1ч';
    const bar = barTxt ? ' Сигнальный ' + tfL + '-бар: ' + barTxt + '.' : '';
    const at = fmtCardTime(t && t.entry_time);
    if (!t || !t.entry_time) return barTxt ? 'Начало сигнального ' + tfL + '-бара: ' + barTxt + '.' : '';
    if (mi && mi.r_outcome === 'CANCELED' && t.m1_skip_why) {
      return 'Сделка не открылась: ' + t.m1_skip_why + ' (вход был бы ' + at + ').' + bar;
    }
    if (mi && mi.r_outcome === 'CANCELED') {
      return 'Сделка не открылась: гэп на открытии бара после сигнального (' + at + ').' + bar;
    }
    switch (t.entry_how) {
      case 'm1': return 'Вход ' + at + ' — по рынку на минуте после публикации сетапа (минутная модель).' + bar;
      case 'fill': return 'Вход ' + at + ' — лимитная заявка исполнилась внутри сигнального бара.' + bar;
      case 'fill_bar': return 'Вход лимитной заявкой внутри сигнального бара, пятиминутка исполнения ещё не определена.' + bar;
      case 'next_session': return 'Вход ' + at + ' — первые торги после сигнального бара (ночью и в выходные торгов нет).' + bar;
      case 'pending': return 'Вход ожидается ' + at + ' — по рынку на открытии бара после сигнального.' + bar;
      default: return 'Вход ' + at + ' — по рынку на открытии бара после сигнального.' + bar;
    }
  }
  // Ячейка «Сетап» — две строки (05.10.2026, решение владельца: колонке не хватало ширины): первая —
  // название и бейджи (buildLightHeadline + бейджи в rowHtml), вторая — вход (buildEntryLine).
  function buildLightHeadline(trigger, finalDir, mi) {
    // Название сетапа — английское, как в сайдбаре «Тип детектора» (DB-тип без _MTF).
    const name = String(trigger.trigger_type || '').replace('_MTF', '');
    const nameColor = SETUP_NAME_COLOR[trigger.trigger_type] || '';
    return '<span class="hl-name"' + (nameColor ? ' style="color:' + nameColor + '"' : '') + '>' + name + '</span>';
  }
  function buildEntryLine(trigger, mi) {
    const _epx = _entryPx(trigger);
    const ep = _epx != null ? _fmtEntryPx(_epx) : null;
    // Volume tag из confluence_factors
    const factors = String(trigger.confluence_factors || '').split(',').map(s => s.trim()).filter(Boolean);
    const hasVol = factors.some(f => /vol/i.test(f) || /объ[её]м/i.test(f));
    const parts = [];
    if (ep)     parts.push('<span class="hl-lvl" title="' + _entryPxTip(trigger, mi) + '">вход' + NBSP + ep + NBSP + '₽</span>');
    if (hasVol) parts.push('<span class="hl-lvl">с' + NBSP + 'объёмом</span>');
    return parts.length ? '<span class="hl-l2">' + parts.join('<span class="hl-lvl"> · </span>') + '</span>' : '';
  }
  // Колонка «Закрыт» в «Истории сделок» (05.10.2026): момент закрытия позиции на едином счёте — минута выхода у минутной
  // модели, пятиминутка у прочих (net.deal.close_at, setups_netting.deal_close_at, 28.10.2026). По его дню сделка
  // отнесена к неделе «Истории недель».
  // На телефоне шапки нет — ячейка встаёт строкой под результатом, с подписью «закрыта».
  function _dealsExitCell(mi) {
    // «История сетапов» вида «Сетапы» (27.10.2026): момент закрытия сетапа по модели (выход модели — то же правило, что у
    // «Истории сделок»: setups_netting.idea_history → deal_close_at)
    if (mi.idea) {
      if (!mi.idea.close_at) return '<div class="row-l-exit"></div>';
      const xw = R_OUTCOME_RU[mi.r_outcome] ? ', выход: ' + R_OUTCOME_RU[mi.r_outcome] : '';
      return '<div class="row-l-exit" title="' + _esc('Сетап закрылся ' + fmtCardTime(mi.idea.close_at) + xw) + '">'
        + '<span class="ex-lbl">закрыт' + NBSP + '</span>' + fmtTime(mi.idea.close_at) + '</div>';
    }
    const n = mi.net || {}, d = n.deal || mi.gdeal || {};
    if (!d.close_at) return '<div class="row-l-exit"></div>';
    if (mi.gdeal && !n.deal) {           // «не торгуем»: сделки на счёте не было — момент, когда закрылась бы
      return '<div class="row-l-exit" title="' + _esc('Не торговали: по модели витрины сделка закрылась бы '
        + fmtCardTime(d.close_at)) + '"><span class="ex-lbl">закрылась бы' + NBSP + '</span>' + fmtTime(d.close_at) + '</div>';
    }
    const why = n.event === 'stop_moved' ? 'стоп перенесён докупкой'
              : (n.event === 'reversal_close' ? 'закрыта встречным сигналом'
                 : (R_OUTCOME_RU[mi.r_outcome] ? 'выход: ' + R_OUTCOME_RU[mi.r_outcome] : ''));
    const tip = 'Позиция закрыта на счёте ' + fmtCardTime(d.close_at) + (why ? ', ' + why : '')
      + '. По дню закрытия сделка входит в неделю «Истории недель»';
    return '<div class="row-l-exit" title="' + _esc(tip) + '"><span class="ex-lbl">закрыта' + NBSP + '</span>'
      + fmtTime(d.close_at) + '</div>';
  }

  // Распределение исходов на 100 сделок (per-cell). Бэкенд отдаёт 6 бакетов
  // (loss/r01/r12/r23/r35/r5) с {cnt: сделок на 100, avg: средний R}. Якорь
  // exp_r_100 = mean_R × 100.
  //   Бар (визуал) — 4 сегмента целыми границами: Убыток / 0–1R / 1–2R / 2R+
  //   (2R+ = r23+r35+r5). Tooltip — все 6 строк с колонкой «Вклад» (cnt×avg),
  //   сумма которой == exp_r_100.
  const RDIST_BAR_SEGS = [
    { keys: ['loss'],              cls: 'seg-loss', label: 'Убыток' },
    { keys: ['r01'],               cls: 'seg-r1',   label: '0–1R'   },
    { keys: ['r12'],               cls: 'seg-r2',   label: '1–2R'   },
    { keys: ['r23','r35','r5'],    cls: 'seg-r3',   label: '2R+'    },
  ];
  const RDIST_LEDGER = [
    { key: 'loss', cls: 'seg-loss', label: 'Убыток' },
    { key: 'r01',  cls: 'seg-r1',   label: 'до 1R'  },
    { key: 'r12',  cls: 'seg-r2',   label: '+1–2R'  },
    { key: 'r23',  cls: 'seg-r3',   label: '+2–3R'  },
    { key: 'r35',  cls: 'seg-r3',   label: '+3–5R'  },
    { key: 'r5',   cls: 'seg-r3',   label: '≥5R'    },
  ];

  /** Якорь-текст «ожидаем +XR на 100 сделок». */
  function fmtExpR(rd) {
    const v = Number(rd.exp_r_100) || 0;
    return (v >= 0 ? '+' : '') + v.toFixed(1) + 'R';
  }

  /** HTML tooltip-таблицы (6 строк, колонка Вклад = cnt×avg, ИТОГО = exp_r_100).
   *  Рендерится скрытым в карточке/строке, показывается по hover через CSS. */
  /** Длина серии для строки «Серия N · вероятность ~X%» — из payload (SSOT
   *  setup_stats.SERIES_N), fallback 20. */
  function _seriesN() { return (STATE.data && STATE.data.series_n) || 20; }

  /** Tooltip-объяснение метрик «Потенциал / Серия» (заменил разбивку по бакетам).
   *  series = {potential, prob20}; rd.n — размер выборки для «проверено на N». */
  function buildRdistTooltip(rd, series) {
    const sn = _seriesN();
    const n = rd && rd.n != null ? Math.round(Number(rd.n)) : null;
    const rows = [];
    if (series && series.potential != null) {
      rows.push(`<div><b>Потенциал ${series.potential.toFixed(2)}R</b></div>`);
    }
    if (series && series.prob20 != null) {
      rows.push(`<div>Вероятность ≈${series.prob20}% на&nbsp;${sn} сделок</div>`);
    }
    rows.push(`<div>Стоп 1R на&nbsp;структуре</div>`);
    if (n) {
      rows.push(`<div class="rt-note">Проверено бэктестом на&nbsp;${n.toLocaleString('ru-RU')} сетапах</div>`);
    }
    return `<div class="rdist-tip rdist-tip-text">${rows.join('')}</div>`;
  }

  /** Сумма cnt по списку ключей бакетов (raw, для расчёта ширин бара). */
  function _rdistSegPct(rd, keys) {
    const b6 = rd.buckets6 || {};
    return keys.reduce((s, k) => s + (Number(b6[k] && b6[k].cnt) || 0), 0);
  }

  // Маркетинговая визуальная корректировка ширины сегментов бара (ТОЛЬКО визуал;
  // числа — реальные). Убыточный сегмент сжимается множителем _RDIST_LOSS_SHRINK
  // (50/90 ≈ 0.556 → убыток 60% рисуется как ~33%), прибыльные расширяются,
  // заполняя освободившееся место и сохраняя пропорции между собой. Раньше был
  // 50/60 (≈0.833) — уменьшен ~в 1.5 раза вместе с переходом на формат «Потенциал».
  const _RDIST_LOSS_SHRINK = 50 / 90;
  function _rdistBarWidths(rd) {
    const segLoss = _rdistSegPct(rd, ['loss']);
    const segR1   = _rdistSegPct(rd, ['r01']);
    const segR2   = _rdistSegPct(rd, ['r12']);
    const segR3   = _rdistSegPct(rd, ['r23', 'r35', 'r5']);
    const total = segLoss + segR1 + segR2 + segR3;
    if (total <= 0) return { 'seg-loss': 1, 'seg-r1': 0, 'seg-r2': 0, 'seg-r3': 0 };
    const dispLoss = (segLoss / total) * _RDIST_LOSS_SHRINK;  // сжатый убыток (доля)
    const profitSum = segR1 + segR2 + segR3;
    if (profitSum <= 0) return { 'seg-loss': 1, 'seg-r1': 0, 'seg-r2': 0, 'seg-r3': 0 };
    const remaining = 1 - dispLoss;                            // место под прибыль
    return {
      'seg-loss': dispLoss,
      'seg-r1': (segR1 / profitSum) * remaining,
      'seg-r2': (segR2 / profitSum) * remaining,
      'seg-r3': (segR3 / profitSum) * remaining,
    };
  }

  /** Ширины сегментов бара из survival-значений ПОПАПА (loss_p + P≥1/≥2) — бар
   *  согласован с лестницей. Красная зона сжата тем же _RDIST_LOSS_SHRINK
   *  («индекс» убытка сохранён). null если нет survival → fallback на rd-бакеты. */
  function _survBarWidths(series) {
    if (!series || !series.survival || series.loss_p == null) return null;
    const sp = {};
    series.survival.forEach(x => { sp[x.r] = x.p; });
    if (sp[0] == null || sp[1] == null || sp[2] == null) return null;
    const segLoss = series.loss_p;
    const segR1 = Math.max(0, sp[0] - sp[1]);   // [0,1R)
    const segR2 = Math.max(0, sp[1] - sp[2]);   // [1,2R)
    const segR3 = sp[2];                          // 2R+
    const total = segLoss + segR1 + segR2 + segR3;
    if (total <= 0) return { 'seg-loss': 1, 'seg-r1': 0, 'seg-r2': 0, 'seg-r3': 0 };
    const dispLoss = (segLoss / total) * _RDIST_LOSS_SHRINK;
    const profitSum = segR1 + segR2 + segR3;
    if (profitSum <= 0) return { 'seg-loss': 1, 'seg-r1': 0, 'seg-r2': 0, 'seg-r3': 0 };
    const remaining = 1 - dispLoss;
    return {
      'seg-loss': dispLoss,
      'seg-r1': (segR1 / profitSum) * remaining,
      'seg-r2': (segR2 / profitSum) * remaining,
      'seg-r3': (segR3 / profitSum) * remaining,
    };
  }

  // [SSOT 2026-07-01] Клиентские лестницы _survProbAt / buildSurvivalLadderLA /
  // buildSurvivalLadder удалены — расчёт целевой лестницы теперь ТОЛЬКО на сервере
  // (setup_stats.build_target_ladder, общий с TG), рендер — _renderServerLadder.

  /** Колонка «Потенциал» в строке (открытые сетапы). Инлайн = направление (медиум
   *  ЛОНГ/ШОРТ) + бар на survival-значениях попапа; сам потенциал целиком в попапе
   *  по клику/hover (админ — лестница цен, иначе текстовый tooltip). */
  // Формат цены/RR — тот же, что в лестнице и в TG (_fmt_px_ladder/_fmt_rr, scan.py).
  function _fpxRow(p) { const a = Math.abs(p); return a >= 100 ? p.toFixed(1) : a >= 1 ? p.toFixed(2) : p.toFixed(4); }
  function _fmtRRow(r) { return (Math.abs(r - Math.round(r)) < 0.05) ? String(Math.round(r)) : r.toFixed(1); }

  // Витрина «как в TG» (2026-07-20): вместо попапа-лестницы — понятные числа в строке.
  // Цель/Стоп/RR приходят ГОТОВЫМИ с сервера (trig_json.dispatch_target, посчитаны
  // при эмиссии) → сайт и рассылка совпадают по построению. «В плюсе» = series.win_p
  // (gross, БЕЗ CANCELED — до комиссии брокера, см. подсказку).
  // ОТКАТ: LADDER_POPUP = true → прежний попап-лестница (старый код сохранён ниже).
  const LADDER_POPUP = false;

  /** Метка неттинга для строки: чем сделка стала на едином счёте. */
  // ── Неоткрытые капитал-пулом ────────────────────────────────────────────
  // ⚠ Пометку берём НЕ из строки, а из сводки последнего ответа. Причина: лента,
  // на которой считается пул, зависит от фильтров запроса — данные качаются без
  // фильтра типов (клиентская фильтрация показа), агрегаты (slim) считаются по
  // выбранным детекторам. Пометка в строке приходит из широкой ленты, где
  // капитал занимают в том числе снятые детекторы, — из-за этого на экране
  // соседствовали «Пропущено 0» и приглушённые строки (репорт владельца 29.08).
  // Источник правды — `netting.skipped_keys` последнего ответа: он посчитан по
  // той же вселенной, что и карточка «Доход недели».
  var _skipKeysSrc = null, _skipKeysSet = null;
  function _skipKeys() {
    const arr = (STATE.data && STATE.data.netting && STATE.data.netting.skipped_keys) || null;
    if (arr !== _skipKeysSrc) { _skipKeysSrc = arr; _skipKeysSet = arr ? new Set(arr) : null; }
    return _skipKeysSet;
  }
  /** Сделку капитал-пул не открыл (в выбранной вселенной детекторов). */
  function _noCap(net) {
    if (!net) return false;
    const ks = _skipKeys();
    if (ks && net.k) return ks.has(net.k);   // сводка знает точно
    return !!net.no_capital;                 // старый ответ без ключей — как было
  }

  // Коды пропуска слоя счёта (forward_portfolio.pf_skip): подпись бейджа, причина для
  // колонки «Доходность» и подсказка — одна таблица на бейдж и ячейку «не открыта».
  // До 11.09 здесь не было 'opposite_while_open' — основного кода витрины с перехода
  // на правило «без переворота» (08.09), и строки показывали сырой код.
  const _NET_SKIP = {
    no_entry:              { badge: 'нет цены входа', why: 'нет цены входа' },
    capital:               { badge: 'не хватило капитала', why: 'не хватило капитала' },
    opposite_while_open:   { badge: 'пропущен: открыта встречная позиция', why: 'есть встречная позиция',
                             tip: 'Встречный сигнал при открытой позиции: по правилу счёта позиция не ' +
                                  'переворачивается, сделка не открывалась и в доход не идёт' },
    opposite_while_profit: { badge: 'пропущен: позиция в прибыли', why: 'встречная позиция в прибыли' },
    opposite_vetoed:       { badge: 'пропущен: переворот запрещён', why: 'переворот запрещён' },
    add_in_loss:           { badge: 'пропущен: докупка в убытке', why: 'докупка в убытке',
                             tip: 'Докупка шорта, когда открытая позиция по бумаге в минусе или в нуле: счёт не ' +
                                  'усредняет убыточные шорты (правило с 21.10.2026), сделка не открывалась и в доход не идёт' },
    add_unprotected:       { badge: 'пропущен: докупку нельзя защитить', why: 'докупку нельзя защитить' },
    chain_depth:           { badge: 'пропущен: предел докупок', why: 'предел докупок' },
  };
  const _NET_NOCAP_TIP = 'Сетап был, но на момент входа не хватило свободного капитала — ' +
                         'сделка не открылась и в доход не идёт';
  const _NET_SKIP_TIP = 'Сделка на едином счёте не открылась';

  /** Почему сделки нет на едином счёте: {why, tip} или null, если счёт её открыл.
   *  Один ответ на вопрос «была ли сделка» для бейджа, строки и колонки «Доходность»
   *  (14.09: строка решала это своим пулом капитала и спорила с «Доходом недели»). */
  function _netNotOpened(net) {
    if (!net) return null;
    // Режим «только пропущенные встречные»: такая сделка показывается со своим исходом —
    // как если бы её взяли отдельно (ради этого вопроса режим и включают).
    if (STATE.oppSkipOnly && net.skip === 'opposite_while_open') return null;
    if (_noCap(net)) return { why: 'не хватило капитала', tip: _NET_NOCAP_TIP };
    if (net.status === 'opened') return null;
    const s = _NET_SKIP[net.skip] || {};
    return { why: s.why || 'сделка не открылась', tip: s.tip || _NET_SKIP_TIP };
  }

  /** Под названием стоит бейдж пропуска (_nettingBadge — те же условия): причину, почему
   *  сделки нет на счёте, он уже называет, и «Доходность» её не повторяет (28.09.2026). */
  function _netSkipBadged(net) {
    return !!net && (_noCap(net) || !!net.skip);
  }

  /** «Не торгуем» (20.10.2026, setup_gates): сетап снят правилом витрины — подсказка: правило, его причина и прочие
   *  сработавшие правила; строка показана для сравнения, в счёт и суммы не входит. */
  function _gatedTip(g) {
    var others = (g.all || []).filter(function (x) { return x !== g.label; });
    return 'Не торгуем — ' + (g.name || g.label) + (g.why ? ' (' + g.why + ')' : '') + '.'
      + (others.length ? ' Сработали и другие правила: ' + others.join(', ') + '.' : '')
      + ' Сетап показан для сравнения: чем он кончился бы, видно, но в счёт и в доход он не входит.';
  }

  /** Вид «Сетапы» (27.10.2026, решение владельца): правила витрины — только для портфеля; снятый ими сетап считается, как
   *  все, метка лишь поясняет, почему его нет в портфеле. */
  function _gatedIdeaTip(g) {
    var others = (g.all || []).filter(function (x) { return x !== g.label; });
    return 'Портфель этот сетап не берёт — ' + (g.name || g.label) + (g.why ? ' (' + g.why + ')' : '') + '.'
      + (others.length ? ' Сработали и другие правила: ' + others.join(', ') + '.' : '')
      + ' В «Сетапах» он считается, как все: у каждого сетапа свой результат.';
  }

  function _nettingBadge(mi) {
    const _g = mi && mi.trigger && mi.trigger.gated;
    if (_g && _setupsView()) return '<span class="net-badge net-skip gated-badge" title="' + _esc(_gatedIdeaTip(_g))
      + '">портфель не берёт: ' + _esc(_g.label) + '</span>';
    if (_g) return '<span class="net-badge net-skip gated-badge" title="' + _esc(_gatedTip(_g)) + '">не торгуем: '
      + _esc(_g.label) + '</span>';
    const n = mi && mi.net;
    if (!n) return '';
    // Капитала не хватило: сделки не было. Строку не прячем — приглушаем и
    // помечаем (как в журнале /ml-setups), чтобы человек видел, что сетап был,
    // но его не потянул депозит.
    if (_noCap(n))
      return '<span class="net-badge net-skip" title="' + _NET_NOCAP_TIP + '">не хватило капитала</span>';
    if (n.skip) {
      const s = _NET_SKIP[n.skip] || {};
      return '<span class="net-badge net-skip" title="' + (s.tip || _NET_SKIP_TIP) + '">' +
             (s.badge || 'пропущен') + '</span>';
    }
    if (n.event === 'reversal_close')
      return '<span class="net-badge" title="Позицию закрыл встречный сигнал по своей цене входа">закрыто встречным</span>';
    if (n.event === 'stop_moved')
      return '<span class="net-badge" title="После докупки стоп переехал на уровень последнего входа — исход пересчитан">стоп перенесён</span>';
    if (n.event === 'stop_move_pending')
      return '<span class="net-badge" title="Стоп перенесён, сделка ещё в рынке">стоп перенесён · в рынке</span>';
    if (n.event === 'move_not_simulated')
      return '<span class="net-badge net-warn" title="Перенос стопа не смоделирован: цена уже касалась нового уровня до переноса. Оставлен исходный исход">перенос не учтён</span>';
    return '';
  }

  function buildRdistInline(rd, series, direction, target) {
    const dir = direction === 'LONG' ? 'ЛОНГ' : (direction === 'SHORT' ? 'ШОРТ' : '');
    if (!LADDER_POPUP) {
      // Две строки: (1) направление + RR — характеристика сделки; (2) конкретные
      // уровни Цель/Стоп. «В плюсе» живёт в колонке «Выборка» (рядом со своей базой N).
      const rr = (target && target.rr != null)
        ? `<span class="tgt-rr">RR&nbsp;1:${_fmtRRow(target.rr)}</span>` : '';
      const dirLbl = (dir || rr)
        ? `<div class="row-l-dir ${direction === 'LONG' ? 'rld-long' : 'rld-short'}">${dir}${rr}</div>` : '';
      let nums = '';
      if (target && target.price != null) {
        const pctTxt = (target.pct != null)
          ? ` <b class="tgt-pct">(${target.pct >= 0 ? '+' : '−'}${Math.abs(target.pct).toFixed(1)}%)</b>` : '';
        // Стоп в тексте убран (2026-07-20): он и так на графике красной линией у
        // каждого тикера + косвенно виден из RR. Облегчаем карточку.
        // Цель самой сделки (у ячейки с малой выборкой нет цели по уровням) — подсказка говорит, откуда она.
        const tgtTip = (target.src === 'trade')
          ? ` title="Цель сделки: ${target.rr != null ? _fmtRRow(target.rr) + 'R' : 'тейк'} от стопа — здесь сделка фиксирует прибыль и включает трейл. `
            + `Цели по уровням нет: в ячейке мало сделок для статистики"` : '';
        nums = `<div class="row-l-tgt"${tgtTip}>`
          + `<span class="tgt-goal">Цель ${_fpxRow(target.price)}${pctTxt}</span>`
          + `</div>`;
      }
      return `<div class="rdist-anchor">${dirLbl}${nums}</div>`;
    }
    // ── ниже — ПРЕЖНИЙ попап-лестница (живёт только при LADDER_POPUP = true) ──
    // Бар: survival-значения попапа (красная зона сжата); fallback на rd-бакеты.
    const w = _survBarWidths(series) || ((rd && rd.buckets6) ? _rdistBarWidths(rd) : null);
    let bar = '';
    if (w) {
      const segs = RDIST_BAR_SEGS.map(s =>
        `<div class="rdist-seg ${s.cls}" style="flex:${((w[s.cls] || 0) * 100).toFixed(2)}"></div>`).join('');
      bar = `<div class="rdist-bar">${segs}</div>`;
    }
    // Попап по КЛИКУ: лестница целевых цен строится ЛЕНИВО (level-aware, на MTF-уровнях
    // открытого графика) — здесь пустой плейсхолдер surv-tip[data-la], заполняется
    // обработчиком клика / хуком загрузки графика (_fillOpenLadder). Fallback (нет
    // survival/цен — N<40 или нет tp_entry/sl) — текстовый tooltip как раньше (level не нужен).
    const hasLadder = !!(series && series.survival && series.survival.length
                         && series.survival[0].price != null && series.loss_price != null);
    let tip = hasLadder ? `<div class="rdist-tip surv-tip" data-la="1"></div>`
                        : ((rd && rd.buckets6) ? buildRdistTooltip(rd, series) : '');
    // Хинт «см. потенциал »» справа от направления — только когда есть попап.
    // Desktop-only (на mobile скрыт через CSS — нет места рядом с баром в одной строке).
    const hint = (dir && tip)
      ? `<span class="surv-hint">см.&nbsp;потенциал&nbsp;<b class="surv-hint-arr">»</b></span>` : '';
    const dirLbl = dir
      ? `<div class="row-l-dir ${direction === 'LONG' ? 'rld-long' : 'rld-short'}">${dir}${hint}</div>` : '';
    return `<div class="rdist-anchor" tabindex="0">${dirLbl}${bar}${tip}</div>`;
  }

  /** Фильтр для Light: убираем lottery + small_n (низкое качество). */
  // Light отбирает сетапы по ОЖИДАЕМОЙ ДОХОДНОСТИ (avg_R best-варианта), а не по
  // quality-метке. Прежний критерий (q !== 'lottery' && q !== 'small_n') был
  // слепым: аналитика 5 pickle'ов (2026-06-01) показала, что lottery+small_n в
  // 4 из 5 триггеров дают ПОЛОЖИТЕЛЬНЫЙ avg_R (DIVERGENCE lottery +0.30R,
  // STOP_HUNT lottery +0.18R, VSA — вообще ТОЛЬКО lottery/small_n со средним
  // +0.97R, в Light они были полностью скрыты). Quality отражает WR+N, но не
  // expectancy: lottery = низкий WR при положительном R через трейл-хвост.
  // Критерий avg_R > 0 структурно корректен — ловит реально убыточные ячейки
  // (VWAP_REV small_n = −0.22R, 50% выборки) и пропускает прибыльные edge'и
  // независимо от метки. oos_er == is_er == avg_r ячейки (см. catalog_matcher
  // _format_*_variants). variants[0] — best-вариант (sort by quality+oos_er),
  // именно его якорь «+XR на 100 сделок» видит пользователь. Fail-open на NaN:
  // скрываем только когда уверены, что expectancy ≤ 0.
  // Порог «слабого» сетапа: доля прибыльных отдельных сделок (win_p) ниже этого
  // значения → чекбокс «Выкл слабые» его убирает. Тот же порог на сервере
  // (_WEAK_WIN_P) для вкладки «Нед» — иначе таблица и недели разъедутся.
  const WEAK_WIN_P = 51;

  function filterForLight(items) {
    return (items || []).filter(mi => {
      if (!mi || !mi.best) return false;
      const er = Number(mi.best.oos_er);
      return isNaN(er) || er > 0;
    });
  }

  /** Строки, которые СЕЙЧАС видит пользователь в таблице.
   *  Единый источник для рендера и для карточки «Доход» — иначе они расходятся
   *  (баг 2026-08-17: доход считался по полному table, а таблица показывала
   *  отфильтрованное → у DOUBLE_BOTTOM 6 строк в списке против 8 в доходе,
   *  скрытые PLZL/VTBR с oos_er<0 давали −1024 ₽ «из ниоткуда»). */
  /** Выбранные таймфреймы — читаем ЖИВЫЕ чекбоксы (как у типов сетапов:
   *  STATE.filters фиксируется на инициализации и не отражает кликов).
   *  null = блока нет (не-админ) либо выбрано всё → фильтр не нужен. */
  function _selectedTfs() {
    const boxes = document.querySelectorAll('#f-triggers input[type="checkbox"][data-tt]');
    if (!boxes.length) return null;
    const on = new Set(Array.from(boxes).filter(b => b.checked).map(b => b.dataset.tf));
    return on.size >= TIMEFRAMES_ALL.length ? null : on;
  }

  /** Фильтр по ТФ применяем НА КЛИЕНТЕ: ответ /api/setups занимает 5-8 секунд,
   *  и без этого таблица с «Доходом» обновлялись бы с задержкой — непонятно,
   *  применился ли клик. Данные обоих ТФ уже в STATE.data, поэтому режем сразу,
   *  а серверный запрос идёт следом и уточняет агрегаты (топ, статистика, счётчики). */
  function _filterByTf(items) {
    const tfs = _selectedTfs();
    if (!tfs) return items;
    return (items || []).filter(mi => {
      const t = mi && mi.trigger;
      return tfs.has(String((t && t.tf) || '1h'));
    });
  }

  /** DB-тип → UI-тип (обратный к _UI_TO_DB_TT_MAP). Ленивая инициализация:
   *  _UI_TO_DB_TT_MAP объявлен НИЖЕ по файлу (const, TDZ) — строить карту можно
   *  только при первом вызове, к рендеру модуль уже инициализирован целиком. */
  let _dbToUiCache = null;
  function _dbToUiTT(db) {
    if (!_dbToUiCache) {
      _dbToUiCache = {};
      Object.keys(_UI_TO_DB_TT_MAP).forEach(function(ui) { _dbToUiCache[_UI_TO_DB_TT_MAP[ui]] = ui; });
    }
    return _dbToUiCache[db] || db;
  }

  /** Полный КЛИЕНТСКИЙ фильтр показа (аудит скорости 29.08): пары тип:ТФ,
   *  направление, слайдер оборота — расширение приёма _filterByTf на остальные
   *  «дёргалки». Данные качаются полными (пол шкалы оборота, все типы роли),
   *  сужение — мгновенно здесь; серверные агрегаты («Доход», счётчики) доезжают
   *  slim-запросом из fetchAndRender. Источник правды — ЖИВЫЕ контролы (STATE.
   *  filters фиксируется на init — грабли 2026-06-01). Семантика пустого набора
   *  чекбоксов повторяет серверную: ни одного отмеченного → фильтр не применяем. */
  function _filterByUi(items) {
    let out = _filterByTf(items);
    const boxes = document.querySelectorAll('#f-triggers input[type="checkbox"][data-tt]');
    if (boxes.length) {
      const on = new Set();
      let allOn = true;
      boxes.forEach(function(b) {
        if (b.checked) on.add(b.getAttribute('data-tt') + ':' + (b.getAttribute('data-tf') || '1h'));
        else allOn = false;
      });
      if (!allOn && on.size) {
        out = out.filter(function(mi) {
          const t = mi && mi.trigger;
          if (!t) return false;
          const ui = _dbToUiTT(_detGroup(t.trigger_type));     // вариант — по галочке основного (DET_GROUPS)
          return on.has(ui + ':' + String(t.tf || '1h'));
        });
      }
    }
    // Направление. В v7+ final_direction == direction триггера (инверсия была
    // только в legacy v6) → фильтр эквивалентен серверному по final_direction.
    const L = document.getElementById('f-long'), S = document.getElementById('f-short');
    if (L && S && L.checked !== S.checked) {
      const want = L.checked ? 'LONG' : 'SHORT';
      out = out.filter(function(mi) {
        const d = (mi.best && mi.best.final_direction) || (mi.trigger && mi.trigger.direction) || '';
        return String(d).toUpperCase() === want;
      });
    }
    // Оборот [min; max] — turnover есть в каждой строке; нет числа → не отбрасываем.
    const mn = turnoverFromSlider(), mx = turnoverMaxFromSlider();
    if (mn > TURNOVER_VALUES[0] || mx) {
      out = out.filter(function(mi) {
        const tv = Number(mi.trigger && mi.trigger.turnover);
        if (isNaN(tv) || tv <= 0) return true;
        if (tv < mn) return false;
        if (mx && tv > mx) return false;
        return true;
      });
    }
    return out;
  }

  /** Клиентские фильтры в дефолте? (все чекбоксы отмечены, оба направления,
   *  слайдер во всю шкалу) → агрегаты полного ответа совпадают с показом,
   *  slim-дозапрос не нужен. */
  function _clientFiltersDefault() {
    const boxes = document.querySelectorAll('#f-triggers input[type="checkbox"][data-tt]');
    for (let i = 0; i < boxes.length; i++) if (!boxes[i].checked) return false;
    const L = document.getElementById('f-long'), S = document.getElementById('f-short');
    if (L && S && L.checked !== S.checked) return false;
    const mnEl = _turnoverElMin(), mxEl = _turnoverElMax();
    if (mnEl && (parseInt(mnEl.value) || 0) !== 0) return false;
    if (mxEl) { const v = parseInt(mxEl.value); if (!isNaN(v) && v !== TURNOVER_MAX_IDX) return false; }
    return true;
  }

  function visibleItems() {
    const tbl = (STATE.data && STATE.data.table) || [];
    // «История сделок» (05.10.2026): сервер уже отобрал сделки счёта теми же фильтрами, что «Историю недель»,
    // отсортировал и разбил на страницы — показываем как есть: любой клиентский фильтр развёл бы её с неделями.
    if (STATE.deals) return tbl;
    // Живой режим — полный клиентский фильтр.
    let out = _filterByUi(filterForLight(sortItems(tbl)));
    // «Выкл слабые» (admin): убрать сетапы, где отдельная сделка в плюсе реже
    // WEAK_WIN_P. Клиентский фильтр — win_p приходит в series; в «Нед» тот же
    // порог применяется на сервере (параметр hide_weak).
    if (STATE.hideWeak) {
      out = out.filter(mi => {
        const wp = mi && mi.series && mi.series.win_p;
        return wp == null || Number(wp) >= WEAK_WIN_P;   // нет метрики → не отбрасываем
      });
    }
    // «Закрытые сегодня» (admin): оставить только сделки с датой ВЫХОДА = сегодня.
    // Клиентский фильтр — дата выхода уже в payload (mi.exit.bar_date, после правила
    // безубытка). Через visibleItems он автоматически доезжает до «Дохода» и счётчика
    // кнопки («что показано, то и посчитано»). В «Истории недель» и «Истории сделок»
    // не применяется: там историческая выборка, «сегодня» в ней ничего не значит.
    if (STATE.closedToday && !STATE.weekly) {
      const _td = _todayMsk();
      out = out.filter(mi => {
        const bd = mi && mi.exit && mi.exit.bar_date;
        return !!bd && String(bd).slice(0, 10) === _td;
      });
    }
    // «Только пропущенные встречные» (admin, 24.09.2026): строки, которые счёт не открыл
    // из-за открытой встречной позиции. «Доход недели» и дни миничарта по ним же считает
    // сервер (opp_skip=1), строки показывают собственный исход (_netNotOpened).
    if (STATE.oppSkipOnly && !STATE.weekly && !_setupsView()) {   // в «Сетапах» пропусков нет (27.10.2026)
      out = out.filter(mi => mi && mi.net && mi.net.skip === 'opposite_while_open');
    }
    return out;
  }

  /** Сегодняшняя дата по МСК, 'YYYY-MM-DD'. Считаем от UTC, а НЕ от локальной зоны
   *  браузера: у смотрящего может быть любая TZ, а bar_date/exit_bar_date в API —
   *  наивный MSK wall-clock (метка +00 в них ничего не значит). */
  function _todayMsk() {
    return new Date(Date.now() + 3 * 3600 * 1000).toISOString().slice(0, 10);
  }

  /** Карточки ТОП, которые СЕЙЧАС видны (renderCards): клиентские фильтры показа (типы/ТФ/
   *  направление/оборот — сервер с 29.08 отдаёт top нефильтрованным по ним) и Light-фильтр; у «Лучших
   *  завершённых» (mi.actual) по среднему R ячейки не режем — сделка уже состоялась. Одна функция на
   *  рендер карточек и выбор графика первого экрана (26.09.2026): график открывался по top[0] без
   *  фильтров — у анонима это сетап вне его набора (ложный пробой 4ч при наборе «ложный пробой 1ч»). */
  function _visibleTop(top) {
    const ui = _filterByUi(top || []);
    const isActual = !!(ui[0] && ui[0].actual);
    return (isActual ? ui : filterForLight(ui)).slice(0, 12);
  }

  /** Сетап, с которого открывается график первого экрана: первая ВИДИМАЯ карточка; видимых карточек
   *  нет — первая видимая строка таблицы; нет и её — первая карточка ответа (прежнее поведение, чтобы
   *  панель не пустовала). */
  function _firstScreenSetup(top) {
    const vt = _visibleTop(top);
    if (vt.length && vt[0].trigger) return vt[0];
    const rows = (STATE.data && STATE.data.table) ? visibleItems() : [];
    if (rows.length && rows[0].trigger) return rows[0];
    return (top && top.length && top[0].trigger) ? top[0] : null;
  }

  /** Light TOP cards — 6 квадратных карточек.
   *  Backend top[] уже отсортирован по today→yesterday→fallback и приоритезирован
   *  по oos_er/quality. Light просто берёт первые 6 без lottery/small_n. */
  // Карточка ТОП (классы tc-*): шапка (тикер+время)
  // + подзаголовок (тип+уровень) + футер (подсказка «Получать такие сразу», линия над ней; маркера надёжности с числом
  // сделок нет с 16.10.2026 — решение владельца, карточка меньше). Середина
  // вместо SVG-круга — якорь «+XR на 100 сделок» (2 строки) + hover-tooltip. Левой
  // цветной линии нет (у tc-card её не было). Текст русифицирован (Light = consumer).
  function renderCards(top) {
    const root = document.getElementById('top-cards-light');
    if (!root) return;
    // Витрина подчиняется тем же клиентским фильтрам, что и таблица (типы/ТФ/
    // направление/оборот): сервер с 29.08 отдаёт top нефильтрованным. Набор видимых
    // карточек — _visibleTop (общий с выбором графика первого экрана, 26.09.2026).
    const filtered = _visibleTop(top);
    const isActual = !!(filtered[0] && filtered[0].actual);
    // Заголовок секции под содержимое: actual-факт vs forward-витрина (fallback).
    const _tEl = document.getElementById('topcards-title-text');
    const _sEl = document.getElementById('topcards-subtitle');
    if (_tEl) _tEl.textContent = isActual ? 'Лучшие завершенные сетапы' : 'Сетапы дня';
    if (_sEl) _sEl.textContent = isActual ? 'за последнюю неделю' : '';   // .sec-sub = тонкий серый
    if (!filtered.length) {
      root.innerHTML = '<div class="empty">Сильных модельных сигналов сейчас нет. Заглядывайте чаще — детектор обновляет ленту каждый час.</div>';
      return;
    }
    root.innerHTML = filtered.map(mi => {
      const t = mi.trigger;
      const v = mi.best;
      const dirCls = v.final_direction === 'LONG' ? 'tc-dir-long' : 'tc-dir-short';
      // Короткое имя сетапа для карточки (без «RSI», без цены — минимализм).
      const trigName = TRIGGER_CARD_NAME[t.trigger_type] || TRIGGER_RU[t.trigger_type] || t.trigger_type;
      // «+N» вариантов в Light не показываем — раскрытия нет, бейдж не actionable.
      const variantsBadge = '';
      const time = fmtCardTime(_dispBarDate(t));
      // Середина — потенциал (best-bucket R, как в TG) + серийная вероятность;
      // fallback «мало данных» (редко: ячейка с N<40, нет ни series, ни rd).
      const rd = mi.r_distribution;
      const sr = mi.series;
      const hasSeriesTc = sr && sr.potential != null;
      const act = mi.actual;   // admin: вчерашний факт {pct, rr}
      let mid;
      if (act) {
        // Лучший завершённый за 24ч: направление → +X% → RR → вероятность (без «Серия»).
        const pos = act.pct >= 0;
        // Два знака — ровно как в колонке «Доходность» той же строки: с одним
        // «+5.4%» против табличных «+5.38%» читается как расхождение (31.08).
        const pctStr = (pos ? '+' : '−') + Math.abs(act.pct).toFixed(2) + '%';
        // RR — округляем до целого (≥0.5 вверх) + «~» (факт ≈ целевой уровень).
        const rrStr = act.rr > 0 ? ('RR ~1:' + Math.max(1, Math.round(act.rr))) : 'стоп';
        // Вероятность — отдельной строкой (strip = flex column), «N20» = серия из N сделок.
        const probLine = (sr && sr.prob20 != null)
          ? `<span class="tc-anchor-lbl">Вероятность N${_seriesN()} ~${sr.prob20}%</span>` : '';
        const dirRu = v.final_direction === 'LONG' ? 'ЛОНГ' : 'ШОРТ';
        const dirCls2 = v.final_direction === 'LONG' ? 'rld-long' : 'rld-short';
        // Направление ВНУТРИ цветной полосы, сверху (ЛОНГ/ШОРТ и RR одной строкой → +X% → вероятность; RR — справа от
        // направления с 16.10.2026, решение владельца: карточка на строку ниже); полоса (border-left на strip) обнимает
        // весь блок включая направление.
        mid = `<div class="tc-anchor-mid">
                 <div class="tc-anchor-strip">
                   <div class="tc-act-dir ${dirCls2}">${dirRu} <span class="tc-act-rr">${rrStr}</span></div>
                   <span class="tc-anchor-val ${pos ? 'tc-act-pos' : 'tc-act-neg'}">${pctStr}</span>
                   ${probLine}
                 </div>
               </div>`;
      } else if (hasSeriesTc) {
        const sLine = (sr.prob20 != null)
          ? `<div class="tc-series">Серия ${_seriesN()} · вероятность ~${sr.prob20}%</div>` : '';
        mid = `<div class="tc-anchor-mid rdist-anchor" tabindex="0">
                 <div class="tc-anchor-strip">
                   <span class="tc-anchor-val">${sr.potential.toFixed(2)}R</span>
                   <span class="tc-anchor-lbl">потенциал · риск 1R</span>
                 </div>
                 ${sLine}
                 ${(rd && rd.buckets6) ? buildRdistTooltip(rd, sr) : ''}
               </div>`;
      } else if (rd && rd.buckets6) {
        mid = `<div class="tc-anchor-mid rdist-anchor" tabindex="0">
                 <div class="tc-anchor-strip">
                   <span class="tc-anchor-val">${fmtExpR(rd)}</span>
                   <span class="tc-anchor-lbl">потенциал на 100 сделок</span>
                 </div>
                 ${buildRdistTooltip(rd, null)}
               </div>`;
      } else {
        mid = `<div class="tc-anchor-mid tc-anchor-empty">
                 <span class="tc-anchor-lbl">статистики пока мало</span>
               </div>`;
      }
      return `
        <div class="tc-card ${dirCls}" data-tid="${t.id}" data-ticker="${t.ticker}" data-tf="${t.tf || '1h'}">
          <div class="tc-header">
            <div class="tc-ticker-wrap">
              <div class="tc-ticker">${t.ticker}${t.fut_contract ? `<span class="tc-fut" title="Фьючерс ${t.fut_contract}">${t.fut_contract}</span>` : ''}</div>
              ${_favHeart(t.ticker)}
              ${variantsBadge}
            </div>
            <div class="tc-time">${time}</div>
          </div>
          <div class="tc-title">
            <span class="tc-trigger-type">${trigName}</span>
            <span class="tc-tf">${TF_LABEL[t.tf || '1h'] || (t.tf || '1h')}</span>
          </div>
          ${mid}
          <div class="tc-footer"></div>
        </div>`;
    }).join('');
    root.querySelectorAll('.tc-card').forEach(card => {
      card.addEventListener('click', () => {
        const tid = parseInt(card.getAttribute('data-tid'));
        const ticker = card.getAttribute('data-ticker');
        const tf = _tfForTid(tid);
        focusTriggerLight(tid, ticker, tf);
      });
    });
    _syncBotCardHints();   // «Получать такие сразу» (bot_onboard)
  }

  /** Light list — горизонтальные карточки вместо таблицы. */
  // ₽-режим: client capital pool (зеркало ml_setups.html). Хронологически
  // открываем resolved-сделки, лочим invested при входе; не хватило свободного
  // баланса → сделка пропущена (skipped). Депозит 2М, поз. ~20к по лотам.
  const RUB_DEPOSIT = 3_000_000;
  function _rubCapitalPool(items) {
    const ev = [];
    items.forEach(mi => {
      if (mi.trigger && mi.trigger.gated) return;      // «не торгуем» — капитал не занимает
      const r = mi.rub;
      if (!r || r.status !== 'resolved' || !r.invested) return;
      const id = mi.trigger.id;
      ev.push({ t: String(mi.trigger.bar_date).slice(0, 16), k: 0, id: id, inv: r.invested, pnl: r.net_pnl_rub });
      if (r.exit_bar_date) ev.push({ t: String(r.exit_bar_date).slice(0, 16), k: 1, id: id, inv: r.invested, pnl: r.net_pnl_rub });
    });
    ev.sort((a, b) => (a.t < b.t ? -1 : a.t > b.t ? 1 : a.k - b.k));
    const depo = STATE.rubDeposit || RUB_DEPOSIT;
    let bal = depo, realized = 0, locked = 0, peakLocked = 0, nOpened = 0, nSkipped = 0;
    const took = {}, opened = {};
    ev.forEach(e => {
      if (e.k === 0) {
        if (bal >= e.inv) {
          bal -= e.inv; locked += e.inv; took[e.id] = e.inv; opened[e.id] = true; nOpened++;
          if (locked > peakLocked) peakLocked = locked;
        } else { nSkipped++; }
      } else if (took[e.id] != null) {
        bal += took[e.id];
        if (e.pnl != null) { bal += e.pnl; realized += e.pnl; }
        locked -= took[e.id]; delete took[e.id];
      }
    });
    let inWork = 0; for (const k in took) inWork += took[k];
    return { opened, realized, nOpened, nSkipped, peakLocked, inWork, deposit: depo };
  }

  // Постепенная отрисовка таблицы (12.09.2026): поколение отменяет недорисованный
  // прошлый список, LL_CHUNK — строк за кадр, _llFirstCount — сколько показать сразу
  // (экран + запас: на витрине в окне помещается 7–15 строк).
  var _llGen = 0, _llPending = null;
  var LL_CHUNK = 120;
  function _llFirstCount() {
    return Math.max(15, Math.ceil((window.innerHeight || 800) / 60) + 4);
  }
  /** Дорисовать хвост немедленно — для кода, которому нужна строка из ещё не
   *  отрисованной части (прокрутка к строке, фокус из карточки). */
  function _flushListLight() {
    if (_llPending) _llPending(true);
  }
  /** Отменить недорисованные порции — перед тем как положить в #list-light другое
   *  содержимое (пустой список, журнал пресета, ошибка): иначе хвост прошлого
   *  списка дописался бы поверх нового. */
  function _llCancel() {
    _llGen++;
    _llPending = null;
  }


  // «Сетапы_тест» — только представление существующего view=setups, без своего расчёта сделок.
  function _setupsTestView() { return _setupsView(); }
  // Общая строка для тестовых сетапов и админского портфеля; данные и решения счёта прежние.
  function _portfolioTableView() { return (_adminView() || _splitOn()) && !STATE.unitsPct; }
  function _compactListView() {
    return !STATE.weekly && !STATE.detChart && !STATE.presetId
      && (_setupsTestView() || _portfolioTableView());
  }
  const _testDetailsOpen = new Set();
  function _testSeriesTip() {
    return 'Вероятность положительного результата серии из ' + _seriesN()
      + ' сделок на исторической выборке. Это вероятность серии, а не отдельной сделки.';
  }
  function _syncTestHeader() {
    var on = _compactListView();
    document.body.classList.toggle('setups-test-view', on);
    var old = document.getElementById('list-light-hdr');
    if (!old) return;
    var hdr = document.getElementById('list-test-hdr');
    if (on && !hdr) {
      hdr = document.createElement('div');
      hdr.id = 'list-test-hdr';
      hdr.className = 'list-light-hdr';
      hdr.innerHTML = '<div>Время</div><div>Бумага</div><div>Сетап</div><div>Доходность %</div>'
        + '<div class="st-prob-hdr" tabindex="0">Вероятность серии</div>';
      old.parentNode.insertBefore(hdr, old);
    }
    if (hdr) {
      hdr.querySelector('.st-prob-hdr').title = _testSeriesTip();
      hdr.firstElementChild.classList.toggle('lh-sort', !!STATE.deals);
      hdr.firstElementChild.title = STATE.deals ? 'Момент входа. Нажмите — сортировка по входу, новые сверху' : 'Момент входа';
      hdr.firstElementChild.onclick = function () { if (STATE.deals) setDealsSort('entry'); };
    }
  }
  function _testCompanyName(s) {
    return String(s || '').replace(/привилегированн[а-яё]*(?:\s+акци[а-яё]*)?/gi, 'ап');
  }
  function _testRowHtml(mi, headline, portfolio) {
    const t = mi.trigger, v = mi.best, target = mi.target || {};
    const account = portfolio && portfolio.account;
    // Отказ исполнения относится к портфелю; в общей витрине остаётся план сетапа.
    const canceled = !!portfolio && (mi.r_outcome === 'CANCELED' || portfolio.notOpenedCell);
    const closed = !canceled && (portfolio ? !!account
      : mi.r_outcome !== 'CANCELED' && !!(mi.result && mi.result.net_pct != null));
    const pct = canceled ? null : closed ? (account ? account.pct : mi.result.net_pct) : target.pct;
    const price = canceled ? null : closed ? (account ? account.exitPrice : ((mi.exit || {}).price ?? t.exit_price)) : target.price;
    const num = pct == null ? null : Number(pct);
    const color = num > 0 ? 'real-pos' : (num < 0 ? 'real-neg' : '');
    const pctText = num == null || !Number.isFinite(num) ? '—'
      : (num > 0 ? '+' : (num < 0 ? '−' : '')) + Math.abs(num).toFixed(2) + '%';
    const priceText = canceled ? 'Не открыта' : price == null || !Number.isFinite(Number(price)) ? '—' : _fmtEntryPx(Number(price)) + NBSP + '₽';
    const probability = mi.series && mi.series.prob20;
    const probabilityText = probability == null || !Number.isFinite(Number(probability)) ? '—' : '≈' + probability + '%';
    const bits = document.createElement('div');
    bits.innerHTML = headline + (portfolio ? _nettingBadge(mi) : '');
    const name = bits.querySelector('.hl-name, b');
    if (name) name.title = name.textContent;
    const label = name ? name.outerHTML : '<span class="hl-name">' + _esc(t.trigger_type || '') + '</span>';
    const notes = [];
    Array.from(bits.children).forEach(function (el) {
      if (el === name) return;
      const text = el.title || el.textContent;
      if (text && !notes.includes(text)) notes.push(text);
    });
    const dir = v.final_direction === 'SHORT' ? 'Шорт' : 'Лонг';
    notes.unshift('Направление: ' + dir + '.');
    const sl = target.sl ?? t.sl;
    if (sl != null) notes.push('Стоп: ' + _fmtEntryPx(Number(sl)) + NBSP + '₽.');
    if (target.rr != null) notes.push('Соотношение риска и цели: 1:' + _fmtRRow(Number(target.rr)) + '.');
    if (target.price != null) notes.push('Цель: ' + _fmtEntryPx(Number(target.price)) + NBSP + '₽.');
    if (closed && !portfolio) notes.push('Завершён: ' + (R_OUTCOME_RU[mi.result.outcome] || 'закрыт')
      + ((mi.idea && mi.idea.close_at) ? ', ' + fmtCardTime(mi.idea.close_at) : '') + '.');
    if (portfolio) {
      if (portfolio.notOpen) notes.push(portfolio.notOpen.tip || portfolio.notOpen.why);
      const rub = mi.rub || {};
      if (rub.lots != null) notes.push((rub.contract ? 'Контрактов: ' : 'Лотов: ') + rub.lots + '.');
      const invested = account ? account.invested : rub.invested;
      if (invested != null) notes.push('Вложено: ' + Math.round(invested).toLocaleString('ru-RU') + NBSP + '₽.');
      if (account) {
        notes.push('Результат счёта: ' + (account.pnlRub >= 0 ? '+' : '')
          + account.pnlRub.toLocaleString('ru-RU') + NBSP + '₽.');
        if (account.closeAt) notes.push('Закрыт: ' + fmtCardTime(account.closeAt) + '.');
      }
      const explanation = document.createElement('div');
      explanation.innerHTML = portfolio.doxCell;
      const reason = explanation.querySelector('.row-l-rr');
      if (reason) notes.push(reason.title || reason.textContent);
    }
    if (canceled) notes.push('Сделка не открылась' + (t.m1_skip_why ? ': ' + t.m1_skip_why : '') + '.');
    const extraEntry = document.createElement('div');
    extraEntry.innerHTML = buildEntryLine(t, mi);
    if (extraEntry.textContent.includes('объёмом')) notes.push('Сигнал подтверждён объёмом.');
    const quality = QUALITY_LABEL[v.quality];
    const count = v.oos_n == null ? '—' : Number(v.oos_n).toLocaleString('ru-RU');
    const id = _esc(String(t.id));
    const company = _testCompanyName(t.ticker_name);
    const entry = _entryPx(t);
    const entryLine = entry == null ? 'вход —' : 'вход' + NBSP + _fmtEntryPx(entry) + NBSP + '₽';
    return `<div class="row-l st-row ${v.final_direction === 'SHORT' ? 'dir-short' : 'dir-long'}${portfolio && (portfolio.notOpen || t.gated) ? ' row-not-opened' : ''}${String(t.id) === String(STATE.expandedTriggerId) ? ' selected' : ''}"
      data-tid="${id}" data-ticker="${_esc(t.ticker)}" data-tf="${_esc(t.tf || '1h')}"
      data-bar-date="${_esc(t.bar_date || '')}" data-trigger-type="${_esc(t.trigger_type || '')}">
      <div class="row-l-time" title="${_esc(_entryTimeTip(t, mi))}">${fmtTime(t.entry_time || _dispBarDate(t))}</div>
      <div class="row-l-tk"><span class="row-l-tkr-line"><span class="row-l-ticker">${_esc(t.ticker)}</span>${_favHeart(t.ticker)}</span>
        <span class="row-l-name" title="${_esc(company)}">${_esc(t.fut_contract || company)}</span></div>
      <div class="row-l-headline"><span class="st-name-line">${label}${tfBadge(t.tf)}</span>
        <span class="hl-l2" title="${_esc(_entryPxTip(t, mi))}">${entryLine}</span></div>
      <div class="st-result ${color}"${account ? ` data-account-pct="${account.pct}" data-account-pnl="${account.pnlRub}" data-account-exit="${account.exitPrice ?? ''}"` : ''} title="${canceled ? 'Сделка не открылась' : closed ? 'Результат после издержек модели; ниже — цена выхода' : 'Потенциальная доходность до цели; ниже — целевая цена'}">
        <span class="st-result-pct">${pctText}</span><span class="st-result-price">${canceled ? '' : closed ? 'Завершён · ' : 'Цель · '}${priceText}</span></div>
      <div class="st-prob" title="${_esc(_testSeriesTip())}">${probabilityText}</div>
      <details class="st-details" data-test-tid="${id}"${_testDetailsOpen.has(String(t.id)) ? ' open' : ''}>
        <summary>Условия и статистика</summary><div class="st-detail-body"><div><b>Условия</b>${notes.map(s => '<p>' + _esc(s) + '</p>').join('')}</div>
        <div><b>Статистика</b><p>Вероятность серии из ${_seriesN()} сделок: ${probabilityText}.</p>
        <p>Выборка: ${count} сделок.${quality ? ' ' + _esc(quality) + '.' : ''}</p>
        ${mi.series && mi.series.win_p != null ? '<p>Отдельная сделка в плюсе: ≈' + _esc(String(mi.series.win_p)) + '%.</p>' : ''}</div></div>
      </details></div>`;
  }

  function renderListLight() {
    const root = document.getElementById('list-light');
    if (!root || !STATE.data) return;
    _syncTestHeader();
    if (!root.__testDetailsBound) {
      root.__testDetailsBound = true;
      root.addEventListener('toggle', function (ev) {
        const el = ev.target;
        if (!el.matches || !el.matches('details.st-details')) return;
        if (el.open) _testDetailsOpen.add(el.dataset.testTid); else _testDetailsOpen.delete(el.dataset.testTid);
      }, true);
    }
    // Колонка времени — момент входа («Вход», 02.10.2026). В «Истории сделок» (05.10.2026) шапки «Вход» и «Закрыт»
    // сортируют список (сортирует сервер, новые сверху): у выбранной — стрелка.
    const _lhT = document.getElementById('lh-time');
    const _ds = STATE.deals ? (STATE.dealsSort || 'exit') : null;
    if (_lhT) {
      _lhT.textContent = 'Вход' + (_ds === 'entry' ? NBSP + '↓' : '');
      _lhT.title = STATE.deals ? 'Момент входа в сделку. Нажмите — сортировка по входу, новые сверху'
        : 'Момент входа в сделку. Начало сигнального бара — в подсказке у времени';
      _lhT.classList.toggle('lh-sort', !!STATE.deals);
      _lhT.classList.toggle('is-on', _ds === 'entry');
    }
    const _lhX = document.getElementById('lh-exit');
    if (_lhX) {
      _lhX.textContent = 'Закрыт' + (_ds === 'exit' ? NBSP + '↓' : '');
      _lhX.classList.toggle('is-on', _ds === 'exit');
    }
    _llCancel();                       // прошлая отрисовка больше не дописывает строки
    // «История сделок»: сервер уже отобрал, отсортировал и разбил на страницы → показываем как есть.
    // Живое: клиентский filterForLight (avg_R>0) + sortItems.
    let filtered = visibleItems();
    if (!filtered.length) {
      const _thErr = STATE.deals && STATE.data && STATE.data.trades_hist && STATE.data.trades_hist.error;
      root.innerHTML = '<div class="empty">' + (STATE.deals
        ? (_thErr ? 'Не удалось собрать историю сделок. Обновите страницу.'
                  : 'Закрытых сделок по выбранным фильтрам нет.')
        : 'Нет подходящих сетапов. Попробуйте ослабить фильтры в левой колонке.') + '</div>';
      return;
    }
    STATE.sortedTable = filtered;
    // ₽-режим (admin): client capital pool по resolved-сделкам → какие открылись
    // (хватило свободного капитала), какие пропущены. Депозит 2М, поз. ~20к по лотам.
    // ₽-специфику рисуем ТОЛЬКО по рублёвому ответу сервера (payload.rubles).
    // Первый запрос при загрузке уходит БЕЗ ?rubles=1 (режим восстанавливается
    // асинхронно) — раньше по нему рисовались ложные «не открыта» у всех строк
    // и доход 0, пока не придёт второй ответ (репорт 17.08).
    // ₽-режим — в обеих ролях (28.08): центральная часть витрины одинакова, а
    // сервер отдаёт рубли всем. Признак — наличие данных, а не роль.
    const rubMode = !!(STATE.data && STATE.data.rubles);
    // ⚠ Колонка «Лот / ₽» — отдельный флаг: в режиме процентов денежная ветка
    // строки ОСТАЁТСЯ (из неё берётся процент сделки после издержек), а лоты и
    // рубли на экран не идут. Сливать эти два флага нельзя: ячейка доходности
    // тогда уходит в ветку «R сделки» и процента на экране не остаётся вовсе.
    // Открыта ли сделка — решает СЧЁТ (неттинг и пул капитала на сервере), когда он
    // есть: по той же аннотации считается «Доход недели». Свой пул страницы остаётся
    // только для старого способа счёта (netting=0), где аннотации нет. До 14.09 строки
    // брали решение из него и спорили со счётом: пропущенные встречные сигналы
    // показывали рубли, часть сделок счёта — «не открыта: не хватило капитала»
    // (проверка tools/check_setups_netting_rows.py).
    // Вид «Сетапы» (27.10.2026): каждый сетап — своя сделка со своим результатом — ни решений счёта, ни пула страницы
    const ideasMode = _setupsView();
    const netMode = !ideasMode && !!(STATE.data && STATE.data.netting);
    const _rubPool = (rubMode && !netMode && !ideasMode) ? _rubCapitalPool(filtered) : null;
    const rowHtml = (mi) => {
      const t = mi.trigger;
      const v = mi.best;
      const dirCls = v.final_direction === 'LONG' ? 'dir-long' : 'dir-short';
      let headline = t.de_setup
        ? ('<b>' + (_DE_SETUP_RU[t.de_setup] || t.de_setup) + '</b>')
        : buildLightHeadline(t, v.final_direction, mi);
      // ML-фигурные: пометка «скип» — правило геометрии трека 1 (стены на пути /
      // стена по ходу) говорит не торговать этот сетап. Показывается ВСЕМ
      // (2026-08-02): сетап виден, но исключён из дохода. Админский тумблер
      // «Выкл скип» отключает правило — тогда поля нет и строка обычная.
      if (v.figure_skip) {
        headline += '<span class="fig-skip-badge" title="' +
                    String(v.figure_skip).replace(/"/g, '&quot;') + '">скип</span>';
      }
      // R4-ранжир «стоп за уровнем» (figure_skips.stop_at_level): признак КАЧЕСТВА —
      // стоп спрятан за сильный MTF-уровень. На гейте трека 1 такие сетапы заметно
      // лучше: stop_hunt WR 53.7→61.3, divergence 52.5→56.0. Маркер, не фильтр.
      // Риск разворота: рынок в состоянии, где шорты исторически убыточны.
      // Метку получают только СЕГОДНЯШНИЕ шорты (бэк проставляет risk_warning).
      // Тултип начинается с оговорки — иначе бейдж читается как оценка сетапа.
      if (t.risk_warning) {
        headline += '<span class="short-risk-badge" title="Состояние рынка, а не ' +
          'оценка сетапа: рынок падал более 7% от месячного максимума, а сегодня ' +
          'растёт. В таком состоянии шорты исторически убыточны — мы сами их сейчас ' +
          'не торгуем, но сетапы остаются в выдаче.">разворот?</span>';
      }
      // 4ч-правило (h4_brake): с 24.09.2026 такие шорты скрыты у всех; в выдачу они
      // попадают только у админа с чекбоксом «Выкл 4ч-рост» — тогда помечены бейджем.
      if (t.h4_blocked && _adminView() && !t.gated) {
        headline += '<span class="short-risk-badge" title="Шорт после сильного зелёного ' +
          '4ч-блока основной сессии индекса (тело ≥1.25 ATR). На истории такие шорты ' +
          'убыточны. Правило включено для всех: сетап скрыт у пользователей и в доход не ' +
          'идёт, здесь показан чекбоксом «Выкл 4ч-рост».">4ч↑</span>';
      }
      // 2ч-правило (у всех с 28.09.2026): такие шорты скрыты; в выдачу они попадают только у
      // админа с чекбоксом «Выкл 2ч-рост» — тогда помечены бейджем.
      if (t.h2_blocked && _adminView() && !t.gated) {
        headline += '<span class="short-risk-badge" title="Шорт после сильного зелёного ' +
          '2ч-блока основной сессии индекса (тело ≥1.25 ATR). Правило включено для всех: ' +
          'сетап скрыт у пользователей и в доход не идёт, здесь показан чекбоксом ' +
          '«Выкл 2ч-рост».">2ч↑</span>';
      }
      // «Не гнаться за гэпом» (gap_brake, №170, у всех с 28.09.2026): такие сетапы скрыты; в выдачу попадают
      // только у админа с чекбоксом «Gap-race» — тогда с бейджем «гэп↑» (лонг) или «гэп↓» (шорт).
      if (t.gap_blocked && _adminView() && !t.gated) {
        const _gpLong = String(t.direction || '').toUpperCase() === 'LONG';
        headline += '<span class="short-risk-badge" title="' + _esc('Сетап в сторону утреннего гэпа индекса' +
          (t.gap_blocked_why ? ': ' + t.gap_blocked_why : '') + '. Правило включено для всех: сетап скрыт у ' +
          'пользователей и в доход не идёт, здесь показан чекбоксом «Gap-race».') + '">' +
          (_gpLong ? 'гэп↑' : 'гэп↓') + '</span>';
      }
      // «Вечер против» (index_brake, №193, у всех с 20.10.2026, только вперёд): вход вечером или утром против хода индекса от
      // закрытия основной сессии; такие сетапы скрыты, в выдачу попадают только у админа с чекбоксом «Выкл вечер-фильтр» —
      // тогда с бейджем «веч↓» (лонг после падения индекса) или «веч↑» (шорт после роста).
      if (t.ev_blocked && _adminView() && !t.gated) {
        const _evLong = String(t.direction || '').toUpperCase() === 'LONG';
        headline += '<span class="short-risk-badge" title="' + _esc('Вход вне основной сессии против хода индекса от ' +
          'закрытия основной сессии' + (t.ev_blocked_why ? ': ' + t.ev_blocked_why : '') + '. Правило включено для всех: ' +
          'сетап скрыт у пользователей и в доход не идёт, здесь показан чекбоксом «Выкл вечер-фильтр».') + '">' +
          (_evLong ? 'веч↓' : 'веч↑') + '</span>';
      }
      // «Рынок против» (ew_brake, №175, у всех и у бота с 21.10.2026, только вперёд): сетап против хода равновзвешенного
      // рынка ликвидных бумаг скрыт; в выдачу попадает только у админа с чекбоксом «Выкл рынок против» — тогда с бейджем
      // «рын↓» (лонг против падающего рынка) или «рын↑» (шорт против растущего).
      if (t.ew_blocked && _adminView() && !t.gated) {
        const _ewLong = String(t.direction || '').toUpperCase() === 'LONG';
        headline += '<span class="short-risk-badge" title="' + _esc('Сетап против хода равновзвешенного рынка' +
          (t.ew_blocked_why ? ': ' + t.ew_blocked_why : '') + '. Правило включено для всех: сетап скрыт у ' +
          'пользователей, в доход не идёт и боту не уходит, здесь показан чекбоксом «Выкл рынок против».') + '">' +
          (_ewLong ? 'рын↓' : 'рын↑') + '</span>';
      }
      // Фильтр входа по ходу индекса (index_brake, №167, 25.09.2026): такие сетапы скрыты у всех;
      // в выдачу попадают только у админа с чекбоксом «Выкл индекс-фильтр» — тогда с бейджем:
      // «инд↓» у лонга (индекс падал), «инд↑» у шорта (индекс рос).
      if (t.idx_blocked && _adminView() && !t.gated) {
        const _ixShort = String(t.direction || '').toUpperCase() === 'SHORT';
        headline += '<span class="short-risk-badge" title="' + _esc('Сетап открыт против хода ' +
          'индекса' + (t.idx_blocked_why ? ': ' + t.idx_blocked_why : '') + '. На истории такие ' +
          'входы убыточны. Правило включено для всех: сетап скрыт у пользователей и в доход не ' +
          'идёт, здесь показан чекбоксом «Выкл индекс-фильтр».') + '">' +
          (_ixShort ? 'инд↑' : 'инд↓') + '</span>';
      }
      // Дивидендная отсечка впереди: позицию закроем накануне (держать через
      // реестр нельзя — шорт дивиденд платит, лонг получает, а цена падает на его
      // величину). Метка только у ЖИВЫХ сетапов и на горизонте, где сделка реально
      // может дожить: сетапы с отсечкой ≤3 дней в выдачу вообще не попадают (гейт).
      const _divRd = _divAlert(t);
      if (_divRd) {
        headline += '<span class="div-cut-badge" title="Дивидендная отсечка ' +
          _divRd.human + '. Позицию закроем на последнем баре перед ней: держать ' +
          'через реестр нельзя — шорт дивиденд платит, лонг получает, а цена падает ' +
          'примерно на его величину.">отсечка&nbsp;' + _divRd.short + '</span>';
      }
      if (t.stop_at_level) {
        headline += '<span class="stop-at-lvl-badge" ' +
          'title="Стоп спрятан за сильный уровень. По бэктесту такие сетапы чаще ' +
          'закрываются в плюс (доля прибыльных выше), но стоп шире — прибыль в R меньше">' +
          'от уровня</span>';
      }
      const qCls = LIGHT_QUALITY_CLASS[v.quality] || '';
      const qLbl = QUALITY_LABEL[v.quality] || '';
      // При наличии r_distribution (DIVERGENCE MVP) правая колонка строки —
      // это бар + однострочная легенда. Иначе fallback на привычную пару Цель/Риск
      // + quality-метку.
      // Правая колонка: закрытая сделка → реализованный R; открытая → шкала «ожидаем +XR»;
      // иначе → fallback Цель/Риск ₽ + quality.
      const hasReal = (mi.realized_r !== undefined && mi.realized_r !== null);
      // Результат закрытой сделки в процентах (27.08) — приходит ВСЕМ, в отличие
      // от realized_r (он в R и остаётся админским). Пользователь видит, чем сделка
      // кончилась, тем же числом, что админ в ₽-режиме.
      const hasPct = !!(mi.result && mi.result.net_pct != null);
      const isCanceled = (mi.r_outcome === 'CANCELED');
      const hasRdist = mi.r_distribution && mi.r_distribution.buckets6;
      const hasSeries = mi.series && mi.series.potential != null;
      // Колонка «Потенциал» — ОДНА ячейка (закрытая → реализованный R; CANCELED →
      // не открыта; открытая → план: направление + RR, цель).
      let doxCell;
      if (t.de_setup && !hasSeries && !hasReal) {
        // Фолбэк для «тонкой» ячейки DE (n<40, нет survival): gross E[R]/WR/fill из
        // de_setup_cells. Основной путь — каноничный «Потенциал» (hasSeries → buildRdistInline).
        const _er = Number(v.oos_er);
        const _ec = _er >= 0 ? 'real-pos' : 'real-neg';
        const _fl = (v.fill_pct != null && v.fill_pct < 99)
          ? ' · fill ' + Math.round(v.fill_pct) + '%' : '';
        doxCell = '<div class="row-l-de ' + _ec + '">E[R] ' + (_er >= 0 ? '+' : '')
          + _er.toFixed(2) + 'R<span class="de-sub">gross · WR ' + Math.round(v.oos_wr)
          + '%' + _fl + '</span></div>';
      } else if (hasReal) {
        const rr = mi.realized_r;
        const rcls = rr > 0 ? 'real-pos' : (rr < 0 ? 'real-neg' : '');
        const oc = R_OUTCOME_RU[mi.r_outcome] || 'закрыта';
        const _ocTip = mi.r_outcome === 'MKT' ? _esc(_mrevTip(t)) : 'Сделка закрыта: ' + oc;
        doxCell = `<div class="row-l-realr ${rcls}" title="${_ocTip}">${rr >= 0 ? '+' : ''}${rr.toFixed(2)}R<span class="realr-lbl">${oc}</span></div>`;
      } else if (hasPct) {
        const _np = mi.result.net_pct;
        const _pc = _np > 0 ? 'real-pos' : (_np < 0 ? 'real-neg' : '');
        const _oc = R_OUTCOME_RU[mi.result.outcome] || 'закрыта';
        doxCell = `<div class="row-l-realr ${_pc}" title="Движение цены от входа до выхода, до комиссии брокера. Выход: ${_oc}">`
          + `${_np >= 0 ? '+' : ''}${_np.toFixed(2)}%<span class="realr-lbl">${_oc}</span></div>`;
      } else if (isCanceled && t.m1_skip_why) {
        // минутная модель (09.10.2026, админский вид): сделку отсекло правило бота
        doxCell = `<div class="row-l-canceled row-l-notopen" title="${_esc('Сделка не открылась: ' + t.m1_skip_why)}">не открыта`
          + `<span class="nopen-why">${t.m1_skip === 'late_entry' ? 'поздний вход' : 'стоп до входа'}</span></div>`;
      } else if (isCanceled) {
        doxCell = `<div class="row-l-canceled" title="Гэп от сигнала до входа > 0.3 ATR — сделка не открылась">не открыта</div>`;
      } else {
        // Открытая сделка — план сетапа: направление + RR, цель. У ячейки с малой выборкой
        // цели по уровням нет — сервер кладёт цель самой сделки (target.src = 'trade').
        // До 28.09.2026 здесь стояло «+X ₽ / −Y ₽» (calcLightPnL: 1 ATR при позиции 50 000 ₽
        // и цель варианта каталога) — с реальной сделкой не связано, без подписей читалось
        // как «и плюс, и минус» (репорт владельца: VTBR CLIMAX 4ч 28.09).
        doxCell = `<div class="row-l-rdist">${buildRdistInline(mi.r_distribution, mi.series, v.final_direction, mi.target)}</div>`;
      }
      // Колонка N (размер выборки): цветная точка качества + N +
      // data-q/data-n для quality-тултипа (_bindQualityTooltips ниже).
      const nVal = (v.oos_n != null && v.oos_n !== undefined) ? v.oos_n : '—';
      const nqCls = 'q-' + (v.quality || 'small_n');
      // Две строки: «в плюсе ~N%» сверху + точка качества с размером выборки снизу.
      // Вероятность и её база стоят вместе — это одно утверждение («~60% на 243 сделках»).
      const _wp = (mi.series && mi.series.win_p != null)
        ? `<div class="row-l-winp" title="Доля сделок, закрывшихся в плюсе, на выборке бэктеста. До комиссии брокера.">в&nbsp;плюсе ~${mi.series.win_p}%</div>` : '';
      const _p20attr = ((mi.series && mi.series.prob20 != null) ? ` data-prob20="${mi.series.prob20}"` : '')
        + ((mi.series && mi.series.win_p != null) ? ` data-winp="${mi.series.win_p}"` : '');
      const nCell = `<div class="row-l-n" data-q="${v.quality}" data-n="${v.oos_n}"${_p20attr}>${_wp}`
        + `<div class="row-l-nval"><span class="card-quality ${nqCls}"></span>${nVal}</div></div>`;
      // Сделки на едином счёте нет — неттинг пропустил сигнал или не хватило капитала:
      // строка приглушена, лоты тоже. Причину называет бейдж под названием, «Доходность»
      // показывает план сетапа, как у остальных строк; «не открыта» с причиной — только
      // у строки без бейджа. Решает счёт (_netNotOpened); без неттинга строку не трогаем.
      // «не торгуем» (t.gated, переключатель «Все»): меток счёта у снятой строки нет намеренно — «вне расчёта счёта» ей не
      // ставим, «Доходность» показывает результат модели (строка приглушена, причину называет метка «не торгуем: …»)
      const notOpen = netMode
        ? (mi.net ? _netNotOpened(mi.net)
                  : ((hasReal && !isCanceled && !t.gated)
                      ? { why: 'вне расчёта счёта', tip: 'Сделка не вошла в расчёт единого счёта' }
                      : null))
        : null;
      // ₽-режим: колонка Лот/₽ + переопределение Доходности: закрытая сделка счёта —
      // её деньги, сделки нет — план сетапа (причина в бейдже) или «не открыта» с
      // причиной, если бейджа нет. CANCELED/открытые — как есть.
      let lotCell = '';
      let compactAccount = null;
      if (rubMode) {
        const rub = mi.rub;
        // Старый способ счёта (без неттинга): открыта ли — по пулу страницы.
        const poolOpened = !netMode && !!(rub && rub.status === 'resolved'
                                          && (ideasMode || (_rubPool && _rubPool.opened[t.id])));
        const lotDim = netMode ? !!notOpen : !!(rub && rub.status === 'resolved' && !poolOpened);
        // Позицию закрыл счёт, а своя запись сделки ещё открыта: докупка перенесла стоп,
        // и позиция вышла по нему. В «Доходе недели» сделка уже есть — строка показывает её
        // деньги, а не потенциал открытой (14.09: у анонима 5 таких сделок на −692 ₽ стояли
        // в таблице открытыми, и сумма строк не сходилась с карточкой).
        // «История сделок» (05.10.2026): сделка закрыта на счёте по построению; процент и вложено — из строки
        // счёта (net.deal), из которых «История недель» складывает доход недели, — суммы сходятся до рубля.
        const _deal = (netMode && ((mi.net && mi.net.deal) || mi.gdeal)) || null;   // gdeal — снятая сделка («Все»)
        const acctClosed = netMode && !notOpen
          && (!!_deal || !!(mi.net && mi.net.net_pct != null && mi.net.exit_date));
        // Лоты/вложено показываем СРАЗУ, как только известна цена входа (26.08):
        // размер позиции задаётся сетапом на входе и не зависит от того, чем сделка
        // кончилась. Пока колонка молчала до разрешения, витрина выглядела так, будто
        // размер подбирается задним числом. Приглушаем, только когда сделки не было —
        // строка приглушена целиком и помечена бейджем пропуска, ячейки не спорят.
        if (rub && rub.lots) {
          // Фьючерс (режим «Фьючи», 11.10.2026): лоты — контракты, вложено — номинал позиции; капитал счёта она
          // занимает в размере ГО.
          const _futNote = rub.contract
            ? ' Контрактов ' + rub.lots + ' ' + rub.contract + ', номинал позиции'
              + (rub.cap_rub != null ? ', ГО ' + Math.round(rub.cap_rub).toLocaleString('ru-RU') + ' ₽' : '') + '.'
            : '';
          const _ttl = (lotDim
            ? (notOpen ? 'Столько потребовалось бы, но сделка не открылась: ' + notOpen.why
                       : 'Столько потребовалось бы, но в пуле не хватило свободного капитала')
            : ((rub.status === 'active' && !acctClosed)
                ? 'Размер позиции по цене входа сетапа. Сделка ещё не закрыта'
                : 'Размер позиции по цене входа сетапа')) + _futNote;
          // Две строки (05.10.2026, решение владельца): лоты сверху, вложено снизу — как «Вход» и «Закрыт».
          lotCell = `<div class="row-l-lotrub${lotDim ? ' row-l-lotrub-dim' : ''}" title="${_ttl}">`
            + `<b class="lot-line">${rub.lots}</b>`
            + `<span class="rub-line">${Math.round(rub.invested).toLocaleString('ru-RU')}&nbsp;₽</span></div>`;
        } else {
          const _why = (rub && rub.status === 'canceled')
            ? (t.m1_skip_why ? 'Сделка не открылась: ' + t.m1_skip_why : 'Сделка не открылась: гэп до цены входа')
            : (rub && rub.pending)
              ? 'Сделка на контракте ещё не посчитана: модель считает её примерно через минуту после публикации сетапа (ночью и в клиринг — после открытия торгов), у неликвидного контракта — после первой сделки по нему'
              : 'Нет цены входа или оборот ниже 2 млн ₽ в день';
          lotCell = `<div class="row-l-lotrub row-l-lotrub-dim" title="${_why}">—</div>`;
        }
        const planKnown = v.final_direction === 'LONG' || v.final_direction === 'SHORT'
                          || !!(mi.target && mi.target.price != null);
        if (notOpen && _netSkipBadged(mi.net) && planKnown) {
          // Причину уже называет бейдж под названием («пропущен: открыта встречная позиция»,
          // «не хватило капитала») — ячейка её не повторяет, а показывает план сетапа, как у
          // остальных строк: направление + RR, цель (репорт владельца 28.09.2026: рядом с
          // бейджем стояло «не открыта · есть встречная позиция»). Строка приглушена целиком.
          doxCell = `<div class="row-l-rdist">${buildRdistInline(mi.r_distribution, mi.series, v.final_direction, mi.target)}</div>`;
        } else if (notOpen) {
          doxCell = `<div class="row-l-canceled row-l-notopen" title="${notOpen.tip}">не открыта`
            + `<span class="nopen-why">${notOpen.why}</span></div>`;
        } else if (hasReal || acctClosed) {
          // Деньги счёта: процент позиции, если неттинг переопределил исход (докупка
          // сдвинула стоп), и рубли = вложено × процент — ровно так их складывает
          // «Доход недели» (сверка 3в). rub.net_pnl_rub считается от лотов и расходился
          // с карточкой на рубли округления, а у переопределённых сделок — на весь исход.
          const np = (_deal && _deal.pct != null) ? Number(_deal.pct)
                   : (netMode && mi.net && mi.net.net_pct != null) ? Number(mi.net.net_pct)
                   : (rub ? rub.net_pct : null);
          const _inv = (_deal && _deal.inv != null) ? Number(_deal.inv) : (rub ? rub.invested : null);
          const npr = !rub ? null
                    : (netMode ? ((_inv != null && np != null) ? Number(_inv) * np / 100 : null)
                               : rub.net_pnl_rub);
          const showMoney = netMode
            ? !!(rub && (rub.status === 'resolved' || acctClosed) && np != null && npr != null)
            : poolOpened;
          if (showMoney) {
            // Округлённые значения без «минус нуля»: иначе у нулевого результата «+-0 ₽».
            const nprR = Math.round(npr) || 0;
            const npS = (Number(np).toFixed(2) === '-0.00') ? '0.00' : Number(np).toFixed(2);
            const pcls = nprR > 0 ? 'real-pos' : (nprR < 0 ? 'real-neg' : '');
            // Берём готовые np / nprR из ТОЙ ЖЕ ветки, что рисует прежние деньги счёта.
            compactAccount = { pct: Number(npS), pnlRub: nprR, invested: _inv,
              exitPrice: (netMode && mi.net && mi.net.net_pct != null)
                ? mi.net.exit_price : ((mi.exit || {}).price ?? t.exit_price),
              closeAt: (_deal && _deal.close_at) || (mi.net && mi.net.exit_date)
                || (mi.exit && (mi.exit.at || mi.exit.bar_date)) || t.exit_bar_date };
            const _gross = !!(rub && rub.gross);
            // Исход переопределён счётом (докупка перенесла стоп) — подпись называет это:
            // «TP 1R · риск 1R» у такой сделки читался бы как обычный тейк.
            const _ev = (netMode && mi.net && mi.net.net_pct != null) ? mi.net.event : null;
            // RR-уровень сетапа: стоп известен (sl_r обычно 1R) → TP/риск в R.
            // При BE цель и стоп сетапа не отработали — показываем причину выхода,
            // иначе «TP 1R · риск 1R» читается как обычный тейк (репорт 24.08).
            const _rr = (_ev === 'stop_moved')
              ? '<span class="row-l-rr">стоп&nbsp;перенесён</span>'
              : (_ev === 'reversal_close')
                ? '<span class="row-l-rr">закрыто&nbsp;встречным</span>'
                : (mi.r_outcome === 'BE')
                  ? '<span class="row-l-rr">стоп&nbsp;в&nbsp;безубытке</span>'
                : (mi.r_outcome === 'MKT')
                  ? '<span class="row-l-rr" title="' + _esc(_mrevTip(t)) + '">разворот&nbsp;рынка</span>'
                  : ((v.tp_r != null && v.sl_r != null)
                    ? `<span class="row-l-rr">TP&nbsp;${v.tp_r}R&nbsp;·&nbsp;риск&nbsp;${v.sl_r}R</span>` : '');
            const _ttl = _gross
              ? 'Результат без учёта издержек (gross)'
              : 'Чистый результат после издержек (комиссия + проскальзывание)';
            // В режиме процентов денег в строке нет — печатаем один процент
            // (сервер и лоты не присылает: rubles=false, колонки «Лот / ₽» нет).
            doxCell = STATE.unitsPct
              ? `<div class="row-l-netrub ${npS >= 0 ? 'real-pos' : 'real-neg'}" title="${_ttl}">${Number(npS) >= 0 ? '+' : ''}${npS}%${_rr}</div>`
              : `<div class="row-l-netrub ${pcls}" title="${_ttl}">${Number(npS) >= 0 ? '+' : ''}${npS}% / ${nprR >= 0 ? '+' : ''}${nprR.toLocaleString('ru-RU')}&nbsp;₽${_rr}</div>`;
          } else if (!netMode) {
            doxCell = `<div class="row-l-canceled" title="Не хватило свободного капитала в пуле на момент входа">не открыта</div>`;
          }
        }
      }
      if (_compactListView()) {
        let portfolio = null;
        if (_portfolioTableView()) {
          const cell = document.createElement('div');
          cell.innerHTML = doxCell;
          portfolio = { account: compactAccount, notOpen: notOpen, doxCell: doxCell,
            notOpenedCell: !!cell.querySelector('.row-l-canceled') };
        }
        return _testRowHtml(mi, headline, portfolio);
      }
      return `
        <div class="row-l ${dirCls}${(hasRdist || hasSeries) && !hasReal && !hasPct ? ' has-rdist' : ''}${(notOpen || (t.gated && !ideasMode)) ? ' row-not-opened' : ''}${(t.gated && !ideasMode) ? ' row-gated' : ''}${String(t.id) === String(STATE.expandedTriggerId) ? ' selected' : ''}" data-tid="${t.id}" data-ticker="${t.ticker}" data-tf="${t.tf || '1h'}"
             data-bar-date="${t.bar_date}" data-trigger-type="${t.trigger_type}">
          <div class="row-l-time" title="${_esc(_entryTimeTip(t, mi))}">${fmtTime(t.entry_time || _dispBarDate(t))}</div>
          <div class="row-l-tfcell">${tfBadge(t.tf)}</div>
          <div class="row-l-tk">
            <span class="row-l-tkr-line"><span class="row-l-ticker">${t.ticker}</span>${_favHeart(t.ticker)}</span>
            ${t.fut_contract
              ? `<span class="row-l-name row-l-fut" title="${_esc('Фьючерс ' + t.fut_contract + (t.ticker_name ? ' · ' + t.ticker_name : ''))}">${t.fut_contract}</span>`
              : `<span class="row-l-name"${t.ticker_name ? ` title="${_esc(t.ticker_name)}"` : ''}>${t.ticker_name || ''}</span>`}
          </div>
          <div class="row-l-headline"><span class="hl-l1">${headline}</span>${t.de_setup ? '' : buildEntryLine(t, mi)}${_nettingBadge(mi)}</div>
          ${STATE.deals ? _dealsExitCell(mi) : ''}
          ${(rubMode && !STATE.unitsPct) ? lotCell : ''}
          ${doxCell}
          ${nCell}
        </div>`;
    };
    // Постепенная отрисовка (12.09.2026, решение владельца): сначала строки, которые
    // видно в окне, остальные — порциями в следующих кадрах. Замер до правки: 559 строк
    // рисовались одним куском 0,4 с на быстрой машине и 2,8 с при CPU×4 — всё это время
    // таблицы не было на экране. Порядок и состав строк не меняются.
    const _gen = _llGen;
    const _nFirst = Math.min(filtered.length, _llFirstCount());
    root.innerHTML = filtered.slice(0, _nFirst).map(rowHtml).join('');
    _bindQualityTooltips(root);
    let _i = _nFirst;
    const _paintRest = (sync) => {
      if (_gen !== _llGen) return;                     // пришла новая отрисовка
      while (_i < filtered.length) {
        const _end = Math.min(_i + LL_CHUNK, filtered.length);
        root.insertAdjacentHTML('beforeend',
                                filtered.slice(_i, _end).map(rowHtml).join(''));
        _i = _end;
        _bindQualityTooltips(root);
        if (!sync) { requestAnimationFrame(() => _paintRest(false)); return; }
      }
      _llPending = null;
      _llDone();
    };
    if (_i < filtered.length) {
      _llPending = _paintRest;
      requestAnimationFrame(() => _paintRest(false));
    } else {
      _llDone();
    }
    // Клик по строке — делегированием на контейнере (один обработчик на весь список):
    // дорисованные порции работают без повторной привязки.
    if (!root.__rowsBound) {
      root.__rowsBound = true;
      root.addEventListener('click', (_ev) => {
        if (_compactListView() && _ev.target.closest('details.st-details')) return;
        const row = _ev.target && _ev.target.closest ? _ev.target.closest('.row-l') : null;
        if (!row || !root.contains(row)) return;
        const tid = row.getAttribute('data-tid');
        const ticker = row.getAttribute('data-ticker');
        const barDate = row.getAttribute('data-bar-date');
        const trigType = row.getAttribute('data-trigger-type');
        const tf = _tfForType(trigType, row.getAttribute('data-tf'));
        // Visual selection
        root.querySelectorAll('.row-l.selected').forEach(r => r.classList.remove('selected'));
        row.classList.add('selected');
        STATE.expandedTriggerId = tid;
        STATE.selectedTid = tid;   // точный id выбранного сетапа → sim-кнопка = его направление
        STATE.selectedTriggerBarDate = barDate;
        STATE.selectedTriggerType = trigType;
        // de-версии: строка несёт trigger_type='DOUBLE_EXTREME_MTF', но на графике маркер —
        // свой DE_-тип. Для solo (только выбранный сетап) селект по DE_-типу через de_setup.
        var _miClk = _findSetupByTid(tid);
        if (_miClk && _miClk.trigger.de_setup) {
          STATE.selectedTriggerType = _DE_SETUP_TO_TYPE[_miClk.trigger.de_setup] || trigType;
        }
        var opts = {};
        // «История сделок»: страница выбранной сделки — для возврата к ней по клику на маркер графика
        if (STATE.deals) STATE.selectedDealsPage = STATE.dealsPage;
        if (barDate) {
          // Live (Последние 14 дней): грузим окно вокруг даты сетапа → выбранная строка
          // видна на графике на ЛЮБОЙ глубине (а не только за 7-дневное окно витрины).
          // _applySoloFromSelection + selectTrigger ниже сами найдут её в data.triggers.
          opts.around = barDate;
        }
        loadChartInPanel(ticker, tf, opts);
      });
    }
  }

  /** Действия, которым нужен ВЕСЬ список (после последней порции). */
  function _llDone() {
    // Отложенный скролл после смены страницы «Истории сделок» (клик по маркеру на графике
    // → строка на другой странице → gotoDealsPage → сюда → скроллим к ней).
    if (STATE._pendingScroll) {
      var _ps = STATE._pendingScroll; STATE._pendingScroll = null;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { _scrollTableRowTo(_ps.bd16, _ps.type, true); });
      });
    }
  }

  /** Клик по карточке ТОП: подсвечиваем строку в списке + scroll-into-view +
   *  загружаем график. Без accordion (строки не раскрываются — один вариант). */
  function focusTriggerLight(tid, ticker, tf) {
    if (!STATE.data) return;
    STATE.expandedTriggerId = String(tid);
    // Solo: запомнить выбранный триггер кликнутой карточки (bar_date+type), чтобы
    // на графике показался именно он, а не «свежайший» fallback.
    _setSelectedFromTid(tid);
    // Перерисовать list-light (вынесем selected и проставим заново)
    renderListLight();
    _flushListLight();                 // строка может быть в ещё не отрисованной порции
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const row = document.querySelector(`.list-light .row-l[data-tid="${tid}"]`);
      if (row) row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      loadChartInPanel(ticker, tf);
    }));
  }

  // ── Table ────────────────────────────────────────
  /** Список — единая хронологическая лента: свежие сверху (по бару сигнала). */
  function sortItems(items) {
    // По моменту входа (колонка «Вход», 02.10.2026), без него — по началу сигнального бара.
    return [...items].sort((a, b) => {
      const va = a.trigger.entry_time || a.trigger.bar_date || '', vb = b.trigger.entry_time || b.trigger.bar_date || '';
      if (va < vb) return 1;
      if (va > vb) return -1;
      return 0;
    });
  }

  // Тултип «Доходность»: hover (CSS, мгновенно) + клик (для mobile). Клик вне — закрыть.
  function toggleRTip(e) {
    if (e) e.stopPropagation();
    var c = document.getElementById('r-help-card');
    if (c) c.classList.toggle('tip-open');
  }
  document.addEventListener('click', function() {
    var c = document.getElementById('r-help-card');
    if (c) c.classList.remove('tip-open');
  });

  // Track-record карточки (Всего сетапов + WR%) над Light-списком. Накопительно
  // по закрытым сделкам из re-detect (бэкенд: payload.track_record, с учётом
  // слайдера мин. оборота). WR% подкрашиваем относительно 50% безубытка.
  // Track-record карточки (Всего сетапов / WR / Доходность) — считаются КЛИЕНТСКИ по
  // закрытым сделкам (realized_r != null) из STATE.data.table. table уже отфильтрован
  // сервером по окну (1нед/1мес), типам и обороту → карточки реагируют на все эти
  // фильтры через refetch. Считаем по реальному исходу, не по серверному агрегату.
  // Карточка «Доходность» (chip, Light/Backtest). «Всего сетапов» и «Win Rate»
  // убраны — число сетапов переехало в переключатели (renderWindowCounts).
  // Понедельник текущей недели (локальное время браузера = МСК у наших юзеров).
  function _weekMonday() {
    const d = new Date();
    const dow = (d.getDay() + 6) % 7;            // пн=0 … вс=6
    d.setDate(d.getDate() - dow);
    d.setHours(0, 0, 0, 0);
    return d;
  }
  function _weekMondayLabel() {
    const m = _weekMonday();
    return String(m.getDate()).padStart(2, '0') + '.' + String(m.getMonth() + 1).padStart(2, '0');
  }
  // Сделки недели ПО ДАТЕ ВЫХОДА — та же единица, что во вкладке «Доход»
  // (иначе карточка и вкладка снова разъедутся, как «14 дн» против «Нед»).
  // back=0 — текущая неделя, back=1 — предыдущая.
  function _weekItems(items, back) {
    const from = _weekMonday();
    from.setDate(from.getDate() - 7 * (back || 0));
    const to = new Date(from); to.setDate(to.getDate() + 7);
    return (items || []).filter(function (mi) {
      // Админ читает дату выхода из ₽-блока, пользователь — из mi.exit (₽ ему не
      // отдаются). Порядок важен: у админа есть оба, берём привычный rub.
      const x = (mi.rub && mi.rub.exit_bar_date)
             || (mi.exit && mi.exit.bar_date) || null;
      if (!x) return false;
      const t = new Date(String(x).slice(0, 19).replace(' ', 'T'));
      return !isNaN(t) && t >= from && t < to;
    });
  }

  // Дней в мини-чарте «Доход недели» (28.09.2026): 7, когда стоп и трейл работают в сессию выходного дня
  // (settings.WEEKEND_SESSIONS → __SETUPS_CFG__.weekDays), иначе 5. Столбики сервера (netting.days) приходят
  // той же длины; клиентские запасные расчёты ниже строят столько же.
  const _WK_N = ((window.__SETUPS_CFG__ && window.__SETUPS_CFG__.weekDays) === 7) ? 7 : 5;
  const _wkZeros = function () { const a = []; for (let i = 0; i < _WK_N; i++) a.push(0); return a; };
  const _wkIdx = function (d) { return Math.min(_WK_N - 1, (d.getDay() + 6) % 7); };

  /** Доход по дням текущей недели (пн..пт, при _WK_N = 7 — пн..вс) — из ТЕХ ЖЕ сделок, что дала карточка.
   *  Считаем только по тем, что капитал-пул реально открыл (pool.opened), иначе
   *  сумма столбиков разошлась бы с числом рядом. При 5 днях закрытий в сб/вс не
   *  бывает (модель выхода выходных не видит), но если такая появится, кладём её в
   *  пятницу: лучше сдвиг дня, чем расхождение суммы с карточкой. */
  /** Дневная разбивка НЕТТИНГА: рубли закрытых позиций по дням недели.
   *  Считаем по тем же строкам, что показаны, и по тому же исходу, что в
   *  карточке (pf_net_pct переопределяет net_pct, если позиция закрыта иначе). */
  function _weekDailyPnlNet(items) {
    const by = _wkZeros();
    const _mon = (function () {                    // понедельник текущей недели, МСК
      const d = new Date(Date.now() + 3 * 3600e3);
      const t = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()));
      t.setUTCDate(t.getUTCDate() - ((t.getUTCDay() + 6) % 7));
      return t;
    })();
    (items || []).forEach(function (mi) {
      const n = mi.net, r = mi.rub;
      if (!n || n.status !== 'opened' || !r) return;
      // ⚠ Сделку, которую капитал-пул НЕ открыл, в столбик класть нельзя: её не
      // было. В таблице она приглушена («не хватило капитала»), карточка её тоже
      // исключает — а чарт считал (29.08, при депо 2 млн понедельник показывал
      // −61 ₽ вместо честных +935: две неоткрытые убыточные тянули его вниз).
      if (_noCap(n)) return;
      const pct = (n.net_pct != null) ? n.net_pct : r.net_pct;
      const xd = n.exit_date || r.exit_bar_date;
      if (pct == null || !xd) return;
      const d = new Date(String(xd).slice(0, 19).replace(' ', 'T'));
      if (isNaN(d) || d < _mon) return;            // только текущая неделя
      by[_wkIdx(d)] += (Number(r.invested) || 0) * Number(pct) / 100;
    });
    return by;
  }

  function _weekDailyPnl(items, pool) {
    const by = _wkZeros();
    (items || []).forEach(function (mi) {
      const r = mi.rub;
      if (!r || r.status !== 'resolved' || !pool.opened[mi.trigger.id]) return;
      if (r.net_pnl_rub == null || !r.exit_bar_date) return;
      const d = new Date(String(r.exit_bar_date).slice(0, 19).replace(' ', 'T'));
      if (isNaN(d)) return;
      by[_wkIdx(d)] += r.net_pnl_rub;
    });
    return by;
  }

  /** Сумма процентов закрытых сделок по дням недели — пользовательский аналог
   *  _weekDailyPnl. Капитал-пула здесь нет (₽ и лоты пользователю не отдаются),
   *  поэтому берём ВСЕ закрытые сделки недели: карточка считает по тем же. */
  function _weekDailyPct(items) {
    const by = _wkZeros();
    (items || []).forEach(function (mi) {
      if (mi.trigger && mi.trigger.gated) return;      // «не торгуем» — в доход не входит
      const r = mi.result, x = mi.exit;
      if (!r || r.net_pct == null || !x || !x.bar_date) return;
      const d = new Date(String(x.bar_date).slice(0, 19).replace(' ', 'T'));
      if (isNaN(d)) return;
      by[_wkIdx(d)] += Number(r.net_pct);
    });
    return by;
  }

  const _WK_DAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

  /** Мини-чарт дохода по дням недели. Нулевая линия по центру: плюс растёт
   *  вверх, минус вниз. Значение показывает тултип (CSS ::after по data-tip) —
   *  число на каждом столбике превратило бы полоску в таблицу. */
  function _renderWeekSpark(vals, unit) {
    const el = document.getElementById('wk-spark');
    if (!el) return;
    if (!vals) { el.innerHTML = ''; return; }
    el.innerHTML = _weekSparkHtml(vals, unit, { today: Math.min(vals.length - 1, (new Date().getDay() + 6) % 7) });
  }
  /** Столбики дохода по дням недели — общая разметка мини-чарта «Доход недели» и строк «Истории недель»
   *  (02.10.2026). o.max — масштаб (у «Истории недель» общий для всех недель; без него — своя неделя);
   *  o.today — индекс дня для подсветки подписи (-1 — нет); o.labels === false — без подписей дней под
   *  столбиками; o.monday — понедельник недели ('YYYY-MM-DD') для даты в подсказке; o.minH — минимальная
   *  высота ненулевого столбика в процентах (маленькая сумма рядом с большой неделей не пропадает). */
  function _weekSparkHtml(vals, unit, o) {
    o = o || {};
    const max = o.max || Math.max(1, ...vals.map(function (v) { return Math.abs(v); }));
    const today = (o.today == null) ? -1 : o.today;
    const mon = o.monday ? String(o.monday).match(/^(\d{4})-(\d{2})-(\d{2})/) : null;
    const dayDate = function (i) {
      if (!mon) return '';
      const d = new Date(Date.UTC(+mon[1], +mon[2] - 1, +mon[3] + i));
      return ' ' + String(d.getUTCDate()).padStart(2, '0') + '.' + String(d.getUTCMonth() + 1).padStart(2, '0');
    };
    return vals.map(function (v, i) {
      const h0 = Math.round(Math.abs(v) / max * 100);
      const h = (v !== 0 && o.minH) ? Math.max(o.minH, h0) : h0;
      const cls = v > 0 ? 'pos' : (v < 0 ? 'neg' : '');
      // ⚠ Точность по величине: дневная сумма процентов бывает сотыми долями
      // (день на +3 ₽ при позиции 20 тыс — это +0.015%), и один знак показал бы
      // «+0.0%» вместо числа.
      const val = (unit === 'pct')
        ? (v >= 0 ? '+' : '') + v.toFixed(Math.abs(v) < 1 ? 2 : 1) + '%'
        : (v >= 0 ? '+' : '') + Math.round(v).toLocaleString('ru-RU') + ' ₽';
      const tip = _WK_DAYS[i] + dayDate(i) + ': ' + (v === 0 ? 'нет закрытых сделок' : val);
      return '<div class="wk-day' + (i === today ? ' is-today' : '') + '" data-tip="'
        + tip.replace(/"/g, '&quot;') + '">'
        + '<div class="wk-half up"><i class="' + cls + '" style="height:' + (v > 0 ? h : 0) + '%"></i></div>'
        + '<div class="wk-half dn"><i class="' + cls + '" style="height:' + (v < 0 ? h : 0) + '%"></i></div>'
        + (o.labels === false ? '' : '<span class="wk-lbl">' + _WK_DAYS[i] + '</span>') + '</div>';
    }).join('');
  }

  /** «Доход недели %» и «Доход %» «Истории недель» — сумма процентов сделок (движение цены от входа до выхода
   *  после издержек), а не процент от депозита (08.10.2026: утром обкатка у админа, днём — всем ролям): тот же
   *  процент, что у строк таблицы и «Истории сделок», поэтому числа складываются из строк. Процент к депозиту —
   *  в подсказке карточки и второй строкой «Итого». Нет поля sum_pct (сервер старее страницы, кэш прошлого
   *  визита) — прежний вид; режим «только проценты» (админ) — свой. */
  function _pctFromPrice(s) {
    return !STATE.unitsPct && !!s && s.sum_pct != null;
  }

  /** Текст «фирменного» тултипа карточки дохода. Пишем коротко и без жаргона:
   *  на витрине NET (комиссия по полю «Комиссия брокера» и проскальзывание уже
   *  вычтены) — слова «gross» в тексте быть не должно (владелец 29.08). */
  function _tipNet(n) {
    const mln = (v) => (Number(v) / 1e6).toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    const rub = (v) => Math.round(Number(v) || 0).toLocaleString('ru-RU');
    if (STATE.unitsPct && n.inv_pct != null) {
      // Режим «%» с «на вложенные» (23.10.2026, settings.SETUPS_UNITS_INV_MODE): главная цифра — доход на вложенные,
      // сумма процентов сделок на экран не выводится; справочно — средний результат сделки.
      const avgI = (n.closed ? (Number(n.net_pct || 0) / n.closed) : 0);
      return '<div class="tr-tip-title">Доход недели на вложенные</div>'
        + '<div>Что стало бы с&nbsp;деньгами, если вкладывать в&nbsp;каждый сигнал одну и&nbsp;ту&nbsp;же сумму: доход каждого '
          + 'дня (закрытые сделки и&nbsp;открытые позиции по&nbsp;цене) делится на&nbsp;деньги, одновременно стоявшие '
          + 'в&nbsp;сделках в&nbsp;этот день, дни сцепляются&nbsp;— как у&nbsp;индекса.</div>'
        + '<div>Закрытых сделок ' + (n.closed || 0) + ', в&nbsp;среднем ' + (avgI >= 0 ? '+' : '')
          + avgI.toFixed(3) + '%&nbsp;на&nbsp;сделку.</div>'
        + '<div>Комиссия и&nbsp;проскальзывание уже вычтены.</div>'
        + '<div>Позиция по&nbsp;бумаге одна: сигнал в&nbsp;ту&nbsp;же сторону сливается в&nbsp;неё, встречный при&nbsp;открытой позиции не&nbsp;открывается.</div>';
    }
    if (STATE.unitsPct) {
      // Режим «только проценты»: денег и капитала нет, поэтому и объяснять надо
      // другое — как читать сумму и почему она не равна доходности счёта.
      const avg = (n.closed ? (Number(n.net_pct || 0) / n.closed) : 0);
      return '<div class="tr-tip-title">Сумма % за неделю</div>'
        + '<div>Сумма результатов сделок, закрытых на&nbsp;этой неделе, в&nbsp;процентах от&nbsp;цены бумаги.</div>'
        + '<div>Каждая сделка берётся ОДНИМ размером, капитал не&nbsp;ограничен&nbsp;— поэтому число не&nbsp;равно доходности счёта: '
          + 'чтобы перевести, разделите на&nbsp;«депозит ÷ размер позиции».</div>'
        + '<div>Закрытых сделок ' + (n.closed || 0) + ', в&nbsp;среднем ' + (avg >= 0 ? '+' : '')
          + avg.toFixed(3) + '%&nbsp;на&nbsp;сделку'
          + (n.max_concurrent ? '; одновременно держалось до&nbsp;' + n.max_concurrent + '&nbsp;позиций' : '') + '.</div>'
        + '<div>Комиссия и&nbsp;проскальзывание уже вычтены.</div>'
        + '<div>Позиция по&nbsp;бумаге одна: сигнал в&nbsp;ту&nbsp;же сторону сливается в&nbsp;неё, встречный при&nbsp;открытой позиции не&nbsp;открывается.</div>';
    }
    const _pp = _pctFromPrice(n);
    const _dp = Number(n.net_pct) || 0;
    return '<div class="tr-tip-title">Доход недели</div>'
      + '<div>Сумма результатов сделок, закрытых на этой неделе.</div>'
      + (_pp && _investedView()
        ? '<div>Проценты&nbsp;— сумма процентов сделок: движение цены от&nbsp;входа до&nbsp;выхода с&nbsp;учётом издержек, '
          + 'как в&nbsp;строках таблицы. Размер позиции ' + rub(n.pos_size) + '&nbsp;₽ (меняется слайдером в&nbsp;сайдбаре).</div>'
        : _pp
        ? '<div>Проценты&nbsp;— сумма процентов сделок: движение цены от&nbsp;входа до&nbsp;выхода с&nbsp;учётом издержек, '
          + 'как в&nbsp;строках таблицы. К&nbsp;депозиту ' + mln(n.capital_rub) + '&nbsp;млн&nbsp;₽ неделя дала '
          + (_dp >= 0 ? '+' : '') + _dp.toFixed(2) + '%, размер позиции ' + rub(n.pos_size)
          + '&nbsp;₽ (меняются слайдерами в&nbsp;сайдбаре).</div>'
        : '<div>Проценты&nbsp;— от&nbsp;депозита ' + mln(n.capital_rub) + '&nbsp;млн&nbsp;₽'
          + ', размер позиции ' + rub(n.pos_size) + '&nbsp;₽ (меняются слайдерами в&nbsp;сайдбаре).</div>')
      + '<div>Комиссия и&nbsp;проскальзывание уже вычтены: комиссия&nbsp;— из&nbsp;поля '
        + '«Комиссия брокера» в&nbsp;сайдбаре, проскальзывание&nbsp;— по&nbsp;типовому спреду бумаги.</div>'
      + '<div>Позиция по&nbsp;бумаге одна: сигнал в&nbsp;ту&nbsp;же сторону сливается в&nbsp;неё, встречный при открытой позиции не&nbsp;открывается. Такие сетапы видны в&nbsp;таблице приглушёнными.</div>'
      + ((n.skipped_week != null ? n.skipped_week : n.skipped)
         ? '<div class="tr-tip-note">'
           + (n.skipped_week != null ? n.skipped_week : n.skipped)
           + ' сетапов на&nbsp;этой неделе не&nbsp;открылись: '
           + 'не&nbsp;хватило капитала.</div>'
         : '');
  }

  var _TR_TIP_DEFAULT = null;    // исходный текст из разметки (R-шкала)

  function _setTrTip(html) {
    var el = document.getElementById('r-tip-bubble');
    if (!el) return;
    if (_TR_TIP_DEFAULT === null) _TR_TIP_DEFAULT = el.innerHTML;
    el.innerHTML = (html === null ? _TR_TIP_DEFAULT : html);
  }

  function renderTrackCards() {
    const elS = document.getElementById('tr-sumr');
    const elSL = document.getElementById('tr-sumr-lbl');
    if (!elS) return;
    // «История сделок» — сделки всех недель; доход текущей недели там не к месту (как в «Истории недель»):
    // карточку прячет CSS, итог истории — в строке над таблицей (renderDealsLabel).
    if (STATE.deals) { _renderWeekSpark(null); return; }
    // Сброс native-title карточки (ставится только в ₽-режиме; иначе остался бы стейл).
    const _rhc = document.getElementById('r-help-card');
    if (_rhc) _rhc.title = '';
    // Текст тултипа зависит от способа счёта: ниже ветка неттинга поставит свой,
    // а для старого способа (R-шкала) возвращаем исходный из разметки.
    _setTrTip(null);
    // ₽-режим (admin): доход за ТЕКУЩУЮ КАЛЕНДАРНУЮ НЕДЕЛЮ (решение владельца
    // 24.08). Раньше карточка считала по всему окну таблицы (14 дней) — число
    // менялось само по себе, когда старая сделка выпадала из скользящего окна,
    // и не совпадало с вкладкой «Доход». Единица учёта теперь одна — неделя,
    // сделка относится к ней по дате ВЫХОДА (когда деньги получены).
    // Неттинг (admin-прототип): главная цифра — доход на работающие деньги
    // (прибыль ÷ средний занятый капитал). Депозит не назначаем: он производная
    // от размера позиции и потока сигналов, поэтому идёт справочной строкой.
    // Неттинг — расчёт витрины ДЛЯ ВСЕХ (28.08): различие ролей только в том,
    // ЧТО показываем (админу ещё и рубли), а не в том, КАК считаем.
    const _net = STATE.data && STATE.data.netting;
    if (_net) {
      const n = STATE.data.netting;
      // ⚠ Та же база, что в «Истории недель» — депозит. Иначе карточка и строка
      // той же недели показывали бы разные числа (было 2.11% против 2.63%).
      // У админа (08.10.2026) — сумма процентов сделок недели (_pctFromPrice); процент к депозиту — в подсказке.
      // В режиме процентов денег нет: показываем сумму процентов сделок недели
      // и их число (решение владельца 22.09). Рубли сервер не присылает вовсе.
      const _upct = !!STATE.unitsPct;
      // режим «%» с «на вложенные» (23.10.2026): доход недели на вложенные вместо суммы процентов (сервер: inv_pct)
      const _uinv = _upct && n.inv_pct != null;
      const pct = _uinv ? (Number(n.inv_pct) || 0)
        : _pctFromPrice(n) ? (Number(n.sum_pct) || 0)
        : (Number(n.net_pct) || 0);   // прежний «на работающие» (on_working_pct) на экран не выводится (16.10.2026)
      const _rub = (!_upct && n.profit_rub != null)
        ? ' <span class="tc-sub">' + (n.profit_rub >= 0 ? '+' : '')
          + Math.round(n.profit_rub).toLocaleString('ru-RU') + ' ₽</span>'
        : (_upct && n.closed != null
           ? ' <span class="tc-sub">' + n.closed + ' сд.</span>' : '');
      elS.innerHTML = (pct >= 0 ? '+' : '') + pct.toFixed(2) + '%' + _rub;
      elS.style.color = pct > 0 ? 'var(--green)' : (pct < 0 ? 'var(--red)' : '');
      if (elSL) elSL.textContent = n.opp_skip_only
        ? (_upct ? 'Сумма % · пропущенные встречные' : 'Доход · пропущенные встречные')
        : (_uinv ? 'Доход недели · на вложенные' : (_upct ? 'Сумма % за неделю' : 'Доход недели'));
      _updatePosNote();
      // Мини-чарт по дням — часть того же блока, что и раньше (владелец 28.08):
      // в неттинге считаем по закрытым позициям текущей недели.
      // ⚠ Дни считает СЕРВЕР (netting.days) — по той же ленте, что карточку.
      // Клиентский расчёт остаётся запасным путём: он идёт по показанным
      // строкам, а они скачаны без фильтра детекторов, и у админа в ленте
      // участвует admin-only детектор — дни расходились с пользовательскими
      // при одинаковом итоге (владелец 29.08).
      // Единицы мини-чарта — те же, что у карточки: в режиме процентов сервер
      // присылает дневные суммы уже в процентах (вес сделки 100 единиц).
      _renderWeekSpark(STATE.weekly ? null
                       : ((_uinv && Array.isArray(n.inv_days)) ? n.inv_days
                          : Array.isArray(n.days) ? n.days
                          : _weekDailyPnlNet(visibleItems())),
                       _upct ? 'pct' : undefined);
      // ⚠ Нативный title снят (владелец 29.08): при наведении всплывали ДВА
      // тултипа сразу. Остаётся один — «фирменный» .tr-tip, его текст ниже.
      const _cardN = document.getElementById('r-help-card');
      if (_cardN) _cardN.removeAttribute('title');
      _setTrTip(_tipNet(n));
      return;
    }
    if (STATE.mode === 'rubles' && STATE.data && STATE.data.rubles) {
      // Строго ТЕКУЩАЯ неделя: значение копится с понедельника по пятницу
      // (требование владельца 24.08). В понедельник до первых закрытий это
      // ноль — так и должно быть, подмена прошлой неделей вводила бы в
      // заблуждение («доход» был бы не за тот период, что в таблице).
      const wkItems = _weekItems(visibleItems(), 0);
      const pool = _rubCapitalPool(wkItems);
      const ret = pool.deposit ? (pool.realized / pool.deposit * 100) : 0;
      const _profit = (pool.realized >= 0 ? '+' : '') + Math.round(pool.realized).toLocaleString('ru-RU')
        + ' ₽ / ' + (ret >= 0 ? '+' : '') + ret.toFixed(2) + '%';
      // Хвост «текущая неделя» убран (владелец 25.08): период называет сам
      // лейбл «Доход недели», а разбивку по дням показывает мини-чарт справа.
      elS.innerHTML = _profit;
      elS.style.color = pool.realized > 0 ? 'var(--green)' : (pool.realized < 0 ? 'var(--red)' : '');
      if (elSL) elSL.textContent = 'Доход недели';
      _renderWeekSpark(_weekDailyPnl(wkItems, pool));
      const _card = document.getElementById('r-help-card');
      if (_card) _card.title = 'Текущая неделя с ' + _weekMondayLabel()
        + ' (по дате выхода из сделки) · '
        + pool.nOpened + ' открыто · ' + pool.nSkipped
        + ' пропущено (нехватка капитала) · депозит ' + (pool.deposit / 1e6).toFixed(1) + ' млн ₽'
        + ' · полная разбивка — вкладка «Доход»';
      return;
    }
    // Пользовательский режим: та же карточка недели, но в процентах — ₽ и лоты
    // пользователю не отдаются (решение владельца 28.08). Метрика — СУММА
    // результатов закрытых сделок недели (его выбор из трёх вариантов).
    // ⚠ Число достижимо только если взять КАЖДУЮ сделку недели равным размером
    // одновременно; про это прямо сказано в подсказке карточки, иначе +168%
    // читалось бы как обещание.
    if (STATE.mode === 'user' && STATE.data) {
      const wkItems = _weekItems(visibleItems(), 0);
      const closed = wkItems.filter(function (mi) {
        return mi.result && mi.result.net_pct != null;
      });
      const sum = closed.reduce(function (a, mi) { return a + Number(mi.result.net_pct); }, 0);
      elS.innerHTML = (sum >= 0 ? '+' : '') + sum.toFixed(2) + '%';
      elS.style.color = sum > 0 ? 'var(--green)' : (sum < 0 ? 'var(--red)' : '');
      if (elSL) elSL.textContent = 'Доход недели';
      _renderWeekSpark(_weekDailyPct(closed), 'pct');
      const _cardU = document.getElementById('r-help-card');
      if (_cardU) _cardU.title = 'Текущая неделя с ' + _weekMondayLabel()
        + ' (по дате выхода из сделки) · ' + closed.length + ' закрытых сделок · '
        + 'сумма результатов при равном размере позиции, без комиссии. '
        + 'Ваш результат зависит от того, сколько сделок вы взяли.';
      return;
    }
    _renderWeekSpark(null);   // не ₽-режим → мини-чарт недели неуместен
    // ⚠ Ранний выход для user убран (28.08): центральная часть одинакова в обеих
    // ролях, realized_r приходит всем. При неттинге (расчёт по умолчанию) сюда
    // вообще не доходит — ветка _net выше.
    if (elSL) elSL.textContent = 'Доходность';
    const rows = ((STATE.data && STATE.data.table) || [])
                   .filter(mi => mi.realized_r !== undefined && mi.realized_r !== null);
    if (!rows.length) { elS.textContent = '—'; elS.style.color = ''; return; }
    const sumR = rows.reduce((s, r) => s + r.realized_r, 0);
    const s = Math.round(sumR);
    elS.textContent = (s >= 0 ? '+' : '') + s.toLocaleString('ru-RU') + 'R';
    elS.style.color = sumR > 0 ? 'var(--green)' : (sumR < 0 ? 'var(--red)' : '');
  }

  // Счётчик сетапов у вкладки «Неделя» — из payload.setup_counts или по строкам таблицы. Счётчик «Всей
  // истории» снят вместе с вкладкой (05.10.2026: она переехала в лабораторию). Вызывается из renderTable.
  function renderWindowCounts() {
    const sc = (STATE.data && STATE.data.setup_counts) || null;
    const fmt  = n => (n == null) ? '' : Number(n).toLocaleString('ru-RU');
    const wrap = s => s ? '(' + s + ')' : '';   // число сетапов — в скобках
    const elR = document.getElementById('rng-count-recent');
    const elRg = document.getElementById('rng-count-recent-g');  // зеркало для Gross (admin)
    // Таб «Неделя» показывает только сделки текущей недели (фильтр на сервере),
    // а серверный счётчик setup_counts.recent считает 14-дневное окно — он соврал
    // бы у ОБЕИХ ролей (у пользователя показывал 1319 при 202 строках). Берём факт.
    const _weekTab = !STATE.deals && !STATE.weekly;
    // Пока лёгкий ответ в пути (пары «детектор × ТФ», направление или оборот сужены), серверные счётчики
    // полного ответа посчитаны без них — не рисуем, оставляем прежнюю надпись до лёгкого ответа (28.09.2026).
    const _pending = !!(STATE.data && STATE.data._slimPending);
    if (_weekTab || !_pending) {
      // «не торгуем» в счётчик не входят — кроме вида «Сетапы»: там снятые правилами считаются, как все (27.10.2026)
      const _sv = _setupsView();
      const recTxt = _weekTab ? wrap(fmt(visibleItems().filter(function (mi) { return _sv || !(mi.trigger && mi.trigger.gated); }).length))
                              : (sc ? wrap(fmt(sc.recent)) : '');
      if (elR) { elR.textContent = recTxt; elR.classList.remove('rng-count-wait'); }
      if (elRg) elRg.textContent = recTxt;
    }
  }

  function renderTable() {
    renderWindowCounts();     // счётчики переключателей вкладок
    renderTrackCards();
    return renderListLight();
  }

  // ── Sidebar drawer (mobile) ──────────────────────
  function toggleSidebar() {
    const sb = document.getElementById('sidebar');
    const bd = document.getElementById('sidebar-backdrop');
    if (!sb) return;
    const isOpen = sb.classList.toggle('open');
    if (bd) bd.classList.toggle('open', isOpen);
    // Lock body scroll при открытом drawer (избегаем double-scroll)
    document.body.style.overflow = isOpen ? 'hidden' : '';
  }
  // ESC закрывает drawer (если открыт)
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const sb = document.getElementById('sidebar');
      if (sb && sb.classList.contains('open')) toggleSidebar();
    }
  });

  // window-toggle удалён — stats всегда показываются за день (stats_day).

  // ── Filters ──────────────────────────────────────
  function currentFilters() {
    const f = {};
    // DE_* admin-версии идут в trigger_types наравне с обычными типами — так каждая
    // версия фильтруется независимо И в таблице (build_de_admin_setups → per-version),
    // И на графике (state.triggerTypes). Иначе «только тест» показывал бы все сетапы.
    // Пары «тип:ТФ» — у каждого детектора свои чекбоксы 1ч/4ч.
    // trigger_types шлём тоже: его читают смежные ветки (вкладка «Нед»).
    const _on = Array.from(document.querySelectorAll('#f-triggers input[type="checkbox"][data-tt]:checked'));
    // галочка основного детектора включает и связки его вариантов (DET_GROUPS, 27.10.2026)
    const _pairs = _expandPairs(_on.map(x => x.getAttribute('data-tt') + ':' + x.getAttribute('data-tf')));
    const tts = Array.from(new Set(_pairs.map(p => p.split(':')[0])));
    if (tts.length) f.trigger_types = tts.join(',');
    if (_pairs.length) f.type_tf = _pairs.join(',');
    // Таймфреймы: шлём, только если выбраны не все (пусто на сервере = все витринные).
    const long = document.getElementById('f-long').checked;
    const short = document.getElementById('f-short').checked;
    if (long && !short) f.direction = 'LONG';
    if (short && !long) f.direction = 'SHORT';
    // Вселенная акций — «Голубые фишки» и «Префы»; в режиме «Фьючи» у контрактов своя («Фьючи-ликвид» / «Фьючи-неликв»
    // ниже), эти галочки спрятаны и не действуют.
    if (!_futOn()) {
      if (document.getElementById('f-blue-chips').checked) f.blue_chips_only = 1;
      // «Префы» (05.10.2026 админ, с 07.10.2026 всем ролям): привилегированные акции — одни или вместе с «Голубыми
      // фишками» (объединение, catalog_matcher.blue_universe).
      var _bp = document.getElementById('f-blue-prefs');
      if (_bp && _bp.checked) f.blue_chips_prefs = 1;
    }
    // «Только избранные» — серверный фильтр. Anon: шлём CSV из localStorage;
    // auth: бэкенд резолвит из БД (favorite_tickers игнорируется, см. api_setups).
    if (document.getElementById('f-favorites').checked) {
      f.favorites_only = 1;
      f.favorite_tickers = (window.Favorites ? Favorites.getFavorites() : []).join(',');
    }
    f.min_turnover = turnoverFromSlider();
    var _mxTurn = turnoverMaxFromSlider();
    if (_mxTurn) f.max_turnover = _mxTurn;  // шлём только при реальном верхнем пределе
    // Ticker filter — volatile (НЕ сохраняется в prefs).
    const tickEl = document.getElementById('ticker-input');
    const tk = tickEl ? tickEl.value.trim() : '';
    if (tk) f.ticker = tk;
    // Админские чекбоксы-фильтры (volatile): убирают строки И меняют «Доход».
    if (STATE.hideSkipped) f.hide_skipped = '1';
    // правило безубытка для шортов (admin); у модели фьючерсов безубытка нет — в режиме «Фьючи» чекбокс спрятан
    if (STATE.beShort && !_futOn()) f.be_short = '1';
    if (STATE.hideWeak) f.hide_weak = '1';
    if (STATE.onlyAtLevel) f.only_at_level = '1';
    // «Показать слабые в падении» — снимает серверный фильтр weak_brake (admin).
    if (STATE.showWeakBlocked) f.show_weak_blocked = '1';
    // «Выкл 4ч-рост» — снимает серверный фильтр h4_brake (admin; у всех включён с 24.09).
    if (STATE.showH4) f.show_h4_blocked = '1';
    // «Выкл 2ч-рост» — снимает серверный фильтр 2ч-правила (admin; у всех включён с 28.09.2026):
    // шорты после сильного 2ч-блока сессии индекса (trig_json.h2_blocked).
    if (STATE.showH2) f.show_h2_blocked = '1';
    // «Gap-race» — снимает серверный фильтр «не гнаться за гэпом» (admin; у всех включён с 28.09.2026,
    // №170): сетапы в сторону утреннего гэпа IMOEX (trig_json.gap_blocked).
    if (STATE.showGap) f.show_gap_blocked = '1';
    // «Выкл индекс-фильтр» — снимает серверный фильтр входа по ходу индекса (admin; у всех
    // включён с 25.09.2026, №167).
    if (STATE.showIdx) f.show_idx_blocked = '1';
    // «Выкл вечер-фильтр» — снимает серверный фильтр «Вечер против» (admin; у всех включён с 20.10.2026, №193): вход вне
    // основной сессии против хода IMOEX от закрытия основной (trig_json.ev_blocked; помечены только новые сетапы).
    if (STATE.showEv) f.show_ev_blocked = '1';
    // «Выкл запрет усреднения шортов» — снимает правило счёта «не усредняем вниз» шорты (admin; у всех с 21.10.2026,
    // №194, только вперёд): счёт, недели, «История сделок» и «Детекторы» — без правила, своя запись счёта на сервере.
    // В виде «Сетапы» правил счёта нет — галочка спрятана и не шлётся (27.10.2026)
    if (STATE.avgDownOff && !_setupsView()) f.avg_down = '0';
    // «Все» (20.10.2026, setup_gates): ещё и сетапы, снятые правилами витрины, — приглушённо, отдельной лентой сервера;
    // счёт и суммы от параметра не меняются (_gatedOn — режим __SETUPS_CFG__.gatedMode и роль)
    if (_gatedOn()) f.show_gated = '1';
    // «Выкл рынок против» — снимает серверный фильтр «Рынок против» (admin; у всех и у бота с 21.10.2026, №175, только
    // вперёд): сетапы против хода равновзвешенного рынка ликвидных бумаг (trig_json.ew_blocked, вход с ew_brake.LIVE_SINCE).
    if (STATE.showEw) f.show_ew_blocked = '1';
    // «Разворот рынка» — обкатка под админом (№188, 16.10.2026): правило выхода поверх модели витрины — шорт
    // закрывается, когда рынок откатил от лучшей точки после входа на 1,5 % и больше (market_reversal.apply_exits).
    if (STATE.mrevExit) f.mrev_exit = '1';
    // «Ранний трейл шортов» — обкатка под админом (№190, 20.10.2026): параметр уходит, только когда галочка расходится
    // с режимом по умолчанию (_armParam) — у вида по умолчанию ключи кэша те же, что готовит пересчётчик.
    var _arm = _armParam();
    if (_arm) f.arm_exit = _arm;
    // «Стоп дальше у «Скрытого уровня»» — обкатка под админом (№196, 23.10.2026): стоп дальше, позиция — тот же риск в
    // рублях; только вперёд (сетапы с SETUPS_WIDE_STOP_SINCE). По умолчанию выключена — параметр уходит только с галочкой.
    if (_wsParam()) f.wide_stop = '1';
    // Сборка витрины (admin, из адреса): сервер сам проверит роль — не-админу признак не действует.
    if (STATE.build) f.build = STATE.build;
    // Модель выхода (admin, из адреса): сервер сам проверит роль — не-админу параметр не действует.
    if (STATE.xm) f.exit_model = STATE.xm;
    // Режим «Фьючи» (11.10.2026, admin): витрина фьючерсов. Отсюда признак берут все запросы — данные, лёгкий ответ,
    // карточки, «История недель», «История сделок» (_ledgerFilters), «Детекторы» (переносит явно).
    // Вселенная контрактов — галочки сайдбара «Фьючи-ликвид» (fut_liquid: от порога «дешёвый контракт») и «Фьючи-неликв»
    // (fut_illiquid: остальные); обе — все контракты, как без них: не шлём ни одной (тот же ключ кэша).
    if (_futOn()) {
      f.fut = '1';
      var _fl = !!(document.getElementById('f-fut-liquid') || {}).checked;
      var _fi = !!(document.getElementById('f-fut-illiquid') || {}).checked;
      if (_fl && !_fi) f.fut_liquid = '1';
      if (_fi && !_fl) f.fut_illiquid = '1';
    }
    // «Только пропущенные встречные» (admin, 24.09.2026): сервер считает «Доход недели»,
    // дни миничарта и «Историю недель» по сделкам, пропущенным из-за открытой встречной
    // позиции (каждая со своим исходом); таблица оставляет только их (visibleItems).
    if (STATE.oppSkipOnly && !_setupsView()) {     // в «Сетапах» пропусков нет — галочка спрятана (27.10.2026)
      f.opp_skip = '1';
      // Пропуск из-за встречной позиции — двусторонний: счёт режима строится БЕЗ фильтра
      // направления (иначе «только лонги» давали бы счёт без шортов, где пропускать нечего,
      // и 0 ₽), а направление уходит отдельным параметром — сервер отбирает по нему
      // пропущенные сделки. Таблица фильтрует направление как обычно (по галочкам).
      if (f.direction) { f.opp_dir = f.direction; delete f.direction; }
    }
    // Режим User у админа: сервер отдаёт РОВНО пользовательскую выдачу.
    if (STATE.mode === 'user' && _authState && _authState.is_admin) f.view_as = 'user';
    return f;
  }

  /** Серверные фильтры запроса ДАННЫХ живой витрины: без клиентских (пары тип:ТФ, направление, верх
   *  слайдера оборота — их сужение мгновенно делает _filterByUi), низ оборота — пол шкалы. Общая часть
   *  запроса данных (fetchAndRender) и лёгкого запроса карточек (_topParams), 26.09.2026. */
  function _dataFilters(f) {
    const d = Object.assign({}, f);
    delete d.trigger_types; delete d.type_tf; delete d.direction;
    delete d.max_turnover;
    d.min_turnover = String(TURNOVER_VALUES[0]);
    return d;
  }

  /** Лёгкий запрос карточек (top_only) — теми же издержками, единицами, сборкой и серверными фильтрами
   *  вселенной, что запрос данных, плюс week_only (26.09.2026): карточки лёгкого ответа = карточкам
   *  полного. Точка сборки — первый визит (fetchAndRender; прелоад в <head> — подпись
   *  setups_defaults.default_top_query). Карточки — витрина всего рынка: фильтр по тикеру к ним не относится. */
  function _topParams(f) {
    const u = _dataFilters(f);
    delete u.ticker;
    delete u.show_gated;                 // карточки — только торгуемые сделки: переключатель «Все» их не меняет
    return new URLSearchParams({ days_back: STATE.daysBack, window: STATE.window, top_only: '1',
                                 week_only: '1', ..._urlDemoShortRisk(), ..._commissionQuery(),
                                 ..._unitsQuery(), ...u });
  }

  // ── Ticker filter handlers ────────────────────────
  // Volatile state — НЕ сохраняется в prefs (по дизайну: пользователь не хочет
  // прибитый прошлый ticker при следующем заходе). URL ?ticker=X — auto-apply.
  function applyTickerFilter(value) {
    const v = (value || '').trim();
    const wrap = document.getElementById('ticker-search-wrap');
    const input = document.getElementById('ticker-input');
    if (input.value !== v) input.value = v;
    if (wrap) wrap.classList.toggle('has-value', !!v);
    onFilterChange();
  }
  function clearTickerFilter() {
    const input = document.getElementById('ticker-input');
    if (input) input.value = '';
    const wrap = document.getElementById('ticker-search-wrap');
    if (wrap) wrap.classList.remove('has-value');
    onFilterChange();
  }
  // Apply ?ticker=X from URL on initial load (one-shot, before fetchAndRender).
  (function initTickerFromURL() {
    try {
      const u = new URL(window.location.href);
      const t = (u.searchParams.get('ticker') || '').toUpperCase();
      if (t) {
        const input = document.getElementById('ticker-input');
        if (input) {
          input.value = t;
          const wrap = document.getElementById('ticker-search-wrap');
          if (wrap) wrap.classList.add('has-value');
        }
      }
      // ?solo_bar=<bar_date>&solo_type=<TRIGGER_TYPE>[&solo_dir=LONG|SHORT] —
      // жёстко зафиксировать, КАКОЙ сетап показать на графике. Нужен скриншотеру
      // для TG-рассылки (setup_screenshot.py): он снимает #chartPanel, и выбор
      // сетапа не должен зависеть от таблицы — та у анонима задержана на 4 ч
      // (ANON_DELAY_HOURS), т.е. свежего сетапа в ней ещё нет.
      // Эти два поля STATE — тот же вход, что и у клика по строке: через них уже
      // работают solo-маркер, линии дивергенции, линия SL и подсветка уровня
      // (всё берётся из данных графика, не из таблицы). Новой логики не заводим.
      const sBar = u.searchParams.get('solo_bar');
      const sType = u.searchParams.get('solo_type');
      if (sBar && sType) {
        STATE.selectedTriggerBarDate = sBar;
        STATE.selectedTriggerType = sType;
        STATE.soloDir = u.searchParams.get('solo_dir') || null;
      }
      // ТФ панели для скриншотера — НЕЗАВИСИМО от solo-параметров: FA-пики
      // daily_pick снимаются без сетапа (?ticker=X&solo_tf=D1). Для solo-снимков
      // тоже нужен: _tfForTicker судит по таблице, а она у анонима задержана
      // (ANON_DELAY) → свежего сетапа там нет → выбрал бы дефолт 15m.
      STATE.soloTf = u.searchParams.get('solo_tf') || null;
      // ?preset=<id> (из TG-уведомления) — авто-открыть пресет-таб после загрузки
      // списка пресетов (renderSetupsPresets применит pending).
      const pr = parseInt(u.searchParams.get('preset'), 10);
      if (pr) STATE._pendingPreset = pr;
    } catch (e) { /* URL API not available */ }
  })();
  // Input change handler: re-fetch on debounce (300ms after last keystroke)
  let _tickerDebounceTimer = null;
  document.getElementById('ticker-input').addEventListener('input', function(e) {
    // НЕ форсим uppercase — поиск умный (рус название / англ тикер, регистр не важен).
    const v = e.target.value.trim();
    const wrap = document.getElementById('ticker-search-wrap');
    if (wrap) wrap.classList.toggle('has-value', !!v);
    clearTimeout(_tickerDebounceTimer);
    _tickerDebounceTimer = setTimeout(() => onFilterChange(), 300);
  });
  // Esc key — clear ticker filter (when input has value, otherwise no-op)
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    const input = document.getElementById('ticker-input');
    if (input && input.value) {
      e.preventDefault();
      clearTickerFilter();
    }
  });
  // RSI pane показывается ВСЕГДА (по запросу 2026-06-05), независимо от фильтра
  // триггеров. _isDivergenceFilterActive остаётся для авто-показа линий дивергенции.
  function _isDivergenceFilterActive() {
    var cb = document.querySelector('#f-triggers input[data-tt="DIVERGENCE"]');
    return cb ? cb.checked : false;
  }
  function _syncChartRsiVisibility() {
    if (_panelEngine && _panelEngine.setShowRsi) {
      _panelEngine.setShowRsi(true);   // RSI всегда виден
    }
  }

  // UI trigger_types → DB trigger_type (соответствует _UI_TO_DB_TT в catalog_matcher).
  // Маркеры на /api/ta/chart-data приходят в DB-формате (FALSE_BREAKOUT_MTF и т.д.),
  // а STATE.filters.trigger_types хранит UI-аббревиатуры (FALSE_BREAKOUT). Mapping
  // нужен для setTriggerTypes() — chart-engine принимает DB-format Set.
  const _UI_TO_DB_TT_MAP = {
    'FALSE_BREAKOUT': 'FALSE_BREAKOUT_MTF',
    'VWAP_REV':       'VWAP_REV_MTF',
    'STOP_HUNT':      'STOP_HUNT_MTF',
    'VSA':            'VSA_MTF',
    'DIVERGENCE':     'DIVERGENCE',
    'CLIMAX':         'CLIMAX_MTF',
    'CLEAN_BOUNCE':   'CLEAN_BOUNCE_MTF',
    // ML-фигурные: UI-имя = DB-имя
    'DOUBLE_TOP':     'DOUBLE_TOP',
    'DOUBLE_BOTTOM':  'DOUBLE_BOTTOM',
    'BEARISH_FLAG':   'BEARISH_FLAG',
    'HIDDEN_LEVEL':   'HIDDEN_LEVEL',
    'ELLIOTT_STEP':   'ELLIOTT_STEP',
    'IMPULSE_BACK':      'IMPULSE_BACK',
    'IMPULSE_BACK_LATE': 'IMPULSE_BACK_LATE',
    // DE_* (admin chart-only версии) — identity (fallback ниже их и так пропустит)
  };
  /** Возвращает Set<string> DB-format trigger_types для chart filter, или null
   *  если фильтр НЕ нужен (все active-триггеры отмечены — показываем всё).
   *  Источник правды — ЖИВЫЕ чекбоксы #f-triggers (тот же, что у таблицы в
   *  currentFilters/extractFiltersForPrefs). STATE.filters.trigger_types читать
   *  здесь НЕЛЬЗЯ: он фиксируется на init (= все 5 active) и не обновляется при
   *  runtime-тоглах чекбоксов → chart-фильтр был stale и показывал ВСЕ типы
   *  независимо от чекбоксов (баг до 2026-06-01: таблица фильтровалась по DOM,
   *  а график — по замороженному STATE). */
  function _getCurrentTriggerTypesDb() {
    var boxes = document.querySelectorAll('#f-triggers input[type="checkbox"][data-tt]');
    if (!boxes.length) return null;  // чекбоксы ещё не построены → не фильтруем
    var tts = Array.prototype.slice.call(boxes)
                .filter(function(x) { return x.checked; })
                .map(function(x) { return x.getAttribute('data-tt'); });
    if (!tts.length) return new Set();  // ничего не отмечено = ничего не показывать
    // Все ВКЛючённые (не-disabled) чекбоксы отмечены → null = no filter (показать всё).
    // Считаем по числу enabled-боксов (не по TRIGGER_TYPES_ACTIVE.size) — чтобы учесть
    // admin-only DE_*-чекбоксы (их 0 у не-админа, 3 у админа).
    var _enabled = Array.prototype.slice.call(boxes).filter(function(x) { return !x.disabled; }).length;
    if (tts.length === _enabled) return null;
    var dbTypes = [];
    tts.forEach(function (t) {                 // с вариантами основного детектора (DET_GROUPS, 27.10.2026)
      dbTypes.push(_UI_TO_DB_TT_MAP[t] || t);
      _groupVariantsUi(t).forEach(function (v) { dbTypes.push(_UI_TO_DB_TT_MAP[v] || v); });
    });
    return new Set(dbTypes);
  }
  function _syncChartTriggerTypes() {
    if (_panelEngine && _panelEngine.setTriggerTypes) {
      _panelEngine.setTriggerTypes(_getCurrentTriggerTypesDb());
    }
  }

  // Правило безубытка меняет ИСХОД шорта — график обязан считать его тем же
  // правилом, что таблица (иначе строка «+1.00%», а маркер «выход по стопу»,
  // репорт 24.08). Флаг уезжает в chart-data через штатный хук extraQuery.
  function _syncChartBeShort() {
    if (_panelEngine && _panelEngine.setExtraQuery) {
      _panelEngine.setExtraQuery(_chartExtraQuery());
    }
  }

  function onFilterChange() {
    savePrefs('setups.filters', extractFiltersForPrefs());
    _syncTtHeadChecks();       // шапка колонки — ведомая, пересчитываем всегда
    _syncChartRsiVisibility();
    _syncChartTriggerTypes();
    // Мгновенный отклик (аудит 29.08): клиентские фильтры применяются к уже
    // загруженным данным сразу — таблица и карточки не ждут сети; серверные
    // агрегаты доезжают slim-запросом из fetchAndRender (дебаунс ниже).
    if (STATE.data && !STATE.weekly && !STATE.deals && !STATE.presetId) {
      renderTable();
      if (STATE.data.top) renderCards(STATE.data.top);
    }
    _scheduleFetch();          // дебаунс: серия кликов = один запрос
  }
  ['f-long','f-short','f-blue-chips','f-favorites','f-blue-prefs','f-fut-liquid','f-fut-illiquid'].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.addEventListener('change', onFilterChange);
  });
  // Админские чекбоксы-фильтры (volatile): «Выкл скип» и «От уровня».
  [['f-hide-skipped', 'hideSkipped'], ['f-only-at-level', 'onlyAtLevel'],
   ['f-hide-weak', 'hideWeak'], ['f-be-short', 'beShort'],
   ['f-netting', 'netting'], ['f-opp-skip', 'oppSkipOnly']].forEach(function (p) {
    var el = document.getElementById(p[0]);
    if (!el) return;
    el.addEventListener('change', function () {
      // ⚠ Чекбокс неттинга ИНВЕРСНЫЙ: с 28.08 единый счёт — основной расчёт,
      // поэтому галочка называется «Старый способ счёта» и в дефолте снята.
      // Прежний вид («Как в терминале», включён) читался как «включён
      // экспериментальный режим» и сбивал с толку.
      STATE[p[1]] = (p[1] === 'netting') ? !el.checked : !!el.checked;
      if (p[1] === 'netting') _syncNettingUI();
      onFilterChange();          // re-fetch: сервер пересчитает выдачу и доход
      if (p[1] === 'beShort' && _panelTicker) {
        _syncChartBeShort();                        // маркер выхода на графике —
        loadChartInPanel(_panelTicker, _panelTf);   // по тому же правилу
      }
    });
  });
  // Поле «Комиссия брокера» (admin, 08.09.2026): в админских видах заменяет
  // чекбокс «Без комиссии» — комиссия за одну сделку в одну сторону, % от суммы.
  // Уходит на сервер параметром commission= (там: × 2 + спред константой бумаги
  // из стакана); 0 = без комиссии. Живёт в UI-prefs (setups.ui.commission), как
  // gross. Дефолт — data-default поля (плейсхолдер из SSOT level_aware_exit).
  (function () {
    var el = document.getElementById('f-commission');
    if (!el) return;
    function _commit() {
      var v = parseFloat(String(el.value).replace(',', '.'));
      if (!isFinite(v)) v = _commissionDefault();
      if (v == null) return;
      v = Math.round(Math.min(Math.max(v, 0), 1) * 10000) / 10000;
      el.value = String(v);
      var changed = (STATE.commission !== v);
      STATE.commission = v;
      if (!changed) return;
      savePrefs('setups.ui', extractUIForPrefs());
      onFilterChange();            // сервер пересчитает процент, рубли и ленту
      if (STATE.beShort && _panelTicker) {
        _syncChartBeShort();       // уровень безубытка зависит от издержек —
        loadChartInPanel(_panelTicker, _panelTf);   // маркер выхода по тем же
      }
    }
    el.addEventListener('change', _commit);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); el.blur(); }
    });
  })();

  // «Показать слабые в падении» (admin, volatile) — снимает СЕРВЕРНЫЙ фильтр
  // weak_brake, поэтому нужен полный refetch (клиент этих строк просто не имеет).
  (function () {
    var el = document.getElementById('f-show-weak-blocked');
    if (!el) return;
    el.addEventListener('change', function () {
      STATE.showWeakBlocked = !!el.checked;
      if (_panelEngine && _panelEngine.setExtraQuery) {
        // маркеры графика фильтруются тем же флагом — иначе строка вернулась бы
        // в таблицу, а маркера на графике не было бы (и наоборот)
        _panelEngine.setExtraQuery(_chartExtraQuery());
      }
      onFilterChange();
    });
  })();

  // «Выкл 4ч-рост» (admin, volatile) — снимает серверный фильтр h4_brake: полный
  // refetch + маркеры графика тем же флагом (иначе строка вернулась бы, а маркер нет).
  (function () {
    var el = document.getElementById('f-show-h4');
    if (!el) return;
    el.addEventListener('change', function () {
      STATE.showH4 = !!el.checked;
      if (_panelEngine && _panelEngine.setExtraQuery) _panelEngine.setExtraQuery(_chartExtraQuery());
      onFilterChange();
    });
  })();

  // «Выкл 2ч-рост» (admin, volatile; правило у всех с 28.09.2026) — снимает серверный фильтр
  // 2ч-правила: полный refetch + маркеры графика тем же флагом, как у «Выкл 4ч-рост».
  (function () {
    var el = document.getElementById('f-show-h2');
    if (!el) return;
    el.addEventListener('change', function () {
      STATE.showH2 = !!el.checked;
      if (_panelEngine && _panelEngine.setExtraQuery) _panelEngine.setExtraQuery(_chartExtraQuery());
      onFilterChange();
    });
  })();

  // «Gap-race» (admin, volatile; правило «не гнаться за гэпом» у всех с 28.09.2026, №170) — снимает
  // серверный фильтр: полный refetch + маркеры графика тем же флагом, как у «Выкл 2ч-рост».
  (function () {
    var el = document.getElementById('f-show-gap');
    if (!el) return;
    el.addEventListener('change', function () {
      STATE.showGap = !!el.checked;
      if (_panelEngine && _panelEngine.setExtraQuery) _panelEngine.setExtraQuery(_chartExtraQuery());
      onFilterChange();
    });
  })();

  // «Выкл вечер-фильтр» (admin, volatile; правило «Вечер против» у всех с 20.10.2026, №193) — снимает серверный фильтр:
  // полный refetch + маркеры графика тем же флагом, как у «Gap-race».
  (function () {
    var el = document.getElementById('f-show-ev');
    if (!el) return;
    el.addEventListener('change', function () {
      STATE.showEv = !!el.checked;
      if (_panelEngine && _panelEngine.setExtraQuery) _panelEngine.setExtraQuery(_chartExtraQuery());
      onFilterChange();
    });
  })();

  // «Выкл запрет усреднения шортов» (admin, volatile; правило счёта у всех с 21.10.2026, №194) — снимает правило
  // «не усредняем вниз» шорты на этом экране: полный refetch (счёт, недели, «История сделок», «Детекторы»). Графика правило
  // не касается — решения счёта на свечах не рисуются.
  (function () {
    var el = document.getElementById('f-avg-down');
    if (!el) return;
    el.addEventListener('change', function () {
      STATE.avgDownOff = !!el.checked;
      onFilterChange();
    });
  })();
  /** Режим правила «не усредняем вниз» шорты (__SETUPS_CFG__.avgDownMode, settings.SETUPS_NO_AVG_DOWN_MODE). */
  function _avgDownMode() {
    var m = window.__SETUPS_CFG__ && window.__SETUPS_CFG__.avgDownMode;
    return (m && m.indexOf('<!--') !== 0) ? m : 'off';
  }

  // «Выкл рынок против» (admin, volatile; правило «Рынок против» у всех с 21.10.2026, №175) — снимает серверный фильтр:
  // полный refetch + маркеры графика тем же флагом, как у «Выкл вечер-фильтр».
  (function () {
    var el = document.getElementById('f-show-ew');
    if (!el) return;
    el.addEventListener('change', function () {
      STATE.showEw = !!el.checked;
      if (_panelEngine && _panelEngine.setExtraQuery) _panelEngine.setExtraQuery(_chartExtraQuery());
      onFilterChange();
    });
  })();

  // «Ранний трейл шортов» (admin, volatile; обкатка №190, 20.10.2026; settings.SETUPS_EXIT_ARM_MODE →
  // __SETUPS_CFG__.armMode): у шорта трейл модели взводится с прибыли в долю дневного ATR бумаги, не дожидаясь цели 1R.
  // В админском виде включён по умолчанию ('admin' / 'on'); галочка выключает его для сравнения на тех же фильтрах —
  // полный refetch и выходы на графике, как у «Разворота рынка». null — как в режиме по умолчанию.
  function _armMode() {
    return (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.armMode) || 'off';
  }
  function _armDefault() {
    var m = _armMode();
    return m === 'admin' || m === 'on';
  }
  function _armParam() {
    if (STATE.armExit === null || STATE.armExit === undefined || !_adminView() || _futOn()) return '';
    return (STATE.armExit === _armDefault()) ? '' : (STATE.armExit ? '1' : '0');
  }
  (function () {
    var el = document.getElementById('f-arm-exit');
    if (!el) return;
    el.checked = _armDefault();
    el.addEventListener('change', function () {
      STATE.armExit = !!el.checked;
      if (_panelEngine && _panelEngine.setExtraQuery) _panelEngine.setExtraQuery(_chartExtraQuery());
      onFilterChange();
    });
  })();

  // «Стоп дальше у «Скрытого уровня»» (admin, volatile; обкатка №196, 23.10.2026; settings.SETUPS_WIDE_STOP_MODE →
  // __SETUPS_CFG__.wsMode): у сделок правила стоп дальше на k ATR сигнала, цель на месте, размер — тот же риск в рублях.
  // Режим 'admin' — по галочке (по умолчанию выключена), 'on' — у всех без параметра. Полный refetch и стоп на графике.
  function _wsMode() {
    return (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.wsMode) || 'off';
  }
  function _wsParam() {
    return (STATE.wideStop && _wsMode() === 'admin' && _adminView() && !_futOn()) ? '1' : '';
  }
  (function () {
    var el = document.getElementById('f-wide-stop');
    if (!el) return;
    el.addEventListener('change', function () {
      STATE.wideStop = !!el.checked;
      if (_panelEngine && _panelEngine.setExtraQuery) _panelEngine.setExtraQuery(_chartExtraQuery());
      onFilterChange();
    });
  })();

  // «Разворот рынка» (admin, volatile; обкатка №188, 16.10.2026) — правило выхода поверх модели витрины: полный refetch
  // + выходы на графике тем же флагом, как у «Рынок против».
  (function () {
    var el = document.getElementById('f-mrev-exit');
    if (!el) return;
    el.addEventListener('change', function () {
      STATE.mrevExit = !!el.checked;
      if (_panelEngine && _panelEngine.setExtraQuery) _panelEngine.setExtraQuery(_chartExtraQuery());
      onFilterChange();
    });
  })();

  // «Выкл индекс-фильтр» (admin, volatile, 25.09.2026) — снимает серверный фильтр входа по ходу
  // индекса: полный refetch + маркеры графика тем же флагом, как у «Выкл 4ч-рост».
  (function () {
    var el = document.getElementById('f-show-idx');
    if (!el) return;
    el.addEventListener('change', function () {
      STATE.showIdx = !!el.checked;
      if (_panelEngine && _panelEngine.setExtraQuery) _panelEngine.setExtraQuery(_chartExtraQuery());
      onFilterChange();
    });
  })();

  // «Закрытые сегодня» (admin, volatile) — клиентский фильтр поверх уже загруженных
  // данных: серверу он не нужен, поэтому перерисовываем без запроса.
  (function () {
    var el = document.getElementById('f-closed-today');
    if (!el) return;
    el.addEventListener('change', function () {
      STATE.closedToday = !!el.checked;
      if (STATE.data) renderTable();     // таблица + «Доход» + счётчик кнопки
    });
  })();

  ['f-turnover-min', 'f-turnover-max'].forEach(function(id) {
    var el = document.getElementById(id);
    if (!el) return;
    // активный ползунок — наверх, чтобы оставался захватываемым при наложении
    el.addEventListener('pointerdown', function() {
      _turnoverElMin().style.zIndex = 3;
      _turnoverElMax().style.zIndex = 3;
      el.style.zIndex = 6;
    });
    el.addEventListener('input', _onTurnoverInput);
    el.addEventListener('change', onFilterChange);
  });
  _updateTurnoverUI();  // первичная синхронизация подписи + заливки
  // Слайдер депозита (вернулся 29.08): задаёт единую базу процента и включает
  // капитал-пул. Пока человек его не трогал — auto (пик занятого, пропусков нет).
  (function() {
    var d = document.getElementById('f-depo');
    if (!d) return;
    d.addEventListener('input', function() { _applyDepo(this.value, true); });
    d.addEventListener('change', function() { _applyDepo(this.value); });
  })();
  // Слайдер размера позиции (режим неттинга): депозит производный, поэтому
  // пересчёт только на сервере — тянем новую выдачу по отпускании ползунка.
  (function() {
    var p = document.getElementById('f-pos-size');
    if (!p) return;
    p.addEventListener('input', function() { _applyPosSize(this.value, true); });
    p.addEventListener('change', function() {
      _applyPosSize(this.value);
      savePrefs('setups.ui', extractUIForPrefs());
      fetchAndRender();          // размер влияет на лоты/₽ и на подпись во всех видах
    });
  })();
  // ── Fetch ────────────────────────────────────────
  // fetchAndRender(_isAuto, _retry): _isAuto — вызов авторефреша, _retry — internal retry counter
  // (default 0). При failed fetch'е (network error / 5xx / etc.) делаем silent retry с linear backoff
  // тем же видом вызова; UI-ошибку показываем ТОЛЬКО после MAX_RETRIES неудачных попыток. Это закрывает кейс
  // server restart (1-2s downtime) — пользователь видит «загрузка…» чуть
  // дольше вместо мигающей «Ошибка: Failed to fetch».
  // «История сделок» (05.10.2026, решение владельца): все сделки единого счёта с начала ленты — ровно те, из
  // которых «История недель» складывает недели. Запрос — с теми же параметрами, что у недель (_ledgerFilters /
  // _ledgerQuery — общие с fetchWeekly), поэтому сервер берёт ту же запись счёта; плюс страница и сортировка.
  // Отбирает, сортирует и листает сервер — клиент показывает как есть (visibleItems). Карточки ТОП не трогаем:
  // это витрина живого рынка с вкладки «Неделя».
  async function fetchDeals() {
    // Навигация по клику на маркер графика (pending-scroll к строке) — скролл наверх в конце не сбрасываем.
    const _hadPendingScroll = !!STATE._pendingScroll;
    const root = document.getElementById('list-light');
    const _empty = function (txt) {
      STATE.data = Object.assign({}, STATE.data || {}, { table: [], trades_hist: null });
      _dataGen += 1;
      _llCancel();
      if (root) root.innerHTML = '<div class="empty">' + txt + '</div>';
      renderDealsPager(); renderDealsLabel();
    };
    if (!_nettingOn()) { _empty('История сделок считается только единым счётом — снимите «Старый способ счёта».'); return; }
    const f = _ledgerFilters();
    if (!f) { _empty('Не выбран ни один таймфрейм.'); return; }
    const params = new URLSearchParams(Object.assign({ trades_hist: '1', rubles: '1' }, _ledgerQuery(), f));
    params.set('th_page', String(STATE.dealsPage || 1));
    if (STATE.dealsSort === 'entry') params.set('th_sort', 'entry');
    const _seq = _beginReq();
    try {
      const r = await fetch('/api/setups?' + params.toString());
      const j = await r.json();
      if (_isStale(_seq)) return;        // за время запроса кликнули ещё раз
      if (!r.ok) throw new Error(j.error || 'error');
      // карточки ТОП — живые (вкладки «Неделя»): по ним клик открывает живой график
      j.top = (_liveDataCache && _liveDataCache.top) || j.top || [];
      STATE.data = j;
      _dataGen += 1;
      _lastDataSig = null;   // STATE.data теперь история сделок — slim-шорткат живого пути невалиден
      const th = j.trades_hist || {};
      if (th.page) STATE.dealsPage = th.page;
      _syncDepoUI();        // подпись депозита — по факту данных
      renderTable();
      renderDealsPager();
      renderDealsLabel();
      if (!_hadPendingScroll) { try { document.querySelector('.main').scrollTo({ top: 0 }); } catch (e) {} }
    } catch (e) {
      if (_isStale(_seq)) return;
      _llCancel();
      if (root) root.innerHTML = '<div class="empty">Не удалось загрузить историю ' + (_setupsView() ? 'сетапов' : 'сделок')
        + '. Обновите страницу.</div>';
    } finally { _endReq(_seq); }
  }

  /** Фильтры запроса счёта — те же у «Истории недель» и «Истории сделок» (05.10.2026): все фильтры сайдбара без
   *  поиска по тикеру (к счёту он не относится). null — снят каждый таймфрейм: сервер вернул бы полный набор. */
  function _ledgerFilters() {
    const f = currentFilters();
    delete f.ticker;
    const _tfSel = _selectedTfs();
    if (_tfSel && _tfSel.size === 0) return null;
    return f;
  }

  /** Параметры счёта — размер позиции, способ счёта, издержки, единицы, депозит: одна сборка у «Истории недель» и
   *  «Истории сделок» (05.10.2026), иначе они посчитали бы разные счета. */
  function _ledgerQuery() {
    const q = { pos_size: String(STATE.posSize || 20000), netting: _nettingOn() ? '1' : '0' };
    Object.assign(q, _commissionQuery(), _unitsQuery());
    if (!STATE.depoAuto && STATE.rubDeposit && !_investedView()) q.deposit = String(STATE.rubDeposit);   // пусто = auto (пик занятого)
    return q;
  }

  // Строка над таблицей «Истории сделок»: сколько сделок и итог — то же число, что строка «Итого» «Истории недель».
  function renderDealsLabel() {
    const el = document.getElementById('deals-label');
    if (!el) return;
    const th = STATE.deals && STATE.data && STATE.data.trades_hist;
    const s = (th && th.sum) || null;
    if (!th || !s || !th.total) { el.innerHTML = ''; return; }
    const upct = (STATE.data.units === 'pct') || !!STATE.unitsPct;
    const sign = v => (v >= 0 ? '+' : '');
    // «История сетапов»: число закрытых сетапов, сумма процентов и доля в плюсе.
    if (th.view === 'setups') {
      const n = Number(s.closed) || 0, sp = Number(s.sum_pct) || 0;
      el.innerHTML = '<span class="deals-label-icon">📋</span><span>Сетапов' + _feedStartTitle() + ': <b>'
        + n.toLocaleString('ru-RU') + '</b> · сумма <b>' + sign(sp) + sp.toFixed(2) + '%</b>'
        + (n ? ' · в' + NBSP + 'плюсе ' + Math.round(100 * (Number(s.wins) || 0) / n) + '%' : '')
        + '</span>';
      return;
    }
    let tot;
    if (upct && s.inv_pct != null) {
      // режим «%» с «на вложенные» (23.10.2026): итог — доход на вложенные (то же число, что «Итого» «Истории недель»)
      tot = '<b>' + sign(s.inv_pct) + Number(s.inv_pct).toFixed(2) + '%</b>' + NBSP + '(на' + NBSP + 'вложенные)';
    } else if (upct) {
      const sp = Number(s.sum_pct != null ? s.sum_pct : s.net_pct) || 0;
      tot = '<b>' + sign(sp) + sp.toFixed(2) + '%</b>' + NBSP + '(сумма процентов сделок)';
    } else {
      const pr = Number(s.profit_rub) || 0, pc = Number(s.net_pct) || 0;
      tot = '<b>' + sign(pr) + Math.round(pr).toLocaleString('ru-RU') + NBSP + '₽</b>' + (_investedView()
        ? (s.inv_pct != null ? NBSP + '(' + sign(s.inv_pct) + Number(s.inv_pct).toFixed(2) + '%' + NBSP + 'на' + NBSP
                               + 'вложенные)' : '')
        : NBSP + '(' + sign(pc) + pc.toFixed(2) + '%' + NBSP + 'от депозита)');
    }
    const wr = (s.closed ? Math.round(100 * (Number(s.wins) || 0) / s.closed) : null);
    const _ng = Number(th.gated) || 0;   // «Все»: снятые правилами — в списке, но не в счёте и не в итоге
    el.innerHTML = '<span class="deals-label-icon">📋</span><span>Сделок единого счёта' + _feedStartTitle()
      + ': <b>' + (Number(th.total) - _ng).toLocaleString('ru-RU') + '</b>'
      + (_ng ? ' · ещё не торговали: ' + _ng.toLocaleString('ru-RU') : '') + ' · итог ' + tot
      + (wr != null ? ' · в' + NBSP + 'плюсе ' + wr + '%' : '')
      + ' · по неделям закрытия — как в' + NBSP + '<span class="deals-emph">«Истории недель»</span></span>';
  }

  // Список страниц для пагинатора: 1 2 3 4 5 … N (window вокруг текущей + первая/
  // последняя + эллипсис). '…' — маркер разрыва (некликабельный).
  function _pageList(p, np) {
    if (np <= 7) { var a = []; for (var i = 1; i <= np; i++) a.push(i); return a; }
    var lo, hi;
    if (p <= 4) { lo = 2; hi = 5; }                      // у начала: 1 2 3 4 5 … N
    else if (p >= np - 3) { lo = np - 4; hi = np - 1; }   // у конца: 1 … N-4 … N
    else { lo = p - 1; hi = p + 1; }                      // середина: 1 … p-1 p p+1 … N
    var out = [1];
    if (lo > 2) out.push('…');
    for (var j = lo; j <= hi; j++) out.push(j);
    if (hi < np - 1) out.push('…');
    out.push(np);
    return out;
  }

  function renderDealsPager() {
    const el = document.getElementById('deals-pager');
    if (!el) return;
    const th = (STATE.deals && STATE.data && STATE.data.trades_hist) || null;
    if (!th) { el.innerHTML = ''; return; }
    const np = th.npages || 1, p = th.page || 1, tot = th.total || 0;
    const unit = th.view === 'setups' ? ' сетапов' : ' сделок';   // «История сетапов» (27.10.2026)
    if (np <= 1) {   // одна страница — только счётчик сделок
      el.innerHTML = tot ? '<span class="pg-info">' + tot.toLocaleString('ru-RU') + unit + '</span>' : '';
      return;
    }
    var parts = [
      '<button class="pg-btn" ' + (p <= 1 ? 'disabled' : '') + ' onclick="gotoDealsPage(' + (p - 1) + ')">‹</button>'
    ];
    _pageList(p, np).forEach(function(x) {
      if (x === '…') parts.push('<span class="pg-ellipsis">…</span>');
      else if (x === p) parts.push('<button class="pg-num active" disabled>' + x + '</button>');
      else parts.push('<button class="pg-num" onclick="gotoDealsPage(' + x + ')">' + x + '</button>');
    });
    parts.push('<button class="pg-btn" ' + (p >= np ? 'disabled' : '') + ' onclick="gotoDealsPage(' + (p + 1) + ')">›</button>');
    parts.push('<span class="pg-info">' + tot.toLocaleString('ru-RU') + unit + '</span>');
    el.innerHTML = parts.join('');
  }

  // «Нед»: доход Net по неделям с 2026-05-05. Тот же net-₽ базис, что «14 дн Net»,
  // но агрегат по неделям (уважает фильтры типов/оборота/направления).
  async function fetchWeekly() {
    const _seq = _beginReq();
    // Сняты ВСЕ таймфреймы: currentFilters() параметр не шлёт (пусто = «все»),
    // и сервер вернул бы полный набор — а таблица в этот момент пустая.
    // Держим согласованность: показываем пусто, на сервер не ходим.
    const f = _ledgerFilters();          // поиск по тикеру к недельному агрегату не применяется
    if (!f) {
      if (_isStale(_seq)) return;
      STATE.weeklyData = { weeks: [], total: null };
      renderWeekly(STATE.weeklyData);
      return;
    }
    // Неттинг: недели считает СЕРВЕР по позициям единого счёта (клиентский
    // капитал-пул здесь неприменим — капитал производная от потока сделок).
    // Параметры счёта — одной сборкой с «Историей сделок» (_ledgerQuery, 05.10.2026); поле «Комиссия брокера»
    // в ней (репорт владельца 08.09: у недель своя сборка запроса, и параметр сюда не доезжал).
    const params = new URLSearchParams(Object.assign({ weekly: '1', rubles: '1' }, _ledgerQuery(), f));
    try {
      const r = await fetch('/api/setups?' + params.toString());
      const j = await r.json();
      if (_isStale(_seq)) return;          // пока ждали — стартовал более свежий
      if (!r.ok) throw new Error(j.error || 'error');
      STATE.weeklyData = j;
      _lastDataSig = null;   // живой STATE.data устареет за время недельного режима
      renderWeekly(j);
      _syncDepoUI();        // числа недель — тот же источник для подписи депозита
    } catch (e) {
      if (_isStale(_seq)) return;
      const wv = document.getElementById('weekly-view');
      if (wv) { wv.style.display = 'block'; wv.innerHTML = '<div class="empty">Не удалось загрузить недельный доход. Обновите страницу.</div>'; }
    } finally { _endReq(_seq); }
  }

  // Рендер недельной таблицы (свежая неделя сверху + Итого).
  //
  // ⚠ ЕДИНЫЙ ИСТОЧНИК ПРАВДЫ (28.08): основной путь — `_renderWeeklyNetting`,
  // он один и тот же для пользователя и админа; роль решает только НАБОР КОЛОНОК
  // (рубли приходят лишь админу — сервер их вычищает). Ветки ниже — СТАРЫЙ способ
  // счёта (независимые сделки + капитал-пул), он остаётся доступен ТОЛЬКО админу
  // по снятой галочке «Как в терминале» для сравнения. Правки основной витрины
  // делаются в неттинг-пути, иначе версии разъедутся.
  // Подпись под «Историей недель» — одна на все виды таблицы.
  // Ставки фрикции приходят С СЕРВЕРА (SSOT level_aware_exit): одного числа нет,
  // комиссия+спред зависят от ликвидности (0.10 / 0.25 / 0.50 % по обороту),
  // поэтому показываем диапазон применимых при текущем фильтре ставок.
  function _psLabel(j) {
    const ps = Number((j && j.pos_size) || 20000);
    return (ps >= 1000 ? Math.round(ps / 1000) + 'к' : Math.round(ps)) + '\u00a0₽/сделку';
  }

  function _weeklyNote(j) {
    // ⚠ Формулировка ЗАДАНА ВЛАДЕЛЬЦЕМ дословно (29.08) — расширять список
    // нельзя. Прежняя версия принимала `extra`, и подпись обрастала хвостами
    // («единый счёт», «в среднем работало», «депозит…»), переставая совпадать
    // с согласованным текстом. Параметра `extra` больше нет — по этой причине.
    // Из данных подставляется размер позиции, из SSOT (level_aware_exit) —
    // состав комиссии: тариф брокера и сбор биржи названы отдельно.
    const cm = (j && j.commission) || {};
    const parts = ['Живые сетапы', 'размер позиции ~' + _psLabel(j)];
    var _costOn = false;
    if (cm.applied_side != null) {
      // Поле «Комиссия брокера» (08.09.2026): одно число за сделку в одну сторону
      // (брокер + урегулирование + сбор Мосбиржи); спред — константой бумаги из
      // нашего стакана (calibrate_ticker_spread.py), так что пункт про стакан верен.
      parts.push('комиссия на сделку ' + String(Math.round(Number(cm.applied_side) * 10000) / 10000)
                 + '% в одну сторону',
                 'проскальзывание рассчитано по стакану');
      _costOn = true;
    }
    // Четвёртый пункт (29.08): шорт — заём бумаги, за каждую ночь брокер берёт
    // плату по ставке, привязанной к ключевой. Раньше эта статья расходов не
    // учитывалась вовсе; 59% шортов ночуют, поэтому молчать о ней нельзя.
    if (_costOn && cm.short_carry_annual != null) {
      parts.push('перенос шорта по ключевой ставке (' +
                 Number(cm.short_carry_annual).toFixed(0) + '%\u00a0годовых)');
    }
    return parts.join(' · ');
  }


  // Недели в режиме неттинга: считает сервер по ПОЗИЦИЯМ (пачка входов по
  // тикеру = одна позиция), капитал — производная от потока, поэтому клиентский
  // пул и депозит-слайдер здесь не участвуют. Процент — «на работающие деньги»
  // (прибыль недели ÷ средний занятый капитал этой недели): каждая неделя
  // независима, поэтому проценты по неделям НЕ складываются в итог.
  function _renderWeeklyNetting(wv, j) {
    const weeks = j.weeks || [];
    const t = j.total || {};
    // Таблицу рисует ОБЩАЯ функция — колонки одни и те же во всех видах.
    // Процент здесь «на работающие деньги» и приходит с сервера по каждой
    // неделе, поэтому передаём его напрямую, а не считаем из рублей.
    // Режим «только проценты» (22.09.2026): денег нет — колонка «Доход ₽» и
    // «Пропущено» (капитал не ограничивает) убраны, процент недели = сумма
    // процентов её сделок.
    const _upct = (j.units === 'pct') || !!STATE.unitsPct;
    // режим «%» с «на вложенные» (23.10.2026, settings.SETUPS_UNITS_INV_MODE): недели, «Итого» и столбики по дням — доход
    // на вложенные вместо суммы процентов (сервер: weeks[].inv_pct / inv_days, total.inv_pct)
    const _uinv = _upct && t.inv_pct != null;
    const _pp = !_upct && _pctFromPrice(t);
    const _iv = !_upct && _investedView();           // вид «на вложенные» (16.10.2026)
    const _sg = (x) => (x >= 0 ? '+' : '') + Number(x || 0).toFixed(2) + '%';
    // «Итого» под суммой процентов (решение владельца 16.10.2026): у вида «на вложенные» — доход на вложенные; у админа —
    // сверху вниз сумма % сделок, на вложенные, к депо. «На вложенные» — то же число, что вид «IMOEX» за «Всё»
    // (сервер: total.inv_pct ← web_app._inv_total).
    const _invSub = (t.inv_pct != null)
      ? {text: 'на' + NBSP + 'вложенные' + NBSP + _sg(t.inv_pct),
         tip: 'Доход на деньги, реально стоявшие в сделках, за всё время: доход каждого дня делится на наибольшую '
              + 'сумму, одновременно занятую в сделках за этот день, дни сцепляются — как у индекса. С учётом открытых '
              + 'позиций — то же число, что на графике IMOEX вкладки «Детекторы».'}
      : null;
    const _depSub = {text: 'к' + NBSP + 'депо' + NBSP + _sg(t.net_pct),
                     tip: 'Итог в процентах от депозита ' + Math.round(Number(t.capital_rub) || 0).toLocaleString('ru-RU')
                          + ' ₽ — доход в рублях, делённый на депозит'};
    _weeklyTable(wv, _uinv ? weeks.map((w) => Object.assign({}, w, {days: Array.isArray(w.inv_days) ? w.inv_days : w.days}))
                           : weeks, {
      n: t.trades, net_rub: t.profit_rub || 0,
      unitsPct: _upct,
      // доход по дням в строке недели (02.10.2026): сервер присылает weeks[].days
      days: weeks.some((w) => Array.isArray(w.days)),
      sparkUnit: _upct ? 'pct' : undefined,
      // WR% (25.09.2026; админ — с утра, всем ролям — с вечера того же дня): прибыльных
      // (результат после издержек больше нуля) из закрытых; считает сервер по тем же
      // сделкам, что колонка «Сделок».
      wr: true, wins: t.wins, closed: t.closed,
      // ⚠ Процент — ОТ ДЕПОЗИТА (одна база на все строки), поэтому колонка
      // складывается в «Итого». Прежний вариант (своя база у каждой недели)
      // не складывался: владелец сложил вручную и получил +46.65% против
      // +31.42%. Собственная эффективность недели — в подсказке строки.
      // У админа (08.10.2026) — сумма процентов сделок недели (_pctFromPrice): складывается из строк «Истории
      // сделок»; процент к депозиту — второй строкой «Итого» и в подсказке строки.
      pct: (v, w) => (_uinv ? (w ? (w.inv_pct || 0) : (t.inv_pct || 0))
                    : _pp ? (w ? (w.sum_pct || 0) : (t.sum_pct || 0))
                          : (w ? (w.net_pct || 0) : (t.net_pct || 0))),
      totPct: _uinv ? (t.inv_pct || 0) : (_pp ? (t.sum_pct || 0) : (t.net_pct || 0)),
      totSubs: (_iv ? [_invSub] : (_pp ? [_invSub, _depSub] : [])).filter(Boolean),
      skipped: t.skipped || 0,
      // колонка нужна всегда: ноль — тоже ответ; у вида «на вложенные» депозита нет — пропусков по капиталу не бывает
      showSkipped: !_upct && !_iv,
      pctHead: _uinv ? 'На&nbsp;вложенные' : (_upct ? 'Сумма&nbsp;%' : (_iv ? 'Сумма&nbsp;%&nbsp;сделок' : null)),
      rowTip: (w) => (_upct
        ? ((w && w.n) ? 'Сделок ' + w.n + ', в среднем '
            + ((w.net_pct || 0) / w.n >= 0 ? '+' : '')
            + ((w.net_pct || 0) / w.n).toFixed(3) + '% на сделку.' : '')
        : (_iv && w
          ? 'Сумма процентов сделок недели — движение цены от входа до выхода после издержек.'
          : _pp && w
          ? 'Сумма процентов сделок недели — движение цены от входа до выхода после издержек. К депозиту: '
            + ((w.net_pct || 0) >= 0 ? '+' : '') + Number(w.net_pct || 0).toFixed(2) + '%.'
          : '')),
      pctTip: _uinv
        ? 'Доход недели на вложенные: что стало бы с деньгами, если вкладывать в каждый сигнал одну и ту же сумму. Доход '
          + 'каждого дня (закрытые сделки и открытые позиции по цене) делится на деньги, одновременно стоявшие в сделках, '
          + 'дни сцепляются — как у индекса. Недели перемножаются в «Итого», поэтому сумма колонки близка к итогу, '
          + 'но не равна ему.'
        : _upct
        ? 'Сумма процентов сделок недели (каждая сделка одним размером, капитал не ограничен). '
          + 'Колонка складывается в «Итого».'
        : _iv
        ? 'Сумма процентов сделок недели — движение цены от входа до выхода после издержек, как в строках '
          + '«Истории сделок». Это не доход денег: сделки идут одновременно. Колонка складывается в «Итого»; '
          + 'доход на вложенные деньги — второй строкой «Итого».'
        : _pp
        ? 'Сумма процентов сделок недели — движение цены от входа до выхода после издержек, как в строках '
          + '«Истории сделок». Колонка складывается в «Итого»; доход к депозиту — второй строкой «Итого».'
        : 'Доход недели ÷ депозит — одна база для всех строк, поэтому колонка '
          + 'складывается в «Итого».',
      note: (j.opp_skip_only
        ? '<b>Только сделки, пропущенные из-за открытой встречной позиции</b> — каждая '
          + 'со своим исходом, как если бы её взяли отдельно. '
        : '') + _weeklyNote(j),
    });
  }

  function renderWeekly(j) {
    if (!j) return;
    const wv = document.getElementById('weekly-view');
    if (!wv) return;
    document.body.classList.add('mode-weekly');
    _updatePosNote();          // депозит производный — держим подпись свежей
    var st = _tableTitleEl();
    if (st && st.childNodes[0]) st.childNodes[0].nodeValue = 'Доход по неделям';
    // ⚠ ОДНА таблица на все случаи (владелец 28.08): колонки
    // «Неделя · Сделок · Доход ₽ · Доход %» — и у пользователя, и у админа, и в
    // старом способе счёта. «Пропущено» больше нет (депозит производный от размера
    // позиции, капитал сделок не ограничивает), «Работало ₽» тоже (средний занятый
    // капитал рядом с суммируемыми колонками читался как сумма).
    if (j.netting) return _renderWeeklyNetting(wv, j);

    // Старый способ счёта (админская опция netting=0) — приводим к тому же виду.
    const depo = STATE.rubDeposit || 3000000;
    let weeks = j.weeks || [];
    let tot = j.total || { n: 0, net_rub: 0 };
    if (Array.isArray(j.trades) && j.trades.length) {
      const byWeek = {};
      j.trades.forEach(t => { (byWeek[t.w] || (byWeek[t.w] = [])).push(t); });
      const agg = {};
      let tN = 0, tNet = 0;
      let tW = 0;
      Object.keys(byWeek).forEach(wk => {
        const a = agg[wk] = { n: 0, net: 0, wins: 0 };
        byWeek[wk].forEach(t => { a.n++; a.net += t.p; if (t.p > 0) a.wins++; });
        tN += a.n; tNet += a.net; tW += a.wins;
      });
      weeks = weeks.map(w => Object.assign({}, w, {
        n: (agg[w.week_start] || {}).n || 0,
        net_rub: (agg[w.week_start] || {}).net || 0,
        closed: (agg[w.week_start] || {}).n || 0,
        wins: (agg[w.week_start] || {}).wins || 0,
      }));
      tot = { n: tN, net_rub: tNet, closed: tN, wins: tW };
    }
    _weeklyTable(wv, weeks, {
      n: tot.n, net_rub: tot.net_rub,
      wr: true, wins: tot.wins, closed: tot.closed,
      pct: (v) => (depo ? v / depo * 100 : 0),
      note: _weeklyNote(j),
    });
  }

  /** Единственный рендер недельной таблицы. Колонки одни и те же везде;
   *  различие только в том, откуда берётся процент (opts.pct). */
  function _weeklyTable(wv, weeks, opts) {
    if (!weeks.length) {
      wv.innerHTML = '<div class="empty">Нет разрешённых сетапов за период.</div>';
      wv.style.display = 'block';
      return;
    }
    const fmtRub = (v) => (v > 0 ? '+' : '') + Math.round(v || 0).toLocaleString('ru-RU') + ' ₽';
    const fmtP = (v) => (v > 0 ? '+' : '') + (Number(v) || 0).toFixed(2) + '%';
    const cls = (v) => v > 0 ? 'wk-pos' : (v < 0 ? 'wk-neg' : 'wk-zero');
    // ⚠ Одна колонка счёта вместо двух (владелец 28.08) — «Сделок»: это те же
    // строки, что человек видит в таблице витрины и в счётчике вкладки. Число
    // позиций (пачек после слияния докупок) ушло в подпись под таблицей.
    const skipCol = !!opts.showSkipped;
    const rubCol = !opts.unitsPct;      // «Доход ₽» — только когда деньги есть
    // WR% (25.09.2026, все роли) — последней колонкой: номера прежних колонок не сдвигаются.
    // Нет закрытых или ответ без поля (сервер старее страницы) — прочерк, а не 0 %.
    const wrCol = !!opts.wr;
    // Мини-чарт дохода по дням в колонке «Сделок» (02.10.2026, решение владельца): у каждой недели свои
    // столбики (сервер: weekly_breakdown(days=) — те же сделки, сумма = доход недели), масштаб ОБЩИЙ для
    // всех недель — сильная неделя видна сразу. Есть только в режиме неттинга (opts.days).
    const sparkMax = opts.days
      ? Math.max(0, ...weeks.map((w) => Math.max(0, ...(w.days || []).map((v) => Math.abs(Number(v) || 0)))))
      : 0;
    const nCell = (w) => ((opts.days && Array.isArray(w.days) && w.days.length)
      ? '<td class="wk-n"><span class="wk-n-num">' + w.n + '</span><span class="wk-spark wk-rowspark">'
        + _weekSparkHtml(w.days.map(Number), opts.sparkUnit,
                         { max: sparkMax || 1, labels: false, monday: w.week_start, minH: 12 })
        + '</span></td>'
      : '<td>' + w.n + '</td>');
    const fmtWr = (wn, cl) => ((cl > 0 && wn != null)
      ? '<td class="wk-wr" title="прибыльных ' + wn + ' из ' + cl + '">'
        + Math.round(wn / cl * 100) + '%</td>'
      : '<td class="wk-wr">—</td>');
    const rows = weeks.map((w) =>
      '<tr><td class="wk-week">' + w.label + '</td>' +
      nCell(w) +
      (skipCol ? '<td class="wk-skip">' + (w.skipped || 0) + '</td>' : '') +
      (rubCol ? '<td class="' + cls(w.net_rub) + '">' + fmtRub(w.net_rub) + '</td>' : '') +
      // цвет процента — по его собственному знаку (08.10.2026): сумма процентов сделок бывает другого знака, чем рубли
      '<td class="' + cls(opts.pct(w.net_rub, w)) + '"' +
        (opts.rowTip ? ' title="' + String(opts.rowTip(w) || '').replace(/"/g, '&quot;') + '"' : '') +
        '>' + fmtP(opts.pct(w.net_rub, w)) + '</td>' +
      (wrCol ? fmtWr(w.wins, w.closed) : '') + '</tr>'
    ).join('');
    const tot = '<tr class="wk-total"><td class="wk-week">Итого</td>' +
      (opts.days ? '<td class="wk-n"><span class="wk-n-num">' + (opts.n == null ? '—' : opts.n) + '</span></td>'
                 : '<td>' + (opts.n == null ? '—' : opts.n) + '</td>') +
      (skipCol ? '<td class="wk-skip">' + (opts.skipped || 0) + '</td>' : '') +
      (rubCol ? '<td class="' + cls(opts.net_rub) + '">' + fmtRub(opts.net_rub) + '</td>' : '') +
      '<td class="' + cls(opts.totPct != null ? opts.totPct : opts.pct(opts.net_rub, null)) + '">'
        + fmtP(opts.totPct != null ? opts.totPct : opts.pct(opts.net_rub, null))
        // строки под суммой «Итого» тонким шрифтом (08.10.2026 — к депо; 16.10.2026 — и на вложенные, сверху вниз)
        + (opts.totSubs || (opts.totSub ? [{text: opts.totSub, tip: opts.totSubTip}] : [])).map(function (x) {
            return '<div class="wk-sub"' + (x.tip ? ' title="' + String(x.tip).replace(/"/g, '&quot;') + '"' : '')
                 + '>' + x.text + '</div>';
          }).join('')
        + '</td>' +
      (wrCol ? fmtWr(opts.wins, opts.closed) : '') + '</tr>';
    // ⚠ Заголовок процента задаётся вызывающим: в неттинге это ВКЛАД недели в
    // итоговый (единая база, складывается), а в старом способе — процент от
    // депозита. Держать оба под именем «Доход %» нельзя: карточка витрины
    // показывает доход недели НА ЕЁ работающие деньги (другая база), и два
    // разных числа под одним именем — ровно та путаница, что чиним.
    const head = '<th class="wk-week">Неделя</th>' +
      (opts.days ? '<th class="wk-nh" title="Число сделок недели и доход по дням выхода, Пн–Вс. Масштаб столбиков общий для '
                   + 'всех недель; сумма дня — при наведении на столбик">Сделок</th>' : '<th>Сделок</th>') +
      (skipCol ? '<th title="Сетапы, которые не открылись: на момент входа не ' +
                 'хватило свободного капитала. В доход не идут.">Пропущено</th>' : '') +
      (rubCol ? '<th>Доход&nbsp;₽</th>' : '') +
      '<th title="' + (opts.pctTip || 'Доход недели в процентах') + '">' +
      (opts.pctHead || 'Доход&nbsp;%') + '</th>' +
      (wrCol ? '<th title="Доля прибыльных сделок: результат после издержек больше нуля. ' +
               'Считается по закрытым сделкам недели — тем же, что в колонке «Сделок».">' +
               'WR&nbsp;%</th>' : '');
    wv.innerHTML =
      '<div class="wk-scroll"><table class="weekly-tbl"><thead><tr>' + head + '</tr></thead><tbody>' +
      rows + tot + '</tbody></table></div>' +
      '<div class="weekly-note">' + opts.note + '</div>';
    wv.style.display = 'block';
  }

  // ── Переключение фильтров: поколения запросов + дебаунс ──────────────
  // Раньше каждый клик по чекбоксу сразу стартовал запрос, а защиты от гонки
  // не было ни в одном режиме: при ответе 1-5 с быстрая серия кликов давала
  // несколько запросов в полёте, и поздний ответ СТАРОГО перетирал свежий —
  // со стороны «глючит и тормозит» (репорт владельца 24.08).
  let _reqSeq = 0;              // поколение: растёт на каждый новый запрос
  // Поколение ДАННЫХ (28.09.2026, гонка счётчика «Вся история»): растёт, только когда STATE.data заменяется.
  // Лёгкий ответ агрегатов (slim) правит текущие данные — значит, устаревает, лишь если данные сменились или
  // ушёл более свежий лёгкий запрос. По _reqSeq его судить нельзя: авто-опрос, ответивший «лента не менялась»,
  // тоже берёт поколение запросов — лёгкий ответ терялся, и на кнопке «Вся история» оставался счётчик полного
  // ответа, посчитанный без выбранных пар «детектор × ТФ» (у владельца 26k вместо 23k).
  let _dataGen = 0;
  let _slimSeq = 0;              // последний отправленный лёгкий запрос
  let _inflight = 0;            // сколько запросов в полёте (для индикатора)
  let _fetchTimer = null;       // дебаунс серии кликов
  const _loadingRequests = new Set();   // только загрузки по действию пользователя; автоопрос — тихий

  function _syncLoading() {
    const busy = !!(_loadingRequests.size || _fetchTimer);
    document.body.classList.toggle('is-loading', busy);
    const main = document.querySelector('.main');
    if (main) main.setAttribute('aria-busy', String(busy));
    const status = document.getElementById('page-loading');
    if (status) status.setAttribute('aria-hidden', String(!busy));
  }
  function _beginReq(quiet) {
    _reqSeq += 1;
    _inflight += 1;
    if (!quiet) _loadingRequests.add(_reqSeq);
    _syncLoading();
    return _reqSeq;
  }
  // Снять один запрос с учёта; индикатор гаснет, когда в полёте никого.
  function _endReq(seq) {
    _inflight = Math.max(0, _inflight - 1);
    _loadingRequests.delete(seq);
    _syncLoading();
  }
  // Ответ устарел, если за время запроса стартовал более свежий → не рисуем.
  function _isStale(n) { return n !== _reqSeq; }
  // Серия кликов (типы сетапов, чекбоксы) → ОДИН запрос вместо N.
  function _scheduleFetch(ms) {
    if (_fetchTimer) clearTimeout(_fetchTimer);
    _fetchTimer = setTimeout(function () {
      _fetchTimer = null;
      Promise.resolve(fetchAndRender()).finally(_syncLoading);
    }, ms == null ? 120 : ms);   // 120 мс: API стал быстрым (аудит 29.08), длинный дебаунс только тянул отклик
    _syncLoading();              // отклик сразу, до запроса
  }

  let _lastDataSig = null;   // подпись последнего запроса ДАННЫХ (без клиентских фильтров)
  let _liveDataCache = null; // последний живой ответ — мгновенный рендер при возврате на таб

  // ── Клиентский кэш последнего ответа (localStorage) ──────────────────
  // Хард-рефреш/новый заход больше не ждёт сервер с пустым экраном («загрузка…»
  // на несколько секунд — репорт владельца 29.08): интерфейс рисуется мгновенно
  // из последнего успешного ответа ЭТОГО браузера (та же роль и настройки),
  // свежие данные заменяют его штатным fetchAndRender через секунды.
  var _DATA_CACHE_KEY = 'setups.cachedData';
  var _dataCacheSavedAt = 0;
  var _dataCacheSig = null;
  function _saveDataCache(sig, j) {
    // Теневая сборка (?build=asof, admin) — режим адреса, volatile: её подпись в кэш и в
    // прелоад <head> не пишем, иначе следующий обычный заход сначала запросил бы теневую сборку.
    if (STATE.build) return;
    var now = Date.now();
    // Та же подпись — не чаще раза в минуту (авторефреш). Новая подпись — сразу (02.10.2026): до этого после смены
    // настроек следующий визит предзагружал старую подпись (у админа на телефоне — витрину по умолчанию, 850 КБ
    // впустую) и не рисовал из кэша.
    if (sig === _dataCacheSig && now - _dataCacheSavedAt < 60000) return;
    _dataCacheSavedAt = now;
    _dataCacheSig = sig;
    try {
      localStorage.setItem(_DATA_CACHE_KEY, JSON.stringify({ q: sig, ts: now, data: j }));
      localStorage.setItem('setups.lastQ', sig);   // подпись — для prefetch в <head>
    } catch (e) { /* квота/приватный режим — просто без кэша */ }
  }
  function _restoreDataCache(sig) {
    try {
      var raw = localStorage.getItem(_DATA_CACHE_KEY);
      if (!raw) return false;
      var c = JSON.parse(raw);
      if (!c || !c.data || !c.data.table || !c.data.table.length) return false;
      if (Date.now() - (c.ts || 0) > 24 * 3600 * 1000) return false;  // старше суток — не показываем
      // ⚠ Подпись обязана совпасть: кэш снят при КОНКРЕТНЫХ настройках (депозит,
      // размер позиции, комиссия, окно). Рисовать его при других — показывать
      // числа, которых человек не запрашивал. Подпись сохранялась и раньше, но
      // не сверялась — кэш от авто-депозита рисовался поверх выбранных 2 млн.
      if (!c.q || !sig || c.q !== sig) return false;
      STATE.data = c.data;
      _dataGen += 1;
      if (!_clientFiltersDefault()) STATE.data._slimPending = true;   // счётчики кэша — полного ответа
      renderTable();
      if (c.data.top) renderCards(c.data.top);
      var stats = c.data.stats_day || c.data.stats;
      if (stats) { renderStats(stats); renderSecCount(stats); }
      return true;
    } catch (e) { return false; }
  }


  /** Применить slim-ответ (агрегаты по текущим фильтрам): patch STATE.data +
   *  перерисовка карточек/счётчиков. Таблицу не трогаем данными — она уже
   *  показана из полного набора, только перерисовываем (учёт агрегатов в шапке). */
  function _applySlim(js) {
    if (!STATE.data || !js) return;
    ['stats', 'stats_hour', 'stats_day', 'setup_counts', 'track_record', 'netting',
     'short_risk', 'short_risk_since', 'rubles'].forEach(function(k) {
      if (k in js) STATE.data[k] = js[k];
    });
    delete STATE.data._slimPending;      // счётчики окон — уже по выбранным парам
    _syncDepoUI();
    const stats = STATE.data.stats_day || STATE.data.stats;
    renderStats(stats);
    renderSecCount(stats);
    renderTable();
  }

  /** Фоновый slim-запрос агрегатов по ПОЛНЫМ фильтрам (после полного ответа,
   *  когда клиентские фильтры не в дефолте). Уважает поколения запросов:
   *  устаревший ответ не применяется. */
  function _fetchSlimAggregates(_rub, _demo, f, quiet) {
    const ps = new URLSearchParams({ window: STATE.window, days_back: STATE.daysBack,
                                     week_only: '1', slim: '1', ..._rub, ..._demo, ...f });
    const mySlim = ++_slimSeq, gen = _dataGen;
    // устарел — только если данные с тех пор сменились или ушёл более свежий лёгкий запрос
    const fresh = function() { return mySlim === _slimSeq && gen === _dataGen; };
    // Доводка счётчиков — часть той же загрузки, но новое поколение данных не создаёт.
    const loading = {};
    if (!quiet) _loadingRequests.add(loading);
    _syncLoading();
    fetch('/api/setups?' + ps.toString())
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(js) {
        if (!fresh()) return;
        if (js) { _applySlim(js); return; }
        if (STATE.data) { delete STATE.data._slimPending; renderWindowCounts(); }   // ответа нет — счётчики полного
      })
      .catch(function() { if (fresh() && STATE.data) { delete STATE.data._slimPending; renderWindowCounts(); } })
      .finally(function() { _loadingRequests.delete(loading); _syncLoading(); });
  }

  async function fetchAndRender(_isAuto, _retry) {
    // Пресет-режим: forward-журнал пресета. Авто-refresh пропускаем (журнал
    // наполняется фоновым cron раз в час, не каждую минуту).
    if (STATE.presetId) {
      if (_isAuto) return;
      return fetchPresetSetups();
    }
    // «История сделок»: страница сделок счёта. Авто-обновление пропускаем, как у недель: сделки закрываются
    // не ежеминутно, а перезапрос сбивал бы открытую страницу. Ручной вызов (смена фильтра) — с первой страницы.
    if (STATE.deals) {
      if (_isAuto) return;
      STATE.dealsPage = 1;
      return fetchDeals();
    }
    // «Нед»: недельный агрегат. Авто-refresh (setInterval) пропускаем — данные
    // меняются медленно (по мере резолва сетапов), refetch каждую минуту не нужен.
    if (STATE.weekly) {
      if (_isAuto) return;
      return fetchWeekly();
    }
    // «Детекторы»: график доходности. Авто-refresh пропускаем по той же причине,
    // что и недели — данные меняются по мере резолва сделок, не ежеминутно.
    if (STATE.detChart) {
      if (_isAuto) return;
      return fetchDetectors();
    }
    const f = currentFilters();
    // Backend всегда возвращает days_back=14 + stats_hour/stats_day одновременно;
    // window-toggle на UI выбирает только какой stats-блок отрисовать.
    // Ticker-mode: два запроса в параллель — один без ticker (для глобальной
    // TOP-витрины), один с ticker (для table). Идея пользователя: TOP остаётся
    // showcase'ом всего рынка, в таблице — конкретный тикер.
    // Издержки: поле «Комиссия брокера» (commission=) — одно на все роли с 08.09;
    // чекбокса «Без комиссии» больше нет, параметр gross сервер игнорирует.
    const _rub = (STATE.mode === 'rubles') ? { rubles: '1' } : {};
    Object.assign(_rub, _commissionQuery(), _unitsQuery());   // издержки и единицы — всем точкам сборки
    // Размер позиции шлём ВСЕГДА: он определяет кратность лотов, вложенную сумму
    // и рублёвый доход — не только в неттинге.
    _rub.pos_size = String(STATE.posSize || 20000);
    // Неттинг — расчёт по умолчанию; явный netting=0 нужен, чтобы админ мог
    // посмотреть прежний способ счёта.
    _rub.netting = _nettingOn() ? '1' : '0';
    // Депозит шлём только когда человек его выбрал: пусто → сервер берёт пик
    // занятого (капитал-пул никого не режет).
    if (!STATE.depoAuto && STATE.rubDeposit && !_investedView()) _rub.deposit = String(STATE.rubDeposit);
    // demo_short_risk приходит в адресе САМОЙ страницы, а запрос к API мы строим
    // свой — без явного проброса параметр до бэка не доезжает (админский показ
    // метки «риск разворота» молча не работал).
    const _demo = _urlDemoShortRisk();
    // Таб «Неделя»: сервер оставит только живые на этой неделе сделки (открытые
    // + закрытые с понедельника). Клиентского дубля правила нет намеренно.
    // Клиентские фильтры (пары тип:ТФ, направление, слайдер оборота) с 29.08 НЕ
    // сужают запрос ДАННЫХ: таблица качается полной (в пределах серверных гейтов
    // и пола шкалы оборота — TURNOVER_VALUES[0] = минимум слайдера), сужение
    // мгновенно делает _filterByUi. Серверу фильтры уходят только в slim-запросе
    // агрегатов — принцип «что показано, то и посчитано» сохраняется: «Доход» и
    // счётчики считает сервер по фильтрам, они доезжают на ~полсекунды позже.
    const fData = _dataFilters(f);
    // ⚠ Набор детекторов уходит ОТДЕЛЬНЫМ параметром: таблица остаётся полной
    // (мгновенная фильтрация показа), а лента неттинга и капитал-пул считаются
    // по выбранным детекторам — решение владельца 29.08. Пока лента считалась
    // по всем, снятый «шаг Эллиотта» встречными сигналами закрывал позиции, а
    // капитал занимали чужие сделки. Подпись запроса из-за этого меняется при
    // клике по чекбоксу — рефетч нужен, иначе строки несли бы старые исходы.
    // Полный набор пар (все, что объявил сервер в __SETUPS_CFG__.netPairsAll) равен
    // отсутствию фильтра — не шлём его, чтобы подпись совпадала с прелоадом и
    // прогревом (09.09: набор в ключе кэша давал два ключа под один расчёт, и тот,
    // что просила страница, всегда был холодным). Сервер нормализует то же самое
    // у себя (_pairs_cover_full) — старые адреса с полным списком дают тот же ключ.
    if (f.type_tf && !_pairsCoverAll(f.type_tf)) fData.net_type_tf = _pairsCanon(f.type_tf);
    // ⚠ Направление — тоже отдельным параметром (24.09.2026): таблица остаётся с
    // обеими сторонами (фильтр показа мгновенный), а счёт строк считается по
    // выбранной стороне — как карточка «Доход недели» из slim-ответа. Без этого
    // лонг, открытый на счёте одной стороны, в строке стоял «не открыта: открыта
    // встречная позиция». Режим «только пропущенные встречные» (admin) шлёт
    // направление как opp_dir и сюда не попадает: там счёт двусторонний.
    if (f.direction) fData.net_direction = f.direction;
    // Оборот — так же (24.09.2026): при заданном депозите счёт бумаги зависит от
    // остальных бумаг через капитал, и строки из широкой вселенной спорили с
    // карточкой (замер: 37 из 319 строк недели при депозите 1,5 млн и обороте
    // от 100 млн). Таблица по-прежнему качается с пола шкалы.
    if (Number(f.min_turnover) > TURNOVER_VALUES[0]) fData.net_min_turnover = String(f.min_turnover);
    if (f.max_turnover) fData.net_max_turnover = String(f.max_turnover);
    const params = new URLSearchParams({ window: STATE.window, days_back: STATE.daysBack,
                                         week_only: '1', ..._rub, ..._demo, ...fData });
    const _seq = _beginReq(!!_isAuto);
    // Подпись запроса данных не изменилась (клик был по клиентскому фильтру) →
    // полный рефетч не нужен: таблица уже перерисована мгновенно (onFilterChange),
    // обновляем только серверные агрегаты лёгким slim-ответом (~10 КБ).
    const _dataSig = params.toString();
    // Мгновенный первый рендер из кэша прошлого визита — ровно здесь, где уже
    // известна подпись текущих настроек: кэш рисуется, только если он снят при
    // ТЕХ ЖЕ настройках. Иначе человек увидел бы чужие числа (репорт 29.08:
    // «депозит 2 млн» рядом с числами от авто-депозита).
    if (!_isAuto && !f.ticker && !STATE.data && _restoreDataCache(_dataSig)) {
      _earlyChart(STATE.data.top, f);      // график — сразу по кэшу, не после полного ответа (C1)
    }
    if (!_isAuto && !f.ticker && STATE.data && STATE.data.table
        && STATE.data.table.length && _lastDataSig === _dataSig) {
      const mySlim = ++_slimSeq, gen = _dataGen;
      try {
        const ps = new URLSearchParams({ window: STATE.window, days_back: STATE.daysBack,
                                         week_only: '1', slim: '1', ..._rub, ..._demo, ...f });
        const r = await fetch('/api/setups?' + ps.toString());
        const js = await r.json();
        // устарел — только если данные сменились или ушёл более свежий лёгкий запрос (авто-опрос «без
        // изменений» его больше не отменяет, 28.09.2026)
        if (mySlim !== _slimSeq || gen !== _dataGen) return;
        if (r.ok) _applySlim(js);
      } catch (e) { /* агрегаты обновит следующий авто-рефреш */ }
      finally { _endReq(_seq); }
      return;
    }
    // Поблочная загрузка (идея владельца, 29.08): первый-в-жизни заход — ни
    // localStorage-кэша, ни STATE.data. Карточки «Лучшие завершённые» приезжают
    // отдельным лёгким top_only-запросом (~24 КБ, без неттинг-блока — самой
    // дорогой части на холодных ключах) и рисуются, не дожидаясь полного ответа.
    // Гонка безопасна: полный ответ пришёл раньше → STATE.data установлен и
    // top_only-ответ игнорируется; позже → перерисует карточки тем же содержимым.
    // Повтор после сбоя (_retry) карточки отдельно не запрашивает — их нарисует полный ответ.
    if (!STATE.data && !f.ticker && !_isAuto && !_retry) {
      // Карточки — теми же издержками, единицами, сборкой И серверными фильтрами вселенной, что запрос
      // данных, плюс week_only (_topParams, 26.09.2026). Без фильтров у анонима (набор — голубые фишки)
      // сначала рисовались карточки всего рынка, а полный ответ их заменял — график первого экрана
      // грузился дважды. Подпись по умолчанию — setups_defaults.default_top_query (прелоад в <head>).
      const psTop = _topParams(f);
      // Прелоад карточек из <head> (первый визит) — берём при байт-идентичной подписи.
      const _topQ = psTop.toString();
      let _ptop = null;
      if (window.__setupsPrefetchTop && window.__setupsPrefetchTop.q === _topQ) {
        _ptop = window.__setupsPrefetchTop.p; window.__setupsPrefetchTop = null;
      } else if (window.__setupsPrefetchTop) {
        // Промах = лишний запрос карточек; ловят проверки прелоада (фраза «прелоад не совпал»).
        console.warn('[setups] прелоад не совпал с подписью страницы (карточки):',
                     window.__setupsPrefetchTop.q, '≠', _topQ);
        window.__setupsPrefetchTop = null;
      }
      (_ptop || fetch('/api/setups?' + _topQ).then(function(r) { return r.ok ? r.json() : null; }))
        .then(function(js) {
          if (js && js.top && js.top.length && !STATE.data) {
            renderCards(js.top);
            renderSession(js.session, js.today_date);
            renderTopbarRegime(js.regime);
            _earlyChart(js.top, f);          // график по первой карточке, не дожидаясь полного ответа (C1)
          }
        }).catch(function() {});
    }
    let j;
    let _accepted = false;   // ответ принят — дальше отрисовка: её сбой повтором запроса не лечится
    try {
      if (f.ticker) {
        // Параллельный fetch: глобальный (без ticker) + фильтрованный
        const fGlobal = Object.assign({}, f);
        delete fGlobal.ticker;
        // Карточки — теми же издержками, что таблица (поле «Комиссия брокера»).
        const paramsGlobal = new URLSearchParams({ window: STATE.window, days_back: STATE.daysBack,
                                                   ..._demo, ..._commissionQuery(), ..._unitsQuery(), ...fGlobal });
        const [respGlobal, respFiltered] = await Promise.all([
          fetch('/api/setups?' + paramsGlobal.toString()),
          fetch('/api/setups?' + params.toString()),
        ]);
        const jGlobal = await respGlobal.json();
        j = await respFiltered.json();
        if (!respGlobal.ok) throw new Error(jGlobal.error || 'error');
        if (!respFiltered.ok) throw new Error(j.error || 'error');
        // TOP-витрина — из глобального ответа (без ticker filter).
        // Stats и table — из фильтрованного.
        j.top = jGlobal.top;
      } else {
        // Прелоад из <head> (ранний старт до исполнения JS): берём его ТОЛЬКО при
        // байт-идентичной подписи запроса; одноразово. null (ошибка) → обычный fetch.
        let _pf = null;
        if (!_isAuto && window.__setupsPrefetch && window.__setupsPrefetch.q === _dataSig) {
          _pf = window.__setupsPrefetch; window.__setupsPrefetch = null;
          j = await _pf.p;
        } else if (!_isAuto && window.__setupsPrefetch) {
          // Промах прелоада = лишний полный запрос. При первом визите (подпись из
          // setups_defaults) это разъехавшиеся дефолты сервера и клиента — ловит
          // tools/check_commission_field.py; при повторном — сменились настройки.
          console.warn('[setups] прелоад не совпал с подписью страницы:',
                       window.__setupsPrefetch.q, '≠', _dataSig);
          window.__setupsPrefetch = null;
        }
        if (!j) {
          // Условный авторефреш (B1, 09.09): авто-опрос несёт токен версии
          // последнего полного ответа при той же подписи; сервер отвечает
          // {unchanged:true}, если лента не менялась, — тогда ничего не
          // перерисовываем (раньше каждую минуту качался полный ответ и
          // список рисовался заново — 0,4–1,9 с CPU на слабом устройстве).
          const _verQ = (_isAuto && STATE.data && STATE.data.ver && _lastDataSig === _dataSig)
                        ? '&ver=' + encodeURIComponent(STATE.data.ver) : '';
          const r = await fetch('/api/setups?' + params.toString() + _verQ);
          j = await r.json();
          if (!r.ok) throw new Error(j.error || 'error');
          if (j && j.unchanged) return;      // лента не менялась; finally снимет счётчик запросов
        }
      }
      if (_isStale(_seq)) return;        // ответ устарел — пришёл более свежий клик
      _accepted = true;
      STATE.data = j;
      _dataGen += 1;
      _liveDataCache = j;                // мгновенный возврат на таб «Неделя» (setRange)
      if (_mnData) _mnRenderEvening();   // открытые сделки против хода индекса — по свежему счёту (20.10.2026)
      if (!f.ticker) _saveDataCache(_dataSig, j);  // кэш прошлого визита + подпись для prefetch
      _lastDataSig = f.ticker ? null : _dataSig;   // ticker-режим — всегда полный рефетч
      // Клиентские фильтры не в дефолте → агрегаты полного ответа посчитаны «по
      // всем», а показ отфильтрован. Доводим их slim-запросом (fire-and-forget).
      // Счётчики окон полного ответа посчитаны по всем парам — пока лёгкий ответ в пути, их не рисуем
      // (renderWindowCounts оставляет прежнюю надпись), иначе «Вся история» мелькала 26k → 23k.
      if (!f.ticker && !_clientFiltersDefault()) {
        j._slimPending = true;
        _fetchSlimAggregates(_rub, _demo, f, !!_isAuto);
      }
      // ⚠ Подпись депозита («Пропущено N сделок») зависит от ответа сервера,
      // поэтому обновляем её ЗДЕСЬ, а не в ветке карточек: иначе она не
      // реагировала на смену размера позиции и оживала только от движения
      // собственного ползунка (репорт владельца 29.08).
      _syncDepoUI();
      // Только stats_day — переключатель час/день удалён
      const stats = j.stats_day || j.stats;
      renderSession(j.session, j.today_date);
      renderTopbarRegime(j.regime);
      renderStats(stats);
      renderSecCount(stats);
      renderCards(j.top);
      renderTable();
      // Гейт-баннеры (взаимоисключающие): anon → «войдите»; free после триала →
      // «сетапы с задержкой — по подписке» (модель 12.09.2026: бесплатный видит все
      // бумаги с задержкой анонима, гейт «только голубые фишки» снят). Платные —
      // оба скрыты. Замок на чекбоксе голубых фишек больше не ставится.
      const ab = document.getElementById('anon-banner');
      if (ab) ab.style.display = j.is_anon ? 'flex' : 'none';
      const fbb = document.getElementById('free-delay-banner');
      if (fbb) fbb.style.display = (j.free_tier && !j.is_anon) ? 'flex' : 'none';
      _syncReferralUI();   // баннеры приглашённого друга заменяют эти два (реферальная программа, 01.10.2026)
      _applyBlueChipsGate(false);
      // Риск разворота — состояние РЫНКА, поэтому полосой над таблицей.
      // В «Истории сделок» не показываем: там история, «сейчас» ни при чём.
      const srb = document.getElementById('short-risk-banner');
      if (srb) srb.style.display = (j.short_risk && !STATE.deals) ? 'flex' : 'none';
      // Момент активации в заголовке плашки: по нему видно, почему шорты до
      // него остались в выдаче с меткой, а появившиеся после скрыты. Не удалось
      // разобрать (сбой источника) → прежнее «Сейчас».
      const srbMain = document.getElementById('srb-main');
      if (srbMain) {
        // «13:00 27.08» → «13:00 МСК 27 авг»: зона рядом со временем, дата словом.
        const _M = ['янв','фев','мар','апр','мая','июн','июл','авг','сен','окт','ноя','дек'];
        const raw = j.short_risk_since || '';
        let since = '';
        const mm = raw.match(/^(\d{2}:\d{2}) (\d{2})\.(\d{2})$/);
        if (mm) since = mm[1] + ' МСК ' + parseInt(mm[2], 10) + ' ' + (_M[parseInt(mm[3], 10) - 1] || '');
        srbMain.textContent = (since ? 'С ' + since.trim() + ' шорты' : 'Сейчас шорты')
          + ' рискованны: рынок падал более 7% от месячного максимума, а сегодня растёт.';
      }
      // При первой загрузке: заряжаем chart-panel первым ТОП-сетапом.
      // На последующих re-fetch (60-сек авторефреш) — НЕ трогаем panel,
      // чтобы пользователь, смотрящий на конкретный тикер, не сбивался.
      // Ticker-mode: если активен фильтр по тикеру и chart показывает другое —
      // фокусируем на нём (UX: ticker filter подразумевает «смотрю на этот тикер»).
      // Ленивая загрузка графика: сперва даём таблице отрисоваться и отдать кадр,
      // график (холодный chart-data + инициализация WebGL) подгружаем в простое —
      // страница «чувствуется» быстрой на слабых устройствах. На авто-рефреше тут
      // лишь подсветка выбранной строки (дёшево), отложить её на тик безвредно.
      var _initPanelChart = function() {
        // Предварительный старт (C1): помним, по какому сетапу панель поднята до
        // полного ответа, и сбрасываем метку — решение принимается один раз.
        var _prelim = _panelPrelimTid, _prelimTicker = _panelPrelimTicker;
        _panelPrelimTid = null; _panelPrelimTicker = null;
        // Поле поиска принимает и тикер, и РУССКОЕ название («озон» → OZON), поэтому
        // грузить график по сырому вводу нельзя: `'озон'.toUpperCase()` = «ОЗОН», и
        // график падал в «unknown ticker». Резолвим настоящий тикер из выдачи; точное
        // совпадение с введённым имеет приоритет (ввод «OZPH» при выдаче с OZON сверху).
        var _q = (f.ticker || '').trim();
        var _rows = j.table || [];
        var tickerFilterValue = '';
        if (_q) {
          var _up = _q.toUpperCase();
          var _exact = null;
          for (var _i = 0; _i < _rows.length; _i++) {
            if (_rows[_i].trigger && _rows[_i].trigger.ticker === _up) { _exact = _up; break; }
          }
          if (_exact) tickerFilterValue = _exact;
          else if (_rows.length && _rows[0].trigger) tickerFilterValue = _rows[0].trigger.ticker;
          else if (/^[A-Za-z0-9]+$/.test(_q)) tickerFilterValue = _up;   // сетапов нет, но это тикер
        }
        // Новый поиск (или график ушёл на другую бумагу) → график на ПЕРВУЮ ВИДИМУЮ
        // строку найденного тикера, как клик по ней: её ТФ (дивергенция 4ч → 4H),
        // выбор сетапа, окно вокруг бара. Раньше ТФ выбирался «по тикеру»
        // (_tfForTicker: любая дивергенция → 1H, прочие → текущий ТФ панели), а если
        // график уже стоял на этом тикере — не пересчитывался вовсе: поиск «роснефть»
        // оставлял 15M от первой карточки, хотя в таблице одна строка — дивергенция 4ч
        // (репорт владельца 23.09). Повтор того же поиска (авторефреш раз в минуту)
        // ручной выбор строки и ТФ не сбивает. ?solo_tf= (скриншотер, ссылка из бота) —
        // прежний путь: там сетап и ТФ заданы адресом.
        var _searchMi = null;
        if (!tickerFilterValue) {
          _searchFocused = '';
        } else if (!STATE.soloTf
                   && (tickerFilterValue !== _searchFocused || _panelTicker !== tickerFilterValue)) {
          _searchFocused = tickerFilterValue;
          _searchMi = visibleItems().find(function(m) {
            return m.trigger && m.trigger.ticker === tickerFilterValue;
          }) || null;
        }
        // Сетап первого экрана (26.09.2026) — первая видимая карточка; считаем, только если он нужен.
        var _fsMemo;
        var _fsGet = function() {
          if (_fsMemo === undefined) _fsMemo = _firstScreenSetup(j.top);
          return _fsMemo;
        };
        if (_searchMi) {
          _focusSearchRow(_searchMi);
        } else if (tickerFilterValue && _panelTicker !== tickerFilterValue) {
          // Видимых строк у тикера нет (или ТФ задан адресом) — как раньше.
          // STATE.soloTf (?solo_tf=) — форс ТФ от скриншотера.
          loadChartInPanel(tickerFilterValue, STATE.soloTf || _tfForTicker(tickerFilterValue));
        } else if (!_panelTicker && _fsGet()) {
          // Выбрать сетап первого экрана (_firstScreenSetup: первая ВИДИМАЯ карточка, 26.09.2026 —
          // раньше top[0] без фильтров показа) → _doLoad покажет ИМЕННО его (Case 1 рисует линии
          // для дивергенции / Case 3 очищает для прочих типов). Без выбора Case (2)
          // авто-рисовал «свежайшую» дивергенцию поверх чужого сетапа (напр. AQUA =
          // DOUBLE_EXTREME, а линии дивергенции висели) → путало пользователя.
          var _fs0 = _fsGet().trigger;
          STATE.selectedTriggerBarDate = _fs0.bar_date;
          STATE.selectedTriggerType = _fs0.trigger_type;
          STATE.selectedTid = _fs0.id;   // точный id → sim-кнопка = направление показанного сетапа
          // ТФ берём У САМОГО сетапа, а не '1h' константой: карточки с 24.08
          // сортируются хронологически, и первой всё чаще стоит четырёхчасовая —
          // её бар на часовом графике не существует, solo цеплялся к чужому
          // маркеру (репорт владельца: карточка OZON 24.08 07:00, а стрелка
          // 21.08 10:00). _tfForType — тот же резолвер, что у клика по строке.
          loadChartInPanel(_fs0.ticker, _tfForType(_fs0.trigger_type, _fs0.tf));
        } else if (_prelim && _panelTicker === _prelimTicker && _fsGet()
                   && _fsGet().trigger.id !== _prelim) {
          // Панель поднята предварительно (кэш прошлого визита / лёгкий ответ), а
          // сетап первого экрана в свежем ответе другой, и человек панель не трогал —
          // переключаем на него (один раз).
          var _fs1 = _fsGet().trigger;
          STATE.selectedTriggerBarDate = _fs1.bar_date;
          STATE.selectedTriggerType = _fs1.trigger_type;
          STATE.selectedTid = _fs1.id;
          loadChartInPanel(_fs1.ticker, _tfForType(_fs1.trigger_type, _fs1.tf));
        }
      };
      if (window.requestIdleCallback) requestIdleCallback(_initPanelChart, { timeout: 1000 });
      else setTimeout(_initPanelChart, 0);
    } catch (e) {
      // Сбой отрисовки (ответ уже принят) — ошибка кода, а не сети: повтор упал бы так же и лишь нагрузил
      // сервер полными запросами. Пробрасываем как есть — она видна в консоли и браузерным проверкам.
      if (_accepted) throw e;
      // Silent retry на сетевые ошибки и transient 5xx (server restart blip).
      // Backoff: 0.8s, 1.6s, 2.4s — суммарно ~5s до показа UI-ошибки.
      // До 15.10.2026 повтор не работал: после переименования параметра в _isAuto счётчик _retry не был
      // объявлен, catch падал с ReferenceError — ни повтора, ни сообщения об ошибке на первом заходе.
      const MAX_RETRIES = 3;
      const attempt = (_retry || 0) + 1;
      if (attempt <= MAX_RETRIES && !_isStale(_seq)) {
        await new Promise(r => setTimeout(r, 800 * attempt));
        // За паузу ушёл более свежий запрос (смена фильтра или вкладки) — повторять нечего.
        if (_isStale(_seq)) return;
        return fetchAndRender(_isAuto, attempt);
      }
      if (_isStale(_seq)) return;
      // Ошибку показываем, только если на экране ещё нет данных (первая загрузка):
      // сбой авторефреша оставляет прежние — они лучше пустого экрана с ошибкой.
      if (!STATE.data) {
        _llCancel();
        const _ll = document.getElementById('list-light');
        if (_ll) _ll.innerHTML = '<div class="empty">Не удалось загрузить сетапы ('
          + _esc(e && e.message) + '). Обновите страницу.</div>';
        const _tc = document.getElementById('top-cards-light');
        if (_tc) _tc.innerHTML = '';
      }
    } finally { _endReq(_seq); }
  }



  // Длительность одного бара в часах — окно сделки задано в барах СВОЕГО ТФ.
  const TF_HOURS = { '1h': 1, '4h': 4, '15m': 0.25, '5m': 1 / 12, 'D1': 24 };
  function windowHours(bars, tf) {
    const h = (Number(bars) || 0) * (TF_HOURS[tf || '1h'] || 1);
    return h >= 1 ? Math.round(h) : Math.round(h * 60) / 60;
  }

  // ── Таймфрейм сетапа ────────────────────────────────────────────
  // Сетапы 1Ч и 4Ч лежат в одном списке (решение 19.08), поэтому ТФ виден
  // в каждой строке и в каждой карточке.
  const TF_LABEL = { '1h': '1Ч', '4h': '4Ч', '15m': '15М', '5m': '5М', 'D1': 'Д' };
  function tfBadge(tf) {
    const lbl = TF_LABEL[tf || '1h'] || (tf || '1h');
    return '<span class="row-l-tf" title="Таймфрейм сетапа">' + lbl + '</span>';
  }
  function setupTf(mi) {
    return (mi && mi.trigger && mi.trigger.tf) || '1h';
  }

  // ── TA Chart Side Panel ───────────────────────────────────
  // Engine создаётся один раз при первой загрузке тикера и переиспользуется.
  var _panelEngine = null;
  var _panelTicker = null;
  // Предварительный старт панели (C1, 09.09): id и тикер сетапа, по которому график
  // поднят ДО полного ответа. Полный ответ переключит панель на свою первую
  // карточку, только если она другая и панель всё ещё показывает предварительную.
  var _panelPrelimTid = null;
  var _panelPrelimTicker = null;
  // ТФ графика по умолчанию и типы «на своём ТФ» — с сервера (settings.SETUPS_CHART_*, 26.09.2026): по ним
  // же крон прогрева греет график первой карточки (setups_defaults.chart_tfs_for).
  var _CHART_TF = (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.chartTf) || {};
  var _CHART_TF_OWN = _CHART_TF.own || [];
  var _panelTf = _CHART_TF.desktop || '15m';
  var _searchFocused = '';   // тикер поиска, по которому график уже сфокусирован (_initPanelChart)

  // Дивергенция — 1H-паттерн: её линии (цена + RSI) считаются на 1H. На 15m/5m
  // chart-data enrichment НЕ воспроизводит 1H-эмитнутую дивергенцию (ре-детект
  // бежит по свечам младшего ТФ) → у маркеров нет pivot-полей → линий нет,
  // только стрелки. Поэтому сетап дивергенции открываем на 1H; прочие — на
  // текущем ТФ панели (десктоп-дефолт 15m для гранулярности входа).
  function _tfForType(trigType, setupTfVal) {
    // Сетап 4Ч открываем на четырёхчасовом графике: его бар на младшем ТФ
    // просто не существует, маркер было бы не к чему привязать.
    if (setupTfVal && setupTfVal !== '1h') return setupTfVal;
    // Типы «на своём ТФ» — settings.SETUPS_CHART_OWN_TF_TYPES (с сервера, 26.09.2026; тот же список берёт
    // прогрев графика первого экрана): DIVERGENCE — линии только на 1H; детекция фигур 1h-based, на 15m
    // re-detect даст ДРУГИЕ фигуры → маркеры не совпадут с геометрией строки таблицы; HIDDEN_LEVEL и
    // ELLIOTT_STEP — зона построена по барам своего ТФ, на младшем график нарисовал бы её по чужим
    // координатам. Все они → 1h.
    if ((_CHART_TF_OWN || []).indexOf(trigType) >= 0) return '1h';
    return _panelTf || '15m';
  }
  function _tfForTid(tid) {
    var typ = null, stf = null;
    if (typeof STATE !== 'undefined' && STATE.data) {
      var pool = (STATE.data.top || []).concat(STATE.data.table || []);
      var mi = pool.find(function(m) { return m.trigger && String(m.trigger.id) === String(tid); });
      if (mi) { typ = mi.trigger.trigger_type; stf = mi.trigger.tf; }
    }
    return _tfForType(typ, stf);
  }
  // Открытие по тикеру (ticker-фильтр / ссылка из бота `?ticker=X`) — типа триггера
  // нет, поэтому смотрим: есть ли у тикера дивергенц-сетап в выдаче. Если да —
  // открываем 1H (бот шлёт ссылку под конкретный триггер; на дивергенции линии
  // только на 1H). Иначе — текущий ТФ панели.
  /** Ранний старт графика по первой карточке (C1 аудита скорости 09.09): тикер
   *  известен из кэша прошлого визита или из лёгкого top_only-ответа за секунды до
   *  полного, а панель раньше ждала полный ответ (+2,5–3 с на повторном визите,
   *  +5 с на первом). Старт предварительный: _initPanelChart переключит панель на
   *  первую карточку полного ответа, если она другая и панель никто не трогал. */
  function _earlyChart(top, f) {
    if (_panelTicker) return;
    if (f && f.ticker) return;             // фильтр по тикеру — панель выберет _initPanelChart
    // Первая ВИДИМАЯ карточка (26.09.2026), а не top[0]: у анонима top[0] бывал сетапом вне его набора.
    // Видимых нет — заранее не стартуем: сетап выберет _initPanelChart по полному ответу.
    var vt = _visibleTop(top);
    if (!vt.length || !vt[0].trigger) return;
    var t = vt[0].trigger;
    STATE.selectedTriggerBarDate = t.bar_date;
    STATE.selectedTriggerType = t.trigger_type;
    STATE.selectedTid = t.id;
    _panelPrelimTid = t.id;
    _panelPrelimTicker = t.ticker;
    // Окно вокруг сетапа — явно (26.09.2026). На первом визите лёгкий ответ с карточками приходит раньше
    // полного, STATE.data ещё пуст, и loadChartInPanel не находил выбранный сетап (_findSetupByTid) — график
    // грузился без окна: правый край и уровни на сегодня. Когда первым приходил полный ответ — с окном и
    // центром на сетапе. Теперь всегда как на повторном визите и как при клике по строке.
    var _o = t.bar_date ? { around: t.bar_date } : {};
    if (t.fut_contract) _o.fut = t.fut_contract;   // режим «Фьючи»: ответа ещё нет — контракт из карточки
    loadChartInPanel(t.ticker, _tfForType(t.trigger_type, t.tf), _o);
  }

  /** Поиск по тикеру: выбрать строку сетапа и открыть её на графике тем же правилом,
   *  что клик по строке (ТФ строки, выбор для solo, окно вокруг бара). Та же строка
   *  на том же ТФ уже на графике → только подсветка, без перезагрузки. */
  function _focusSearchRow(mi) {
    var t = mi.trigger;
    var tid = String(t.id);
    var tf = _tfForType(t.trigger_type, t.tf || '1h');
    var same = _panelTicker === t.ticker && _panelTf === tf && String(STATE.selectedTid) === tid;
    STATE.expandedTriggerId = tid;
    _setSelectedFromTid(tid);
    _flushListLight();                 // строка может быть в ещё не отрисованной порции
    var root = document.getElementById('list-light');
    if (root) {
      root.querySelectorAll('.row-l.selected').forEach(function(r) { r.classList.remove('selected'); });
      var row = root.querySelector('.row-l[data-tid="' + tid + '"]');
      if (row) row.classList.add('selected');
    }
    if (!same) loadChartInPanel(t.ticker, tf, t.bar_date ? { around: t.bar_date } : {});
  }

  function _tfForTicker(ticker) {
    if (typeof STATE !== 'undefined' && STATE.data) {
      var pool = (STATE.data.top || []).concat(STATE.data.table || []);
      var hasDiv = pool.some(function(m) {
        return m.trigger && m.trigger.ticker === ticker && m.trigger.trigger_type === 'DIVERGENCE';
      });
      if (hasDiv) return '1h';
    }
    return _panelTf || '15m';
  }

  // Запомнить выбранный триггер по его id (tid) — bar_date+type для solo/divergence.
  function _setSelectedFromTid(tid) {
    STATE.selectedTid = tid;   // для admin sim-трейда (кнопка Купить/Продать выбранного сетапа)
    if (typeof _renderSimBar === 'function') _renderSimBar();
    if (!STATE.data) return;
    var pool = (STATE.data.top || []).concat(STATE.data.table || []);
    var item = pool.find(function(mi) { return mi.trigger && String(mi.trigger.id) === String(tid); });
    if (item) {
      STATE.selectedTriggerBarDate = item.trigger.bar_date;
      // de-строки: все несут trigger_type='DOUBLE_EXTREME_MTF', но на графике маркер —
      // свой DE_-тип. Для solo (_applySoloFromSelection) selectedTriggerType должен
      // совпадать с trigger маркера → мапим через de_setup. bar_date строки == bar_date
      // маркера (bear/top = бар фигуры, double_bottom = бар пробоя).
      STATE.selectedTriggerType = item.trigger.de_setup
        ? (_DE_SETUP_TO_TYPE[item.trigger.de_setup] || item.trigger.trigger_type)
        : item.trigger.trigger_type;
    }
  }

  function _findSetupByTid(tid) {
    if (!tid || !STATE.data) return null;
    var pool = (STATE.data.table || []).concat(STATE.data.top || []);
    return pool.find(function (mi) { return mi.trigger && String(mi.trigger.id) === String(tid); }) || null;
  }

  // ── Ручной симулятор торговли (admin-only) ────────────────────────
  // Кнопка Купить/Продать (в направлении выбранного сетапа, SL сетапа as-is) или
  // Закрыть открытую позицию + live-P&L. Трекер (cron) ведёт трейл и шлёт TG-алерт;
  // закрываю вручную здесь. Полный журнал — /admin/sim-trades.
  var _simOpenByTicker = {};   // {TICKER: trade} для OPEN/PENDING
  var _simTimer = null;
  var _simWired = false;
  function _simHeaders() {
    var h = { 'Content-Type': 'application/json' };
    if (_csrfToken) h['X-CSRF-Token'] = _csrfToken;
    return h;
  }
  function _simFmtPx(p) { var a = Math.abs(p); return a >= 100 ? p.toFixed(1) : a >= 1 ? p.toFixed(2) : p.toFixed(4); }
  // Не-блокирующий тост (вместо browser alert для результата/ошибок sim-трейда — сам
  // alert-результат бессмыслен: сделка уже закрыта по confirm-клику).
  function _simToast(msg, isErr) {
    var t = document.getElementById('simToast');
    if (!t) { t = document.createElement('div'); t.id = 'simToast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.className = 'sim-toast ' + (isErr ? 'err' : 'ok') + ' show';
    clearTimeout(t._h); t._h = setTimeout(function () { t.className = 'sim-toast'; }, 2600);
  }
  function _loadSimOpen() {
    if (!_authState.is_admin) return Promise.resolve();
    return fetch('/api/admin/sim-trades', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        _simOpenByTicker = {};
        if (j && j.ok) (j.rows || []).forEach(function (t) {
          if (t.status === 'OPEN' || t.status === 'PENDING_CLOSE') _simOpenByTicker[t.ticker] = t;
        });
        _renderSimBar();
      }).catch(function () {});
  }
  var _SIM_ALERT_RU = { SL: 'стоп', TRAIL: 'трейл', TRAIL_TIME: 'время', EXPIRED: 'время' };
  // Сетап, показанный на графике — надёжно, не завися от пути клика (строка списка
  // ставит selectedTriggerType/bar_date напрямую, минуя _setSelectedFromTid). Резолвим
  // ИМЕННО выбранный сетап (без fallback на «другой сетап тикера» — кнопка отражает то,
  // что выбрано): 1) по клик-tid; 2) по bar_date+type (переживает auto-open,
  // где expandedTriggerId обнуляется/не ставится). Кнопку показываем ТОЛЬКО если сетап
  // активен — в таблице ещё нет исхода: realized_r == null И r_outcome == null (исключает
  // и разрешённые SL/TRAIL/…, и CANCELED «не открыта»).
  function _findPanelSetup() {
    if (!STATE.data || !_panelTicker) return null;
    var pool = (STATE.data.table || []).concat(STATE.data.top || []);
    var mi = _findSetupByTid(STATE.expandedTriggerId);
    // Точный id выбранного сетапа — РАЗЛИЧАЕТ два сетапа одного тикера+бара+типа,
    // но ПРОТИВОПОЛОЖНЫХ направлений (напр. regular_bullish LONG + hidden_bearish
    // SHORT дивергенции на одном баре GMKN). Фолбэк по bar_date этого не различал
    // → кнопка брала первый попавшийся (не то направление, что на графике).
    if (!mi || !mi.trigger || mi.trigger.ticker !== _panelTicker) mi = _findSetupByTid(STATE.selectedTid);
    if (!mi || !mi.trigger || mi.trigger.ticker !== _panelTicker) {
      var bd = String(STATE.selectedTriggerBarDate || '').replace('T', ' ').substring(0, 16);
      var tp = STATE.selectedTriggerType;
      mi = pool.find(function (m) {
        if (!m.trigger || m.trigger.ticker !== _panelTicker) return false;
        if (bd) return String(m.trigger.bar_date || '').replace('T', ' ').substring(0, 16) === bd;
        var mtp = m.trigger.de_setup
          ? (_DE_SETUP_TO_TYPE[m.trigger.de_setup] || m.trigger.trigger_type)
          : m.trigger.trigger_type;
        return tp && mtp === tp;
      }) || null;
    }
    if (!mi || !mi.trigger || mi.trigger.sl == null || mi.trigger.atr == null) return null;
    if (mi.realized_r != null || mi.r_outcome != null) return null;   // только активные
    return mi;
  }
  function _renderSimBar() {
    var el = document.getElementById('simTradeBar');
    if (!el) return;
    if (!_authState.is_admin || !_panelTicker) { el.style.display = 'none'; return; }
    var pos = _simOpenByTicker[_panelTicker];
    if (pos) {
      var longP = pos.direction === 'LONG';
      var entry = Number(pos.entry_price);
      var lp = pos.last_price != null ? Number(pos.last_price) : entry;
      var pct = longP ? (lp - entry) / entry * 100 : (entry - lp) / entry * 100;
      var pcl = Math.abs(pct) < 0.05 ? 'sim-pnl-flat' : (pct > 0 ? 'sim-pnl-pos' : 'sim-pnl-neg');
      var pend = pos.status === 'PENDING_CLOSE'
        ? '<span class="sim-pend">⚠ ' + (_SIM_ALERT_RU[pos.alert_reason] || 'выход') + '</span>' : '';
      el.innerHTML =
        '<div class="sim-pos"><span class="sim-pos-top sim-pos-dir-' + (longP ? 'long' : 'short') + '">'
        + (longP ? 'ЛОНГ' : 'ШОРТ') + ' @' + _simFmtPx(entry) + '</span>'
        + '<span class="' + pcl + '">' + (pct >= 0 ? '+' : '−') + Math.abs(pct).toFixed(2) + '%</span></div>'
        + pend
        + '<button class="sim-close" data-simclose="' + pos.id + '">Закрыть</button>'
        + _socialBtnHtml()
        + '<a class="sim-jrnl" href="/admin/sim-trades" target="_blank">журнал</a>';
      el.style.display = 'flex';
      return;
    }
    var mi = _findPanelSetup();
    if (!mi) { el.style.display = 'none'; return; }
    var dir = (mi.best && mi.best.final_direction) || mi.trigger.direction || 'LONG';
    var longS = dir === 'LONG';
    el.innerHTML =
      '<button class="' + (longS ? 'sim-buy' : 'sim-sell') + '" data-simopen="1">'
      + (longS ? 'Купить (ЛОНГ)' : 'Продать (ШОРТ)') + '</button>'
      + _socialBtnHtml()
      + '<a class="sim-jrnl" href="/admin/sim-trades" target="_blank">журнал</a>';
    el.style.display = 'flex';
  }
  // Пост в соцсети по ВЫБРАННОМУ сетапу. Кнопка есть и когда позиция открыта
  // (тогда пост подкреплён сделкой), и когда нет (разбор без позиции) — оба
  // варианта разрешены, различие фиксируется на сервере.
  function _socialBtnHtml() {
    var mi = _findPanelSetup();
    var tid = mi && mi.trigger && mi.trigger.id;
    return tid ? '<button class="sim-social" data-social="' + tid + '">В соцсети</button>' : '';
  }
  function _socialPost(triggerId) {
    if (!confirm('Сгенерировать пост для Пульса/Профита? Придёт в Telegram через ~30 сек.')) return;
    fetch('/api/admin/social-post', { method: 'POST', headers: _simHeaders(),
      credentials: 'same-origin', body: JSON.stringify({ trigger_id: Number(triggerId) }) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        _simToast(j && j.ok ? 'Готовлю пост — придёт в Telegram'
                            : 'Не запустилось: ' + ((j && j.error) || ''), !(j && j.ok));
      }).catch(function () { _simToast('Ошибка сети', true); });
  }

  function _simOpen() {
    var mi = _findPanelSetup();
    if (!mi || !mi.trigger) return;
    var dir = (mi.best && mi.best.final_direction) || mi.trigger.direction;
    if (!confirm('Открыть ' + (dir === 'LONG' ? 'ЛОНГ' : 'ШОРТ') + ' ' + mi.trigger.ticker + ' по рынку?')) return;
    var body = {
      ticker: mi.trigger.ticker,
      ticker_name: mi.trigger.ticker_name || mi.trigger.ticker,
      direction: dir, sl: mi.trigger.sl, atr: mi.trigger.atr,
      tp_rr: (mi.best && mi.best.tp_r) || 1.0,
      // Журнал сделок отсчитывает окно ЧАСОВЫМИ барами, поэтому переводим
      // бары ТФ сетапа в часы (на 4h один бар = четыре часа).
      window_bars: windowHours((mi.best && mi.best.window_bars) || 30, mi.trigger && mi.trigger.tf),
      setup_ref: mi.trigger.ticker + ' ' + String(mi.trigger.bar_date || '').substring(0, 16)
        + ' ' + (mi.trigger.tf || '1h') + ' ' + (mi.trigger.trigger_type || '')
    };
    fetch('/api/admin/sim-trade/open', { method: 'POST', headers: _simHeaders(),
      credentials: 'same-origin', body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.ok) { _simToast('Не открыто: ' + ((j && j.error) || ''), true); return; }
        _loadSimOpen();
      }).catch(function () { _simToast('Ошибка сети', true); });
  }
  function _simClose(id) {
    // Тянем СВЕЖУЮ цену (ровно ту, по которой реально закроется) для превью — чтобы
    // confirm не показывал устаревший last_price (трекер пишет его раз в минуту).
    // Fallback на last_price при сбое запроса — с пометкой. Фактическое закрытие —
    // по свежей серверной цене на клике (сервер фетчит свою, число клиента не читает).
    var pos = null;
    for (var _k in _simOpenByTicker) { var _p = _simOpenByTicker[_k]; if (_p && _p.id === id) { pos = _p; break; } }
    fetch('/api/admin/sim-trade/quote?id=' + id, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (j) {
        var fresh = !!(j && j.ok && j.price != null);
        var price = fresh ? Number(j.price) : (pos && pos.last_price != null ? Number(pos.last_price) : null);
        var q = 'Закрыть позицию по текущей цене?';
        if (pos && price != null) {
          var entry = Number(pos.entry_price), sl = Number(pos.sl_price);
          var long = pos.direction === 'LONG', sd = Math.abs(entry - sl);
          var r = sd > 0 ? (long ? (price - entry) / sd : (entry - price) / sd) : 0;
          var pct = long ? (price - entry) / entry * 100 : (entry - price) / entry * 100;
          q = 'Закрыть позицию по текущей цене ' + _simFmtPx(price) + '? ('
            + (r >= 0 ? '+' : '') + r.toFixed(2) + 'R / ' + (pct >= 0 ? '+' : '') + pct.toFixed(2) + '%)'
            + (fresh ? '' : ' — цена из последнего обновления');
        }
        if (!confirm(q)) return;
        fetch('/api/admin/sim-trade/close', { method: 'POST', headers: _simHeaders(),
          credentials: 'same-origin', body: JSON.stringify({ id: id }) })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            if (!j || !j.ok) { _simToast('Не закрыто: ' + ((j && j.error) || ''), true); return; }
            var t = j.trade;
            _simToast('Закрыто: ' + (t.realized_r >= 0 ? '+' : '') + Number(t.realized_r).toFixed(2)
              + 'R (' + Number(t.realized_pct).toFixed(2) + '%)');
            _loadSimOpen();
          }).catch(function () { _simToast('Ошибка сети', true); });
      });
  }
  function _initSimTrade() {
    if (_simWired || !_authState.is_admin) return;
    _simWired = true;
    var el = document.getElementById('simTradeBar');
    if (el) el.addEventListener('click', function (e) {
      var ob = e.target.closest('[data-simopen]');
      var cb = e.target.closest('[data-simclose]');
      var sb = e.target.closest('[data-social]');
      if (ob) _simOpen();
      else if (cb) _simClose(parseInt(cb.getAttribute('data-simclose'), 10));
      else if (sb) _socialPost(sb.getAttribute('data-social'));
    });
    _loadSimOpen();
    if (_simTimer) clearInterval(_simTimer);
    _simTimer = setInterval(_loadSimOpen, 30000);   // трекер обновляет last_price ежеминутно
  }
  // SSOT-рендер серверной лестницы (trigger.ladder из chart-data) — те же fpx/fpct/
  // fmtR/row, что buildSurvivalLadderLA → HTML идентичен; расчёт строк уже на сервере
  // (setup_stats.build_target_ladder), общий с TG. rows: [{kind,price,pct,rr,prob,ge}].
  function _renderServerLadder(rows) {
    if (!rows || !rows.length) return '';
    var fpx = function (p) { var a = Math.abs(p); return a >= 100 ? p.toFixed(1) : a >= 1 ? p.toFixed(2) : p.toFixed(4); };
    var fpct = function (v) { return v == null ? '' : '<span class="surv-pct">(' + (v >= 0 ? '+' : '−') + Math.abs(v).toFixed(1) + '%)</span>'; };
    var fmtR = function (r) { return (Math.abs(r - Math.round(r)) < 0.05) ? String(Math.round(r)) : r.toFixed(1); };
    var rrCell = function (ge, txt) { return '<span class="surv-rr-ge">' + (ge || '') + '</span>' + txt; };
    var row = function (cls, price, pct, rrHtml, p) {
      return '<div class="surv-row ' + cls + '"><span class="surv-dot">●</span>'
        + '<span class="surv-price">' + fpx(price) + fpct(pct) + '</span>'
        + '<span class="surv-rr">' + rrHtml + '</span>'
        + '<span class="surv-p">~' + p + '%</span></div>';
    };
    var out = ['<div class="surv-row surv-head"><span class="surv-dot"></span>'
      + '<span class="surv-price">Цель</span><span class="surv-rr">RR</span>'
      + '<span class="surv-p">Вероятность</span></div>'];
    rows.forEach(function (r) {
      out.push(r.kind === 'loss'
        ? row('loss', r.price, r.pct, rrCell('', 'стоп'), r.prob)
        : row('', r.price, r.pct, rrCell(r.ge, '1:' + fmtR(r.rr)), r.prob));
    });
    return '<div class="surv-ladder">' + out.join('') + '</div>';
  }
  // Триггер chart-data (d.triggers), соответствующий сетапу mi (bar_date+тип) — несёт
  // серверную лестницу .ladder.
  function _findChartTrigger(d, trig) {
    var allTr = (d && d.triggers) ? d.triggers : [];
    var bd = String(trig.bar_date || '').replace('T', ' ').substring(0, 16);
    // DE-строки несут trigger_type='DOUBLE_EXTREME_MTF', а маркер на графике — свой
    // DE_-тип (_DE_SETUP_TO_TYPE). Матчим по нему, иначе ladder DE-маркера не находится
    // (брался чужой prod-DE-маркер того же бара / «Целевых уровней нет»).
    var wantType = (trig.de_setup && _DE_SETUP_TO_TYPE[trig.de_setup]) || trig.trigger_type;
    for (var i = 0; i < allTr.length; i++) {
      if (String(allTr[i].bar_date || '').substring(0, 16) === bd
          && allTr[i].trigger === wantType) return allTr[i];
    }
    return null;
  }
  // Заполнить пустую лестницу (surv-tip[data-la]). SSOT: серверный trigger.ladder из
  // chart-data (единый расчёт с TG, setup_stats.build_target_ladder). График загружен, а
  // ladder нет → у сетапа нет валидной цели (wrong-side стоп / отменённый — как и в TG,
  // pick_dispatch_target=None): показываем «нет цели», НЕ пересчитываем на клиенте
  // (старый buildSurvivalLadderLA удалён — давал расходящуюся с TG лестницу).
  function _tryFillLadder(tip, mi) {
    if (!tip || !mi || !mi.trigger || !_panelEngine || !_panelEngine.getLastData) return false;
    var d = _panelEngine.getLastData();
    if (!d || !d.meta || d.meta.ticker !== mi.trigger.ticker) return false;
    var ct = _findChartTrigger(d, mi.trigger);
    if (ct && ct.ladder && ct.ladder.length) {           // ← SSOT-путь
      tip.innerHTML = _renderServerLadder(ct.ladder);
      tip.removeAttribute('data-la');
      return true;
    }
    if (!d.levels || !d.levels.mtf) return false;         // ещё ждём загрузки MTF-уровней графика
    // График загружен, сервер не построил лестницу → цели нет (SSOT с TG, не фабрикуем).
    tip.innerHTML = '<div class="surv-load">Целевых уровней нет</div>';
    tip.removeAttribute('data-la');
    return true;
  }
  // Хук «график загрузился» (из _applySoloFromSelection): дозаполнить открытый сейчас
  // попап лестницы, если он ждал MTF-уровней этого тикера.
  function _fillOpenLadder() {
    var anchor = document.querySelector('.rdist-anchor.tip-open');
    if (!anchor) return;
    var tip = anchor.querySelector('.rdist-tip.surv-tip[data-la]');
    if (!tip) return;
    var row = anchor.closest('[data-tid]');
    if (row) _tryFillLadder(tip, _findSetupByTid(row.getAttribute('data-tid')));
  }
  // Делегированный клик: попап лестницы потенциала — toggle (.tip-open), закрытие по
  // клику вне. БЕЗ stopPropagation — клик строки/карточки сам грузит график (нужны его
  // MTF-уровни); level-aware лестницу дозаполняет _fillOpenLadder по готовности.
  document.addEventListener('click', function (e) {
    var anchor = e.target.closest ? e.target.closest('.rdist-anchor') : null;
    var openA = document.querySelector('.rdist-anchor.tip-open');
    if (openA && openA !== anchor) openA.classList.remove('tip-open');   // закрыть чужой / по клику вне
    if (!anchor) return;
    var tip = anchor.querySelector('.rdist-tip');
    if (!tip) return;                                                    // у якоря нет попапа
    if (anchor.classList.contains('tip-open')) { anchor.classList.remove('tip-open'); return; }
    anchor.classList.add('tip-open');
    if (!tip.hasAttribute('data-la')) return;                            // текстовый tooltip / уже построено
    var row = anchor.closest('[data-tid]');
    var mi = row ? _findSetupByTid(row.getAttribute('data-tid')) : null;
    if (!mi) return;
    if (_tryFillLadder(tip, mi)) return;                                 // график этой бумаги открыт → мгновенно
    tip.innerHTML = '<div class="surv-load"><span class="tv-spin"></span>Считаю…</div>';   // ждём загрузки графика (см. _fillOpenLadder)
  }, false);

  // Solo-режим: на графике показываем ТОЛЬКО выбранный сетап (вход+выход, точно
  // по цене). Явный выбор (STATE.selectedTrigger*) → его триггер; нет выбора
  // (auto-load) → самый свежий триггер тикера. Вызывается из loadChartInPanel
  // (после load).
  function _applySoloFromSelection() {
    if (!_panelEngine || !_panelEngine.setSoloTrigger || !_panelEngine.getLastData) return;
    var d = _panelEngine.getLastData();
    var allTr = (d && d.triggers) ? d.triggers : [];
    var solo = null;
    // Направление выбранного сетапа (по точному id) — различает два сетапа одного
    // бара+типа, но ПРОТИВОПОЛОЖНЫХ направлений (regular_bullish LONG + hidden_bearish
    // SHORT дивергенции на одном баре), чтобы solo-маркер совпал с sim-кнопкой.
    var _selMi = _findSetupByTid(STATE.selectedTid);
    // STATE.soloDir — запасной источник направления (из ?solo_dir=): у скриншотера
    // сетапа нет в таблице (anon-задержка), значит _selMi там не найдётся.
    var _selDir = (_selMi && _selMi.best && _selMi.best.final_direction)
      || (_selMi && _selMi.trigger && _selMi.trigger.direction) || STATE.soloDir || null;
    // ТФ выбранного сетапа: на одном баре бывают часовой и четырёхчасовой сетапы
    // ОДНОГО типа и направления (метки баров 1ч и 4ч совпадают) — без ТФ solo брал
    // первый в списке, т.е. чужой (найдено 20.08 на DOMRF: график показывал стоп
    // часовой сделки, пока в таблице была выбрана четырёхчасовая).
    var _selTf = (_selMi && _selMi.trigger && _selMi.trigger.tf) || STATE.soloTf || null;
    if (STATE.selectedTriggerBarDate && STATE.selectedTriggerType) {
      var sBd = String(STATE.selectedTriggerBarDate).replace('T', ' ').substring(0, 16);
      for (var i = 0; i < allTr.length; i++) {
        if (String(allTr[i].bar_date || '').substring(0, 16) === sBd
            && allTr[i].trigger === STATE.selectedTriggerType
            && (!_selDir || allTr[i].direction === _selDir)
            && (!_selTf || String(allTr[i].tf || '1h') === _selTf)) { solo = allTr[i]; break; }
      }
    }
    var _explicit = !!(STATE.selectedTriggerBarDate && STATE.selectedTriggerType);
    if (!solo && _explicit && _selMi && _panelEngine.addSoloTrigger) {
      // Выбранного сетапа нет среди маркеров графика — так у 4ч-сетапа на младшем ТФ
      // (chart-data отдаёт 4ч-маркеры только на 4ч-графике). Строим триггер из САМОЙ
      // строки и подаём движку: стрелка встанет на бар входа (soloEntryBar знает ТФ
      // сигнала), тултип — свой. Раньше здесь срабатывал фолбэк «самый свежий сетап
      // бумаги», и на 5м/15м/1ч рисовался ЧУЖОЙ: ABIO STOP_HUNT 4ч 11.09 — на 5м
      // 5м-дивергенция 11:55 без цены входа (ни стрелки, ни верного тултипа), на 15м/1ч
      // FALSE_BREAKOUT 1ч 11:00, у которого вход случайно совпал (репорт владельца).
      var _rt = _rowSoloTrigger(_selMi);
      if (_rt) { _panelEngine.addSoloTrigger(_rt); solo = _rt; }
    }
    // Фолбэк «самый свежий сетап бумаги» — ТОЛЬКО без явного выбора (auto-load
    // бумаги по тикеру): при явном выборе показать чужой сетап хуже, чем ничего.
    if (!solo && !_explicit && allTr.length) {
      solo = allTr.slice().sort(function(a, b) { return (b.time || 0) - (a.time || 0); })[0];
    }
    _panelEngine.setSoloTrigger(solo
      ? {bar_date: solo.bar_date, trigger: solo.trigger, direction: solo.direction,
         tf: String(solo.tf || '1h')}
      : null, _selectedExitMarker());
    _fillOpenLadder();   // график загрузился → дозаполнить открытый попап лестницы level-aware
  }

  // Exit-маркер для ВЫБРАННОГО сетапа — любого (строка таблицы ИЛИ TOP-карточка), если он
  // завершён (mi.exit = {price, bar_date, outcome, rr}). user-режим: chart-data не шлёт
  // exit_markers не-админам → рисуем клиентски из out['exit'] (ОТДЕЛЬНОЕ поле; таблица его
  // не читает → остаётся forward-only). admin: дубль из chart-data гасит dedup в setSoloTrigger.
  // Триггер для solo-режима из строки таблицы — тот же контракт, что у объектов
  // chart-data (time = наивное МСК как UTC-число, bar_date 'YYYY-MM-DD HH:MM',
  // entry_price = факт входа по правилу витрины, entry_intrabar у лимитных).
  function _rowSoloTrigger(mi) {
    var t = mi && mi.trigger, v = (mi && mi.best) || {};
    if (!t || !t.bar_date || !t.trigger_type) return null;
    var bd = String(t.bar_date).replace('T', ' ').substring(0, 16);
    var unix = Math.floor(Date.parse(bd.replace(' ', 'T') + ':00Z') / 1000);
    if (!isFinite(unix)) return null;
    var dbTt = String(t.trigger_type);
    var fd = v.final_direction || t.direction;
    var isLong = fd === 'LONG';
    var entry = _entryPx(t);
    var dirRu = isLong ? 'ЛОНГ' : 'ШОРТ';
    return {
      bar_date: bd, trigger: dbTt, direction: t.direction, final_direction: fd,
      tf: String(t.tf || '1h'), time: unix,
      position: isLong ? 'belowBar' : 'aboveBar', shape: isLong ? 'arrowUp' : 'arrowDown',
      color: SETUP_NAME_COLOR[dbTt] || '#ffffff',
      tip_title: TRIGGER_RU[dbTt] || dbTt,
      tip: dirRu + (entry != null ? ' · вход ' + _fmtEntryPx(entry) : '')
           + ' · сигнал ' + (String(t.tf || '1h') === '4h' ? '4ч' : '1ч') + '-бар ' + bd.substring(11),
      entry_price: entry, entry_intrabar: _LIMIT_ENTRY_TYPES.has(dbTt.replace('_MTF', '')),
      level_price: (t.level_price != null) ? Number(t.level_price) : null,
      sl: (t.sl != null) ? Number(t.sl) : null,
      series: mi.series || null, matches: [],
      strength: t.strength, confluence: t.confluence, confluence_factors: t.confluence_factors || '',
      _fromRow: true
    };
  }

  function _selectedExitMarker() {
    if (!STATE.selectedTriggerBarDate || !STATE.selectedTriggerType || !STATE.data) return null;
    var sbd = String(STATE.selectedTriggerBarDate).replace('T', ' ').substring(0, 16);
    // ВАЖНО: матч по тикеру тоже — иначе при многих сетапах одного типа на одном баре
    // (напр. 25.06 23:00 DIVERGENCE у GMKN/MAGN/LENT/…) .find() вернёт ПЕРВЫЙ (чужой
    // тикер) → exit_price чужого сетапа рисуется на графике (та же мина, что в _scrollTableRowTo).
    // ТФ выбранного сетапа — иначе при часовом и четырёхчасовом сетапе одного типа
    // на общем баре .find() вернёт первый (чужой) выход (20.08, DOMRF: рисовался
    // «выход по стопу» часовой сделки под четырёхчасовой строкой таблицы).
    var _selMiEx = _findSetupByTid(STATE.selectedTid);
    var _selTfEx = (_selMiEx && _selMiEx.trigger && _selMiEx.trigger.tf) || STATE.soloTf || null;
    function findIn(list) {
      return (list || []).find(function (x) {
        return x.trigger && String(x.trigger.bar_date || '').substring(0, 16) === sbd
            && x.trigger.trigger_type === STATE.selectedTriggerType
            && (!_panelTicker || x.trigger.ticker === _panelTicker)
            && (!_selTfEx || String(x.trigger.tf || '1h') === _selTfEx);
      });
    }
    var mi = findIn(STATE.data.table) || findIn(STATE.data.top);
    if (!mi || !mi.exit || mi.exit.price == null || !mi.exit.bar_date) return null;
    var ex = mi.exit, t = mi.trigger;
    // bar_date бывает с tz-суффиксом ('…+00:00') ИЛИ наивным; не ломаем 'Z' двойным tz.
    var es = String(ex.bar_date).trim().replace(' ', 'T');
    if (!/[+\-]\d{2}:?\d{2}$|[Zz]$/.test(es)) es += 'Z';   // наивное = UTC (как chart-data _fmt_time)
    var exUnix = Math.floor(Date.parse(es) / 1000);
    if (!isFinite(exUnix)) return null;
    // Точный момент выхода (модель «стоп идёт за ценой», все роли): график ставит выход в
    // свечу, внутри которой он лежит (ta-chart._momentCandleIndex). Нет — бар выхода, как раньше.
    var exAt = null;
    if (ex.at) {
      var xs = String(ex.at).trim().replace(' ', 'T');
      if (!/[+\-]\d{2}:?\d{2}$|[Zz]$/.test(xs)) xs += 'Z';
      exAt = Math.floor(Date.parse(xs) / 1000);
      if (!isFinite(exAt)) exAt = null;
    }
    // Тултип — как admin chart-data _tip + карточка RR: «Выход по трейлу 109.0 / RR ~1:5»
    // (прибыль) | «Выход по стопу 96.8» (стоп, без RR).
    var _ru = {TP: 'тейку', TRAIL: 'трейлу',
               TRAIL_TIME: 'истечению окна (трейл взведён)', SL: 'стопу',
               EXPIRED: 'истечению окна'}[ex.outcome] || 'выходу';
    var _p = Number(ex.price);
    var _px = !isFinite(_p) ? '' : (_p >= 100 ? _p.toFixed(1) : _p >= 1 ? _p.toFixed(2)
                                    : _p >= 0.01 ? _p.toFixed(4) : _p.toFixed(6));
    var _tip = ('Выход по ' + _ru + ' ' + _px).replace(/\s+$/, '');
    if (ex.rr > 0) _tip += ' / RR ~1:' + Math.max(1, Math.round(ex.rr));
    return {
      bar_date: t.bar_date,          // СИГНАЛ bar_date — для match с soloKey в _renderSoloMarkers
      trigger: t.trigger_type, direction: t.direction, tf: String(t.tf || '1h'),
      exit_price: ex.price, time: exUnix, exit_at: exAt,
      color: '#ff2bd6',   // маджента (как chart-data + setBacktestTrade) — видна на любых свечах
      tip: _tip,
      shape: 'square', position: 'inBar', exit: true
    };
  }

  // Горизонтальные линии под выбранным сетапом (solo-просмотр):
  //  • SL (тонкая красная + маркер «SL» у ценовой шкалы) — для ВСЕХ типов: показывает
  //    1R от входа, чтобы пользователь видел, чему равен R в конкретном случае.
  //  • Ключевой уровень (Ложный пробой / Сбор ликвидности / Климакс) — отдельной линией
  //    «Уровень» НЕ рисуем (был дубль MTF-уровня → два «PDH» на графике = путаница).
  //    Вместо этого подсвечиваем совпадающую MTF-подпись («PDH·7» и т.п.) через
  //    setHighlightLevel: один уровень, ярче+жирнее, консистентная подпись (как у всех).
  var _LEVEL_LINE_TYPES = { FALSE_BREAKOUT_MTF: 1, STOP_HUNT_MTF: 1, CLIMAX_MTF: 1 };
  function _applyPanelLines(trigType, levelPrice, slPrice) {
    if (!_panelEngine || !_panelEngine.setPriceLines) return;
    var lines = [];
    var sl = Number(slPrice);
    if (slPrice != null && isFinite(sl)) {
      lines.push({ price: sl, color: 'rgba(247,80,73,0.8)', title: 'SL', lineStyle: 0 });   // сплошная, 0.8
    }
    _panelEngine.setPriceLines(lines);   // [] снимает всё (нет выбора / смена тикера)
    // Подсветка уровня сетапа на совпадающей MTF-подписи (level-типы); иначе снять.
    var lp = Number(levelPrice);
    if (_panelEngine.setHighlightLevel) {
      _panelEngine.setHighlightLevel(
        (_LEVEL_LINE_TYPES[trigType] && levelPrice != null && isFinite(lp)) ? lp : null);
    }
  }


  // Центрировать график на свече маркера (solo-просмотр на любой глубине) — чтобы
  // не скроллить влево. half ≈ половина дефолтной плотности (маркер по центру).
  function _centerPanel(t) {
    if (t == null || !_panelEngine || !_panelEngine.centerOnTime) return;
    var chartEl = document.getElementById('panel-tv-chart');
    var w = (chartEl && chartEl.clientWidth) || 560;
    var bars = Math.max(60, Math.min(450, Math.round(w / 5.5)));
    _panelEngine.centerOnTime(t, Math.round(bars / 2));
  }

  // Скролл строки таблицы к центру + подсветка .selected (обратная связь график→таблица).
  // Матч по (data-ticker панели + data-bar-date[:16] + data-trigger-type). ВАЖНО: тикер
  // обязателен — таблица показывает ВСЕ тикеры, а у разных тикеров бывают сетапы одного
  // типа на одном баре (напр. много DIVERGENCE 26.06 23:00) → без тикера находило ПЕРВУЮ
  // такую строку (другой тикер, выше) и подсвечивало не тот триггер.
  // Возвращает true, если строка найдена на текущей странице.
  function _scrollTableRowTo(bd16, type, highlight) {
    _flushListLight();                 // ищем строку по всему списку, а не по первой порции
    var rows = document.querySelectorAll('#list-light .row-l[data-bar-date]');
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (String(r.getAttribute('data-bar-date') || '').substring(0, 16) === bd16
          && r.getAttribute('data-trigger-type') === type
          && (!_panelTicker || r.getAttribute('data-ticker') === _panelTicker)) {
        if (highlight) {
          document.querySelectorAll('#list-light .row-l.selected').forEach(function (x) { x.classList.remove('selected'); });
          r.classList.add('selected');
        }
        r.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }
    }
    return false;
  }

  // Клик по маркеру/стрелке на графике → подсветить и проскроллить соответствующую
  // строку таблицы к центру. В «Истории сделок», если строка на другой странице — сперва
  // переход на страницу выбранной сделки (gotoDealsPage), затем скролл (через pending).
  function _onChartMarkerClick(picks) {
    if (!picks || !picks.length) return;
    var pk = null;
    if (STATE.selectedTriggerBarDate && STATE.selectedTriggerType) {
      var sbd = String(STATE.selectedTriggerBarDate).replace('T', ' ').substring(0, 16);
      pk = picks.filter(function (p) {
        return p.trigger === STATE.selectedTriggerType
            && String(p.bar_date || '').substring(0, 16) === sbd;
      })[0];
    }
    if (!pk) pk = picks[0];
    var bd16 = String(pk.bar_date || '').substring(0, 16);
    var type = pk.trigger;
    if (_scrollTableRowTo(bd16, type, true)) return;   // нашли на текущей странице
    // «История сделок»: строка на другой странице → вернуться на страницу выбранной сделки
    if (STATE.deals && STATE.selectedDealsPage && STATE.selectedDealsPage !== STATE.dealsPage) {
      STATE._pendingScroll = { bd16: bd16, type: type };
      gotoDealsPage(STATE.selectedDealsPage);
    }
  }

  // Спиннер по центру пустого окна графика, пока грузятся данные (свежий тикер/TF).
  // Показываем с задержкой 120мс — чтобы быстрый (кэшированный) лоад не мигал спиннером.
  var _chartLoadingTimer = null;
  function _showChartLoading() {
    var host = document.getElementById('panel-tv-chart');
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    clearTimeout(_chartLoadingTimer);
    _chartLoadingTimer = setTimeout(function() {
      var el = document.getElementById('panel-chart-loading');
      if (!el) {
        el = document.createElement('div');
        el.id = 'panel-chart-loading';
        el.innerHTML = '<span class="tv-spin tv-spin-lg"></span><span class="cl-txt">Загружаю график…</span>';
        host.appendChild(el);
      }
      el.style.display = 'flex';
    }, 120);
  }
  function _hideChartLoading() {
    clearTimeout(_chartLoadingTimer);
    var el = document.getElementById('panel-chart-loading');
    if (el) el.style.display = 'none';
  }

  function loadChartInPanel(ticker, tf, opts) {
    if (!ticker) return;
    opts = opts || {};
    var hadEngine = !!_panelEngine;   // был ли график уже создан (для решения «показывать ли спиннер»)
    // _around: solo-просмотр строки → opts.around (дата сетапа). Грузим окно вокруг неё → виден сетап
    // любой давности.
    // Солирование: уровни (S/R, MTF, лестница) должны строиться НА ДАТУ СЕТАПА, а не
    // на сегодня — иначе на старой сделке рисуются уровни, которых в момент входа не
    // существовало. Кейс BANEP 17.08: стоп стоял за 20-дневным минимумом 759.0, но час
    // спустя цена обновила минимум до 756.5, метка «20L» на графике уехала вниз, и
    // корректный стоп стал выглядеть стоящим ПЕРЕД уровнем.
    // Клик по строке передаёт around явно, но остальные точки входа (топ-карточка,
    // авто-открытие, СМЕНА ТФ) его теряли. Поэтому берём дату
    // выбранного сетапа сами — но только если он относится к ОТКРЫВАЕМОМУ тикеру
    // (иначе выбор по бумаге A применился бы к графику бумаги B).
    var _around = opts.around || null;
    if (!_around && STATE.selectedTriggerBarDate) {
      var _selForTk = _findSetupByTid(STATE.selectedTid);
      if (_selForTk && _selForTk.trigger && _selForTk.trigger.ticker === ticker) {
        _around = STATE.selectedTriggerBarDate;
      }
    }
    // Режим «Фьючи» (11.10.2026): график КОНТРАКТА сделки — на его свечах считались вход и выход; тикер панели
    // остаётся тикером акции (строки, избранное, «Фундамент»).
    var _futSym = _futOn() ? (opts.fut || _futContractOf(ticker)) : null;
    var sameTicker = (ticker === _panelTicker) && ((_futSym || null) === (_panelFut || null));
    var oldTf = _panelTf;
    _panelTicker = ticker;
    _panelFut = _futSym || null;
    if (typeof _renderSimBar === 'function') _renderSimBar();   // admin sim-бар под новый тикер
    _panelTf = tf || _panelTf || '15m';
    var sameTf = (oldTf === _panelTf);

    // Header сразу обновляем (UX feedback пока chart грузится)
    document.getElementById('panel-ticker').textContent = ticker;
    if (!sameTicker) document.getElementById('panel-name').textContent = '';
    if (_panelHeader) _panelHeader.setTf(_panelTf);
    // Сердечко избранного в шапке графика — привязываем к текущему тикеру.
    var _pf = document.getElementById('panel-fav');
    if (_pf) {
      _pf.setAttribute('data-ticker', ticker);
      _pf.style.display = '';
      if (window.Favorites) Favorites.refreshHearts(document.getElementById('panel-chart-header') || document);
    }

    // Instant clear stale chart — UX fix. Раньше старый ticker оставался
    // видимым на graph несколько секунд пока новые данные не пришли. Теперь
    // chart очищается мгновенно при смене тикера/TF, юзер видит что началась
    // загрузка нового.
    if ((!sameTicker || !sameTf) && _panelEngine && _panelEngine.clearData) {
      _panelEngine.clearData();
    }
    // Кнопка «Фундамент» — обновляем href для middle-click / right-click открытия
    var faBtn = document.getElementById('chartFaBtn');
    if (faBtn) faBtn.href = '/fa?ticker=' + encodeURIComponent(ticker);
    // Алерт «отчёт МСФО рядом» на кнопке «Фундамент».
    _updateReportAlert(ticker);

    // Скрываем placeholder, показываем chart-контейнер
    document.getElementById('panel-empty').style.display = 'none';
    document.getElementById('panel-tv-chart').style.display = 'block';
    // Спиннер «Загружаю график…» — только когда окно будет пустым во время загрузки
    // (первый показ или смена тикера/TF; same-ticker+same-tf оставляет прежний график).
    if (!hadEngine || !sameTicker || !sameTf) _showChartLoading();

    // Engine создаётся один раз
    if (!_panelEngine) {
      _panelEngine = TaChart.create(
        document.getElementById('panel-tv-chart'),
        document.getElementById('panel-vsaTooltip'),
        { tf: _panelTf, showRsi: true,    // RSI всегда (не только при фильтре DIVERGENCE)
          onMarkerClick: _onChartMarkerClick }   // клик по маркеру → скролл строки таблицы
      );
      // Sync trigger-type filter сразу при создании — load() ниже отрисует
      // markers уже отфильтрованными по UI-чекбоксам.
      _syncChartTriggerTypes();
      _syncChartBeShort();
      // Sync layer-toggle states с engine defaults через shared header
      if (_panelHeader) {
        ['sr','fib','ema'].forEach(function(layer) {
          _panelHeader.setLayer(layer, _panelEngine.getLayer(layer));
        });
      }
    } else {
      // Engine уже создан — синхронизируем showRsi и trigger types на случай
      // если фильтр менялся между ticker switches.
      _syncChartRsiVisibility();
      _syncChartTriggerTypes();
      _syncChartBeShort();
    }

    // Load chart с retry: первый load на свежесозданном engine иногда падает
    // из-за race условий (display:block transition, engine internal init,
    // конкурирующие XHR'ы). Retry через 400ms решает 99% таких кейсов.
    function _doLoad(retryCount) {
      if (_panelEngine.setDataUrlBase) _panelEngine.setDataUrlBase(_futSym ? FUT_CHART_URL : null);
      if (_panelEngine.setExtraQuery) _panelEngine.setExtraQuery(_futSym ? _futChartQuery(ticker) : _chartExtraQuery());
      _panelEngine.load(_futSym || ticker, _panelTf, _around).then(function(data) {
        // Race guard: если пользователь уже переключился на другой тикер
        // (быстрые клики по разным тикерам в таблице), late-arriving response
        // не должен оверрайдить уже отрисованный новый chart. Иначе symptoms:
        //  • ticker_name = старого тикера на новом chart
        //  • divergence-линии старого тикера (с прежними prices) накладываются
        //    на новый chart → «улетают» за shкалу из-за price-range mismatch
        //  • RSI / candles в смешанном состоянии
        if (ticker !== _panelTicker || (_futSym || null) !== (_panelFut || null)) return;

        // Backend для known-error (нет 15m для ELMT/SPBE и т.п.) возвращает
        // {error, _failed:true} вместо throw.
        if (data && data._failed) {
          // Auto-fallback: если 15m недоступен — пробуем 1h (нет ELMT/SPBE 15m
          // в Tinkoff/ISS, но 1h есть). Это избавляет пользователя от пустого
          // экрана: он увидит график в доступном TF без ручных переключений.
          if (_panelTf === '15m' && retryCount < 2) {
            _panelTf = '1h';
            if (_panelHeader) _panelHeader.setTf('1h');
            _doLoad(retryCount + 1);
            return;
          }
          // Если и fallback провалился (или mы уже на 1h) — показываем сообщение
          var panelEmpty = document.getElementById('panel-empty');
          var panelChart = document.getElementById('panel-tv-chart');
          if (panelEmpty) {
            panelEmpty.textContent = data.error || ('Данные ' + _panelTf + ' недоступны');
            panelEmpty.style.display = 'flex';
          }
          if (panelChart) panelChart.style.display = 'none';
          _hideChartLoading();
          document.getElementById('panel-ticker').textContent = ticker + ' — ' + _panelTf;
          document.getElementById('panel-name').textContent = '';
          return;
        }
        // Успешный load — скрываем placeholder + спиннер, показываем chart
        var panelEmpty = document.getElementById('panel-empty');
        var panelChart = document.getElementById('panel-tv-chart');
        if (panelEmpty) panelEmpty.style.display = 'none';
        if (panelChart) panelChart.style.display = 'block';
        _hideChartLoading();
        // Regime теперь в topbar — здесь только обновляем имя
        if (data && data.meta && data.meta.ticker_name) {
          document.getElementById('panel-name').textContent = data.meta.ticker_name;
        }
        // Default zoom — фиксированное число баров (не суток!).
        // Это делает свечи одинаковой визуальной плотности при переключении TF
        // (D1 ↔ 1H) и одинаковыми по толщине между normal и expand-режimes
        // (количество растёт пропорционально ширине chart'а).
        _applyChartZoom();

        // Solo-режим (2026-06-07): на графике показываем ТОЛЬКО выбранный сетап
        // (вход+выход, точно по цене) — иначе при >1 триггере на баре маркеры
        // налагаются. См. _applySoloFromSelection.
        _applySoloFromSelection();

        // Divergence visualization: 3 кейса
        //   (1) selectedTriggerType='DIVERGENCE' + selectedTriggerBarDate выбран →
        //       нарисовать линии этого конкретного триггера (row click in table)
        //   (2) selectedTriggerType='DIVERGENCE' но bar_date не выбран ИЛИ
        //       ничего ещё не выбрано (hard refresh, auto-open top card) →
        //       auto-select самый свежий DIVERGENCE триггер этого тикера,
        //       чтобы пользователь сразу увидел линии без клика
        //   (3) selectedTriggerType ≠ DIVERGENCE → очистить линии
        try {
          if (_panelEngine.selectTrigger) {
            var divTrigsInChart = (data && data.triggers ? data.triggers : [])
              .filter(function(t) { return t.trigger === 'DIVERGENCE'; });
            if (STATE.selectedTriggerType === 'DIVERGENCE'
                && STATE.selectedTriggerBarDate) {
              // Case (1): конкретный выбор
              var selBd = String(STATE.selectedTriggerBarDate).replace('T', ' ').substring(0, 16);
              var divTrig = null;
              for (var i = 0; i < divTrigsInChart.length; i++) {
                var tiBd = String(divTrigsInChart[i].bar_date || '').substring(0, 16);
                if (tiBd === selBd) { divTrig = divTrigsInChart[i]; break; }
              }
              if (divTrig) _panelEngine.selectTrigger(divTrig);
            } else if (!STATE.selectedTriggerType && _isDivergenceFilterActive()
                       && divTrigsInChart.length > 0) {
              // Case (2): auto-select latest divergence (нет явного выбора) —
              // ТОЛЬКО когда DIVERGENCE активен в фильтре (чекбокс). Без этой
              // проверки линия дивергенции авто-рисовалась при VWAP_REV-only
              // (или любом виде без явного выбора), хотя DIVERGENCE выключен — баг.
              // Сортируем по bar_date desc, берём свежайший. STATE НЕ обновляем —
              // это пассивная подсветка, не persistent выбор, чтобы collapse
              // другой строки не считал её "выбранной".
              divTrigsInChart.sort(function(a, b) {
                return String(b.bar_date || '').localeCompare(String(a.bar_date || ''));
              });
              _panelEngine.selectTrigger(divTrigsInChart[0]);
            } else if (STATE.selectedTriggerType
                       && STATE.selectedTriggerType !== 'DIVERGENCE') {
              // Case (3): другой тип триггера выбран — очистить divergence-линии
              _panelEngine.selectTrigger(null);
            } else if (!_isDivergenceFilterActive()) {
              // DIVERGENCE выключен в фильтре и нет явного DIVERGENCE-выбора →
              // снять любую остаточную линию дивергенции (VWAP-only / toggle off).
              _panelEngine.selectTrigger(null);
            }
            // else: collapse/no-state — оставляем как есть
          }
        } catch (e) { console.warn('Divergence draw failed:', e); }

        // Линия уровня для выбранного НЕ-дивергенц сетапа (Ложный пробой / Сбор
        // ликвидности / Климакс). Находим выбранный триггер в data.triggers
        // (там level_price), рисуем горизонталь; иначе — снимаем.
        try {
          // Находим выбранный сетап среди chart-триггеров (любого типа, вкл. дивергенцию)
          // → рисуем SL-линию (красная) для всех + уровень (золотая) для не-дивергенц.
          var _selLT = null;
          if (STATE.selectedTriggerBarDate && STATE.selectedTriggerType) {
            var _slbd = String(STATE.selectedTriggerBarDate).replace('T', ' ').substring(0, 16);
            _selLT = (data && data.triggers ? data.triggers : []).filter(function(t) {
              return t.trigger === STATE.selectedTriggerType
                  && String(t.bar_date || '').substring(0, 16) === _slbd;
            })[0];
          }
          // У графика контракта маркеров детекторов нет — стоп выбранной сделки берём из строки (цены контракта).
          var _selFut = (_futSym && !_selLT) ? _findSetupByTid(STATE.selectedTid) : null;
          if (_selFut && _selFut.trigger && _selFut.trigger.ticker === ticker) _selLT = { sl: _selFut.trigger.sl };
          _applyPanelLines(STATE.selectedTriggerType,
                           _selLT && _selLT.level_price,
                           _selLT && _selLT.sl);
        } catch (e) {}


        // Центрируем график на маркере выбранного сетапа (solo на любой глубине) —
        // только в around-режиме (клик по строке); дефолтная витрина не трогается.
        if (_around && STATE.selectedTriggerBarDate && STATE.selectedTriggerType) {
          try {
            var _cbd = String(STATE.selectedTriggerBarDate).replace('T', ' ').substring(0, 16);
            var _cm = (data && data.triggers ? data.triggers : []).filter(function(t) {
              return t.trigger === STATE.selectedTriggerType
                  && String(t.bar_date || '').substring(0, 16) === _cbd;
            })[0];
            if (_cm && _cm.time != null) _centerPanel(_cm.time);
            else if (_futSym) {
              var _rt = _rowSoloTrigger(_findSetupByTid(STATE.selectedTid));
              if (_rt && _rt.time != null) _centerPanel(_rt.time);
            }
          } catch (e) {}
        }
      }).catch(function(e) {
        console.error('Panel chart load error (retry=' + (retryCount||0) + '):', e);
        // Retry once after 400ms — устраняет transient errors на первом mount
        if (!retryCount) {
          setTimeout(function() { _doLoad(1); }, 400);
        } else {
          _hideChartLoading();
          document.getElementById('panel-ticker').textContent = ticker + ' — ошибка';
        }
      });
    }
    _doLoad(0);
  }

  // Shared ChartHeader для chart-panel — рендерится при инициализации.
  // Содержит: ticker block (cp-ticker + cp-name), Layer toggles, TF switch.
  var _panelHeader = null;
  function _initPanelHeader() {
    if (_panelHeader) return _panelHeader;
    var container = document.getElementById('panel-chart-header');
    if (!container || typeof ChartHeader === 'undefined') return null;
    // Дефолтный TF берётся из prefs/UI defaults — соответствует старому HTML
    // (15m был active). Layer defaults: sr=on, fib=off, ema=on.
    _panelHeader = ChartHeader.build({
      container: container,
      prefix: 'panel',
      tfs: ['D1','4h','1h','15m','5m'],
      layers: ['sr','fib','ema','mtf'],
      defaultTf: '15m',
      defaultLayers: { sr: true, fib: false, ema: true, mtf: true },
      // Справка о правилах расчёта уровней — только админу. Кнопку рисуем сразу
      // (шапка строится до резолва auth) и прячем; показывает _syncLevelsInfoBtn.
      levelsInfo: true,
      // Сердечко СЛЕВА от тикера — иначе длинные имена компаний задвигают его
      // вправо под TF/layer-кнопки.
      leftSlot: '<button class="fav-heart cp-fav" id="panel-fav" type="button" data-ticker="" '
              + 'style="display:none" aria-pressed="false" title="Добавить этот тикер в watchlist">'
              + '<svg viewBox="0 0 24 22" fill="none" stroke="currentColor" stroke-width="2" '
              + 'stroke-linecap="round" stroke-linejoin="round" class="fav-outline">'
              + '<path d="M12 21s-7.5-4.5-9.5-9.5C1.2 7.6 4 4 7.5 4c2.1 0 3.5 1.3 4.5 2.6C13 5.3 14.4 4 16.5 4 20 4 22.8 7.6 21.5 11.5 19.5 16.5 12 21 12 21z"/></svg>'
              + '<svg viewBox="0 0 24 22" fill="currentColor" class="fav-filled" style="display:none">'
              + '<path d="M12 21s-7.5-4.5-9.5-9.5C1.2 7.6 4 4 7.5 4c2.1 0 3.5 1.3 4.5 2.6C13 5.3 14.4 4 16.5 4 20 4 22.8 7.6 21.5 11.5 19.5 16.5 12 21 12 21z"/></svg>'
              + '</button>'
              + '<div class="cp-ticker-block">'
              + '<span class="cp-ticker" id="panel-ticker">—</span>'
              + '<span class="cp-name" id="panel-name"></span>'
              + '</div>',
      onTfChange: function(tf) {
        if (!_panelTicker) return;
        loadChartInPanel(_panelTicker, tf);
      },
      onLayerToggle: function(layer, on) {
        if (!_panelEngine) return;
        // toggleLayer сам инвертит — синхронизируем чтобы итог совпадал с on
        var currentlyActive = (typeof _panelEngine.getLayerState === 'function')
          ? _panelEngine.getLayerState(layer) : !on;
        if (currentlyActive !== on) _panelEngine.toggleLayer(layer);
      },
    });
    _syncLevelsInfoBtn();
    return _panelHeader;
  }

  // Значок ⓘ (правила расчёта уровней) виден только админу. Вызывается после
  // build (auth ещё не резолвлен → скрываем) и из refreshAuthState (показываем).
  function _syncLevelsInfoBtn() {
    var btn = document.getElementById('panel-levels-info');
    if (!btn) return;
    btn.style.display = (_authState && _authState.is_admin) ? '' : 'none';
  }

  function panelSwitchTf(tf) {
    // Backward-compat: вызывается из старых onclick. Helper сам обновит UI.
    if (_panelHeader) _panelHeader.setTf(tf);
    if (_panelTicker) loadChartInPanel(_panelTicker, tf);
  }

  // Mobile-настройка шапки графика: дефолтный TF = 1H (на desktop остаётся 15m),
  // TF свёрнут в одну кнопку (active) с inline-раскрытием по клику. Слои скрыты
  // через CSS (@900). Вызывается один раз после _initPanelHeader().
  function _initMobileChartHeader() {
    if (window.innerWidth > 900) return;
    _panelTf = _CHART_TF.mobile || '1h';   // первый chart-load — на ТФ телефона (settings.SETUPS_CHART_TF_MOBILE)
    if (_panelHeader) _panelHeader.setTf(_panelTf);
    var sw = document.getElementById('panel-tfs');
    if (!sw) return;
    // Перехват в capture-фазе (до chart-header handler): свёрнуто → раскрыть;
    // раскрыто → закрыть (по другому TF пускаем bubbling, он сделает setTf).
    sw.addEventListener('click', function(e) {
      if (window.innerWidth > 900) return;
      var btn = e.target.closest('.ch-tf-btn');
      if (!btn) return;
      if (!sw.classList.contains('tf-open')) {
        sw.classList.add('tf-open');
        e.stopImmediatePropagation();      // клик по active не должен no-op'ить
      } else {
        sw.classList.remove('tf-open');
        if (btn.classList.contains('active')) e.stopImmediatePropagation();
      }
    }, true);
    // Клик вне переключателя — свернуть.
    document.addEventListener('click', function(e) {
      if (!sw.contains(e.target)) sw.classList.remove('tf-open');
    });
  }

  // Mobile: переключатель окна Последние 14 дней / История → одна кнопка (active) +
  // inline-dropdown (зеркало TF-дропдауна). Breakpoint 700px (как sec-title-row).
  function _initMobileRangeDropdown() {
    if (window.innerWidth > 700) return;
    var rs = document.getElementById('range-seg');
    if (!rs) return;
    rs.addEventListener('click', function(e) {
      if (window.innerWidth > 700) return;
      var btn = e.target.closest('.rng-btn');
      if (!btn) return;
      if (!rs.classList.contains('rng-open')) {
        rs.classList.add('rng-open');
        e.stopImmediatePropagation();    // свёрнуто: клик по active не должен переключать
      } else {
        rs.classList.remove('rng-open');
        // раскрыто: по active — стоп (no-op); по другой — пусть inline onclick переключит
        if (btn.classList.contains('active')) e.stopImmediatePropagation();
      }
    }, true);  // capture: до inline onclick кнопок (setRange/setRangeDeals)
    document.addEventListener('click', function(e) {
      if (!rs.contains(e.target)) rs.classList.remove('rng-open');
    });
  }

  // Default zoom: bar count подбирается из ширины chart'а на ~5.5px/bar.
  // Это ≈1.5× плотнее старого 8px/bar — свечи тоньше, истории видно больше.
  // Работает в обоих режимах: chartEl.clientWidth адаптируется под normal
  // (~560px) или expand (~1400px) layout. Min 60 / max 450 — расширены
  // пропорционально.
  function _applyChartZoom() {
    if (!_panelEngine || typeof _panelEngine.setVisibleBars !== 'function') return;
    var chartEl = document.getElementById('panel-tv-chart');
    var w = (chartEl && chartEl.clientWidth) || 560;
    var bars = Math.max(60, Math.min(450, Math.round(w / 5.5)));
    _panelEngine.setVisibleBars(bars);   // padding справа — общий дефолт движка (10 баров)
  }

  // Кнопка «Тестирование» — персональная лаборатория детекторов. Авторизованным
  // открывает /testing; анониму — попап регистрации (как FA-кнопка).
  var _labWin = null;   // ссылка на открытую вкладку лаборатории (переиспуем, как «К сетапам»)
  function openTesting() {
    if (window.innerWidth <= 900) {   // лаборатория desktop-only (3 колонки не помещаются на мобилке)
      _logLabClick('mobile');
      _showLabDesktopTip();
      return;
    }
    if (_authState.is_anon) {
      _logLabClick('anon');
      showAuthPopup({title: 'Зарегистрируйтесь, чтобы настраивать собственные сетапы',
                     text: 'и получите <b>Premium бесплатно</b>'});
      return;
    }
    _logLabClick('opened');
    // имя вкладки → лаборатория сможет вернуть фокус СЮДА (window.open('/setups','moexSetups'))
    try { window.name = 'moexSetups'; } catch (e) {}
    // Переиспользуем вкладку лабы (как «К сетапам»): живая → фокус БЕЗ перезагрузки
    // (текущий прогон сохраняется), закрыта/нет ссылки → открываем именованную 'moexLab'.
    if (_labWin && !_labWin.closed) {
      try { window.open('', 'moexLab'); _labWin.focus(); } catch (e) {}
    } else {
      _labWin = window.open('/lab/backtest', 'moexLab');
    }
  }
  // Лог клика по «Лаборатории» (кто/когда/исход) → SEO-раздел админки. Fire-and-forget.
  function _logLabClick(result) {
    try {
      var headers = { 'Content-Type': 'application/json' };
      if (_csrfToken) headers['X-CSRF-Token'] = _csrfToken;
      fetch('/api/lab/log-click', { method: 'POST', headers: headers,
        body: JSON.stringify({ result: result }), keepalive: true }).catch(function () {});
    } catch (e) {}
  }
  // Тултип у кнопки «Лаборатория» при клике на мобилке (переиспуем стиль .fav-toast).
  function _showLabDesktopTip() {
    var btn = document.getElementById('sb-testing-btn');
    if (!btn) return;
    var t = document.createElement('div');
    t.className = 'fav-toast';
    t.textContent = 'Работает только в десктоп-версии';
    document.body.appendChild(t);
    var r = btn.getBoundingClientRect();
    var w = t.offsetWidth;
    var left = Math.max(8, Math.min(r.left + r.width / 2 - w / 2, window.innerWidth - w - 8));
    t.style.left = left + 'px';
    t.style.top = Math.max(8, r.top - 38) + 'px';   // над кнопкой
    setTimeout(function() {
      t.classList.add('out');
      setTimeout(function() { t.remove(); }, 500);
    }, 2400);
  }

  // Кнопка «Фундамент» — открывает ФА текущего тикера в новой вкладке.
  // Используем onclick (а не просто target=_blank) чтобы (а) гасить клик до выбора
  // тикера, (б) гарантированно строить URL по актуальному _panelTicker.
  function openFundamentalForPanel(e) {
    if (!_panelTicker) {
      if (e) e.preventDefault();
      return false;
    }
    // Гейт: фундамент по тикеру — только для зарегистрированных. Anon → попап
    // регистрации (free/premium открывают ФА штатно).
    if (_authState.is_anon) {
      if (e) e.preventDefault();
      showAuthPopup({title: 'Зарегистрируйтесь для просмотра фундамента по тикеру'});
      return false;
    }
    // По умолчанию <a> сам откроет в новой вкладке через target=_blank — кроме
    // случаев когда пользователь модифицировал клик (Ctrl/Shift). В любом случае
    // window.open надёжнее: он не зависит от стейта href в DOM.
    if (e) e.preventDefault();
    window.open('/fa?ticker=' + encodeURIComponent(_panelTicker), '_blank', 'noopener');
    return false;
  }

  // ── Алерт «отчёт МСФО рядом» на кнопке «Фундамент» ──
  // При загрузке тикера в график дёргаем /api/report-alert (ближайший МСФО ±7д).
  // Есть → золотой бейдж ⚠ + hover-тултип (предупреждение о волатильности).
  function _ensureReportTipWired() {
    var btn = document.getElementById('chartFaBtn');
    var tip = document.getElementById('faBtnTip');
    if (!btn || !tip || btn._tipWired) return;
    btn._tipWired = true;
    if (btn._defaultTitle == null) btn._defaultTitle = btn.getAttribute('title') || '';
    btn.addEventListener('mouseenter', function() {
      if (btn._reportTipHtml) { tip.innerHTML = btn._reportTipHtml; tip.style.display = 'block'; }
    });
    btn.addEventListener('mouseleave', function() { tip.style.display = 'none'; });
  }
  function _updateReportAlert(ticker) {
    _ensureReportTipWired();
    var btn = document.getElementById('chartFaBtn');
    var ico = document.getElementById('faBtnAlert');
    var nws = document.getElementById('faBtnNews');
    var tip = document.getElementById('faBtnTip');
    if (!btn) return;
    btn.classList.remove('has-report-alert');     // reset
    btn.classList.remove('has-news');
    if (btn._defaultTitle != null) btn.setAttribute('title', btn._defaultTitle);
    if (ico) ico.style.display = 'none';
    if (nws) nws.style.display = 'none';
    if (tip) { tip.style.display = 'none'; tip.innerHTML = ''; }
    btn._reportTipHtml = '';
    if (!ticker) return;
    fetch('/api/report-alert/' + encodeURIComponent(ticker))
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (!d) return;
        if (_panelTicker !== ticker) return;       // тикер сменился пока шёл fetch
        // Метка «News» — свежая корпоративная новость (3 торговых дня). Независима
        // от алерта отчёта: гореть могут обе.
        if (d.news) {
          btn.classList.add('has-news');
          btn.removeAttribute('title');            // нативный title перекрыл бы кастомный тултип
          if (nws) nws.style.display = '';
          var nd = d.news.last_date || '';
          var nds = nd ? (nd.slice(8, 10) + '.' + nd.slice(5, 7)) : '';
          var cnt = d.news.count > 1 ? (' · ещё ' + (d.news.count - 1)) : '';
          btn._reportTipHtml =
            '<div class="tip-title">Новость ' + nds + cnt + '</div>' +
            '<div>' + _esc(d.news.title || '') + '</div>';
        }
        if (!d.alert) return;
        var days = d.days, when;
        if (days === 0) when = 'сегодня';
        else if (days === 1) when = 'завтра';
        else if (days === -1) when = 'вчера';
        else if (days > 0) when = 'через ' + days + ' дн';
        else when = Math.abs(days) + ' дн назад';
        var ds = d.event_date ? (d.event_date.slice(8, 10) + '.' + d.event_date.slice(5, 7)) : '';
        btn.classList.add('has-report-alert');
        btn.removeAttribute('title');   // снимаем нативный title — он перекрывал кастомный тултип
        if (ico) ico.style.display = '';
        // Отчёт идёт ПЕРЕД новостью и не затирает её — гореть могут обе метки.
        btn._reportTipHtml =
          '<div class="tip-title">Отчёт МСФО ' + when + (ds ? ' · ' + ds : '') + '</div>'
          + (btn._reportTipHtml || '');
      })
      .catch(function() {});
  }

  // Экранирование для вставки заголовка новости в тултип (текст приходит из
  // внешней ленты — вставлять его в innerHTML сырым нельзя).
  // Админский показ метки «риск разворота»: ?demo_short_risk=1 в адресе страницы.
  // Бэкенд всё равно проверяет права — тут только проброс.
  function _urlDemoShortRisk() {
    try {
      return new URLSearchParams(location.search).get('demo_short_risk')
             ? { demo_short_risk: '1' } : {};
    } catch (e) { return {}; }
  }

  function _esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function panelToggleLayer(layer) {
    // Backward-compat: рекомендуемый путь — через _panelHeader.onLayerToggle.
    if (!_panelEngine) return;
    var active = _panelEngine.toggleLayer(layer);
    if (_panelHeader) _panelHeader.setLayer(layer, active);
  }

  // ── Chart Expanded Mode ─────────────────────────────
  // Состояние chartExpanded хранится в prefs.setups.ui (см. applyUI/extractUIForPrefs).
  function isChartExpanded() {
    return document.querySelector('.layout').classList.contains('expanded');
  }

  function toggleChartExpanded() {
    const layout = document.querySelector('.layout');
    const nowExpanded = layout.classList.toggle('expanded');
    // Зеркалим класс на body для CSS-селектора `.layout-expanded .topbar`
    // (чтобы спрятать topbar в mobile expand — он не child .layout, поэтому
    // селектор через body нужен; :has() недоступен на старых браузерах).
    document.body.classList.toggle('layout-expanded', nowExpanded);
    updateExpandBtn(nowExpanded);
    // Сохраняем UI-состояние через prefs (localStorage всегда; сервер если logged in)
    savePrefs('setups.ui', extractUIForPrefs());
    // Engine resize после CSS reflow — chart берёт новую ширину контейнера.
    // Затем _applyChartZoom() пересчитает visible bars под новую ширину
    // (в expand больше пикселей → больше баров → одинаковая толщина свечи).
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (_panelEngine) {
        _panelEngine.resize();
        _applyChartZoom();
      }
    }));
  }

  // Раскладка сменилась сама (окно сузили за порог узкого экрана или расширили обратно, 16.10.2026): ширина графика
  // меняется почти вдвое — пересчитать видимые бары, как при раскрытии кнопкой (_applyChartZoom). Мелкие изменения
  // ширины (обычный ресайз окна) масштаб, выставленный человеком, не трогают.
  (function _chartWidthWatch() {
    var el = document.getElementById('panel-tv-chart');
    if (!el || typeof ResizeObserver === 'undefined') return;
    var last = 0;
    try {
      new ResizeObserver(function () {
        var w = el.clientWidth || 0;
        if (last && w && Math.abs(w - last) / last > 0.3) _applyChartZoom();
        last = w;
      }).observe(el);
    } catch (e) { /* без ResizeObserver — как было */ }
  })();

  function updateExpandBtn(expanded) {
    const btn = document.getElementById('chartExpandBtn');
    if (!btn) return;
    btn.title = expanded ? 'Свернуть (Esc)' : 'Развернуть (Esc для закрытия)';
  }

  // Esc — выход из expanded
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isChartExpanded()) {
      toggleChartExpanded();
    }
  });
  // Восстановление состояния (chartExpanded + sort) делает applyUI() из prefs на init.

  // Pulse-attention при первом визите (показать пользователю что есть expand)
  const EXPAND_BTN_SEEN_KEY = 'setups.expandBtnSeen';
  if (!localStorage.getItem(EXPAND_BTN_SEEN_KEY)) {
    setTimeout(() => {
      const btn = document.getElementById('chartExpandBtn');
      if (btn) {
        btn.classList.add('pulse');
        setTimeout(() => {
          btn.classList.remove('pulse');
          localStorage.setItem(EXPAND_BTN_SEEN_KEY, '1');
        }, 1600);  // 3 итерации × 500ms + чуть запаса
      }
    }, 700);  // дать время странице загрузиться, чтобы pulse не пропустился
  }

  // ── Auth ─────────────────────────────────────────
  // Soft-gate: страница доступна анонимам, логин включает синхронизацию настроек.
  // /api/auth/tg-start exempt от CSRF; /api/auth/logout требует X-CSRF-Token.
  var _authState = { is_anon: true, tier: 'anon', first_name: '', username: '' };
  // Токен приходит из серверного конфига (создаётся на рендере страницы,
  // до параллельных XHR). fetchCsrfToken() остаётся как обновление.
  var _csrfToken = (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.csrf) || null;
  var _authPopupBuilt = false;

  function fetchCsrfToken() {
    return fetch('/api/csrf-token')
      .then(function(r) { return r.json(); })
      .then(function(d) { _csrfToken = d.token || null; })
      .catch(function() {});
  }

  function refreshAuthState() {
    return fetch('/api/auth/status')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        _authState = d;
        updateAuthUI();
        // Управление видом — после резолва auth (читаем is_admin).
        // buildRangeToggle зовём ВСЕГДА: он сам выбирает вариант (админский
        // Net/Gross/История/Нед или пользовательский 14 дней/История). Раньше он
        // вызывался только в админской ветке — поэтому после выхода из аккаунта
        // в той же вкладке в DOM оставались админские кнопки с нулями.
        buildRangeToggle();
        _syncLevelsInfoBtn();   // ⓘ об уровнях — admin-only
        _syncHiddenTriggers();   // строки детекторов, скрытых у пользователя (по виду)
        if (_authState.is_admin) {
          // silent: инициализация не должна перезаписывать сохранённые настройки
          // вкладка из адреса (?view=weeks) — не сбрасываем на «Сделки недели»
          if (!STATE.deals && !_viewFromUrl) _setRubWindow(true);   // ₽-окно недели, silent
          _initSimTrade();   // ручной sim-трейд: загрузка открытых позиций + рефреш 30с + делегат
        } else if (STATE.weekly && !_viewFromUrl) {
          // Админ пропал в этой же вкладке (логаут/смена аккаунта) — выходим из
          // ₽-режимов, иначе останется пустая выдача от админских параметров.
          _exitWeekly();
          applyMode('user');
          _setRangeActive();
          fetchAndRender();
        }
        _viewFromUrl = null;   // вкладка из адреса — только при открытии страницы
        // Избранное: переключаем источник (anon localStorage ↔ auth БД) и
        // перечитываем. При логине с локальными избранными — union-sync на сервер.
        if (window.Favorites) {
          Favorites.setAuth(_authState.is_anon);
          Favorites.load();
        }
        if (!_authState.is_anon) loadSetupsPresets();   // пресеты лаборатории (платящим; блок сам скрыт если limit=0)
        // Когда пользователь залогинен — синкаем prefs с сервера (Option C)
        if (!_authState.is_anon) {
          syncPrefsFromServer('setups.filters',
            _localGetPrefs('setups.filters'),
            function(serverData) { applyFilters(serverData); fetchAndRender(); });
          // ⚠ После applyUI ОБЯЗАТЕЛЕН рефетч. В setups.ui лежат размер позиции,
          // депозит и «Без комиссии» — они меняют ЧИСЛА, а не только вид. Без
          // него приходила рассинхронизация: человек открывает страницу на
          // втором устройстве, localStorage там старый → запрос уходит со
          // старыми настройками, потом с сервера доезжают новые и правят только
          // подписи — на экране «депозит 2 млн» рядом с «Пропущено 0» и числами
          // от авто-депозита (репорт владельца 29.08, Safari). Для фильтров
          // рефетч стоял с самого начала — здесь его забыли.
          syncPrefsFromServer('setups.ui',
            _localGetPrefs('setups.ui'),
            function(serverData) { applyUI(serverData); fetchAndRender(); });
        }
        // Приход из бота по ?notify=1 — только после резолва тира (см. функцию). С ключом Telegram
        // (?tglink=, кнопка «Подключить аккаунт» неподключённого) — сразу подключение (15.10.2026).
        _maybeTgLinkFromUrl();
        maybeOpenNotifWizardFromUrl();
        // Экран «Куда присылать сетапы и подарки?» после первого входа (bot_onboard).
        _maybeBotOnboard();
      })
      .catch(function() {});
  }

  // ── Prefs (Option C: localStorage write-through cache + server sync) ──
  // Anon: только localStorage. Auth: localStorage всегда, плюс PUT на сервер.
  // На загрузке: рендерим из localStorage сразу (не ждём сервер). Параллельно
  // тянем с сервера; если отличается — applyback и re-render.
  const PREFS_LOCAL_PREFIX = 'prefs.';

  function _localGetPrefs(ns) {
    try {
      var raw = localStorage.getItem(PREFS_LOCAL_PREFIX + ns);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function _localSetPrefs(ns, data) {
    try { localStorage.setItem(PREFS_LOCAL_PREFIX + ns, JSON.stringify(data)); }
    catch (e) {}
  }

  function loadPrefsLocal(ns, fallback) {
    var local = _localGetPrefs(ns);
    return (local !== null) ? local : fallback;
  }

  // Per-namespace race-flag: если юзер изменил настройки локально пока шёл
  // server sync, не затираем его работу серверным ответом.
  var _prefsLocallyTouched = {};

  function savePrefs(ns, data) {
    _prefsLocallyTouched[ns] = true;
    _localSetPrefs(ns, data);
    if (_authState.is_anon) return Promise.resolve();
    var headers = { 'Content-Type': 'application/json' };
    if (_csrfToken) headers['X-CSRF-Token'] = _csrfToken;
    return fetch('/api/prefs/' + ns, {
      method: 'PUT', headers: headers, body: JSON.stringify(data)
    }).catch(function() {});
  }

  // Pull server prefs, reconcile if differ from currentData. Calls onChange(serverData) when applied.
  function syncPrefsFromServer(ns, currentData, onChange) {
    if (_authState.is_anon) return;
    fetch('/api/prefs/' + ns).then(function(r) {
      if (r.status === 404) {
        // Server is empty — seed it from localStorage (if any)
        if (currentData !== null && currentData !== undefined) savePrefs(ns, currentData);
        return null;
      }
      if (r.ok) return r.json();
      return null;
    }).then(function(j) {
      if (!j || !j.data) return;
      // Race-guard: пользователь успел поменять настройки пока запрос был в полёте.
      // Его savePrefs уже отправил PUT на сервер — last-write-wins, не трогаем.
      if (_prefsLocallyTouched[ns]) return;
      if (JSON.stringify(j.data) !== JSON.stringify(currentData)) {
        _localSetPrefs(ns, j.data);
        if (onChange) onChange(j.data);
      }
    }).catch(function() {});
  }

  // Defaults и apply/extract для filters/ui
  // trigger_types: ВКЛ все активные триггеры по умолчанию — синхронизировано
  // с buildTriggerFilters() (где те же DIVERGENCE/FB/VWAP/STOP_HUNT/VSA имеют
  // checked атрибут). Раньше был [], из-за чего на первой загрузке (когда
  // localStorage пуст) applyFilters снимал галочки и RSI pane не рендерился —
  // _isDivergenceFilterActive() возвращал false при создании engine'а.
  /** Ступени ползунка из __SETUPS_CFG__ (сервер, settings.py). Нет их — страница собрана без сервера:
   *  один безопасный шаг и ошибка в консоль, своей копии ступеней здесь нет намеренно. */
  function _cfgSteps(key, fallback) {
    var v = window.__SETUPS_CFG__ && window.__SETUPS_CFG__[key];
    if (Array.isArray(v) && v.length) return v.slice();
    console.error('[setups] нет ступеней ползунка в __SETUPS_CFG__.' + key);
    return fallback;
  }

  const FILTERS_DEFAULT = {
    trigger_types: Array.from(TRIGGER_TYPES_ACTIVE),
    direction: null,
    min_turnover: 10000000,  // 10M ₽ default
    max_turnover: 0,         // 0 = без верхнего предела (∞)
    blue_chips_only: false,
    blue_chips_prefs: false,
    favorites_only: false,
  };
  /** Размер позиции (режим неттинга). Депозит НЕ задаём: он производная —
   *  пик занятого капитала, округлённый вверх до 50к (считает сервер). */
  // Ступеньки размера позиции (запрос владельца 28.08): ползунок ходит по ИНДЕКСУ
  // набора, а не по линейной шкале — промежуточных значений быть не должно.
  // Сами ступени — settings.SETUPS_POS_SIZE_STEPS (19.09): их читает и подбор набора для анонимов
  // (anon_preset.py), страница получает их через __SETUPS_CFG__.posSteps.
  const POS_SIZE_VALUES = _cfgSteps('posSteps', [20000]);

  function _posIdx(n) {
    let best = 0, bd = Infinity;
    POS_SIZE_VALUES.forEach((v, i) => {
      const d = Math.abs(v - n);
      if (d < bd) { bd = d; best = i; }
    });
    return best;
  }

  /** v — ИНДЕКС ступени слайдера (0..5), не рубли. */
  function _applyPosSize(v, silent) {
    const i = Math.max(0, Math.min(POS_SIZE_VALUES.length - 1, parseInt(v, 10) || 0));
    const n = POS_SIZE_VALUES[i];
    STATE.posSize = n;
    var sl = document.getElementById('f-pos-size');
    var lb = document.getElementById('f-pos-label');
    if (sl && String(sl.value) !== String(i)) sl.value = i;
    if (lb) lb.textContent = (n / 1000).toFixed(0) + ' тыс ₽';
    // Заливка — тем же приёмом, что у слайдера оборота (общая разметка
    // .sb-dual-range): ползунок один, поэтому полоса идёт от левого края.
    var fill = document.getElementById('f-pos-fill');
    if (fill) {
      var pct = (i / (POS_SIZE_VALUES.length - 1)) * 100;
      fill.style.left = '0%';
      fill.style.width = pct + '%';
    }
    if (!silent) _updatePosNote();
  }

  /** Установка по рублям (prefs, дефолт) — переводим в индекс ступени. */
  function _setPosSizeRub(n, silent) { _applyPosSize(_posIdx(Number(n) || 20000), silent); }

  /** Подпись под размером позиции снята (владелец 29.08): депозит и так виден
   *  в названии своего слайдера, дублировать его здесь незачем. Функция осталась
   *  точкой обновления зависимой подписи — теперь это подпись депозита. */
  function _updatePosNote() { _syncDepoUI(); }

  const UI_DEFAULT = { mode: 'user', chartExpanded: false, days_back: 14, rubDeposit: null, depoAuto: true };

  // Доп. параметры запроса графика — ОДНА точка сборки: раньше строка дублировалась
  // в двух местах с разным отступом, и новый флаг легко забыть в одном из них.
  function _chartExtraQuery() {
    var _cq = _commissionQuery();
    return (STATE.beShort ? '&be_short=1' : '')
         + (_cq.commission ? '&commission=' + _cq.commission : '')
         + (STATE.unitsPct ? '&units=pct' : '')
         + (STATE.showWeakBlocked ? '&show_weak_blocked=1' : '')
         + (STATE.showH4 ? '&show_h4_blocked=1' : '')
         + (STATE.showH2 ? '&show_h2_blocked=1' : '')
         + (STATE.showGap ? '&show_gap_blocked=1' : '')
         + (STATE.showIdx ? '&show_idx_blocked=1' : '')
         + (STATE.showEv ? '&show_ev_blocked=1' : '')
         + (STATE.showEw ? '&show_ew_blocked=1' : '')
         + (STATE.mrevExit ? '&mrev_exit=1' : '')
         + (_armParam() ? '&arm_exit=' + _armParam() : '')
         + (_wsParam() ? '&wide_stop=1' : '')
         + (STATE.build ? '&build=' + STATE.build : '')
         + (STATE.xm ? '&exit_model=' + STATE.xm : '')
         + ((STATE.mode === 'user' && _authState && _authState.is_admin) ? '&view_as=user' : '');
  }

  /** Активная кнопка «₽ / %» — по состоянию (вызывается из applyMode). */
  function _syncUnitsUI() {
    // Два админских вида: общая таблица «Сетапы_тест» и «Модельный портфель».
    var tg = document.getElementById('units-toggle');
    if (tg && _splitOn() && !tg.classList.contains('is-split')) {
      tg.classList.add('is-split');
      tg.title = 'Вид витрины: сетапы — каждый сам по себе, без денег; модельный портфель — единый счёт с деньгами';
      var br = tg.querySelector('.units-btn[data-units="rub"]');
      if (br) {
        br.textContent = 'Модельный портфель';
        br.title = 'Единый счёт: деньги, позиция по бумаге одна (неттинг), «История недель», «История сделок»';
      }
    }
    if (tg && _splitOn() && !tg.querySelector('[data-units="test"]')) {
      var test = document.createElement('button');
      test.type = 'button'; test.className = 'units-btn'; test.dataset.units = 'test';
      test.setAttribute('role', 'tab'); test.textContent = 'Сетапы';
      var today = document.createElement('span');
      today.id = 'setups-today-count'; today.className = 'setups-today-count';
      today.textContent = (document.getElementById('sec-count') || {}).textContent?.trim() || '';
      test.appendChild(today);
      test.title = 'Каждый сетап — своя сделка и свой результат';
      test.addEventListener('click', function () { setUnits('test'); });
      tg.insertBefore(test, tg.querySelector('[data-units="rub"]'));
    }
    document.querySelectorAll('#units-toggle .units-btn').forEach(function (b) {
      var on = (b.getAttribute('data-units') === (_setupsTestView() ? 'test' : 'rub'));
      b.setAttribute('aria-selected', String(on));
      if (b.dataset.units === 'test') b.hidden = !_splitOn();
      b.classList.toggle('active', on);
    });
    _syncShowcaseNavigation();
  }

  // Те же узлы и обработчики: доступ к двум уровням навигации задаёт флаг выкладки.
  function _syncShowcaseNavigation() {
    var on = _splitOn();
    document.body.classList.toggle('showcase-nav-on', on);
    var nav = document.getElementById('showcase-navigation');
    var stack = document.getElementById('mode-stack');
    var home = document.getElementById('showcase-market-home');
    if (nav) nav.style.display = on ? 'flex' : 'none';
    if (!stack || !home || !nav) return;
    if (on && stack.parentNode !== nav) nav.appendChild(stack);
    else if (!on && stack.parentNode !== home.parentNode) home.after(stack);
  }

  /** Переключение единиц: меняет ленту на сервере (другой вес сделки и нет
   *  ограничения капитала), поэтому данные перезапрашиваются целиком. */
  function setUnits(u) {
    if (u === 'pct') u = 'test';   // совместимость старого выбора — сразу новая таблица
    if (u === 'test' && !_splitOn()) return;
    var test = u === 'test';
    var want = test;
    var sameData = want === !!STATE.unitsPct;
    if (sameData) return;
    STATE.unitsPct = want;
    document.body.classList.toggle('units-pct', want);
    document.body.classList.toggle('mode-rubles',
      (STATE.mode === 'rubles' || STATE.mode === 'user') && !want);
    _syncUnitsUI();
    _syncSetupsView();
    var _lh = document.getElementById('lh-dox');
    if (_lh) _lh.textContent = want ? 'Доходность %' : 'Доходность %/₽';
    savePrefs('setups.ui', extractUIForPrefs());
    savePrefs('setups.filters', extractFiltersForPrefs());
    // в «Сетапах» нет «Истории недель» — с неё переходим на «Сетапы недели»; «История сделок» и «История сетапов» — одна
    // вкладка истории в двух видах (27.10.2026): остаёмся на ней, с первой страницы
    if (_setupsView() && STATE.weekly) { setRangeNet(); return; }
    if (sameData && !STATE.weekly && !STATE.detChart) { renderTable(); return; }
    if (STATE.deals) { STATE.dealsPage = 1; STATE.selectedDealsPage = null; renderDealsLabel(); fetchDeals(); return; }
    if (STATE.weekly) { fetchWeekly(); return; }
    if (STATE.detChart) { fetchDetectors(); return; }
    fetchAndRender();
  }
  window.setUnits = setUnits;

  function applyMode(mode) {
    var _isAdmin = !!(_authState && _authState.is_admin);
    // Канонизация: legacy 'light' / 'pro' (старые prefs) и дефолт → 'admin'. Затем
    // не-админ принудительно в 'user' — пользовательский вид (без результатов
    // завершённых сделок; admin-поля вычищены и бэкендом).
    var m = (mode === 'rubles') ? 'rubles'
          : (mode === 'user') ? 'user'
          : 'admin';   // 'admin' | legacy 'light' / 'pro' / 'la' | неизвестное
    if (!_isAdmin) m = 'user';                              // Admin/₽ — только админу
    var prevMode = STATE.mode;
    STATE.mode = m;
    // Тоггл [Admin|User] — admin-only (возвращён 28.08 по просьбе владельца).
    // Не-админу скрыт: ему переключать нечего, он и так в user-режиме.
    var _tog = document.getElementById('mode-toggle');
    if (_tog) _tog.style.display = _isAdmin ? 'inline-flex' : 'none';
    // Ряд над шапкой ТОП-карточек (22.09): у пользователя он пуст — не показываем,
    // иначе занимал бы высоту пустой полосой.
    var _abar = document.getElementById('topcards-adminbar');
    if (_abar) _abar.style.display = _isAdmin ? 'flex' : 'none';
    // Переключатель единиц «₽ / %» — как и весь ряд, только админу. В режиме User
    // режим процентов гасим: там выдача ровно пользовательская.
    var _ut = document.getElementById('units-toggle');
    if (_ut) _ut.style.display = _splitOn() ? 'inline-flex' : 'none';
    if (m === 'user' && !_splitOn()) STATE.unitsPct = false;
    // Плашку лидера при входе в режим User гасим до ответа сервера: цифра на экране
    // посчитана в админских настройках (например, в режиме процентов). Ответ для
    // пользовательского вида вернёт её снова (с 25.09.2026 плашка у всех ролей).
    if (m === 'user') {
      var _dl = document.getElementById('det-leader');
      // Невидимую заготовку первого кадра не трогаем: цифр в ней нет, а пустая плашка сдвинула бы шапку
      // (02.10.2026; applyMode зовётся и при старте, до данных).
      if (_dl && !_dl.classList.contains('det-leader-wait')) { _dl.hidden = true; _dl.innerHTML = ''; }
    }
    // Строки детекторов, скрытых у пользователя, — по виду. ДО смены набора фильтров режима (_futSync): набор
    // «Фьючей» ставится на сайдбар, собранный под свой вид, — иначе при Admin → User → Admin он терял связки, скрытые у
    // пользователя (11.10.2026).
    if (prevMode !== m) _syncHiddenTriggers();
    _syncSetupsPairs();    // снять пользовательский набор до перехода к админским фьючерсам
    _futSync();            // режим «Фьючи» — только в админском виде: в User — акции (11.10.2026)
    _syncCommissionUI();   // поле комиссии — значение из prefs или дефолт SSOT
    // mode-user — метка пользовательского вида (своих правил в CSS нет, JS идёт по
    // STATE.mode); mode-rubles — колонка «Лот / ₽» и 7-колоночная сетка списка.
    document.body.classList.toggle('mode-user', m === 'user');
    // ⚠ mode-rubles ставится и в пользовательском режиме: центральная часть
    // (колонка «Лот / ₽», доход в ₽ и %) одинакова в обеих ролях — иначе зачем
    // было выносить пользователю слайдер размера позиции (владелец, 28.08).
    // ⚠ В режиме процентов колонки «Лот / ₽» нет (сервер шлёт rubles:false) —
    // класс снимаем, иначе шапка осталась бы семиколоночной, а строка шести-
    // колоночной: ровно та рассинхронизация, что ловили 21.09 в «Истории».
    document.body.classList.toggle('mode-rubles',
      (m === 'rubles' || m === 'user') && !STATE.unitsPct);
    document.body.classList.toggle('units-pct', !!STATE.unitsPct);
    _syncInvestedView();   // вид «на вложенные»: слайдер депозита прячется по классу (16.10.2026)
    _syncUnitsUI();
    _syncSetupsView();     // вид «Сетапы»: класс страницы и вкладки (27.10.2026)
    // Набор кнопок диапазона и админские чекбоксы зависят от ВИДА, а не роли:
    // перестраиваем при каждой смене режима (иначе в User остаются админские).
    if (prevMode !== m) buildRangeToggle();
    if (prevMode !== m && typeof _mnSync === 'function') _mnSync();   // строка «Сейчас» и окно — по виду (20.10.2026)
    if (prevMode !== m && typeof _syncGatedUI === 'function') _syncGatedUI();   // «Только торгуемые / Все» — по виду
    var _lhDox = document.getElementById('lh-dox');
    // В режиме «только проценты» рублей в колонке нет — и в заголовке тоже.
    if (_lhDox) _lhDox.textContent = STATE.unitsPct ? 'Доходность %' : 'Доходность %/₽';
    // Active state на кнопках toggle
    // Активная кнопка: админский дефолт — ₽-режим ('rubles'), а кнопка называется
    // «Admin» → мапим оба админских режима на неё.
    var _btnMode = (m === 'user') ? 'user' : 'admin';
    document.querySelectorAll('.mode-toggle .mode-btn').forEach(function(btn) {
      btn.classList.toggle('active', btn.getAttribute('data-mode') === _btnMode);
    });
    // Заголовок секции: actual-витрина «Лучшие завершённые …» во ВСЕХ видах (та же
    // подпись стоит в разметке — первый кадр до скрипта не мигает). renderCards
    // финально уточняет по isActual (fallback на «Сетапы дня», если завершённых нет).
    var titleEl = document.getElementById('topcards-title-text');
    var subEl   = document.getElementById('topcards-subtitle');
    if (titleEl) titleEl.textContent = 'Лучшие завершенные сетапы';
    if (subEl)   subEl.textContent   = 'за последнюю неделю';   // .sec-sub = тонкий серый; renderCards уточнит на '' если forward
    // Re-render existing data в новом режиме (если data уже загружена и mode реально менялся).
    if (prevMode && prevMode !== m && STATE.data) {
      try {
        renderCards(STATE.data.top || []);
        renderTable();
      } catch (e) { console.warn('re-render on mode change failed', e); }
    }
  }

  /** Сохранённые фильтры (setups.filters) → наборы режимов и сайдбар: верхние ключи — набор акций, ключ fut — набор
   *  режима «Фьючи» (11.10.2026). На экран — набор действующего режима; у «Фьючей» без своего набора — первый набор
   *  (_futInitialSet: копия набора акций). */
  function applyFilters(f) {
    if (!f || typeof f !== 'object') f = {};
    _setupsPairs = Array.isArray(f.setups_type_tf) ? f.setups_type_tf.slice() : null;
    _modeFilters.stock = _stockFilterSet(f);
    _modeFilters.fut = (f.fut && typeof f.fut === 'object') ? _futFilterSet(f.fut) : null;
    if (_futApplied && !_modeFilters.fut) _modeFilters.fut = _futInitialSet();
    _applyFilterSet(_futApplied ? _modeFilters.fut : _modeFilters.stock);
  }

  /** Набор фильтров → сайдбар: детекторы, направление, вселенная (акций или контрактов), watchlist, оборот. */
  function _applyFilterSet(f) {
    if (!f || typeof f !== 'object') f = {};
    // Migration: пустой массив trigger_types никогда не является осмысленным
    // конечным состоянием (таблица показывала бы пустоту). Это либо stale
    // localStorage с эпохи когда FILTERS_DEFAULT был [], либо просто отсутствие
    // ключа. Восстанавливаем дефолт (все активные триггеры) — это также
    // фиксит баг с первой загрузкой RSI на /setups: без галочки DIVERGENCE
    // _isDivergenceFilterActive() возвращал false и engine создавался с
    // showRsi=false (см. фикс FILTERS_DEFAULT выше).
    var tts = Array.isArray(f.trigger_types) ? f.trigger_types : [];
    if (tts.length === 0) tts = Array.from(TRIGGER_TYPES_ACTIVE);
    document.querySelectorAll('#f-triggers input[type="checkbox"][data-tt]').forEach(function(cb) {
      var _tt = cb.getAttribute('data-tt');
      cb.checked = tts.indexOf(_tt) >= 0;
    });
    // Таймфреймы: пустой список — это «все» (как и у типов сетапа), а не «ничего».
    // Пары «тип:ТФ»: есть в настройках — восстанавливаем по ним; иначе по
    // старым спискам (настройки, записанные до перехода на пары).
    var _pairs = Array.isArray(f.type_tf) ? f.type_tf : null;
    var _tfs = (Array.isArray(f.timeframes) && f.timeframes.length)
               ? f.timeframes : TIMEFRAMES_ALL.slice();
    if (_setupsPairsApplied && !_futApplied) {
      if (_setupsPairs === null) {
        const base = _pairs ? _pairs.slice() : Array.from(document.querySelectorAll('#f-triggers input[data-tt]'))
          .filter(cb => tts.indexOf(cb.dataset.tt) >= 0 && _tfs.indexOf(cb.dataset.tf) >= 0)
          .map(cb => cb.dataset.tt + ':' + cb.dataset.tf);
        _setupsPairs = _expandPairs(Array.from(new Set(base.concat(
          (window.__SETUPS_CFG__ || {}).ideasDefaultPairs || []))));
      }
      _pairs = _setupsPairs;
    }
    document.querySelectorAll('#f-triggers input[type="checkbox"][data-tt]').forEach(function(cb) {
      var _t = cb.getAttribute('data-tt'), _f = cb.getAttribute('data-tf');
      cb.checked = _pairs ? (_pairs.indexOf(_t + ':' + _f) >= 0
                             || _groupVariantsUi(_t).some(function (v) { return _pairs.indexOf(v + ':' + _f) >= 0; }))
                          : (tts.indexOf(_t) >= 0 && _tfs.indexOf(_f) >= 0);
    });
    // Отмеченные в настройках связки, скрытые сейчас: чекбоксов нет, состояние держим здесь (extractFiltersForPrefs).
    _keptHiddenPairs = [];
    USER_HIDDEN_PAIRS.forEach(function (p) {
      var _t = p.split(':')[0], _f = p.split(':')[1];
      if (!_pairHiddenNow(_t, _f)) return;
      if (_pairs ? _pairs.indexOf(p) >= 0 : (tts.indexOf(_t) >= 0 && _tfs.indexOf(_f) >= 0)) _keptHiddenPairs.push(p);
    });
    document.getElementById('f-long').checked = (f.direction === 'LONG');
    document.getElementById('f-short').checked = (f.direction === 'SHORT');
    var bcEl = document.getElementById('f-blue-chips');
    if (bcEl) bcEl.checked = !!f.blue_chips_only;
    var bpEl = document.getElementById('f-blue-prefs');
    if (bpEl) bpEl.checked = !!f.blue_chips_prefs;
    var favEl = document.getElementById('f-favorites');
    if (favEl) favEl.checked = !!f.favorites_only;
    // Вселенная контрактов режима «Фьючи» (в наборе акций этих ключей нет — галочки сняты)
    var flqEl = document.getElementById('f-fut-liquid');
    if (flqEl) flqEl.checked = !!f.fut_liquid;
    var filEl = document.getElementById('f-fut-illiquid');
    if (filEl) filEl.checked = !!f.fut_illiquid;
    // min_turnover: если в prefs не задан — fallback на дефолт 10M.
    var v = (typeof f.min_turnover === 'number' && f.min_turnover >= 0)
            ? f.min_turnover
            : (parseInt(f.min_turnover) || 10000000);
    // max_turnover: 0/не задан = без верхнего предела (∞).
    var vx = (typeof f.max_turnover === 'number' && f.max_turnover >= 0)
            ? f.max_turnover
            : (parseInt(f.max_turnover) || 0);
    setTurnoverSlider(v, vx);
    _syncTtHeadChecks();     // состояние шапки выводим из восстановленных галочек
  }

  /** Сохраняемые фильтры (setups.filters): верхние ключи — набор акций, ключ fut — набор режима «Фьючи» (11.10.2026).
   *  Набор действующего режима — из сайдбара, другого — из _modeFilters. */
  function extractFiltersForPrefs() {
    var cur = _domFilterSet();
    var out = _futApplied ? Object.assign({}, _modeFilters.stock || _stockFilterSet(cur)) : _captureStockFilters(cur);
    var fut = _futApplied ? _futFilterSet(cur) : _modeFilters.fut;
    if (fut) out.fut = fut;
    if (_setupsPairs !== null) out.setups_type_tf = _setupsPairs.slice();
    return out;
  }

  // Общие фильтры сохраняются как раньше; у пользовательских «Сетапов» свой выбор пар.
  function _captureStockFilters(cur) {
    var out = _stockFilterSet(cur);
    if (_setupsPairsApplied) {
      _setupsPairs = cur.type_tf.slice();
      ['trigger_types', 'timeframes', 'type_tf'].forEach(function(key) {
        if (_modeFilters.stock && Object.prototype.hasOwnProperty.call(_modeFilters.stock, key))
          out[key] = _modeFilters.stock[key];
        else delete out[key];
      });
    }
    _modeFilters.stock = out;
    return out;
  }

  function _syncSetupsPairs() {
    var want = _setupsView() && !_adminView() && !_futOn();
    if (want && _futApplied) return;   // сначала _futSync вернёт набор акций
    if (want === _setupsPairsApplied) return;
    if (!_futApplied) _captureStockFilters(_domFilterSet());
    _setupsPairsApplied = want;
    if (!_futApplied) _applyFilterSet(_modeFilters.stock || {});
    _syncChartTriggerTypes();
  }

  /** Сайдбар как есть → набор фильтров (ключи обоих режимов; лишние снимают _stockFilterSet / _futFilterSet). */
  function _domFilterSet() {
    var tts = Array.from(document.querySelectorAll('#f-triggers input[type="checkbox"][data-tt]:checked'))
                   .map(function(x) { return x.getAttribute('data-tt'); })
                   .filter(function(t) { return !!t; });  // DE_* ТОЖЕ персистим: иначе «только DE_*»
                   // сохраняется как пустой набор → миграция applyFilters включает ВСЕ регулярные
    var long = document.getElementById('f-long').checked;
    var short = document.getElementById('f-short').checked;
    var direction = null;
    if (long && !short) direction = 'LONG';
    if (short && !long) direction = 'SHORT';
    var _onB = Array.from(document.querySelectorAll('#f-triggers input[type="checkbox"][data-tt]:checked'));
    var tfs = Array.from(new Set(_onB.map(function(x) { return x.getAttribute('data-tf'); })));
    var type_tf = _expandPairs(_onB.map(function(x) {     // с вариантами основного детектора (DET_GROUPS, 27.10.2026)
      return x.getAttribute('data-tt') + ':' + x.getAttribute('data-tf');
    }));
    type_tf.forEach(function (p) { var _t = p.split(':')[0]; if (tts.indexOf(_t) < 0) tts.push(_t); });
    // Скрытые сейчас связки — как были в настройках (их чекбоксов нет на экране, 04.10.2026).
    _keptHiddenPairs.forEach(function (p) {
      if (type_tf.indexOf(p) >= 0) return;
      type_tf.push(p);
      var _t = p.split(':')[0], _f = p.split(':')[1];
      if (tts.indexOf(_t) < 0) tts.push(_t);
      if (tfs.indexOf(_f) < 0) tfs.push(_f);
    });
    return {
      trigger_types: tts,
      timeframes: tfs,
      type_tf: type_tf,
      direction: direction,
      min_turnover: turnoverFromSlider(),
      max_turnover: turnoverMaxFromSlider(),
      blue_chips_only: document.getElementById('f-blue-chips').checked,
      blue_chips_prefs: !!(document.getElementById('f-blue-prefs') || {}).checked,
      favorites_only: document.getElementById('f-favorites').checked,
      fut_liquid: !!(document.getElementById('f-fut-liquid') || {}).checked,
      fut_illiquid: !!(document.getElementById('f-fut-illiquid') || {}).checked,
    };
  }

  /** Набор режима «Акции» — без галочек контрактов и без вложенного набора «Фьючей». */
  function _stockFilterSet(s) {
    var o = Object.assign({}, s || {});
    delete o.fut; delete o.fut_liquid; delete o.fut_illiquid; delete o.setups_type_tf;
    return o;
  }
  /** Набор режима «Фьючи» — без «Голубых фишек» и «Префов»: у контрактов вселенная своя («Фьючи-ликвид» /
   *  «Фьючи-неликв»). */
  function _futFilterSet(s) {
    var o = Object.assign({}, s || {});
    delete o.fut; delete o.blue_chips_only; delete o.blue_chips_prefs;
    o.fut_liquid = !!o.fut_liquid;
    o.fut_illiquid = !!o.fut_illiquid;
    return o;
  }
  /** Первый набор режима «Фьючи» (своего ещё нет): копия набора акций без «Голубых фишек» и «Префов»; «Фьючи-ликвид» —
   *  как была галочка «Фьюч-ликвид» в setups.ui до 11.10.2026. Дальше наборы живут отдельно. */
  function _futInitialSet() {
    var o = _futFilterSet(_modeFilters.stock || {});
    o.fut_liquid = !!_legacyFutLiquid;
    o.fut_illiquid = false;
    return o;
  }
  /** Смена режима: набор уходящего режима запоминается, на экран — набор входящего. */
  function _swapModeFilters(toFut) {
    var cur = _domFilterSet();
    if (toFut) {
      _modeFilters.stock = _stockFilterSet(cur);
      if (!_modeFilters.fut) _modeFilters.fut = _futInitialSet();
      _applyFilterSet(_modeFilters.fut);
    } else {
      _modeFilters.fut = _futFilterSet(cur);
      _applyFilterSet(_modeFilters.stock || {});
    }
    _syncChartRsiVisibility();
    _syncChartTriggerTypes();
  }

  /** Склонение слова «сделка» по числу: 1 сделка / 2 сделки / 5 сделок. */
  function _sdelokPlural(n) {
    var d = n % 10, h = n % 100;
    if (d === 1 && h !== 11) return 'сделка';
    if (d >= 2 && d <= 4 && (h < 12 || h > 14)) return 'сделки';
    return 'сделок';
  }

  // Ступени депозита (владелец 29.08): мелкий шаг внизу, крупный вверху —
  // 0.5-1.0 по 100к, дальше по 500к, после 5 млн по 1 млн. Ступени —
  // settings.SETUPS_DEPOSIT_STEPS (19.09), через __SETUPS_CFG__.depoSteps.
  const DEPO_VALUES = _cfgSteps('depoSteps', [3000000]);
  // Границы ползунков — из тех же ступеней (в разметке стоят прежние числа).
  (function _syncSliderMax() {
    var p = document.getElementById('f-pos-size');
    if (p) p.max = String(POS_SIZE_VALUES.length - 1);
    var d = document.getElementById('f-depo');
    if (d) d.max = String(DEPO_VALUES.length - 1);
  })();

  function _depoIdx(n) {
    let best = 0, bd = Infinity;
    DEPO_VALUES.forEach((v, i) => {
      const d = Math.abs(v - n);
      if (d < bd) { bd = d; best = i; }
    });
    return best;
  }

  /** v — ИНДЕКС ступени (0..18) либо null = auto (пик занятого, считает сервер). */
  function _applyDepo(v, silent) {
    if (v == null) { STATE.rubDeposit = null; STATE.depoAuto = true; }
    else {
      const i = Math.max(0, Math.min(DEPO_VALUES.length - 1, parseInt(v, 10) || 0));
      STATE.rubDeposit = DEPO_VALUES[i];
      STATE.depoAuto = false;
    }
    _syncDepoUI();
    if (!silent) { savePrefs('setups.ui', extractUIForPrefs()); onFilterChange(); }
  }

  /** Установка по рублям (prefs) — переводим в индекс ступени. */
  function _setDepoRub(n, silent) {
    if (n == null) return _applyDepo(null, silent);
    _applyDepo(_depoIdx(Number(n) || 3000000), silent);
  }

  /** Слайдер и подпись депозита. В auto показываем производный (пик занятого),
   *  который приехал с сервера в netting.capital_rub. */
  /** Сводка неттинга активного вида: в «Истории недель» — её итог, иначе витрина.
   *  Без этого подпись депозита в режиме недель показывала числа витрины. */
  function _netSummaryForUI() {
    if (STATE.weekly && STATE.weeklyData && STATE.weeklyData.netting)
      return STATE.weeklyData.total || null;
    return (STATE.data && STATE.data.netting) || null;
  }

  function _depoShown() {
    if (!STATE.depoAuto && STATE.rubDeposit) return STATE.rubDeposit;
    var n = _netSummaryForUI();
    return (n && n.capital_rub) || (n && n.peak_rub) || 3000000;
  }

  function _syncDepoUI() {
    var el = document.getElementById('f-depo');
    var lb = document.getElementById('f-depo-label');
    var nt = document.getElementById('f-depo-note');
    var fl = document.getElementById('f-depo-fill');
    var v = _depoShown();
    // Ползунок ходит по ИНДЕКСУ ступени. В auto депозит производный (пик
    // занятого) и в сетку может не попадать — ставим ближайшую ступень,
    // а точное число показываем в подписи слайдера.
    var i = _depoIdx(v);
    if (el && String(el.value) !== String(i)) el.value = String(i);
    if (fl) fl.style.width = Math.round(i / (DEPO_VALUES.length - 1) * 100) + '%';
    if (lb) {
      lb.textContent = (v / 1e6).toFixed(2).replace(/0+$/, '').replace(/\.$/, '')
                       + '\u00a0млн\u00a0₽';
    }
    if (nt) {
      // ⚠ Число ЗА ТЕКУЩУЮ НЕДЕЛЮ (решение владельца 29.08): подпись описывает
      // ровно те сделки, что показаны на витрине. Сервер отдаёт его отдельным
      // полем, поэтому оно не прыгает при смене вкладки и окна (раньше подпись
      // брала сводку активного вида: 2 на «Неделе» против 90 в «Истории»).
      // Пропущенные по остальным неделям — в строках «Истории недель», за весь
      // период — в её «Итого».
      var n = _netSummaryForUI();
      var sk = (n && (n.skipped_week != null ? n.skipped_week : n.skipped)) || 0;
      nt.textContent = 'Пропущено ' + sk + ' ' + _sdelokPlural(sk);
    }
  }

  function applyUI(ui) {
    if (!ui || typeof ui !== 'object') ui = {};
    // Сначала восстанавливаем выбор витрины, затем applyMode синхронизирует кнопки и классы.
    // Сохранённый выбор режима открывает соответствующую вкладку витрины.
    var choice = ui.showcaseView;
    var publicDefault = ((window.__SETUPS_CFG__ || {}).splitMode === 'on')
      && (!(_authState && _authState.is_admin) || ui.mode === 'user');
    STATE.unitsPct = choice === 'setups' ? true : choice === 'portfolio' ? false
      : publicDefault ? true : !!ui.unitsPct;
    applyMode(ui.mode || 'user');
    // chartExpanded
    var layout = document.querySelector('.layout');
    var expanded = !!ui.chartExpanded;
    layout.classList.toggle('expanded', expanded);
    updateExpandBtn(expanded);
    // Единственное live-окно — «14 дней» (устаревшие prefs 7/30 игнорируем).
    STATE.daysBack = 14;
    // Поле «Комиссия брокера» (admin): число из prefs или дефолт SSOT (data-default).
    STATE.commission = (typeof ui.commission === 'number' && isFinite(ui.commission))
      ? ui.commission : null;
    _syncCommissionUI();
    STATE.detTf = (ui.detTf === '1h' || ui.detTf === '4h') ? ui.detTf : 'both';   // ТФ «Детекторов» «Сетапов»
    _setRangeActive();
    // Депозит ₽-режима (admin slider). Разовая миграция 2 → 3 млн (25.08): поднимаем
    // только тем, у кого сохранён РОВНО прежний дефолт, и только один раз — флаг
    // depo3m едет в prefs, поэтому свой выбор (в т.ч. осознанные 2.0 млн после
    // миграции) больше не перетирается.
    // prefs хранят РУБЛИ, слайдер ходит по индексу ступени → переводим
    _setPosSizeRub(typeof ui.posSize === 'number' ? ui.posSize : 20000, true);
    // Депозит: ручной режим только при ЯВНОМ флаге. Старые prefs (до 29.08)
    // несут rubDeposit=3000000 как прежний дефолт — без флага это не выбор
    // человека, а легаси, иначе авто-режим не включился бы ни у кого.
    _setDepoRub((ui.depoAuto === false && typeof ui.rubDeposit === 'number')
                ? ui.rubDeposit : null, true);
    // Режим «Акции / Фьючи» (11.10.2026): выставленный выше набор — набор акций; набор режима «Фьючи» — свой
    // (futSizes; не задан — как у вкладки «Фьючерсы» /ml-setups).
    var _wasFut = _futApplied;
    STATE.futMode = !!ui.futMode;
    STATE.showGated = !!ui.showGated;    // «Только торгуемые / Все» (20.10.2026)
    // «Фьюч-ликвид» жила здесь до 11.10.2026 (теперь — в наборе фильтров «Фьючей»): нужна для его первого набора
    _legacyFutLiquid = !!ui.futLiquid;
    var _fs = ui.futSizes;
    _futSizes.fut = (_fs && typeof _fs.pos === 'number')
      ? { pos: _fs.pos, dep: (typeof _fs.dep === 'number' ? _fs.dep : null),
          auto: !!_fs.auto || typeof _fs.dep !== 'number' }
      : null;
    _futSizes.stock = null;
    _futApplied = false;
    if (_futOn()) {
      _futSizes.stock = _sizesNow();
      _futApplied = true;
      _sizesPut(_futSizes.fut || _futDefaultSizes());
    }
    if (_wasFut !== _futApplied) {
      _swapModeFilters(_futApplied);   // фильтры и набор детекторов — режима (11.10.2026)
      _liveDataCache = null; _futResetPanel(); buildRangeToggle();
    }
    _syncFutUI();
    _syncCommissionUI();
  }

  // Селектор окна таблицы («Последние 14 дней»). Меняет STATE.daysBack, persist, refetch.
  // ── Пресеты (фаза 1): forward-журнал пресета в отдельном табе ──
  function _trigPlural(n) {
    var d = n % 10, h = n % 100;
    if (d === 1 && h !== 11) return 'триггер';
    if (d >= 2 && d <= 4 && !(h >= 12 && h <= 14)) return 'триггера';
    return 'триггеров';
  }
  function loadSetupsPresets() {
    fetch('/api/lab/presets').then(r => r.ok ? r.json() : null).then(d => {
      if (!d) return;
      STATE._presets = d.presets || [];
      STATE._presetLimit = d.limit || 0;
      renderSetupsPresets();
      _nwSyncSources();         // подписи модала уведомлений зависят от наличия пресетов
    }).catch(function(){});
  }
  function renderSetupsPresets() {
    const box = document.getElementById('sb-presets');
    const list = document.getElementById('sb-presets-radios');
    if (!box || !list) return;
    const presets = STATE._presets || [];
    if ((STATE._presetLimit || 0) <= 0 || !presets.length) { box.style.display = 'none'; return; }
    box.style.display = '';
    list.innerHTML = presets.map(function(p) {
      // Контейнерная модель: пресет = набор триггеров (p.triggers[]).
      // Ярлык: 1 триггер → его имя, >1 → «N триггеров», 0 → пусто.
      var tt = (p.triggers || []).map(function(t){ return String(t.trigger_type || '').replace('_MTF',''); });
      var label = tt.length === 1 ? tt[0] : (tt.length > 1 ? (tt.length + ' ' + _trigPlural(tt.length)) : '');
      return '<div class="sb-preset-radio' + (STATE.presetId === p.id ? ' active' : '')
        + '" data-pid="' + p.id + '" data-pname="' + p.name + '">'
        + '<span>' + p.name + '</span><span class="pr-tt">' + label + '</span></div>';
    }).join('');
    list.querySelectorAll('.sb-preset-radio').forEach(function(el) {
      el.onclick = function() {
        const id = parseInt(el.dataset.pid, 10);
        if (STATE.presetId === id) { clearPreset(); fetchAndRender(); }   // повторный клик — выкл
        else setPreset(id, el.dataset.pname);
      };
    });
    // deep-link ?preset=<id> (из TG) — открыть пресет-таб после загрузки списка
    if (STATE._pendingPreset) {
      const p = presets.find(function(x) { return x.id === STATE._pendingPreset; });
      STATE._pendingPreset = null;
      if (p) setPreset(p.id, p.name);
    }
  }
  function _syncPresetTab() {   // динамический таб пресета в #range-seg (после Бэктест)
    const seg = document.getElementById('range-seg');
    if (!seg) return;
    let tab = seg.querySelector('.rng-btn[data-preset]');
    if (STATE.presetId) {
      if (!tab) {
        tab = document.createElement('button');
        tab.type = 'button'; tab.className = 'rng-btn'; tab.setAttribute('data-preset', '1');
        seg.appendChild(tab);
      }
      tab.textContent = STATE.presetName;
      seg.querySelectorAll('.rng-btn').forEach(function(b) {
        b.classList.toggle('active', b.hasAttribute('data-preset'));
      });
    } else if (tab) {
      tab.remove();
      // Пресет снят → возвращаем подсветку живой кнопке (Net/Gross/История),
      // иначе ни одна не активна и непонятно, что показано в таблице.
      _setRangeActive();
    }
  }
  function setPreset(id, name) {
    STATE.presetId = id; STATE.presetName = name;
    _exitDeals();
    document.body.classList.add('mode-preset');
    _syncPresetTab();
    renderSetupsPresets();
    fetchAndRender();
  }
  function clearPreset() {
    if (!STATE.presetId) return;
    STATE.presetId = null; STATE.presetName = ''; STATE.presetData = null;
    STATE._presetSelKey = null;
    // Список чистим СРАЗУ: дальше идёт асинхронный fetchAndRender, и до его ответа
    // (замер: ~0.8 с) на экране оставался старый журнал пресета — выглядело зависанием.
    const _ll = document.getElementById('list-light');
    _llCancel();
    if (_ll) _ll.innerHTML = '<div class="loading">Загрузка…</div>';
    document.body.classList.remove('mode-preset');
    _syncPresetTab();
    renderSetupsPresets();
  }
  async function fetchPresetSetups() {
    try {
      const r = await fetch('/api/lab/preset-setups/' + STATE.presetId);
      // Ошибку сервера НЕ выдаём за «пока пусто»: раньше 500 от эндпоинта выглядел
      // как «журнал наполняется», хотя сетапы в базе были (см. UndefinedColumn 22.07).
      STATE.presetData = r.ok ? await r.json()
        : { rows: [], _failed: true, preset: { name: STATE.presetName } };
    } catch (e) { STATE.presetData = { rows: [], _failed: true, preset: { name: STATE.presetName } }; }
    renderPresetList(STATE.presetData);
  }
  function fmtTimePreset(s) {
    // Тот же разбор, что fmtTime, но в ОДНУ строку: «22.07 13:00» (в журнале
    // колонка времени шире, чем в системной таблице, перенос не нужен).
    if (!s) return '';
    const parts = String(s).split(' ');
    if (parts.length < 2) return s;
    const [, mm, dd] = parts[0].split('-');
    return dd + '.' + mm + ' ' + parts[1].slice(0, 5);
  }
  function renderPresetList(d) {
    const root = document.getElementById('list-light');
    if (!root) return;
    _llCancel();                       // журнал пресета вместо таблицы — хвост не дописываем
    const rows = (d && d.rows) || [];
    const since = (d && d.preset && d.preset.created_at) ? d.preset.created_at.slice(0, 10) : '';
    // Плашка «сетапы по вашим параметрам» — плавающая под шапкой, закрывается крестиком
    // (только на текущий сеанс: состояние в переменной, не в localStorage — по ТЗ).
    let html = '';
    if (!STATE._presetInfoHidden) {
      html += '<div class="preset-info" id="preset-info">'
        + '<span class="preset-info-txt">Пресет «' + STATE.presetName + '» · сетапы по вашим параметрам'
        + (since ? ' с ' + since : '') + ' · накоплено ' + rows.length + '</span>'
        + '<button class="preset-info-x" title="Скрыть" aria-label="Скрыть">&times;</button></div>';
    }
    if (!rows.length) {
      html += d && d._failed
        ? '<div class="empty">Не удалось загрузить журнал пресета — обновите страницу; если повторится, мы уже видим проблему.</div>'
        : '<div class="empty">Пока пусто — журнал наполняется по мере появления сетапов на рынке (раз в час).</div>';
    } else {
      // Шапка журнала: колонки Время / Тикер / Сетап / Направление (сетка задана в CSS,
      // sticky по тому же приёму, что .list-light-hdr).
      html = '<div class="preset-hdr"><span>ВРЕМЯ</span><span>ТИКЕР</span>'
        + '<span>СЕТАП</span><span class="ph-right">НАПРАВЛЕНИЕ</span></div>' + html;
      html += rows.map(function(r) {
        const dir = (r.direction || '').toUpperCase();
        const dcls = dir === 'LONG' ? 'long' : 'short';
        const dru = dir === 'LONG' ? 'ЛОНГ' : 'ШОРТ';
        const tt = (r.trigger_type || '').replace('_MTF', '');
        // цвет названия — из общей SETUP_NAME_COLOR (ключи в DB-формате с _MTF);
        // журнал хранит типы лаборатории без суффикса → приводим через тот же маппинг,
        // что и точки в сайдбаре. Нет в карте (дивергенция, фигурные) → белый.
        const nmColor = SETUP_NAME_COLOR[_UI_TO_DB_TT_MAP[tt] || tt] || 'var(--text)';
        const selCls = (STATE._presetSelKey === r.ticker + '|' + (r.bar_date || '')) ? ' selected' : '';
        return '<div class="prow pd-' + dcls + selCls + '" data-tk="' + r.ticker + '" data-bd="' + (r.bar_date || '') + '">'
          + '<span class="prow-time">' + fmtTimePreset(r.bar_date) + '</span>'
          + '<span class="prow-tk"><span class="prow-tkr">' + r.ticker + '</span>'
          + '<span class="prow-name">' + (r.ticker_name || '') + '</span></span>'
          + '<span class="prow-setup" style="color:' + nmColor + '">' + tt + '</span>'
          + '<span class="prow-dir ' + dcls + '">' + dru + '</span></div>';
      }).join('');
    }
    root.innerHTML = html;
    root.querySelectorAll('.prow').forEach(function(el) {
      el.onclick = function() {
        // подсветка выбранной строки — как в системной таблице (.row-l.selected);
        // ключ в STATE, чтобы выделение переживало ре-рендер журнала
        STATE._presetSelKey = el.dataset.tk + '|' + (el.dataset.bd || '');
        root.querySelectorAll('.prow.selected').forEach(function(r) { r.classList.remove('selected'); });
        el.classList.add('selected');
        loadChartInPanel(el.dataset.tk, '1h', { around: el.dataset.bd });
      };
    });
    const x = root.querySelector('.preset-info-x');
    if (x) x.onclick = function() {          // скрыть плашку до перезагрузки страницы
      STATE._presetInfoHidden = true;
      const box = document.getElementById('preset-info');
      if (box) box.remove();
    };
  }

  // ── Оконный переключатель #range-seg (Сетапы / Доход / История) ──────
  // Единый источник active-подсветки для обеих раскладок (2 кнопки не-админ /
  // 3 кнопки админ). Ключ — состояние STATE, а не data-атрибуты кнопки.
  // 24.08: кнопки «Gross» больше нет — способ счёта переехал в чекбокс
  // «Без комиссии», окно от него не зависит.
  // Состояние графика «Детекторы» (volatile): скрытые кривые (клик по легенде),
  // подсвеченная (наведение), последний ответ. Поколение запроса — общее
  // (_beginReq), чтобы индикатор загрузки гас как на остальных путях.
  var _detHidden = {}, _detFocus = null, _detLast = null;
  var DET_FILL_ALPHA = 0.28;          // заливка кривой в фокусе: прозрачность НА ЭКСТРЕМУМЕ кривой, у нуля 0
  var DET_DIM_OPACITY = '0.25';       // остальные кривые при фокусе (решение владельца 17.09.2026: было 0.15)
  var DET_W = '1.2', DET_W_FOCUS = '1.6';   // толщина кривой и кривой в фокусе (решение владельца: было 1.6 / 2.4, затем 1.0 — тонковато)

  function _currentRngKey() {
    if (STATE.detChart) return 'det';
    if (STATE.weekly) return 'weekly';
    if (STATE.deals) return 'deals';
    return 'net';
  }
  function _setRangeActive() {
    _syncTestHeader();
    if (STATE.presetId) return;   // активна кнопка пресета (_syncPresetTab)
    var key = _currentRngKey();
    document.querySelectorAll('#range-seg .rng-btn').forEach(function(b) {
      if (b.hasAttribute('data-preset')) return;
      b.classList.toggle('active', b.getAttribute('data-rng') === key);
    });
  }
  // Перестроить #range-seg под текущего пользователя: админ → 3 кнопки
  // (14 дней Net / 14 дней Gross / История), не-админ → 2 кнопки (14 дней / История).
  // #range-seg-элемент НЕ пересоздаётся (на нём висит capture-listener
  // _initMobileRangeDropdown) — меняем только innerHTML дочерних кнопок.
  /** Админский ВИД — роль И не пользовательский режим просмотра. Раньше всё
   *  гейтилось ролью, поэтому админ, переключившийся в User, продолжал видеть
   *  «Историю недель» и админские чекбоксы сайдбара, а клик по «Истории недель»
   *  насильно возвращал в Admin (репорт владельца 28.08). */
  function _adminView() {
    return !!(_authState && _authState.is_admin) && STATE.mode !== 'user';
  }
  // Вид «на вложенные» (16.10.2026, settings.SETUPS_USER_INVESTED_MODE → __SETUPS_CFG__.investedMode, решение владельца:
  // меньше путаницы с процентами): у людей нет депозита (капитал не ограничивает сделки, слайдера и колонки «Пропущено»
  // нет), «Итого» «Истории недель» и итог «Истории сделок» — на вложенные, колонка — «Сумма % сделок», вид «IMOEX» —
  // только «% вложенного». 'on' — у всех, кроме админского вида; 'admin' — только админ в виде «User». То же правило —
  // на сервере (web_app._invested_view): запросы такого вида депозит не несут.
  function _investedView() {
    var m = (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.investedMode) || 'off';
    if (_adminView()) return false;
    return m === 'on' || (m === 'admin' && !!(_authState && _authState.is_admin) && STATE.mode === 'user');
  }
  function _syncInvestedView() {
    document.body.classList.toggle('invested-view', _investedView());
  }
  // Вид «Сетапы» (27.10.2026, решение владельца; settings.SETUPS_SPLIT_MODE → __SETUPS_CFG__.splitMode): витрина без денег
  // и без неттинга — каждый сетап своя сделка со своим результатом (сервер: view=setups, web_app._setups_split_on).
  // Переключатель «Сетапы / Модельный портфель» вместо «₽ / %»: режим «%» и есть «Сетапы»; вкладки — «Сетапы недели» и
  // «Детекторы» (полосы плюс / минус по детекторам сайдбара). «Модельный портфель» — витрина как была. 'on' — у всех посетителей.
  function _splitOn() {
    var m = (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.splitMode) || 'off';
    return m === 'on' || (m === 'admin' && _adminView());
  }
  function _setupsView() {
    return _splitOn() && !!STATE.unitsPct;
  }
  // Класс страницы и набор вкладок вида «Сетапы» — при смене единиц и вида (Admin / User)
  function _syncSetupsView() {
    _syncSetupsPairs();
    var on = _setupsView();
    var was = document.body.classList.contains('setups-view');
    document.body.classList.toggle('setups-view', on);
    _syncTestHeader();
    if (was !== on) buildRangeToggle();
    _syncGatedUI();          // «Торгуемые / Все» — только у портфеля (27.10.2026)
  }

  // ── Режим «Акции / Фьючи» (11.10.2026, только админ: settings.SETUPS_FUT_MODE) ──────────────────────────
  // Витрина фьючерсов: те же сетапы витрины, исполненные на квартальном фьючерсе того же эмитента, без ML-отбора;
  // правила счёта — витрины, вход и выход — минутная модель по минуткам контракта (exit_term showcase_fut). Признак
  // режима (fut=1; галочки «Фьючи-ликвид» / «Фьючи-неликв» — fut_liquid=1 / fut_illiquid=1) уходит в КАЖДЫЙ запрос через
  // currentFilters(): данные, лёгкий ответ, карточки, «История недель», «История сделок», «Детекторы» — таблицы акций и
  // фьючерсов не смешиваются. У режима свои размер сделки и депозит (по умолчанию — как у вкладки «Фьючерсы» /ml-setups, __SETUPS_CFG__.fut),
  // график — свечи контракта (/api/ml-setups/fut-chart). В режиме User — всегда акции.
  // var, не const: функции режима зовутся из applyMode, а она бывает раньше этой строки (TDZ у const уронил бы страницу)
  var FUT_CFG = (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.fut) || { on: false };
  var FUT_CHART_URL = '/api/ml-setups/fut-chart/';
  var _futSizes = { stock: null, fut: null };   // неактивный набор «размер сделки + депозит» каждого режима
  var _futApplied = false;                      // активный набор (STATE.posSize / rubDeposit / depoAuto) — фьючерсный
  var _panelFut = null;                         // контракт, чьи свечи сейчас на графике (null — акция)

  /** Режим «Фьючи» действует: включён, разрешён сервером и вид админский. */
  function _futOn() {
    return !!(STATE.futMode && FUT_CFG && FUT_CFG.on && _adminView());
  }
  /** Единый счёт: в режиме «Фьючи» — всегда (счёт фьючерсов — только неттингом, как вкладка «Фьючерсы»); в виде «Сетапы» —
   *  тоже (27.10.2026): сервер собирает сетапы из ленты счёта, а галочка «Старый способ счёта» там спрятана. */
  function _nettingOn() {
    return !!STATE.netting || _futOn() || _setupsView();
  }
  function _sizesNow() {
    return { pos: STATE.posSize || 20000, dep: STATE.rubDeposit, auto: !!STATE.depoAuto };
  }
  function _sizesPut(s) {
    _setPosSizeRub(s.pos || 20000, true);
    _setDepoRub(s.auto ? null : s.dep, true);
  }
  function _futDefaultSizes() {
    var d = Number(FUT_CFG.dep) || null;
    return { pos: Number(FUT_CFG.pos) || 100000, dep: d, auto: !d };
  }
  /** Сделки и свечи у режимов разные: график и выбор сетапа сбрасываются, панель поднимет первая карточка
   *  нового ответа (_initPanelChart). */
  function _futResetPanel() {
    _panelTicker = null;
    _panelFut = null;
    _panelPrelimTid = null;
    _panelPrelimTicker = null;
    STATE.selectedTid = null;
    STATE.selectedTriggerBarDate = null;
    STATE.selectedTriggerType = null;
    STATE.expandedTriggerId = null;
  }
  /** Переключатель, галочка и классы — по состоянию режима. */
  function _syncFutUI() {
    var vis = !!(FUT_CFG && FUT_CFG.on && _adminView());
    var box = document.getElementById('fut-toggle-wrap');
    if (box) box.style.display = vis ? 'flex' : 'none';
    var on = _futOn();
    document.querySelectorAll('#fut-toggle .units-btn').forEach(function (b) {
      b.classList.toggle('active', (b.getAttribute('data-fut') === '1') === on);
    });
    document.body.classList.toggle('fut-mode', _futApplied);
  }
  /** Привести активный набор «размер сделки + депозит» к режиму (_futOn): набор уходящего режима сохраняется,
   *  набор входящего становится активным, график сбрасывается. → true, если режим сменился. */
  function _futSync() {
    var want = _futOn();
    if (want !== _futApplied) {
      _futSizes[_futApplied ? 'fut' : 'stock'] = _sizesNow();
      _futApplied = want;
      _sizesPut(_futSizes[want ? 'fut' : 'stock'] || (want ? _futDefaultSizes() : { pos: 20000, dep: null, auto: true }));
      _swapModeFilters(want);         // фильтры и набор детекторов — режима (11.10.2026)
      _liveDataCache = null;          // живой ответ другого режима: при возврате на «Неделю» — свежий запрос
      _futResetPanel();
      _syncFutUI();
      _syncCommissionUI();
      buildRangeToggle();             // подсказки вкладок — с началом ленты режима
      if (STATE.deals) renderDealsLabel();
      return true;
    }
    _syncFutUI();
    return false;
  }
  /** Перезапрос текущей вкладки после смены режима или галочки «Фьюч-ликвид». */
  function _refetchForFut() {
    if (STATE.presetId) return;                 // журнал пресета — свой запрос
    if (STATE.weekly) { fetchWeekly(); return; }
    if (STATE.detChart) { fetchDetectors(); return; }
    _scheduleFetch(0);                          // «Неделя» и «История сделок» (fetchAndRender → fetchDeals)
  }
  /** Переключатель «Акции / Фьючи». */
  function setFut(on) {
    on = !!on;
    if (on === !!STATE.futMode) return;
    STATE.futMode = on;
    var changed = _futSync();
    savePrefs('setups.ui', extractUIForPrefs());
    // набор фильтров режима «Фьючи» — в настройки сразу (первый вход создаёт его копией набора акций)
    if (changed) savePrefs('setups.filters', extractFiltersForPrefs());
    if (changed) _refetchForFut();
  }
  window.setFut = setFut;
  /** Контракт сделки на графике: выбранный сетап этого тикера, иначе самый свежий сетап тикера в ответе. */
  function _futContractOf(ticker) {
    var mi = _findSetupByTid(STATE.selectedTid);
    if (mi && mi.trigger && mi.trigger.ticker === ticker && mi.trigger.fut_contract) return mi.trigger.fut_contract;
    var best = null;
    var d = STATE.data || {};
    [d.table, d.top].forEach(function (list) {
      (list || []).forEach(function (x) {
        var t = x && x.trigger;
        if (t && t.ticker === ticker && t.fut_contract && (!best || String(t.bar_date) > String(best.bar_date))) best = t;
      });
    });
    return best ? best.fut_contract : null;
  }
  /** Параметры запроса графика контракта: окно дотягивается до выхода выбранной сделки. */
  function _futChartQuery(ticker) {
    var mi = _findSetupByTid(STATE.selectedTid);
    var t = mi && mi.trigger;
    var x = (t && t.ticker === ticker && t.exit_price != null) ? (t.exit_at || t.exit_bar_date) : null;
    return x ? '&until=' + encodeURIComponent(String(x).replace('T', ' ').substring(0, 19)) : '';
  }

  /** В неттинге депозит производный → слайдер депозита прячем, показываем
   *  слайдер размера позиции. Вне неттинга — наоборот. */
  // ── Комиссия брокера (поле в сайдбаре, admin, 08.09.2026) ─────────────
  // Дефолт — data-default поля (плейсхолдер из SSOT level_aware_exit); своей
  // копии числа в JS нет намеренно: нет атрибута → поле не применяется.
  function _commissionDefault() {
    var el = document.getElementById('f-commission');
    var d = el ? parseFloat(el.getAttribute('data-default')) : NaN;
    return isFinite(d) ? d : null;
  }
  function _commissionValue() {      // явно введённое (prefs) или дефолт SSOT
    return (typeof STATE.commission === 'number' && isFinite(STATE.commission))
      ? STATE.commission : _commissionDefault();
  }
  // Модель издержек одна на все роли (выкачено всем 08.09 после приёмки):
  // поле применяется всегда, когда известно значение (prefs или дефолт SSOT).
  function _commissionApplies() {
    return _commissionValue() != null;
  }
  function _commissionQuery() {      // {commission: '0.055'} | {}
    return _commissionApplies() ? { commission: String(_commissionValue()) } : {};
  }
  /** Режим единиц (22.09.2026): {units:'pct'} — результат в процентах от цены
   *  бумаги, без денег и капитала. ⚠ Подмешивать в КАЖДУЮ точку сборки запроса
   *  (`_rub`, `fetchWeekly`, `fetchDetectors`, `psTop`, `_chartExtraQuery`) —
   *  иначе поверхности посчитаются в разных единицах (память
   *  project_setups_query_surfaces: так уже разъезжались комиссия и фильтры). */
  function _unitsQuery() {           // {units: 'pct'[, view: 'setups']} | {}
    if (!STATE.unitsPct) return {};
    return _setupsView() ? { units: 'pct', view: 'setups' } : { units: 'pct' };   // вид «Сетапы» (27.10.2026)
  }
  /** Пары «тип:ТФ» (CSV) в порядке, объявленном сервером (__SETUPS_CFG__.netPairsAll), а не в порядке
   *  чекбоксов сайдбара (19.09.2026): так подпись запроса собирает и сервер — прелоад набора для анонима
   *  (setups_defaults.default_data_query) совпадает с ней байт в байт. Неизвестные серверу — в конце. */
  function _pairsCanon(csv) {
    var all = (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.netPairsAll) || null;
    var got = String(csv).split(',');
    if (!all || !all.length) return got.join(',');
    var have = new Set(got);
    var out = all.filter(function(p) { return have.has(p); });
    got.forEach(function(p) { if (all.indexOf(p) < 0) out.push(p); });
    return out.join(',');
  }
  /** Набор пар «тип:ТФ» (CSV) покрывает весь витринный набор, объявленный сервером
   *  (__SETUPS_CFG__.netPairsAll)? Список не объявлен → false: шлём явно, безопасно. */
  function _pairsCoverAll(csv) {
    var all = (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.netPairsAll) || null;
    if (!all || !all.length) return false;
    var got = new Set(String(csv).split(','));
    for (var i = 0; i < all.length; i++) if (!got.has(all[i])) return false;
    return true;
  }
  // Поле «Комиссия брокера» — всем: показываем, когда известно значение
  // (prefs или дефолт SSOT из data-default); чекбокса «Без комиссии» больше нет.
  function _syncCommissionUI() {
    var row = document.getElementById('sb-commission');
    var on = _commissionApplies();
    // Режим «Фьючи» (11.10.2026): у контракта свои издержки (фиксированная комиссия + спред в шагах цены,
    // futures_layer.friction_pct) — поле на них не действует, прячем.
    if (row) row.style.display = (on && !_futApplied) ? '' : 'none';
    var el = document.getElementById('f-commission');
    if (el && on) el.value = String(_commissionValue());
  }

  function _syncNettingUI() {
    var pos = document.getElementById('sb-pos-size');
    // Слайдер размера позиции виден всегда; слайдера депозита больше нет —
    // депозит производный (пик занятого, кратно 50к).
    if (pos) pos.style.display = '';
    _updatePosNote();
  }

  // Начало ленты витрины — из settings.SETUPS_FEED_START через __SETUPS_CFG__ (24.09.2026): копии даты в JS нет.
  function _feedStartTitle() {
    // режим «Фьючи» (11.10.2026): лента режима — с settings.SETUPS_FUT_FEED_START
    var l = (_futApplied && FUT_CFG && FUT_CFG.startLabel) || (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.feedStartLabel);
    return (l && l.indexOf('<!--') !== 0) ? ' с ' + l : '';
  }

  function buildRangeToggle() {
    var seg = document.getElementById('range-seg');
    if (!seg) return;
    var _isAdmin = _adminView();
    // Админские чекбоксы-фильтры в сайдбаре (видны вместе с admin-переключателями).
    ['sb-skips-off', 'sb-only-at-level', 'sb-hide-weak', 'sb-be-short',
     'sb-closed-today', 'sb-show-weak-blocked', 'sb-show-h4', 'sb-show-h2', 'sb-show-gap', 'sb-show-idx', 'sb-show-ev',
     'sb-show-ew', 'sb-mrev-exit', 'sb-arm-exit', 'sb-wide-stop', 'sb-avg-down', 'sb-netting',
     'sb-opp-skip'].forEach(function (id) {
      var el = document.getElementById(id);
      // «Ранний трейл шортов» и «Выкл запрет усреднения шортов» — только пока правило не выключено (__SETUPS_CFG__);
      // «Стоп дальше у «Скрытого уровня»» — только в режиме обкатки (у всех правило без галочки)
      if (el) el.style.display = (_isAdmin && (id !== 'sb-arm-exit' || _armMode() !== 'off')
                                  && (id !== 'sb-wide-stop' || _wsMode() === 'admin')
                                  && (id !== 'sb-avg-down' || _avgDownMode() !== 'off')) ? 'flex' : 'none';
    });
    _syncCommissionUI();   // поле «Комиссия брокера» — всем (08.09)
    // Фильтр таймфрейма — тоже пока только админу (секция, а не строка-чекбокс).
    // 23.08: обе колонки (1ч/4ч) видны всем — гейт снят вместе с серверным.
    // Вернуть = навесить ' sb-tf-admin' в buildTriggerFilters и скрывать тут.
    // Данных ещё нет — невидимые заготовки держат ширину вкладок, как в разметке первого кадра (02.10.2026):
    // иначе переключатель сужался и снова расширялся, когда приходили числа.
    var _cw = !(STATE.data && STATE.data.table);
    var rc = '<span class="rng-count' + (_cw ? ' rng-count-wait' : '') + '" id="rng-count-recent">' + (_cw ? '(00)' : '') + '</span>';
    // ⚠ ОДИН набор кнопок на обе роли (28.08): центральная часть витрины у
    // пользователя и админа одинакова — различаются только левый сайдбар,
    // переключатель Admin/User и кнопка «Тон рынка». Раньше здесь были две
    // ветки, и они успели разъехаться (у пользователя не было ₽-режима).
    // Вид «Сетапы» (27.10.2026, решение владельца): «Сетапы недели», «История сетапов» и «Детекторы» — «Истории недель»
    // (история счёта) там нет; «История сетапов» — все закрытые сетапы, а не сделки счёта; «Детекторы» — полосы
    var _sv = _setupsView();
    seg.innerHTML = (_sv
      ? '<button type="button" class="rng-btn" data-rng="net" data-d="14" onclick="setRangeNet()" title="Сетапы текущей недели: ещё открытые плюс закрытые с понедельника, у каждого свой результат">Сетапы недели' + rc + '</button>' +
        '<button type="button" class="rng-btn" data-rng="deals" onclick="setRangeDeals()" title="Все закрытые сетапы' + _feedStartTitle() + ' — у каждого свой результат, без решений счёта">История сетапов</button>'
      : '<button type="button" class="rng-btn" data-rng="net" data-d="14" onclick="setRangeNet()" title="Сделки текущей недели: ещё открытые плюс закрытые с понедельника">Сделки недели' + rc + '</button>' +
        '<button type="button" class="rng-btn" data-rng="weekly" onclick="setRangeWeekly()" title="Доход по неделям (по дате выхода из сделки)' + _feedStartTitle() + '">История недель</button>' +
        '<button type="button" class="rng-btn" data-rng="deals" onclick="setRangeDeals()" title="Все закрытые сделки единого счёта' + _feedStartTitle() + ' — те же, что складываются в «Историю недель»">История сделок</button>') +
      '<button type="button" class="rng-btn" data-rng="det" onclick="setRangeDetectors()" title="' + (_sv
        ? 'Сумма процентов сделок в плюсе и в минусе по каждому детектору'
        : 'Доходность по детекторам: нарастающий вклад каждого в общий доход') + '">Детекторы</button>';
    _setRangeActive();
    renderWindowCounts();   // перевесить счётчики на свежие span'ы
  }

  function setRange(d) {
    if (STATE.daysBack === d && !STATE.deals && !STATE.presetId && !STATE.weekly && !STATE.detChart) return;
    clearPreset();
    _exitDetectors();
    _exitWeekly();
    _exitDeals();
    STATE.daysBack = d;
    _setRangeActive();
    savePrefs('setups.ui', extractUIForPrefs());
    // Возврат на таб — мгновенно из кэша последнего живого ответа (свежесть ≤
    // минуты-двух: авто-рефреш и фоновый fetchAndRender ниже тут же обновят).
    if (_liveDataCache && STATE.data !== _liveDataCache) {
      STATE.data = _liveDataCache;
      _dataGen += 1;
      renderTable();
      if (STATE.data.top) renderCards(STATE.data.top);
    }
    fetchAndRender();
  }

  // Admin «Неделя» в ₽ — net (издержки по полю «Комиссия брокера»).
  function setRangeNet()   { _setRubWindow(false, true); }   // вид Admin / User вкладка не меняет (16.10.2026)

  // «История недель» — доход по неделям с 2026-05-05 (admin ₽).
  // Net или Gross — по чекбоксу «Без комиссии» (раньше было жёстко Net).
  // ── Вкладка «Детекторы» ───────────────────────────────────────────
  // Кривая = детектор (оба ТФ вместе), Y — нарастающий вклад в доход в % от
  // депозита. Набор детекторов и ТФ берём из САЙДБАРА: там уже есть ровно эти
  // чекбоксы, они сохраняются в настройках, и второй набор в легенде стал бы
  // вторым источником правды о наборе (класс дефектов, чиненный 29.08).
  function setRangeDetectors(period) {
    if (STATE.detChart) return;
    // график «Всё» при каждом переходе на вкладку (16.10.2026); плашка лидера передаёт свой период
    STATE.detPeriod = period || 'all';
    clearPreset();
    _exitDetectors();
    _exitWeekly();
    _exitDeals();
    STATE.detChart = true;
    STATE.daysBack = 14;
    document.body.classList.add('mode-detectors');
    var st = _tableTitleEl();
    if (st && st.childNodes[0]) st.childNodes[0].nodeValue = 'Доходность детекторов';
    _setRangeActive();
    fetchDetectors();
  }

  function _exitDetectors() {
    if (!STATE.detChart) return;
    STATE.detChart = false;
    document.body.classList.remove('mode-detectors');
    var dv = document.getElementById('det-view'); if (dv) dv.style.display = 'none';
    var st = _tableTitleEl();
    if (st && st.childNodes[0]) st.childNodes[0].nodeValue = 'Все сетапы';
  }

  function setDetPeriod(p) {
    if (STATE.detPeriod === p) return;
    STATE.detPeriod = p;
    fetchDetectors();
  }

  function fetchDetectors() {
    var dv = document.getElementById('det-view');
    if (!dv) return;
    dv.style.display = '';
    if (!dv.innerHTML) dv.innerHTML = '<div class="det-empty">Загружаю…</div>';
    var p = _detQuery(STATE.detPeriod || 'all');
    // ⚠ Через ШТАТНЫЙ счётчик запросов (_beginReq/_endReq), а не через свой:
    // индикатор загрузки (`body.is-loading`, приглушение страницы) взводит
    // _scheduleFetch при каждом клике по фильтру, а гасит только _endReq —
    // со своим счётчиком вкладка оставалась затемнённой навсегда (репорт
    // владельца 29.08: «попереключал чекбоксы, график затемнился и не вернулся»).
    var seq = _beginReq();
    fetch('/api/setups?' + p.toString())
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (_isStale(seq)) return;                 // ответ устаревшего запроса
        var dc = (j && j.netting && j.netting.detectors) || null;
        _ideasPrevKeep(p, dc);                     // «Сетапы»: прошлая неделя — и для плашки лидера
        renderDetectors(dc, (j && j.netting) || {});
        if (_setupsView()) renderDetLeader();      // фильтры могли смениться на вкладке — плашка догоняет
      })
      .catch(function () {
        if (_isStale(seq)) return;
        dv.innerHTML = '<div class="det-empty">Не удалось загрузить данные</div>';
      }).finally(function () { _endReq(seq); });
  }

  /** Запрос вкладки «Детекторы» за период: фильтры сайдбара и параметры счёта. Общий у вкладки и плашки лидера вида
   *  «Сетапы» (27.10.2026) — у них одни числа. В «Сетапах» набор детекторов не шлём: сервер считает все детекторы,
   *  доступные смотрящему (решение владельца — сравнивать детекторы, не трогая набор витрины), ТФ складывает страница. */
  function _detQuery(period) {
    var f = currentFilters();
    var p = new URLSearchParams();
    // days_back здесь не про период графика: сервер считает разбивку по ВСЕЙ
    // ленте (120 дней) и режет её параметром `since` — им управляет week_only.
    p.set('days_back', '14');
    p.set('slim', '1');                      // таблица не нужна, только агрегаты
    p.set('det_chart', '1');
    // Вид «IMOEX» — только «Всё» (решение владельца 16.10.2026): блок за всю ленту при любом периоде кривых, поэтому
    // переключение видов не шлёт запроса. Без параметра сервер считает блок за период вкладки (прежние вкладки).
    p.set('bench', 'all');
    // Период режет СЕРВЕР (since/until по ленте), клиент шлёт только имя периода.
    p.set('det_period', period);
    if (f.min_turnover) p.set('min_turnover', String(f.min_turnover));
    if (f.max_turnover) p.set('max_turnover', String(f.max_turnover));
    if (f.direction) p.set('direction', f.direction);
    // ⚠ currentFilters() отдаёт type_tf уже СТРОКОЙ («TYPE:tf,TYPE:tf») —
    // join здесь ронял вкладку (f.type_tf.join is not a function).
    if (f.type_tf && !_setupsView()) p.set('net_type_tf', _pairsCanon(f.type_tf));
    // ⚠ Фильтры ВСЕЛЕННОЙ (22.09.2026): без них вкладка считала по всем бумагам,
    // пока таблица и плашка лидера — по выбранным. У владельца с «только голубые
    // фишки» дивергенция за прошлую неделю: +1.55 % в плашке против −0.23 % на
    // графике — один детектор с разным знаком на одном экране.
    if (f.blue_chips_only) p.set('blue_chips_only', '1');
    if (f.blue_chips_prefs) p.set('blue_chips_prefs', '1');   // «Префы» (05.10.2026)
    if (f.favorites_only) {
      p.set('favorites_only', '1');
      if (f.favorite_tickers) p.set('favorite_tickers', f.favorite_tickers);
    }
    // Админские флаги правил шортов (24.09.2026): без них вкладка считала по ленте без
    // «Выкл 4ч-рост» / «Выкл 2ч-рост», пока таблица и доход — с ними.
    if (f.show_h4_blocked) p.set('show_h4_blocked', '1');
    if (f.show_h2_blocked) p.set('show_h2_blocked', '1');
    if (f.show_gap_blocked) p.set('show_gap_blocked', '1');   // «Gap-race» (28.09.2026)
    if (f.show_idx_blocked) p.set('show_idx_blocked', '1');   // «Выкл индекс-фильтр» (25.09.2026)
    if (f.show_ev_blocked) p.set('show_ev_blocked', '1');     // «Выкл вечер-фильтр» (№193, 20.10.2026)
    if (f.avg_down) p.set('avg_down', f.avg_down);            // «Выкл запрет усреднения шортов» (№194, 21.10.2026)
    if (f.show_ew_blocked) p.set('show_ew_blocked', '1');     // «Выкл рынок против» (№175, у всех с 21.10.2026)
    if (f.mrev_exit) p.set('mrev_exit', '1');                 // «Разворот рынка» (обкатка №188, 16.10.2026)
    if (f.arm_exit) p.set('arm_exit', f.arm_exit);            // «Ранний трейл шортов» (обкатка №190, 20.10.2026)
    if (f.wide_stop) p.set('wide_stop', '1');                 // «Стоп дальше у «Скрытого уровня»» (обкатка №196)
    if (f.build) p.set('build', f.build);      // сборка витрины (теневая «уровни на день»)
    if (f.fut) p.set('fut', '1');              // режим «Фьючи» (11.10.2026)
    if (f.fut_liquid) p.set('fut_liquid', '1');
    if (f.fut_illiquid) p.set('fut_illiquid', '1');   // «Фьючи-неликв»
    var _cq = _commissionQuery();              // поле «Комиссия брокера» (админские виды)
    if (_cq.commission) p.set('commission', _cq.commission);
    if (STATE.unitsPct) p.set('units', 'pct');
    if (_setupsView()) p.set('view', 'setups');            // вид «Сетапы»: полосы плюс / минус (27.10.2026)
    p.set('pos_size', String(STATE.posSize || 20000));
    p.set('netting', _nettingOn() ? '1' : '0');
    if (!STATE.depoAuto && STATE.rubDeposit && !_investedView()) p.set('deposit', String(STATE.rubDeposit));
    if (STATE.mode === 'user') p.set('view_as', 'user');
    return p;
  }

  // ── Плашка лидера вида «Сетапы» (27.10.2026, решение владельца) ──────────────────────────────────────────────────
  // Плашка открывает «Детекторы» на прошлой неделе, поэтому считается по тем же числам: все детекторы (как вкладка) и
  // ТФ её переключателя «1ч · 4ч · Оба». Сервер в «Сетапах» лидера не шлёт: его лента — набор сайдбара. Данные — ответ
  // вкладки за прошлую неделю (_detQuery('prev')): берём из запроса вкладки, если она его уже сделала, иначе свой тихий
  // запрос (без затемнения страницы). Ключ — строка запроса: сменились фильтры — новый запрос.
  var _ideasPrev = { q: null, dc: null, busy: null };
  function _ideasPrevKey(p) { return p.toString() + '#' + _isoD(_weekMonday()); }   // «прошлая» — от текущей недели
  function _ideasPrevKeep(p, dc) {
    if (!_setupsView() || !p || p.get('det_period') !== 'prev') return;
    _ideasPrev = { q: _ideasPrevKey(p), dc: dc, busy: null };
  }
  function _ideasLeaderRefresh() {
    if (!_setupsView()) return;
    var p = _detQuery('prev'), q = _ideasPrevKey(p);
    if (_ideasPrev.q === q || _ideasPrev.busy === q) return;
    _ideasPrev.busy = q;
    fetch('/api/setups?' + p.toString())
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (_ideasPrev.busy !== q) return;         // за время запроса фильтры сменились
        _ideasPrev = { q: q, dc: (j && j.netting && j.netting.detectors) || null, busy: null };
        renderDetLeader();
      })
      .catch(function () { if (_ideasPrev.busy === q) _ideasPrev.busy = null; });
  }
  /** Лидер прошлой недели по данным вкладки: наибольшая сумма процентов сетапов детектора (плюс и минус) на ТФ
   *  переключателя; неделя целиком убыточна — «потерял меньше всех», как у портфеля. Сделок нет — плашки нет. */
  function _ideasLeader() {
    var dc = _ideasPrev.dc;
    if (!dc || !dc.split || _ideasPrev.q !== _ideasPrevKey(_detQuery('prev'))) return null;
    var best = null, tot = 0;
    (dc.series || []).forEach(function (s) {
      var v = _detTfPart(s), n = v.n_plus + v.n_minus;
      if (!n) return;
      var pct = v.plus + v.minus;
      tot += pct;
      if (!best || pct > best.pct) best = { type: s.type, pct: pct, trades: n };
    });
    if (!best) return null;
    return { type: best.type, pct: best.pct, trades: best.trades, positive: best.pct > 0, total_pct: tot,
             since: dc.since, until: dc.until, tf: STATE.detTf || 'both' };
  }

  // Периоды вкладки «Детекторы». В «Сетапах» вместо «Прошлой недели» — листалка недель «‹ 20–26.10 ›» (27.10.2026, решение
  // владельца: следить за детекторами по неделям): стрелками — назад до первой недели ленты (dc.feed_start), вперёд — до
  // прошлой недели (текущая — «Эта неделя»); полосы и высота те же, меняются числа. Неделя — det_period=w:<понедельник>.
  function _isoD(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function _dIso(iso) { var a = String(iso).slice(0, 10).split('-'); return new Date(+a[0], +a[1] - 1, +a[2]); }
  function _addD(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function _weekRangeTxt(monIso) {
    var a = _dIso(monIso), b = _addD(a, 6);
    var dd = function (d) { return String(d.getDate()).padStart(2, '0'); };
    var mm = function (d) { return String(d.getMonth() + 1).padStart(2, '0'); };
    return (a.getMonth() === b.getMonth() ? dd(a) : dd(a) + '.' + mm(a)) + '\u2013' + dd(b) + '.' + mm(b);
  }
  function _detPeriodHtml(dc) {
    var p = String(STATE.detPeriod || 'all');
    var b = function (key, txt, title) {
      return '<button type="button" class="' + (p === key ? 'active' : '') + '" onclick="setDetPeriod(\'' + key + '\')"'
           + (title ? ' title="' + title + '"' : '') + '>' + txt + '</button>';
    };
    if (!_setupsView()) {
      return '<div class="det-period">' + b('week', 'Эта неделя', 'С понедельника текущей недели')
           + b('prev', 'Прошлая неделя', 'Полная прошлая календарная неделя (пн–вс)') + b('all', 'Всё') + '</div>';
    }
    var prevMon = _isoD(_addD(_weekMonday(), -7));
    var on = (p === 'prev' || p.indexOf('w:') === 0);
    var shown = (p.indexOf('w:') === 0) ? p.slice(2, 12) : prevMon;
    var key = function (mon) { return mon === prevMon ? 'prev' : 'w:' + mon; };
    var back = _isoD(_addD(_dIso(shown), -7)), fwd = _isoD(_addD(_dIso(shown), 7));
    var fs = (dc && dc.feed_start) ? _dIso(dc.feed_start) : null;
    var first = fs ? _isoD(_addD(fs, -((fs.getDay() + 6) % 7))) : null;     // понедельник первой недели ленты
    var arrow = function (ok, to, txt, title) {
      return '<button type="button" class="det-week-arrow"' + (ok ? ' onclick="setDetPeriod(\'' + key(to) + '\')"' : ' disabled')
           + ' title="' + title + '">' + txt + '</button>';
    };
    return '<div class="det-period">' + b('week', 'Эта неделя', 'С понедельника текущей недели')
         + '<span class="det-week-nav">' + arrow(!first || back >= first, back, '\u2039', 'Неделей раньше')
         + '<button type="button" class="det-week-lbl' + (on ? ' active' : '') + '" onclick="setDetPeriod(\'' + key(shown) + '\')"'
         + ' title="Календарная неделя (пн–вс) по дню выхода сделок; стрелками — соседние недели">' + _weekRangeTxt(shown)
         + '</button>' + arrow(fwd <= prevMon, fwd, '\u203a', 'Неделей позже') + '</span>'
         + b('all', 'Всё') + _detTfHtml() + '</div>';
  }

  // ТФ «Детекторов» вида «Сетапы» (27.10.2026, решение владельца): «1Ч · 4Ч · Оба» — только для полос и плашки лидера,
  // ТФ сайдбара по-прежнему отвечают за витрину. Складывает страница из ответа вкладки (поле tf у детектора) — без
  // запроса; выбор — в настройках (setups.ui.detTf).
  function _detTfHtml() {
    var cur = STATE.detTf || 'both';
    var tb = function (key, txt, title) {
      return '<button type="button" class="' + (cur === key ? 'active' : '') + '" data-dettf="' + key + '"'
           + ' onclick="setDetTf(\'' + key + '\')" title="' + title + '">' + txt + '</button>';
    };
    return '<span class="det-tf">' + tb('1h', TF_LABEL['1h'], 'Сетапы на часовых свечах')
         + tb('4h', TF_LABEL['4h'], 'Сетапы на 4-часовых свечах') + tb('both', 'Оба', 'Сетапы обоих таймфреймов') + '</span>';
  }
  function setDetTf(tf) {
    tf = (tf === '1h' || tf === '4h') ? tf : 'both';
    if ((STATE.detTf || 'both') === tf) return;
    STATE.detTf = tf;
    savePrefs('setups.ui', extractUIForPrefs());
    if (_detResp && STATE.detChart) renderDetectors(_detResp.dc, _detResp.sum);
    renderDetLeader();
  }
  /** Полосы детектора на ТФ переключателя: «Оба» — итог детектора, иначе его разбивка по ТФ (detector_split, поле tf). */
  function _detTfPart(s) {
    var tf = STATE.detTf || 'both';
    var v = (tf === 'both') ? (s || {}) : (((s || {}).tf || {})[tf] || {});
    return { plus: Number(v.plus) || 0, n_plus: Number(v.n_plus) || 0,
             minus: Number(v.minus) || 0, n_minus: Number(v.n_minus) || 0 };
  }

  function renderDetectors(dc, sum) {
    var dv = document.getElementById('det-view');
    if (!dv) return;
    var per = _detPeriodHtml(dc);
    // Вид «IMOEX» (блок «Набор против IMOEX», 16.10.2026) — когда сервер его прислал (settings.SETUPS_BENCH_MODE: сейчас
    // обкатка под админом). Ключа нет — переключателя нет, только кривые; null — блок включён, а данных за период ещё
    // нет. Виды взаимоисключающие (решение владельца: два блока друг под другом заставляли скроллить), переключатель
    // «Детекторы / IMOEX» — слева от кнопок периода; ответ один на оба вида — переключение без запроса (setDetView).
    _detResp = { dc: dc, sum: sum };
    _benchDestroy();
    var bv = (sum && ('vs_imoex' in sum)) ? sum.vs_imoex : undefined;
    var view = (bv !== undefined && STATE.detView === 'imoex') ? 'imoex' : 'det';
    _syncDetView(bv !== undefined, view);
    if (view === 'imoex') {                  // только «Всё»: кнопок периода и других переключателей нет (решение владельца)
      dv.innerHTML = _benchHtml(bv);
      _benchMount(bv);
      return;
    }
    if (dc && dc.split) {                     // вид «Сетапы» (27.10.2026): полосы плюс / минус по детекторам сайдбара
      dv.innerHTML = per + _detBarsHtml(dc);
      return;
    }
    if (!dc || !(dc.series || []).length) {
      dv.innerHTML = per + '<div class="det-empty">За выбранный период закрытых сделок нет</div>';
      return;
    }
    // Серии — в порядке строк сайдбара (легенда и порядок рисования кривых), а не по итогу, как их
    // сортирует сервер (ему порядок нужен для плашки лидера). См. _detSlots.
    _detLast = Object.assign({}, dc, { series: _detOrderSeries(dc.series) });
    dv.innerHTML = per + _detChartSvg(_detLast) + _detLegend(_detLast) + _detNote(_detLast, sum);
    _bindDetLegend();
  }

  // «Детекторы» вида «Сетапы» (27.10.2026, решение владельца): у каждого детектора — сумма процентов сделок в плюсе
  // (зелёная полоса вправо) и в минусе (красная влево) с числом сделок, как в легенде портфеля; итогов нет. Подписи —
  // вплотную к концу полосы: справа от зелёной «+X% N сд.», слева от красной «N сд. −X%» (проценты у полосы). Строки — все
  // детекторы, доступные смотрящему (сервер считает их все, набор сайдбара не шлём), в порядке сайдбара; ТФ — переключателя
  // вкладки (_detTfPart). Детектор, выключенный в сайдбаре на этом ТФ, — с приглушённым именем (на витрине его сетапов
  // нет); без сделок за период — «0 сд.», поэтому состав и высота не зависят от периода. Масштаб — наибольшая полоса
  // (доля --w от наибольшей длины полосы --det-bar-max, setups-page.css). Данные — setups_netting.detector_split.
  function _detBarsHtml(dc) {
    var by = {}, seen = {};
    (dc.series || []).forEach(function (s) { by[s.type] = s; });
    var slots = _detSlots().filter(function (sl) { return sl.type in by; });
    slots.forEach(function (sl) { seen[sl.type] = 1; });
    (dc.series || []).forEach(function (s) { if (!seen[s.type]) slots.push({ type: s.type }); });
    var vals = {}, mx = 0;
    slots.forEach(function (sl) {
      var v = vals[sl.type] = _detTfPart(by[sl.type]);
      mx = Math.max(mx, v.plus, -v.minus);
    });
    var pct = function (v) { return (v > 0 ? '+' : '−') + Math.abs(v).toFixed(2) + '%'; };
    var frac = function (v) { return mx > 0 ? (Math.abs(v) / mx).toFixed(4) : '0'; };
    var note = function (txt) { return '<span class="det-bar-val pos"><span class="det-bar-n">' + txt + '</span></span>'; };
    var track = function (side, v, n) {
      if (!n) return '<div class="det-bar-track ' + side + '"></div>';
      var p = '<span class="det-bar-pct">' + pct(v) + '</span>', c = '<span class="det-bar-n">' + n + NBSP + 'сд.</span>';
      var lbl = '<span class="det-bar-val ' + side + '">' + (side === 'neg' ? c + p : p + c) + '</span>';
      var bar = '<span class="det-bar ' + side + '" style="--w:' + frac(v) + '" title="' + n + NBSP + 'сд. в '
              + (side === 'pos' ? 'плюсе' : 'минусе') + ': ' + pct(v) + '"></span>';
      return '<div class="det-bar-track ' + side + '">' + (side === 'neg' ? lbl + bar : bar + lbl) + '</div>';
    };
    var rows = slots.map(function (sl) {
      var col = SETUP_NAME_COLOR[sl.type] || '#e6edf2';
      var inSet = _detInSet(sl.type);
      var name = '<div class="det-bar-name' + (inSet ? '' : ' off') + '"'
               + (inSet ? '' : ' title="Выключен в фильтрах слева: на витрине сетапов этого детектора нет"') + '>'
               + '<span class="det-leg-dot" style="background:' + col + '"></span>'
               + '<span style="color:' + col + '">' + _detUiName(sl.type) + '</span></div>';
      var s = vals[sl.type];
      var none = !s.n_plus && !s.n_minus;
      return '<div class="det-bar-row' + (none ? ' none' : '') + '" data-dettype="' + sl.type + '">' + name
           + track('neg', s.minus, s.n_minus) + '<div class="det-bar-axis"></div>'
           + (none ? '<div class="det-bar-track pos">' + note('0' + NBSP + 'сд.') + '</div>' : track('pos', s.plus, s.n_plus))
           + '</div>';
    });
    return '<div class="det-bars">' + rows.join('') + '</div>';
  }
  /** Включён ли детектор в сайдбаре на ТФ переключателя «Детекторов» («Оба» — на любом ТФ). Строки сайдбара — в
   *  UI-именах, полосы — в именах журнала (варианты уже сложены сервером в основной детектор). */
  function _detInSet(dbType) {
    var row = document.querySelector('#f-triggers .sb-tt-row[data-tt="' + _dbToUiTT(dbType) + '"]');
    if (!row) return false;
    var tf = STATE.detTf || 'both';
    return !!row.querySelector('input[type="checkbox"][data-tt]' + (tf === 'both' ? '' : '[data-tf="' + tf + '"]')
                               + ':checked');
  }

  // Переключатель вида — под табами (#det-view-toggle в setups.html, решение владельца 16.10.2026): общий каркас кнопок
  // страницы (.units-toggle, как «₽ / %» и «Акции / Фьючи»), уменьшенный (is-mini). Виден на вкладке «Детекторы», когда
  // сервер прислал блок (класс on); заголовок раздела — по виду.
  var _detResp = null;               // последний ответ вкладки: переключение вида перерисовывает из него
  function _syncDetView(has, view) {
    var tg = document.getElementById('det-view-toggle');
    if (tg) {
      tg.classList.toggle('on', !!has);
      tg.querySelectorAll('.units-btn').forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-view') === view);
      });
    }
    var st = _tableTitleEl();
    if (STATE.detChart && st && st.childNodes[0]) {
      st.childNodes[0].nodeValue = (view === 'imoex') ? 'Сетапы против IMOEX' : 'Доходность детекторов';
    }
  }
  function setBenchUnit(u) {
    u = (u === 'inv') ? 'inv' : 'dep';
    if (STATE.benchUnit === u) return;
    STATE.benchUnit = u;
    if (_detResp && STATE.detChart) renderDetectors(_detResp.dc, _detResp.sum);
  }
  function setDetView(v) {
    v = (v === 'imoex') ? 'imoex' : 'det';
    if (STATE.detView === v) return;
    STATE.detView = v;
    // «IMOEX → Детекторы» — график «Всё», как у вида IMOEX (16.10.2026): другой период кривых — новый запрос вкладки
    if (v === 'det' && STATE.detChart && STATE.detPeriod !== 'all') {
      STATE.detPeriod = 'all';
      var dv = document.getElementById('det-view');
      if (dv) dv.innerHTML = '<div class="det-empty">Загружаю…</div>';
      _syncDetView(true, 'det');
      fetchDetectors();
      return;
    }
    if (_detResp && STATE.detChart) renderDetectors(_detResp.dc, _detResp.sum);
  }

  // ── Блок «Набор против IMOEX» (16.10.2026, решение владельца) ─────────────────────────────────────────────
  // Доход счёта витрины с выбранными фильтрами в % депозита против тех же денег в IMOEX: проценты детекторов
  // (сумма процентов сделок на позицию) с ходом индекса сравнивать нельзя. Счёт — как в отчёте брокера на конец
  // дня: закрытые сделки — итогом, открытые — по цене закрытия основной сессии. Всё считает сервер
  // (setups_netting.vs_index, web_app._bench_vs_imoex), страница только рисует. Chart.js грузится лениво со своего
  // сервера (__SETUPS_CFG__.chartjs ← web_app.CHARTJS_SRC), только когда открыт вид «IMOEX».
  var _benchChart = null, _benchJs = null, _benchSeq = 0, _benchRetry = null;
  // Цвета линий (--accent и --text2 палитры) тройками RGB: из них же — градиент заливки к нулю
  var BENCH_SET_RGB = '87,165,255', BENCH_IDX_RGB = '138,147,158';

  function _benchPct(v, unit) {
    var n = Number(v) || 0;
    return (n > 0 ? '+' : (n < 0 ? '\u2212' : '')) + Math.abs(n).toFixed(2) + (unit || '%');
  }
  function _benchDay(iso) { return iso ? iso.slice(8, 10) + '.' + iso.slice(5, 7) : ''; }

  // Только «% вложенного» в блоке «Набор против IMOEX»: вид «на вложенные» (16.10.2026) и режим «%» (23.10.2026 — депозита
  // там нет, сервер считает блок с базой 100 единиц).
  function _benchInvOnly() {
    return _investedView() || !!STATE.unitsPct;
  }

  function _benchHtml(v) {
    if (!v) {
      return '<div class="det-bench"><div class="det-bench-msg">Данных за период ещё нет: первая точка '
           + 'появится после первого часа основной сессии.</div></div>';
    }
    if (v.pending || (_benchInvOnly() && !v.inv)) {   // вид «на вложенные» без ряда inv — «% депозита» не показываем
      return '<div class="det-bench"><div class="det-bench-msg">Пересчитываю счёт для сравнения — '
           + 'через минуту обновлю сам.</div></div>';
    }
    var cls = function (n) { return n > 0 ? ' pos' : (n < 0 ? ' neg' : ''); };
    var _iv = _benchInvOnly();       // вид «на вложенные» и режим «%»: только «% вложенного», без переключателя
    var inv = ((_iv || STATE.benchUnit === 'inv') && v.inv) ? v.inv : null;   // режим «% вложенного» (сервер прислал ряд)
    var card = function (lbl, val, c, sub, tip) {
      return '<div class="det-bench-card"' + (tip ? ' title="' + tip + '"' : '') + '>'
           + '<div class="det-bench-lbl">' + lbl + '</div>'
           + '<div class="det-bench-val' + c + '">' + val + '</div>'
           + (sub ? '<div class="det-bench-sub">' + sub + '</div>' : '') + '</div>';
    };
    var NB = '\u00A0';
    var mln = function (x) { return (Number(x || 0) / 1e6).toFixed(2) + NB + 'млн' + NB + '₽'; };
    var setTot = inv ? inv.set_total : v.set_total, alpha = inv ? inv.alpha : v.alpha, setDd = inv ? inv.set_dd : v.set_dd;
    var cards = (inv
                 ? card('Набор, % вложенного', _benchPct(setTot), cls(setTot),
                        (STATE.unitsPct ? 'в сделках в среднем ' + (Number(inv.cap_avg || 0) / 100).toFixed(1)
                                          + NB + 'позиций в день'
                                        : 'в сделках в среднем ' + mln(inv.cap_avg) + ' в день'),
                        'Доход на деньги, реально стоявшие в сделках: доход каждого дня делится на наибольшую сумму, '
                        + 'одновременно занятую в сделках за этот день ('
                        + (STATE.unitsPct ? 'в среднем ' + (Number(inv.cap_avg || 0) / 100).toFixed(1) + ' позиций, до '
                                            + (Number(inv.cap_max || 0) / 100).toFixed(0) + ' — сделки одного размера'
                                          : 'в среднем ' + mln(inv.cap_avg) + ', до ' + mln(inv.cap_max))
                        + '), дни сцепляются — как у индекса.')
                 : card('Набор, % депозита', _benchPct(setTot), cls(setTot),
                        'закрытые ' + _benchPct(v.closed) + ' · переоценка ' + _benchPct(v.open),
                        'Изменение стоимости счёта за период. Закрытые — итог сделок, закрытых в периоде (как в «Истории '
                        + 'недель»). Переоценка — изменение стоимости открытых позиций: позиция, открытая до периода, '
                        + 'входит в него по цене на его начало. Открыто сейчас: ' + (v.open_n || 0) + '.'))
              + card('IMOEX', _benchPct(v.idx_total), cls(v.idx_total),
                     'от закрытия ' + _benchDay(v.idx_base_day) + (v.as_of ? ' до ' + v.as_of : ''))
              + card('Альфа vs IMOEX', _benchPct(alpha, NB + 'п.п.'), cls(alpha), 'набор − IMOEX')
              + card('Просадка набора', (setDd > 0 ? '\u2212' : '') + Number(setDd || 0).toFixed(2) + '%', '',
                     inv ? 'от пика дохода на вложенное' : 'от пика стоимости счёта')
              + card('Просадка IMOEX', (v.idx_dd > 0 ? '\u2212' : '') + Number(v.idx_dd || 0).toFixed(2) + '%', '',
                     'от пика закрытий');
    // Легенда без галочек; справа — единицы набора (решение владельца 16.10.2026: «% депозита | % вложенного» в строке
    // легенды — меняет только этот график и карточки). Без ряда «% вложенного» в ответе (запись до правки) — без него.
    var ub = function (u, label, tip) {
      return '<button type="button" class="units-btn' + (((inv ? 'inv' : 'dep') === u) ? ' active' : '') + '" data-unit="'
           + u + '" role="tab" title="' + tip + '" onclick="setBenchUnit(\'' + u + '\')">' + label + '</button>';
    };
    var leg = '<div class="det-bench-leg">'
            + '<span class="det-bench-li"><span class="det-bench-sw"></span>Сетапы</span>'
            + '<span class="det-bench-li"><span class="det-bench-sw idx"></span>IMOEX</span>'
            + ((v.inv && !_iv) ? '<div class="units-toggle is-mini det-bench-unit" id="det-bench-unit" role="tablist">'
                       + ub('dep', '% депозита', 'Что стало со всеми деньгами счёта, как в /invest: результат к депозиту')
                       + ub('inv', '% вложенного', 'Доход на деньги, реально стоявшие в сделках: по дням, как индекс')
                       + '</div>' : '')
            + '</div>';
    var dep = Math.round(Number(v.deposit) || 0).toLocaleString('ru-RU') + NB + '₽';
    var note = '<div class="det-bench-note">'
             + (inv
                // текст владельца (16.10.2026, вечер); дата начала IMOEX — на карточке индекса
                ? 'Кривая «Сетапы»' + NB + '— доход на' + NB + 'деньги, вложенные в' + NB + 'сделки витрины с' + NB
                  + 'выбранными фильтрами (закрытые сделки и' + NB + 'переоценка открытых по' + NB + 'цене закрытия '
                  + 'основной сессии) относительно наибольшей суммы, одновременно занятой в' + NB + 'сделках.'
                : 'Набор — изменение стоимости счёта витрины с' + NB + 'выбранными фильтрами в' + NB
                  + '% депозита ' + dep + ': закрытые сделки — итогом, открытые — по' + NB + 'цене закрытия основной '
                  + 'сессии дня. IMOEX — те же деньги в' + NB + 'индексе от' + NB + 'закрытия ' + _benchDay(v.idx_base_day)
                  + ' (официальное закрытие основной сессии).')
             + (v.as_of ? ' Сегодня — на' + NB + v.as_of + NB + 'МСК.' : '')
             + (v.unmarked ? '<br>⚠ Без цены на' + NB + 'конец периода: ' + v.unmarked
                             + ' откр. поз. — в' + NB + 'оценку не вошли.' : '')
             + '</div>';
    return '<div class="det-bench"><div class="det-bench-cards">' + cards + '</div>' + leg
         + '<div class="det-bench-plot"><canvas id="det-bench-cv" role="img" aria-label="Сетапы '
         + _benchPct(setTot) + (inv ? ' вложенного' : ' депозита') + ', IMOEX ' + _benchPct(v.idx_total)
         + ' за период"></canvas></div>'
         + note + '</div>';
  }

  function _benchChartJs() {
    if (window.Chart) return Promise.resolve(window.Chart);
    if (_benchJs) return _benchJs;
    var src = (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.chartjs) || '';
    if (!src) return Promise.reject(new Error('Chart.js: адрес не задан'));
    _benchJs = new Promise(function (ok, fail) {
      var el = document.createElement('script');
      el.src = src;
      el.async = true;
      el.onload = function () { if (window.Chart) ok(window.Chart); else { _benchJs = null; fail(new Error('Chart.js')); } };
      el.onerror = function () { _benchJs = null; fail(new Error('Chart.js не загрузился')); };
      document.head.appendChild(el);
    });
    return _benchJs;
  }

  function _benchDestroy() {
    _benchSeq++;
    if (_benchRetry) { clearTimeout(_benchRetry); _benchRetry = null; }
    if (_benchChart) { try { _benchChart.destroy(); } catch (e) { /* холст уже снят */ } _benchChart = null; }
  }

  // После вставки разметки: «пересчитывается» — один повтор запроса вкладки; данные — график и галочки.
  function _benchMount(v) {
    if (v && v.pending) {
      var per = STATE.detPeriod;
      _benchRetry = setTimeout(function () {
        _benchRetry = null;
        if (STATE.detChart && STATE.detPeriod === per) fetchDetectors();
      }, 20000);
      return;
    }
    if (!v || !(v.days || []).length) return;
    var seq = _benchSeq;
    _benchChartJs().then(function (Chart) {
      if (seq !== _benchSeq) return;                // за время загрузки вкладку перерисовали
      var cv = document.getElementById('det-bench-cv');
      if (cv) _benchDraw(Chart, cv, v);
    }).catch(function () {
      if (seq !== _benchSeq) return;
      var plot = document.querySelector('#det-view .det-bench-plot');
      if (plot) plot.outerHTML = '<div class="det-bench-msg">График не загрузился — обновите страницу.</div>';
    });
  }

  // Заливка линии к нулю — градиентом, как у кривой детектора в фокусе (решение владельца 16.10.2026): прозрачность
  // DET_FILL_ALPHA на экстремуме линии, у нуля 0, зеркально вниз (см. _detChartSvg). Пересчитывается при каждом
  // обновлении графика (шкала меняется вместе с размером холста).
  function _benchFill(rgb) {
    return function (ctx) {
      var ch = ctx.chart, ys = ch.scales && ch.scales.y;
      if (!ch.chartArea || !ys) return 'transparent';
      var vmax = 0;
      (ch.data.datasets[ctx.datasetIndex].data || []).forEach(function (x) {
        if (Math.abs(x) > vmax) vmax = Math.abs(x);
      });
      if (!(vmax > 0)) return 'transparent';
      var g = ch.ctx.createLinearGradient(0, ys.getPixelForValue(vmax), 0, ys.getPixelForValue(-vmax));
      g.addColorStop(0, 'rgba(' + rgb + ',' + DET_FILL_ALPHA + ')');
      g.addColorStop(0.5, 'rgba(' + rgb + ',0)');
      g.addColorStop(1, 'rgba(' + rgb + ',' + DET_FILL_ALPHA + ')');
      return g;
    };
  }

  function _benchDraw(Chart, cv, v) {
    // Первая точка — закрытие перед периодом: обе линии стартуют с нуля (одни и те же деньги).
    var days = [v.idx_base_day].concat(v.days);
    var setS = [0].concat(((_benchInvOnly() || STATE.benchUnit === 'inv') && v.inv) ? v.inv.set : v.set),
        idxS = [0].concat(v.idx);
    var font = { family: "'JetBrains Mono', monospace", size: 11 };
    _benchChart = new Chart(cv, {
      type: 'line',
      data: {
        labels: days.map(_benchDay),
        datasets: [
          // «Сетапы» — имя линии в подсказке и легенде (решение владельца 16.10.2026, вечер; было «Набор»)
          { label: 'Сетапы', data: setS, borderColor: 'rgb(' + BENCH_SET_RGB + ')', borderWidth: 2,
            backgroundColor: _benchFill(BENCH_SET_RGB), fill: 'origin',
            pointBackgroundColor: 'rgb(' + BENCH_SET_RGB + ')', pointBorderColor: 'rgb(' + BENCH_SET_RGB + ')',
            pointRadius: 0, pointHoverRadius: 3, tension: 0 },
          // IMOEX — сплошная тонкая линия толщиной кривой детектора (DET_W; решение владельца 16.10.2026: не пунктир)
          { label: 'IMOEX', data: idxS, borderColor: 'rgb(' + BENCH_IDX_RGB + ')', borderWidth: parseFloat(DET_W),
            backgroundColor: _benchFill(BENCH_IDX_RGB), fill: 'origin',
            pointBackgroundColor: 'rgb(' + BENCH_IDX_RGB + ')', pointBorderColor: 'rgb(' + BENCH_IDX_RGB + ')',
            pointRadius: 0, pointHoverRadius: 3, tension: 0 }
        ]
      },
      options: {
        responsive: true, maintainAspectRatio: false, animation: false,
        interaction: { mode: 'index', intersect: false },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              title: function (it) {
                var i = it.length ? it[0].dataIndex : 0, d = days[i] || '';
                return d.slice(8, 10) + '.' + d.slice(5, 7) + '.' + d.slice(0, 4) + (i === 0 ? ' — начало' : '');
              },
              label: function (c) { return c.dataset.label + ': ' + _benchPct(c.parsed.y); },
              footer: function (it) {
                if (!it.length) return '';
                var i = it[0].dataIndex;
                return 'Альфа: ' + _benchPct(setS[i] - idxS[i], '\u00A0п.п.');
              }
            }
          }
        },
        scales: {
          x: { grid: { display: false }, ticks: { color: '#9aa4b0', font: font, maxRotation: 0, autoSkipPadding: 14 } },
          // шкала справа (решение владельца 16.10.2026): взгляд идёт к свежему результату — к правому краю
          y: {
            position: 'right',
            grid: { color: function (c) { return c.tick && c.tick.value === 0 ? 'rgba(255,255,255,0.55)' : 'rgba(255,255,255,0.07)'; } },
            ticks: { color: '#9aa4b0', font: font,
                     callback: function (val) {
                       return (val > 0 ? '+' : (val < 0 ? '\u2212' : '')) + (Math.round(Math.abs(val) * 100) / 100) + '%';
                     } }
          }
        }
      }
    });
  }

  // Порядок легенды — порядок строк сайдбара «Тип детектора», а не итог (30.09.2026, репорт
  // владельца): при сортировке по итогу включение или выключение любого детектора перетасовывало
  // всю легенду — через общий счёт меняются и чужие итоги. Место детектора в легенде постоянное:
  // выключенный в сайдбаре остаётся приглушённой строкой «выкл», включённый без закрытых сделок
  // в периоде — строкой «0 сд.», поэтому соседи не сдвигаются. Набор и порядок берутся из самих
  // строк сайдбара (у не-админа там нет детекторов на обкатке) — своего списка здесь нет.
  function _detSlots() {
    var out = [];
    document.querySelectorAll('#f-triggers .sb-tt-row[data-tt]').forEach(function (row) {
      var ui = row.dataset.tt;
      out.push({ type: _UI_TO_DB_TT_MAP[ui] || ui,
                 on: !!row.querySelector('input[type="checkbox"][data-tt]:checked') });
    });
    return out;
  }
  function _detOrderSeries(series) {
    var pos = {};
    _detSlots().forEach(function (s, i) { pos[s.type] = i; });
    return (series || []).map(function (s, i) { return { s: s, i: i }; })
      .sort(function (a, b) {
        var pa = (a.s.type in pos) ? pos[a.s.type] : 1e6 + a.i;   // детектора нет в сайдбаре — в конец
        var pb = (b.s.type in pos) ? pos[b.s.type] : 1e6 + b.i;
        return pa - pb;
      })
      .map(function (x) { return x.s; });
  }

  // Кумулятив считаем здесь: сервер отдаёт дневной вклад, а нарастающий итог —
  // представление (и его же надо пересчитывать при скрытии кривой из легенды).
  function _detCumulative(dc) {
    return (dc.series || []).map(function (s) {
      var acc = 0, st = s.start || 0;
      // До первого дня детектора точек нет (null): детектор, выведенный в
      // августе, не должен тянуть плоскую линию с начала ленты.
      return { type: s.type, trades: s.trades, total: s.total_pct, start: st,
               pts: (s.pct || []).map(function (v, i) {
                 if (i < st) return null;
                 acc += v; return acc;
               }) };
    });
  }

  // Круглый шаг делений оси Y: 1 / 2 / 2.5 / 5 × 10^k, ~target интервалов на диапазон.
  function _detNiceStep(range, target) {
    var raw = range / (target || 6);
    var mag = Math.pow(10, Math.floor(Math.log10(raw)));
    var norm = raw / mag;
    return (norm <= 1 ? 1 : norm <= 2 ? 2 : norm <= 2.5 ? 2.5 : norm <= 5 ? 5 : 10) * mag;
  }

  function _detChartSvg(dc) {
    // Рисуем под ФАКТИЧЕСКУЮ ширину контейнера, а не в условный viewBox с
    // растяжением: `preserveAspectRatio="none"` сплющивал график на узком экране
    // (390 px → высота 118) и искажал бы подписи.
    var host = document.getElementById('det-view');
    var W = Math.max(320, Math.round((host && host.clientWidth) || 900) - 24);
    var H = W < 620 ? 240 : 320;
    var PL = W < 620 ? 40 : 52, PR = 12, PT = 12, PB = 26;
    var all = _detCumulative(dc);
    var lines = all.filter(function (s) { return !_detHidden[s.type]; });
    var days = dc.days || [];
    if (!lines.length || days.length < 2) return '<div class="det-empty">Мало данных для графика</div>';
    // Шкала — по ВСЕМ детекторам периода, а не по видимым (17.09.2026, запрос владельца: ноль «скакал»):
    // скрытие кривой в легенде больше не пересчитывает шкалу. Деления круглые и всегда проходят
    // через ноль; запас сверху и снизу — до следующего деления, поэтому ноль не ложится на край.
    var lo = 0, hi = 0;
    all.forEach(function (s) {
      s.pts.forEach(function (v) {
        if (v === null) return;
        if (v < lo) lo = v; if (v > hi) hi = v;
      });
    });
    var step = _detNiceStep((hi - lo) || 1, 6);
    var pad = (hi - lo) * 0.04;
    lo = Math.floor((lo - pad) / step) * step;
    hi = Math.ceil((hi + pad) / step) * step;
    if (hi - lo < step) { lo = -step; hi = step; }
    var x = function (i) { return PL + (W - PL - PR) * (days.length < 2 ? 0 : i / (days.length - 1)); };
    var y = function (v) { return PT + (H - PT - PB) * (1 - (v - lo) / (hi - lo)); };
    var out = ['<svg class="det-chart" viewBox="0 0 ' + W + ' ' + H + '" width="' + W + '" height="' + H + '">'];
    // сетка + подписи оси Y: деления кратны шагу, ноль — среди них и подписан «0%»
    var dec = Math.abs(step - Math.round(step)) < 1e-9 ? 0 : (Math.abs(step * 10 - Math.round(step * 10)) < 1e-9 ? 1 : 2);
    for (var k = Math.round(lo / step); k <= Math.round(hi / step); k++) {
      var val = k * step, yy = y(val);
      if (k !== 0) {
        out.push('<line x1="' + PL + '" y1="' + yy.toFixed(1) + '" x2="' + (W - PR) + '" y2="' + yy.toFixed(1) +
                 '" stroke="rgba(255,255,255,0.09)" stroke-width="1"/>');
      }
      out.push('<text x="' + (PL - 6) + '" y="' + (yy + 3.5).toFixed(1) + '" text-anchor="end" ' +
               'fill="' + (k === 0 ? '#e6edf2' : '#9aa4b0') + '" font-size="11" font-family="JetBrains Mono, monospace">' +
               (k === 0 ? '0' : (val > 0 ? '+' : '\u2212') + Math.abs(val).toFixed(dec)) + '%</text>');
    }
    // Вертикальная сетка: на «Всё» — начала недель, на «Неделе» — каждый день
    // (запрос владельца 29.08). Легче горизонтальной, чтобы не спорить с кривыми.
    var vg = [], weekStarts = [];
    var prevMon = null;
    days.forEach(function (d, i) {
      var dt = new Date(d + 'T00:00:00Z');
      var mon = new Date(dt);
      mon.setUTCDate(dt.getUTCDate() - ((dt.getUTCDay() + 6) % 7));   // пн этой недели
      var key = mon.toISOString().slice(0, 10);
      if (key !== prevMon) { weekStarts.push(i); prevMon = key; }
    });
    if (STATE.detPeriod !== 'all') {        // недельные периоды: сетка по дням
      days.forEach(function (_, i) { if (i) vg.push(i); });
    } else {
      vg = weekStarts.filter(function (i) { return i > 0; });
    }
    vg.forEach(function (i) {
      out.push('<line x1="' + x(i).toFixed(1) + '" y1="' + PT + '" x2="' + x(i).toFixed(1) +
               '" y2="' + (H - PB) + '" stroke="rgba(255,255,255,0.07)" stroke-width="1" ' +
               'stroke-dasharray="3 4"/>');
    });
    // Ломаные кривых считаем здесь, до нулевой линии: из них же строится заливка,
    // а она должна лежать НИЖЕ нуля и кривых по порядку рисования.
    var paths = [];
    lines.forEach(function (s) {
      var seg = [], started = false, xa = null, xb = null;
      s.pts.forEach(function (v, i) {
        if (v === null) return;                 // детектор ещё не выведен
        var xi = x(i);
        seg.push((started ? 'L' : 'M') + xi.toFixed(1) + ' ' + y(v).toFixed(1));
        if (!started) xa = xi;
        xb = xi;
        started = true;
      });
      if (seg.length) {
        var vmax = 0;
        s.pts.forEach(function (v) { if (v !== null && Math.abs(v) > vmax) vmax = Math.abs(v); });
        paths.push({type: s.type, col: SETUP_NAME_COLOR[s.type] || '#e6edf2',
                    d: seg.join(' '), x0: xa, x1: xb, vmax: vmax});
      }
    });
    // Нулевая линия — всегда (17.09.2026, запрос владельца): тонкая, яркая белая, на пиксельной сетке,
    // под кривыми. Ноль по построению шкалы внутри диапазона.
    var y0 = Math.round(y(0)) + 0.5;
    // Заливка от кривой к нулю — ТОЛЬКО у одной кривой за раз (17.09.2026, решение владельца):
    // у кривой в фокусе (наведение на строку легенды) либо при солировании — когда в легенде
    // оставлена ровно одна кривая. У всех сразу семь полупрозрачных площадей складывались бы
    // в местах пересечений и цвет переставал бы значить детектор. Прозрачность гаснет к нулю
    // (прибыль и убыток отличаются сразу), рисуется под нулевой линией и под всеми кривыми.
    var fillType = (_detFocus && !_detHidden[_detFocus]) ? _detFocus
                 : (paths.length === 1 ? paths[0].type : null);
    var fillPath = null;
    paths.forEach(function (p) { if (p.type === fillType) fillPath = p; });
    if (fillPath && fillPath.x1 > fillPath.x0 && fillPath.vmax > 0) {
      // Нормировка по ЭКСТРЕМУМУ кривой (решение владельца): градиент идёт от её дальней от нуля
      // точки через ноль к зеркальной, поэтому прозрачность = DET_FILL_ALPHA × |значение| / |экстремум|
      // — детектор, идущий у самого нуля, закрашен так же насыщенно, как ушедший на несколько
      // процентов. Прежний градиент по всей высоте поля оставлял такие кривые почти прозрачными.
      out.push('<defs><linearGradient id="det-fill-grad" gradientUnits="userSpaceOnUse" ' +
               'x1="0" y1="' + y(fillPath.vmax).toFixed(1) + '" x2="0" y2="' + y(-fillPath.vmax).toFixed(1) + '">' +
               '<stop offset="0" stop-color="' + fillPath.col + '" stop-opacity="' + DET_FILL_ALPHA + '"/>' +
               '<stop offset="0.5" stop-color="' + fillPath.col + '" stop-opacity="0"/>' +
               '<stop offset="1" stop-color="' + fillPath.col + '" stop-opacity="' + DET_FILL_ALPHA + '"/>' +
               '</linearGradient></defs>');
      out.push('<path class="det-fill" data-det="' + fillPath.type + '" d="' + fillPath.d +
               ' L ' + fillPath.x1.toFixed(1) + ' ' + y(0).toFixed(1) +
               ' L ' + fillPath.x0.toFixed(1) + ' ' + y(0).toFixed(1) + ' Z" ' +
               'fill="url(#det-fill-grad)" stroke="none"/>');
    }
    out.push('<line class="det-zero" x1="' + PL + '" y1="' + y0 + '" x2="' + (W - PR) + '" y2="' + y0 +
             '" stroke="#ffffff" stroke-opacity="0.82" stroke-width="1" shape-rendering="crispEdges"/>');
    // Подписи оси X стоят ПОД вертикалями (правка владельца 29.08): раньше шаг
    // был равномерный по числу точек и не совпадал с линиями недель.
    // На «Всё» подписываем каждую вторую неделю (иначе 17 дат наезжают друг на
    // друга), на «Неделе» — каждый день.
    var lblIdx;
    if (STATE.detPeriod !== 'all') {        // недельные периоды: подпись у каждого дня
      lblIdx = days.map(function (_, i) { return i; });
    } else {
      // Через одну неделю (правка владельца: 06.05 → 18.05 → 01.06 …). Шаг
      // растёт только когда подписи начнут наезжать — на длинной ленте.
      var stepW = Math.max(2, Math.ceil((weekStarts.length || 1) / 10));
      lblIdx = weekStarts.filter(function (_, k) { return k % stepW === 0; });
    }
    lblIdx.forEach(function (i) {
      var d = days[i];
      if (!d) return;
      // Крайние подписи прижимаем к своей стороне — по центру они срезаются краем
      var _anc = (i === 0) ? 'start' : (i >= days.length - 2 ? 'end' : 'middle');
      out.push('<text x="' + x(i).toFixed(1) + '" y="' + (H - 8) + '" text-anchor="' + _anc + '" ' +
               'fill="#9aa4b0" font-size="11">' + d.slice(8, 10) + '.' + d.slice(5, 7) + '</text>');
    });
    paths.forEach(function (s) {
      var col = s.col;
      out.push('<path d="' + s.d + '" fill="none" stroke="' + col + '" stroke-width="' + (_detFocus === s.type ? DET_W_FOCUS : DET_W) + '" ' +
               'stroke-linejoin="round" stroke-linecap="round" shape-rendering="geometricPrecision" ' +
               'opacity="' + (_detFocus && _detFocus !== s.type ? DET_DIM_OPACITY : '1') + '"/>');
    });
    out.push('</svg>');
    return out.join('');
  }

  // Имя детектора — РОВНО такое же, как в сайдбаре «Тип детектора» (запрос
  // владельца 29.08). Обратный маппинг строим из существующего _UI_TO_DB_TT_MAP,
  // своей карты имён не заводим: разъехалась бы при добавлении детектора.
  var _DB_TO_UI_TT = null;
  function _detUiName(dbType) {
    if (!_DB_TO_UI_TT) {
      _DB_TO_UI_TT = {};
      Object.keys(_UI_TO_DB_TT_MAP).forEach(function (ui) {
        _DB_TO_UI_TT[_UI_TO_DB_TT_MAP[ui]] = ui;
      });
    }
    return _DB_TO_UI_TT[dbType] || dbType;
  }

  function _detLegend(dc) {
    var byType = {}, seen = {};
    (dc.series || []).forEach(function (s) { byType[s.type] = s; });
    var item = function (type, s, on) {
      var col = SETUP_NAME_COLOR[type] || '#e6edf2';
      var name = '<span class="det-leg-dot" style="background:' + col + '"></span>'
               + '<span class="det-leg-name" style="color:' + col + '">' + _detUiName(type) + '</span>';
      if (!s) {
        // Места без кривой (см. _detSlots): не кликаются и не подсвечиваются — прятать нечего.
        return '<div class="det-leg-item nocurve' + (on ? '' : ' off') + '" data-det="' + type + '" title="'
             + (on ? 'Закрытых сделок в выбранном периоде нет' : 'Выключен в фильтрах слева') + '">'
             + name
             + '<span class="det-leg-pct none">\u2014</span>'
             + '<span class="det-leg-n">' + (on ? '0 сд.' : 'выкл') + '</span>'
             + '</div>';
      }
      var sign = s.total_pct >= 0 ? '+' : '';
      var pcol = s.total_pct >= 0 ? 'var(--green)' : 'var(--red)';
      return '<div class="det-leg-item' + (_detHidden[type] ? ' dim' : '') + '" data-det="' + type + '">'
           + name
           + '<span class="det-leg-pct" style="color:' + pcol + '">' + sign + s.total_pct.toFixed(2) + '%</span>'
           + '<span class="det-leg-n">' + s.trades + ' сд.</span>'
           + '</div>';
    };
    var rows = _detSlots().map(function (sl) {
      seen[sl.type] = 1;
      return item(sl.type, byType[sl.type], sl.on);
    });
    // Серия детектора, которого нет в сайдбаре (не должно быть), — в конец: деньги не пропадают с экрана.
    (dc.series || []).forEach(function (s) { if (!seen[s.type]) rows.push(item(s.type, s, true)); });
    return '<div class="det-legend">' + rows.join('') + '</div>';
  }

  // ⚠ Формулировка ЗАДАНА ВЛАДЕЛЬЦЕМ (29.08) — не расширять списком уточнений,
  // как это уже случилось с подписью недельной таблицы. Меняется только база
  // процента: с 22.09.2026 это размер позиции (решение владельца), чтобы числа
  // графика читались в тех же процентах, что строки таблицы.
  function _detNote(dc, sum) {
    // В режиме «только проценты» база — 100 единиц веса, а не рубли: писать
    // «размер позиции 100 ₽» нельзя, там денег нет вовсе.
    var upct = !!STATE.unitsPct;
    var base = dc && dc.base_rub ? Number(dc.base_rub)
             : (sum && sum.pos_size ? Number(sum.pos_size) : 0);
    var pos = (!upct && base) ? Math.round(base).toLocaleString('ru-RU') + '\u00A0₽' : '';
    return '<div class="det-note">'
         + (upct && dc && dc.inv
            ? 'Нарастающий вклад каждого детектора в\u00A0доход на\u00A0вложенные (сумма детекторов за\u00A0день\u00A0— '
              + 'доход дня счёта).'
            : upct
            ? 'Нарастающая сумма процентов сделок каждого детектора.'
            : 'Нарастающий вклад каждого детектора в общий доход в\u00A0% на\u00A0размер позиции.')
         + (pos ? ' Размер позиции ' + pos + '.' : '')
         + '<br>⚠ Результат считается по\u00A0опубликованным на\u00A0витрине сетапам '
         + 'в\u00A0соответствии с\u00A0фильтрами.'
         + '<br>Набор детекторов и таймфреймов управляются фильтрами слева.'
         + '</div>';
  }

  function _bindDetLegend() {
    document.querySelectorAll('#det-view .det-leg-item:not(.nocurve)').forEach(function (el) {
      el.addEventListener('click', function () {
        var d = el.dataset.det;
        _detHidden[d] = !_detHidden[d];   // клик по легенде прячет кривую
        _detRerender();
      });
      el.addEventListener('mouseenter', function () { _detFocus = el.dataset.det; _detRerender(); });
      el.addEventListener('mouseleave', function () { _detFocus = null; _detRerender(); });
    });
  }

  // Ширина берётся у контейнера → при ресайзе перерисовываем (дебаунс).
  var _detResizeT = null;
  window.addEventListener('resize', function () {
    if (!STATE.detChart) return;
    clearTimeout(_detResizeT);
    _detResizeT = setTimeout(_detRerender, 180);
  });

  function _detRerender() {
    if (!_detLast) return;
    var dv = document.getElementById('det-view');
    if (!dv || !STATE.detChart) return;
    var svg = _detChartSvg(_detLast);
    var old = dv.querySelector('.det-chart');
    if (old) { old.outerHTML = svg; }
    dv.querySelectorAll('.det-leg-item:not(.nocurve)').forEach(function (el) {
      el.classList.toggle('dim', !!_detHidden[el.dataset.det]);
    });
  }

  function setRangeWeekly() {
    if (STATE.weekly) return;
    clearPreset();
    _exitDetectors();
    _exitDeals();
    STATE.weekly = true;
    STATE.daysBack = 14;
    document.body.classList.add('mode-weekly');
    // Режим НЕ переключаем: центральная часть и так одинакова, а смена режима
    // выбрасывала админа из режима User (репорт 28.08).
    _setRangeActive();
    fetchAndRender();
  }
  // Заголовок ТАБЛИЦЫ («Все сетапы»), а не первый .sec-title на странице: первым
  // идёт заголовок ТОП-карточек, и подмена его текстового узла давала склейку
  // «Все сетапыЛучшие завершенные сетапы» (найдено 25.08). Якорь — счётчик,
  // который лежит внутри именно табличного заголовка.
  function _tableTitleEl() {
    var c = document.getElementById('sec-count');
    return c ? c.parentNode : null;
  }
  // Выход из «Нед» → вернуть обычный вид списка (вызывается при клике на др. окно).
  function _exitWeekly() {
    if (!STATE.weekly) return;
    STATE.weekly = false;
    document.body.classList.remove('mode-weekly');
    var wv = document.getElementById('weekly-view'); if (wv) wv.style.display = 'none';
    var st = _tableTitleEl();
    if (st && st.childNodes[0]) st.childNodes[0].nodeValue = 'Все сетапы';
  }
  /** silent=true — инициализация (вызов из refreshAuthState): применяем ₽-режим,
   *  но НЕ пишем prefs. Иначе запись дефолтами (а) затирает на сервере то, что
   *  человек сохранил раньше, и (б) ставит race-guard `_prefsLocallyTouched`,
   *  из-за которого syncPrefsFromServer молча не применяет серверные настройки —
   *  на втором устройстве/после очистки кэша страница навсегда оставалась на
   *  дефолтах (репорт владельца 29.08: депозит уходил в авто). */
  function _setRubWindow(silent, keepView) {
    // Вкладка «Сделки недели» (keepView) оставляет админа в виде «User», если он в нём (16.10.2026: раньше она
    // возвращала админский вид, и просмотр пользовательской витрины сбрасывался только на этой вкладке — «История
    // недель», «История сделок» и «Детекторы» вид не меняют); кнопка «Admin» и запуск страницы — в админский ₽-вид.
    var _keep = !!keepView && STATE.mode === 'user' && !!(_authState && _authState.is_admin);
    // No-op если уже в этом ₽-окне (live, не бэктест, не weekly).
    if (!STATE.deals && !STATE.presetId && !STATE.weekly && !STATE.detChart && (STATE.mode === 'rubles' || _keep)) return;
    clearPreset();
    _exitWeekly();
    _exitDetectors();
    _exitDeals();
    STATE.daysBack = 14;
    if (STATE.mode !== 'rubles' && !_keep) applyMode('rubles');   // форсим ₽-режим (admin)
    _setRangeActive();
    if (silent) return;                 // init: prefs не трогаем, данные подтянет sync
    savePrefs('setups.ui', extractUIForPrefs());
    fetchAndRender();
  }

  // «История сделок» (05.10.2026, решение владельца; заменила «Всю историю» — та переехала в лабораторию):
  // все сделки единого счёта с начала ленты, те же, что складываются в «Историю недель». Volatile (не persist).
  function setRangeDeals() {
    if (STATE.deals) return;
    clearPreset();
    _exitWeekly();
    _exitDetectors();
    STATE.deals = true;
    STATE.dealsPage = 1;
    STATE.selectedDealsPage = null;
    document.body.classList.add('mode-deals');
    _setRangeActive();
    renderDealsLabel();
    fetchAndRender();
  }

  // Выход из «Истории сделок» (клик по другой вкладке, пресет): данные вкладки — страница истории, живой ответ
  // возвращаем сразу; свежий приедет штатным запросом вкладки.
  function _exitDeals() {
    if (!STATE.deals) return;
    STATE.deals = false;
    document.body.classList.remove('mode-deals');
    if (_liveDataCache && STATE.data !== _liveDataCache) { STATE.data = _liveDataCache; _dataGen += 1; }
    renderDealsPager(); renderDealsLabel();
  }

  // Сортировка «Истории сделок» кликом по шапке «Вход» / «Закрыт», новые сверху. Сортирует сервер (история листается
  // страницами), смена сортировки — с первой страницы; страница выбранной сделки при другой сортировке другая.
  function setDealsSort(s) {
    if (!STATE.deals || STATE.dealsSort === s) return;
    STATE.dealsSort = s;
    STATE.dealsPage = 1;
    STATE.selectedDealsPage = null;
    fetchDeals();
  }
  [['lh-time', 'entry'], ['lh-exit', 'exit']].forEach(function (p) {
    var el = document.getElementById(p[0]);
    if (el) el.addEventListener('click', function () { setDealsSort(p[1]); });
  });

  // Переход по странице «Истории сделок» — без сброса на стр.1.
  function gotoDealsPage(p) {
    const th = (STATE.data && STATE.data.trades_hist) || {};
    p = Math.max(1, Math.min(p, th.npages || 1));
    if (p === STATE.dealsPage) return;
    STATE.dealsPage = p;
    fetchDeals();
  }

  function extractUIForPrefs() {
    // Размер сделки и депозит — по режимам (11.10.2026): основные ключи — набор акций (его читают все виды и роли),
    // набор режима «Фьючи» — отдельным ключом futSizes.
    var _st = _futApplied ? (_futSizes.stock || { pos: 20000, dep: null, auto: true }) : _sizesNow();
    var _fu = _futApplied ? _sizesNow() : (_futSizes && _futSizes.fut);
    return {
      mode: STATE.mode || 'user',
      chartExpanded: document.querySelector('.layout').classList.contains('expanded'),
      days_back: STATE.daysBack,
      rubDeposit: _st.auto ? null : _st.dep,
      depoAuto: !!_st.auto,      // явный флаг: без него старое число = легаси
      posSize: _st.pos || 20000,
      depo3m: true,
      // Поле «Комиссия брокера» (admin, 08.09): число или null = дефолт SSOT.
      commission: (typeof STATE.commission === 'number' && isFinite(STATE.commission))
        ? STATE.commission : null,
      // Единицы результата (22.09.2026, admin): true — «только проценты».
      unitsPct: !!STATE.unitsPct,
      showcaseView: _splitOn() ? (STATE.unitsPct ? 'setups' : 'portfolio') : null,
      // Режим «Акции / Фьючи» (11.10.2026, admin) и размер сделки и депозит режима. futLiquid — копия галочки
      // «Фьючи-ликвид» набора «Фьючей» (он в setups.filters): по ней строится первый набор, пока своего нет.
      futMode: !!STATE.futMode,
      showGated: !!STATE.showGated,      // «Только торгуемые / Все» (20.10.2026)
      detTf: STATE.detTf || 'both',      // ТФ «Детекторов» вида «Сетапы» (27.10.2026)
      futLiquid: !!(_futApplied ? (document.getElementById('f-fut-liquid') || {}).checked
                                : (_modeFilters.fut ? _modeFilters.fut.fut_liquid : _legacyFutLiquid)),
      futSizes: _fu ? { pos: _fu.pos, dep: _fu.auto ? null : _fu.dep, auto: !!_fu.auto } : null,
    };
  }

  function updateAuthUI() {
    var el = document.getElementById('auth-bar');
    if (!el) return;
    if (_authState.is_anon) {
      el.innerHTML = '<span class="auth-info" style="color:var(--text2)">Не авторизован</span>'
        + '<a class="auth-link" onclick="showAuthPopup()">Войти</a>';
    } else {
      var name = _authState.first_name || _authState.username || 'tg-user';
      var tier = _authState.tier || 'free';
      // Эскейп имени (на случай спецсимволов в Telegram first_name)
      var safeName = String(name).replace(/[<>&"']/g, function(c) {
        return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;',"'":'&#39;'}[c];
      });
      el.innerHTML = '<span class="auth-info">' + safeName
        + ' <span class="auth-tier">· ' + tier + '</span></span>'
        + '<a class="auth-link" onclick="doLogout()">Выйти</a>';
    }
    // CTA-кнопка обновляется отдельно (нужны данные из /api/notifications/settings
    // для определения «настроены/не настроены»). Запускаем фоном:
    refreshNotifCtaState();
    _updatePremiumExpiryBanner();
    _syncReferralUI();
    _syncBotUI();
    _mnAuthReady = true;   // «Правила сейчас» и окно «рынок против открытых сделок» (20.10.2026): роль известна
    _mnSync();
    _syncGatedUI();        // «Только торгуемые / Все» — по роли (20.10.2026)
  }

  // ── Ссылки друзей и партнёров (01.10.2026, referrals.py / partners.py) ──────
  // Правила задаёт сервер: аккаунт, пришедший по ссылке друга /r/<код> или партнёра /p/<код>, привязан
  // к ней на 12 месяцев, и к каждой его оплате — подарок Premium (к месяцу — неделя, к году — 3 месяца;
  // подписи приходят с сервера). Здесь только вид: кнопка «Подарок» (referral.program из
  // /api/auth/status — в режиме обкатки только админу), окно со ссылкой и баннеры пришедшего
  // (referral.pending — аноним по ссылке, referral.invite — вошедший, привязанный к ссылке).
  // Элементы создаются отсюда: разметку страницы не трогаем.
  function _refInfo() { return (_authState && _authState.referral) || null; }
  function _refPending() {
    var r = _refInfo();
    return !!(r && r.pending && _authState.is_anon);
  }
  // Баннер подарка вошедшему: только пока у него нет оплаченной подписки (invite.show с сервера).
  function _refInviteShow() {
    var r = _refInfo();
    return !!(r && r.invite && r.invite.show && !_authState.is_anon);
  }
  // «+неделя к месяцу, +3 месяца к году» — подпись подарка с сервера
  function _refGiftLine(info) {
    return (info && info.text && info.text.line) || '';
  }
  function _refBanner(id, onclick, cta) {
    var el = document.getElementById(id);
    if (el) return el;
    var anchor = document.getElementById('anon-banner');
    if (!anchor || !anchor.parentNode) return null;
    el = document.createElement('div');
    el.className = 'anon-banner tone-accent';
    el.id = id;
    el.style.display = 'none';
    el.onclick = onclick;
    el.innerHTML = '<div class="anon-banner-text"><span class="anon-banner-lock">🎁</span>'
      + '<span class="anon-banner-lines"><span class="anon-banner-main"></span>'
      + '<span class="anon-banner-sub"></span></span></div>'
      + '<div class="anon-banner-cta">' + cta + '</div>';
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
    return el;
  }
  function _syncReferralUI() {
    var r = _refInfo();
    // Кнопка в сайдбаре — под «Получать сетапы в Telegram»
    var btn = document.getElementById('sb-ref-btn');
    var showBtn = !!(r && r.program && !_authState.is_anon);
    if (!btn && showBtn) {
      var wrap = document.querySelector('.sb-notif-wrap');
      if (wrap) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.id = 'sb-ref-btn';
        btn.className = 'sb-ref';
        btn.textContent = '🎁 Подарок';   // название — решение владельца 01.10.2026
        btn.onclick = openReferralModal;
        wrap.appendChild(btn);
      }
    }
    if (btn) btn.style.display = showBtn ? '' : 'none';
    // Баннеры приглашённого: аноним по ссылке — вместо «войдите», вошедший — вместо «по подписке»
    var pend = _refPending(), wait = _refInviteShow();
    var pb = pend ? _refBanner('ref-pending-banner', function () { showAuthPopup(); }, '→ Войти через Яндекс')
                  : document.getElementById('ref-pending-banner');
    if (pb) {
      if (pend) {
        var pi = r.pending;
        pb.querySelector('.anon-banner-main').textContent = pi.kind === 'partner' ? 'Вас пригласили' : 'Вас пригласил друг';
        pb.querySelector('.anon-banner-sub').textContent = 'Войдите — к каждой оплате подписки подарок: ' + _refGiftLine(pi);
      }
      pb.style.display = pend ? 'flex' : 'none';
    }
    var ib = wait ? _refBanner('ref-invite-banner', function () { nwOpenPricingStep('ref'); }, '→ Оформить подписку')
                  : document.getElementById('ref-invite-banner');
    if (ib) {
      if (wait) {
        var iv = r.invite;
        ib.querySelector('.anon-banner-main').textContent = 'Подарок по приглашению — до ' + iv.until;
        ib.querySelector('.anon-banner-sub').textContent = 'К каждой оплате подписки: ' + _refGiftLine(iv);
      }
      ib.style.display = wait ? 'flex' : 'none';
    }
    if (pend) { var ab = document.getElementById('anon-banner'); if (ab) ab.style.display = 'none'; }
    if (wait) { var fb = document.getElementById('free-delay-banner'); if (fb) fb.style.display = 'none'; }
  }
  function _refPlural(n, one, few, many) {
    var m10 = n % 10, m100 = n % 100;
    if (m10 === 1 && m100 !== 11) return one;
    if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
    return many;
  }

  // Окно «Пригласить друзей и получить подарок» (кнопка «Подарок»): ссылка, «Скопировать», «Поделиться в Telegram», счётчики и друзья.
  var _REF_STATUS = { waiting: 'ждём оплату', paid: 'платит', customer: 'уже был подписчиком — подарок только ему',
                      expired: 'срок прошёл' };
  var _REF_TITLE = 'Пригласить друзей и получить подарок';
  function openReferralModal() {
    var ov = document.getElementById('ref-overlay');
    if (!ov) {
      ov = document.createElement('div');
      ov.id = 'ref-overlay';
      ov.className = 'nw-overlay';
      ov.innerHTML = '<div class="nw-modal ref-modal" role="dialog" aria-label="Пригласить друзей и получить подарок">'
        + '<button class="nw-close" type="button" aria-label="Закрыть">&times;</button>'
        + '<div id="ref-body"></div></div>';
      document.body.appendChild(ov);
      ov.addEventListener('click', function (e) { if (e.target === ov) closeReferralModal(); });
      ov.querySelector('.nw-close').onclick = closeReferralModal;
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && ov.classList.contains('open')) closeReferralModal();
      });
    }
    var body = document.getElementById('ref-body');
    body.innerHTML = '<div class="nw-title">' + _REF_TITLE + '</div><div class="pricing-loading">Загрузка…</div>';
    ov.classList.add('open');
    fetch('/api/referral/me').then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(_renderReferral).catch(function () {
      body.innerHTML = '<div class="nw-title">' + _REF_TITLE + '</div>'
        + '<div class="nw-msg" style="color:var(--red)">Не удалось загрузить. Попробуйте ещё раз.</div>';
    });
  }
  function closeReferralModal() {
    var ov = document.getElementById('ref-overlay');
    if (ov) ov.classList.remove('open');
  }
  function _refEsc(s) {
    return String(s == null ? '' : s).replace(/[<>&"']/g, function (c) {
      return {'<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#39;'}[c];
    });
  }
  function _renderReferral(d) {
    var body = document.getElementById('ref-body');
    if (!body) return;
    var link = d.link || '';
    var share = 'https://t.me/share/url?url=' + encodeURIComponent(link)
      + '&text=' + encodeURIComponent('Сетапы по акциям Мосбиржи с проверенной статистикой. По моей ссылке — '
                                      + 'подарок к каждой оплате подписки: ' + _refGiftLine(d) + '.');
    var friends = (d.friends || []).map(function (f) {
      var st = _REF_STATUS[f.status] || f.status;
      if (f.status === 'waiting') st += ' до ' + f.until;
      if (f.status === 'paid') st = 'оплат: ' + f.payments + ' · вам +' + f.days + ' дн.';
      return '<div class="ref-friend ref-' + _refEsc(f.status) + '"><span>' + _refEsc(f.name)
        + ' <span class="ref-muted">· ' + _refEsc(f.joined) + '</span></span><span>' + _refEsc(st) + '</span></div>';
    }).join('');
    // Заголовок — формулировка владельца (01.10.2026); правила (подарок к каждой оплате друга, срок) —
    // решение владельца 01.10.2026 (вечер), числа и подписи — с сервера (settings.LINK_*).
    var acc = (d.text && d.text.acc) || {};
    body.innerHTML = '<div class="nw-title">' + _REF_TITLE + '</div>'
      + '<div class="nw-text">Друг переходит по вашей ссылке и оплачивает подписку — вы оба получаете Premium в подарок: '
      + 'за оплату месяца — ' + _refEsc(acc.month || '') + ', за оплату года — ' + _refEsc(acc.year || '')
      + '. Так — с каждой оплатой друга в течение ' + _refEsc(d.term || '') + '.<br>Число друзей не ограничено 🙌</div>'
      + '<div class="ref-gift-note">Если друг уже оплачивал подписку раньше, подарок получит только он</div>'
      + _refBotLine()
      + '<div class="ref-link-row"><input class="ref-link" id="ref-link" readonly value="' + _refEsc(link) + '">'
      + '<button class="nw-btn nw-btn-primary" id="ref-copy" type="button">Скопировать</button></div>'
      + '<a class="ref-share" href="' + _refEsc(share) + '" target="_blank" rel="noopener">Поделиться в Telegram</a>'
      + '<div class="ref-stats">'
      + '<div><b>' + (d.clicks || 0) + '</b><span>перешли по ссылке</span></div>'
      + '<div><b>' + (d.joined || 0) + '</b><span>пришли</span></div>'
      + '<div><b>' + (d.paid || 0) + '</b><span>оплатили</span></div>'
      + '<div><b>' + (d.earned_days || 0) + '</b><span>дней Premium вам</span></div>'
      + '</div>'
      + (friends ? '<div class="ref-friends">' + friends + '</div>' : '<div class="ref-muted ref-empty">Приглашённых пока нет</div>')
      + (d.mode === 'admin' ? '<div class="ref-muted ref-note">Обкатка: окно видит только админ, работают только ссылки админов.</div>' : '');
    var cp = document.getElementById('ref-copy');
    if (cp) cp.onclick = function () {
      var inp = document.getElementById('ref-link');
      var done = function () { cp.textContent = 'Скопировано'; setTimeout(function () { cp.textContent = 'Скопировать'; }, 1600); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).then(done, function () { inp.select(); document.execCommand('copy'); done(); });
      } else { inp.select(); document.execCommand('copy'); done(); }
    };
  }

  // Баннер «Premium заканчивается …» — за ≤3 календарных дня (по Москве) до конца срока. Срок считается до минуты,
  // поэтому со временем (решение владельца 15.10.2026; до этого — «через N дней» по концу дня браузера): источник —
  // _authState.paid_until_text («18.11.2026 18:33», по Москве) и paid_until_days (0 — сегодня, 1 — завтра) из
  // /api/auth/status (auth_limits.until_text / until_days). Пробный период тоже попадает — в базе он неотличим
  // от платной подписки.
  function _updatePremiumExpiryBanner() {
    var b = document.getElementById('premium-expiry-banner');
    if (!b) return;
    var tier = (_authState && _authState.tier) || 'anon';
    var txt = _authState && _authState.paid_until_text;
    var days = _authState && _authState.paid_until_days;
    if (!txt || typeof days !== 'number' || (tier !== 'premium' && tier !== 'profi') || days < 0 || days > 3) {
      b.style.display = 'none';
      return;
    }
    var main = document.getElementById('premium-expiry-main');
    if (main) {
      var parts = String(txt).split(' '), at = 'в\u00a0' + (parts[1] || '');
      var when = days === 0 ? 'сегодня ' + at
               : days === 1 ? 'завтра ' + at
               : 'через ' + days + '\u00a0' + (days <= 4 ? 'дня' : 'дней') + ' — ' + parts[0] + ' ' + at;
      var tierName = tier === 'profi' ? 'Profi' : 'Premium';
      main.innerHTML = 'Ваша подписка <b>' + tierName + '</b> заканчивается ' + when + '\u00a0МСК.';
    }
    b.style.display = 'flex';
  }

  // ── Notifications CTA + wizard ────────────────────
  // Состояние: anon / free / paid (no settings) / paid (configured, bot inactive) / paid (active)
  var _nwSettings = null;     // последний снимок /api/notifications/settings (paid users)
  var _nwLoading  = false;

  function refreshNotifCtaState() {
    // Текст кнопки одинаковый во всех состояниях — меняется только класс
    // (цвет/тень). См. CSS: .sb-cta / .sb-cta.activated / .sb-cta.configured.
    var btn = document.getElementById('sb-cta-notif');
    if (!btn) return;
    btn.classList.remove('activated', 'configured');
    if (_authState.is_anon) { _nwSettings = null; return; }
    var tier = _authState.tier || 'free';
    if (tier === 'free' || tier === 'early_adopter' || tier === 'anon') {
      _nwSettings = null;
      return;
    }
    // Paid (bonus / premium / profi) — тянем настройки для классификации
    fetch('/api/notifications/settings').then(function(r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function(d) {
      _nwSettings = d;
      if (d.enabled && d.linked)            btn.classList.add('activated');
      else if (d.exists && d.enabled)        btn.classList.add('configured');
      // иначе — default (primary)
    }).catch(function() {});
  }

  // ?notify=1 — приход из Telegram-бота (обе его кнопки ведут сюда). Визард сам
  // выберет шаг по тиру: аноним → регистрация, free → тарифы, платный → фильтры
  // рассылки. Поэтому боту хватает одной ссылки и он не держит копию настроек.
  // Вызывается из refreshAuthState (не из init): до резолва _authState по
  // умолчанию выглядит анонимом, и визард показал бы не тот шаг.
  var _notifyUrlHandled = false;
  function maybeOpenNotifWizardFromUrl() {
    if (_notifyUrlHandled) return;
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (params.get('notify') !== '1') return;
    _notifyUrlHandled = true;
    // Чистим только свой параметр (ticker и прочие оставляем), чтобы F5 не
    // открывал модал заново — как в nwCheckResumeSuccess.
    params.delete('notify');
    var qs = params.toString();
    try {
      window.history.replaceState(null, '',
        window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    } catch (e) {}
    openNotifWizard();
  }

  function openNotifWizard(ctx) {
    if (_authState.is_anon) {
      // Аноним — сначала регистрация (Step C/D появятся после авторизации).
      // Регистрация даёт триал Premium (auth_limits.TRIAL_DAYS, сейчас 7 дней) →
      // на время триала уведомления доступны, дальше нужна подписка.
      showAuthPopup({title: 'Зарегистрируйтесь для уведомлений в Телеграм'});
      return;
    }
    var tier = _authState.tier || 'free';
    var ov = document.getElementById('nw-overlay');
    if (!ov) return;
    // Подключение бота как выгода (bot_onboard, 01.10.2026): кто ещё не подключил Telegram — сначала
    // подключение (одна кнопка), при любом тарифе: бесплатному приходят подарки, напоминания и подборка
    // недели, сетапы — после оплаты. Без блока `bot` (режим выключен / не админ) — прежний порядок шагов.
    var _bi = _botInfo();
    if (_bi && !_bi.linked) { nwOpenConnectStep(ctx || 'notif'); return; }
    // Сначала прячем все шаги, ресетим wide-modal класс
    document.querySelectorAll('.nw-step').forEach(function(s) { s.style.display = 'none'; });
    var modal = ov.querySelector('.nw-modal');
    if (modal) modal.classList.remove('wide', 'pay');

    if (tier === 'free' || tier === 'early_adopter') {
      // Free — Step C (paywall). Настройки подтягиваем, чтобы отличить два
      // случая: человек НЕ настраивал рассылку (обычный пэйвол) и человек её
      // настроил во время триала, а сейчас она молча не идёт — отбор
      // получателей (tg_bot.get_active_subscribers) требует активной подписки.
      // Во втором случае честнее сказать прямо, иначе «перестало приходить,
      // а почему — непонятно».
      nwOpenPricingStep();
      ov.classList.add('open');
      fetch('/api/notifications/settings').then(function(r) {
        return r.ok ? r.json() : null;
      }).then(function(d) {
        _nwSettings = d || _nwSettings;
        nwShowPausedNotice(d && d.requires_paid && d.enabled);
      }).catch(function() {});
      return;
    }

    // Paid — но сперва проверяем, привязан ли бот. Фильтры рассылки лежат в
    // bot_trigger_settings с PK = telegram_id, поэтому без привязки их физически
    // некуда сохранять: PUT вернёт 409 bot_not_linked. Правильный порядок —
    // сначала Step D (привязка), потом фильтры. Особенно заметно при заходе из
    // бота (?notify=1): человек авторизован через Яндекс, подписка есть, а
    // Telegram аккаунту ещё не сопоставлен.
    // Именно linked (users.telegram_id), а НЕ bot_activated: последнее = флаг
    // bot_users.is_active, который при подписке с сайта остаётся FALSE — по нему
    // визард отправлял на привязку уже привязанных.
    if (_nwSettings && _nwSettings.linked === false) {
      nwOpenSuccessStep();          // Step D — deep-link «Открыть бота»
      ov.classList.add('open');
      return;
    }
    if (!_nwSettings) {
      // Настройки ещё не подгружены (CTA-state не успел) — спрашиваем сервер,
      // чтобы не показать не тот шаг. При сбое ведём себя как раньше.
      fetch('/api/notifications/settings')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(d) {
          if (d) _nwSettings = d;
          if (d && d.linked === false) nwOpenSuccessStep();
          else {
            nwLoadSettingsIntoForm();
            document.getElementById('nw-step-filters').style.display = 'block';
          }
          ov.classList.add('open');
        })
        .catch(function() {
          nwLoadSettingsIntoForm();
          document.getElementById('nw-step-filters').style.display = 'block';
          ov.classList.add('open');
        });
      return;
    }

    // Paid + бот привязан — Step B (filters)
    nwLoadSettingsIntoForm();
    document.getElementById('nw-step-filters').style.display = 'block';
    ov.classList.add('open');
  }

  // ── Step C (paywall) — pricing cards ───────────────
  // Аналог showLimitPopup() с главной, но scoped в wizard. См. CLAUDE.md
  // про решение inline-vs-lift: пока inline, лифтнем когда понадобится в третьем месте.
  var _nwPricingPeriod = 'year';   // год по умолчанию (решение владельца 12.09.2026)
  var _nwPricingLoaded = false;

  // nwOpenPricingStep(context?) — paywall переиспользуется под два апселла:
  //  'notif'     (default) — уведомления в Telegram (CTA в сайдбаре, free-тир)
  //  'allstocks'           — просмотр всех акций (баннер blue-only, free-тир)
  // Заголовок/текст шага меняется под контекст; карточки тарифов общие.
  var _NW_PAYWALL_COPY = {
    notif: {
      title: 'Купите подписку',
      text:  '',
    },
    // 'delayed' — бесплатный после триала: сетапы с задержкой (баннер, 12.09.2026).
    // 'allstocks' оставлен алиасом для старых вызовов (гейт голубых фишек снят).
    delayed: {
      title: 'Свежие сетапы — по подписке',
      text:  '',
    },
    allstocks: {
      title: 'Свежие сетапы — по подписке',
      text:  '',
    },
    // 'ref' — пришедший по ссылке друга или партнёра (баннер подарка, 01.10.2026): подарок показывает карточка тарифа.
    ref: {
      title: 'Купите подписку',
      text:  '',
    },
    renew: {
      title: 'Продление подписки',
      text:  'Ваша подписка скоро закончится. Продлите, чтобы не потерять доступ ко всем сетапам и уведомлениям.',
    },
  };
  function nwOpenPricingStep(context) {
    var copy = _NW_PAYWALL_COPY[context] || _NW_PAYWALL_COPY.notif;
    var tEl = document.getElementById('nw-paywall-title');
    var xEl = document.getElementById('nw-paywall-text');
    if (tEl) { tEl.textContent = copy.title; tEl.style.display = copy.title ? '' : 'none'; }
    // Пустую строку прячем — иначе под заголовком остаётся её отступ.
    if (xEl) { xEl.textContent = copy.text; xEl.style.display = copy.text ? '' : 'none'; }
    // Тариф один (12.09.2026): 720px были под две карточки — вместо .wide ставим
    // .pay (520px, как у общего попапа оплаты).
    var modal = document.querySelector('#nw-overlay .nw-modal');
    if (modal) { modal.classList.remove('wide'); modal.classList.add('pay'); }
    // Шаг paywall может открываться вне визарда (клик по баннеру blue-only) —
    // гарантируем что оверлей открыт и прочие шаги скрыты.
    var ov = document.getElementById('nw-overlay');
    if (ov) {
      document.querySelectorAll('.nw-step').forEach(function(s) { s.style.display = 'none'; });
      ov.classList.add('open');
    }
    document.getElementById('nw-step-paywall').style.display = 'block';
    // По умолчанию скрыта: шаг открывается и по другим поводам (голубые фишки,
    // тренажёр), там про рассылку речи нет. Включает её только free-ветка визарда.
    nwShowPausedNotice(false);
    var msg = document.getElementById('nw-pricing-msg');
    if (msg) msg.textContent = '';
    // Каждый раз перезагружаем планы (актуальная цена + bonus_promo flag)
    nwLoadPricingPlans();
  }

  // Строка «рассылка приостановлена» на шаге тарифов. Показывается только
  // тому, у кого рассылка реально была настроена и включена (bot_trigger_settings
  // .enabled), а подписка кончилась. Настройки при этом остаются нетронутыми —
  // после оплаты рассылка возобновится сама, перенастраивать ничего не нужно.
  function nwShowPausedNotice(show) {
    var host = document.getElementById('nw-step-paywall');
    if (!host) return;
    var el = document.getElementById('nw-paused-notice');
    if (!show) { if (el) el.style.display = 'none'; return; }
    if (!el) {
      el = document.createElement('div');
      el.id = 'nw-paused-notice';
      el.className = 'nw-paused-notice';
      el.innerHTML = '<span class="nw-paused-lock">\u23F8</span>' +
        '<span>Рассылка приостановлена — подписка закончилась. ' +
        'Ваши фильтры сохранены: после оплаты сетапы снова начнут приходить.</span>';
      var title = document.getElementById('nw-paywall-title');
      if (title && title.parentNode) title.parentNode.insertBefore(el, title);
      else host.insertBefore(el, host.firstChild);
    }
    el.style.display = 'flex';
  }

  var _nwPlans = null;   // планы последнего ответа — для перерисовки при смене периода
  function nwLoadPricingPlans() {
    var wrap = document.getElementById('nw-pricing-cards');
    if (!wrap) return;
    fetch('/api/payment/plans').then(function(r) { return r.json(); }).then(function(d) {
      var plans = (d.plans || []).filter(function(p) {
        return p.tier === 'premium' || p.tier === 'profi';
      });
      _nwPlans = plans;
      wrap.innerHTML = nwBuildPricingCards(plans);
      // кнопки общего билдера без inline-onclick — вешаем обработчик покупки
      wrap.querySelectorAll('.pricing-card-btn').forEach(function(b) {
        b.onclick = function() { nwBuyPlan(b); };
      });
      _nwPricingLoaded = true;
    }).catch(function() {
      wrap.innerHTML = '<div class="pricing-loading" style="color:var(--red)">Ошибка загрузки тарифов</div>';
    });
  }

  function nwBuildPricingCards(plans) {
    // Единый билдер карточек тарифов (web_app.py PAYWALL_JS). Кнопки эмитятся
    // без inline-onclick → обработчик (nwBuyPlan) вешается в nwLoadPricingPlans.
    return window.PaywallUI.buildCards(plans, _nwPricingPeriod);
  }

  function nwSetPricingPeriod(p) {
    _nwPricingPeriod = p;
    document.querySelectorAll('#nw-step-paywall .pricing-toggle button').forEach(function(b) {
      b.classList.toggle('active', b.dataset.period === p);
    });
    // Карточка несёт зачёркнутую цену, бейдж и пересчёт года — правкой отдельных
    // полей не обойтись, перерисовываем общим билдером (12.09.2026).
    var wrap = document.getElementById('nw-pricing-cards');
    if (wrap && _nwPlans) {
      wrap.innerHTML = nwBuildPricingCards(_nwPlans);
      wrap.querySelectorAll('.pricing-card-btn').forEach(function(b) {
        b.onclick = function() { nwBuyPlan(b); };
      });
    }
  }

  function nwBuyPlan(btn) {
    var planKey = btn.dataset.plan;
    var rec = document.getElementById('nw-pricing-recurring');
    var recurring = rec ? rec.checked : false;
    var msg = document.getElementById('nw-pricing-msg');
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Загрузка…';
    if (msg) { msg.textContent = ''; msg.style.color = ''; }

    var headers = { 'Content-Type': 'application/json' };
    if (_csrfToken) headers['X-CSRF-Token'] = _csrfToken;
    // source=setups — Robokassa вернёт это в Shp_source, и /api/payment/success
    // редиректнет на /setups?wizard_resume=success вместо главной
    fetch('/api/payment/create', {
      method: 'POST', headers: headers,
      body: JSON.stringify({ plan: planKey, recurring: recurring, source: 'setups' })
    }).then(function(r) { return r.json(); }).then(function(d) {
      if (d.ok && d.url) {
        // Same-tab redirect — после оплаты Success URL вернёт на /setups?wizard_resume=success
        window.location.href = d.url;
      } else {
        btn.disabled = false;
        btn.textContent = orig;
        if (msg) { msg.textContent = d.error || 'Ошибка'; msg.style.color = 'var(--red)'; }
      }
    }).catch(function() {
      btn.disabled = false;
      btn.textContent = orig;
      if (msg) { msg.textContent = 'Ошибка сети'; msg.style.color = 'var(--red)'; }
    });
  }

  // ── Step D (success + deep-link) ───────────────────
  function nwOpenSuccessStep() {
    var ov = document.getElementById('nw-overlay');
    if (!ov) return;
    document.querySelectorAll('.nw-step').forEach(function(s) { s.style.display = 'none'; });
    var modal = ov.querySelector('.nw-modal');
    if (modal) modal.classList.remove('wide', 'pay');
    document.getElementById('nw-step-success').style.display = 'block';
    ov.classList.add('open');
    // Token подтянем при первом клике (lazy) — экономим request если user закрыл сразу.
  }

  function nwDeepLinkClick(a) {
    // Lazy-fetch одноразового токена. Если уже было кликнуто — открываем
    // ту же ссылку (token валиден 7 дней, бот пометит used_at при первом /start).
    if (a.dataset.tokenLoaded === '1') {
      return true;  // обычное открытие href в новой вкладке
    }
    a.dataset.tokenLoaded = 'pending';
    a.style.opacity = '0.6';
    a.textContent = 'Загрузка…';
    var headers = { 'Content-Type': 'application/json' };
    if (_csrfToken) headers['X-CSRF-Token'] = _csrfToken;
    fetch('/api/notifications/start-token', { method: 'POST', headers: headers, body: '{}' })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        a.style.opacity = '';
        if (d.ok && d.token) {
          a.href = 'https://t.me/MOEXanalystBot?start=auth_' + encodeURIComponent(d.token);
          a.textContent = 'Открыть бота → /start';
          a.dataset.tokenLoaded = '1';
          // Программно открываем (первоначальный клик мы preventDefault'или возвратом false)
          window.open(a.href, '_blank', 'noopener');
        } else {
          a.textContent = 'Открыть бота → /start';
          a.dataset.tokenLoaded = '0';
          var hint = document.getElementById('nw-deep-link-hint');
          if (hint) {
            hint.textContent = 'Не удалось получить токен: ' + (d.error || 'попробуйте ещё раз');
            hint.style.color = 'var(--red)';
          }
        }
      }).catch(function() {
        a.style.opacity = '';
        a.textContent = 'Открыть бота → /start';
        a.dataset.tokenLoaded = '0';
        var hint = document.getElementById('nw-deep-link-hint');
        if (hint) { hint.textContent = 'Ошибка сети'; hint.style.color = 'var(--red)'; }
      });
    return false;  // отменяем обычное открытие — откроется после fetch'а
  }

  function nwGoToFiltersFromSuccess() {
    // Закрываем Step D и открываем Step B (теперь юзер paid).
    var ov = document.getElementById('nw-overlay');
    if (!ov) return;
    document.querySelectorAll('.nw-step').forEach(function(s) { s.style.display = 'none'; });
    var modal = ov.querySelector('.nw-modal');
    if (modal) modal.classList.remove('wide', 'pay');
    nwLoadSettingsIntoForm();
    document.getElementById('nw-step-filters').style.display = 'block';
  }

  // wizard_resume=success — пользователь вернулся через Success URL после оплаты
  function nwCheckResumeSuccess() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('wizard_resume') !== 'success') return;
      // Очищаем URL, чтобы при F5 не открывался снова
      var clean = window.location.pathname + window.location.hash;
      window.history.replaceState(null, '', clean);
      // Подождём refreshAuthState (чтобы _authState был paid), затем откроем
      var attempts = 0;
      function tryOpen() {
        attempts++;
        if (_authState && !_authState.is_anon) {
          // Подключение бота как выгода (bot_onboard): не подключён — окно подключения, подключён —
          // визард сам откроет фильтры рассылки. Без блока `bot` — прежний шаг «Открыть бота».
          var _bi = _botInfo();
          if (_bi && !_bi.linked) nwOpenConnectStep('notif');
          else if (_bi) openNotifWizard();
          else nwOpenSuccessStep();
          // Параллельно обновляем CTA-state (после оплаты paid_until поменялся)
          refreshNotifCtaState();
        } else if (attempts < 20) {
          setTimeout(tryOpen, 250);  // 5s max
        }
      }
      tryOpen();
    } catch (e) { /* noop */ }
  }

  function closeNotifWizard() {
    var ov = document.getElementById('nw-overlay');
    if (ov) ov.classList.remove('open');
    _bcPollStop();
    if (_bcCtx === 'onboard') _bcOnboardSeen();
    var msg = document.getElementById('nw-msg');
    if (msg) msg.textContent = '';
  }

  // Esc — закрыть wizard
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var ov = document.getElementById('nw-overlay');
      if (ov && ov.classList.contains('open')) closeNotifWizard();
    }
  });

  // ── Подключение Telegram-бота (01.10.2026, bot_onboard.py) ─────────────────
  // Решение владельца: бот предлагается в нужный момент и подключается одной кнопкой. Сервер в блоке
  // `bot` ответа /api/auth/status говорит, видно ли новое (settings.BOT_ONBOARD_MODE: на обкатке — только
  // админу), подключён ли Telegram (linked), идут ли сетапы (access, delivery, blue_chips_only), сколько
  // дней Premium даст подключение (bonus_days) и пора ли показать экран после первого входа (onboard_due).
  // Окно подключения — шаг визарда уведомлений (#nw-step-connect, создаётся отсюда): ссылка в бота и
  // QR-код, окно само узнаёт о подключении (опрос /api/notifications/settings раз в bot.poll_sec) и
  // показывает «Telegram подключён» со следующим шагом. Здесь же «Получать такие сразу» на карточках,
  // строка в окне «Подарок» и уведомление о начисленном Premium (блок `grants`).
  // Предпросмотр для админа: ?bot_onboard=1 — экран подключения, ?bot_onboard=done — «Подключено».
  function _botInfo() { return (_authState && _authState.bot) || null; }
  var _BC_TITLE = { onboard: 'Куда присылать сетапы и подарки?' };
  var _BC_POLL_MAX_MS = 15 * 60 * 1000;   // окно открыто дольше — перестаём спрашивать
  var _bcCtx = null, _bcPollTimer = null, _bcPollFrom = 0, _bcPreview = false, _bcDone = false, _bcAuto = false;

  function _bcDays(n) { return '+' + n + ' ' + _refPlural(n, 'день', 'дня', 'дней'); }
  function _bcHeaders() {
    var h = { 'Content-Type': 'application/json' };
    if (_csrfToken) h['X-CSRF-Token'] = _csrfToken;
    return h;
  }
  function _bcStep() {
    var host = document.querySelector('#nw-overlay .nw-modal');
    if (!host) return null;
    var el = document.getElementById('nw-step-connect');
    if (!el) {
      el = document.createElement('div');
      el.className = 'nw-step';
      el.id = 'nw-step-connect';
      el.style.display = 'none';
      host.appendChild(el);
    }
    return el;
  }
  function _bcStatus(text) {
    var el = document.getElementById('bc-status');
    if (el) el.textContent = text || '';
  }

  // Шаг «Подключите Telegram»: ctx — откуда открыли (notif — кнопка в сайдбаре, card — карточка,
  // ref — окно «Подарок», onboard — экран после первого входа); opts.preview — без опроса (админ).
  function nwOpenConnectStep(ctx, opts) {
    opts = opts || {};
    var b = _botInfo() || {};
    var ov = document.getElementById('nw-overlay');
    var step = _bcStep();
    if (!ov || !step) return;
    _bcCtx = ctx || 'notif';
    _bcPreview = !!opts.preview;
    _bcDone = false;
    document.querySelectorAll('.nw-step').forEach(function (s) { s.style.display = 'none'; });
    var modal = ov.querySelector('.nw-modal');
    if (modal) { modal.classList.remove('wide'); modal.classList.add('pay'); }
    var items = [];
    if (b.bonus_days) items.push('🎁 <b>' + _bcDays(b.bonus_days) + ' Premium</b> сразу после подключения');
    items.push(b.access ? '📈 сетапы в момент появления' : '📈 сетапы в момент появления — по подписке');
    items.push('💌 подарки и напоминания о подписке');
    if (!b.access) items.push('🏆 по пятницам — подборку лучших сетапов недели');
    step.innerHTML = '<div class="nw-title">' + (_BC_TITLE[_bcCtx] || 'Подключите Telegram') + '</div>'
      + '<div class="nw-text">Подключите бота <b>@' + _refEsc(b.bot_username || '') + '</b> — он будет присылать:</div>'
      + '<ul class="bc-list">' + items.map(function (x) { return '<li>' + x + '</li>'; }).join('') + '</ul>'
      + '<a class="nw-deep-link bc-link" id="bc-link" href="#" target="_blank" rel="noopener">Загрузка…</a>'
      + '<div class="bc-qr" id="bc-qr" style="display:none"><img alt="QR-код: подключить Telegram">'
      + '<span>или наведите камеру телефона</span></div>'
      + '<div class="bc-status" id="bc-status"></div>'
      + '<button class="bc-later" type="button" id="bc-later">Не сейчас</button>';
    step.style.display = 'block';
    ov.classList.add('open');
    var link = document.getElementById('bc-link');
    link.onclick = function (e) {
      if (link.dataset.ready !== '1') { e.preventDefault(); if (link.dataset.ready === 'err') _bcLoadLink(); return false; }
      _bcStatus('Нажмите «Старт» в Telegram — это окно само увидит подключение.');
      return true;
    };
    document.getElementById('bc-later').onclick = closeNotifWizard;
    if (opts.fromBot) { _bcLinkFromBot(opts.fromBot); return; }
    _bcLoadLink();
    if (!_bcPreview) _bcPollStart();
  }

  // Подключение по ключу из бота (?tglink=, 15.10.2026): кнопка «Подключить аккаунт» у неподключённого Telegram
  // несёт ключ этого Telegram — подключаем сразу, без возврата в Telegram. Отказ — объяснение сервера и обычная
  // ссылка с QR (сервер: /api/notifications/link-tg).
  function _bcLinkFromBot(key) {
    var link = document.getElementById('bc-link');
    if (link) { link.dataset.ready = '0'; link.textContent = 'Подключаем…'; link.classList.add('bc-wait'); }
    _bcStatus('Подключаем Telegram из бота…');
    var fallback = function (msg) {
      if (_bcDone || !_bcOpen()) return;
      _bcLoadLink();
      if (!_bcPreview) _bcPollStart();
      _bcStatus(msg || 'Не получилось подключить — нажмите «Подключить Telegram»');
    };
    fetch('/api/notifications/link-tg', { method: 'POST', headers: _bcHeaders(), body: JSON.stringify({ key: key }) })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) { if (d && d.ok) _bcLinked(); else fallback(d && d.message); })
      .catch(function () { fallback(); });
  }

  // ?tglink=<ключ> — приход из бота по кнопке «Подключить аккаунт» неподключённого Telegram (15.10.2026). Ключ
  // переживает вход через Яндекс в sessionStorage (та же вкладка): аноним сначала входит, вернувшись — подключаем.
  // Вызывается из refreshAuthState до maybeOpenNotifWizardFromUrl: окно по ?notify=1 тогда не открывается.
  var _TGLINK_SS = 'bc.tglink', _tgLinkHandled = false;
  function _maybeTgLinkFromUrl() {
    if (_tgLinkHandled) return false;
    var key = null, params = null;
    try { params = new URLSearchParams(window.location.search); key = params.get('tglink'); } catch (e) {}
    if (key) {
      try { sessionStorage.setItem(_TGLINK_SS, key); } catch (e) {}
      // Ключ — из адреса долой (обновление страницы и пересланная ссылка его не повторят), notify — тоже.
      params.delete('tglink');
      params.delete('notify');
      var qs = params.toString();
      try {
        window.history.replaceState(null, '',
          window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
      } catch (e) {}
    } else {
      try { key = sessionStorage.getItem(_TGLINK_SS); } catch (e) {}
    }
    if (!key) return false;
    _tgLinkHandled = true;
    _notifyUrlHandled = true;
    if (_authState.is_anon) {
      showAuthPopup({ title: 'Войдите, чтобы подключить Telegram',
                      text: 'Вход через Яндекс ID — и Telegram из бота сразу подключится к аккаунту' });
      return true;
    }
    try { sessionStorage.removeItem(_TGLINK_SS); } catch (e) {}
    nwOpenConnectStep('notif', { fromBot: key });
    return true;
  }

  // Ссылка в бота с одноразовым токеном и QR-код (сервер: /api/notifications/start-token).
  function _bcLoadLink() {
    var link = document.getElementById('bc-link');
    if (!link) return;
    link.dataset.ready = '0';
    link.textContent = 'Загрузка…';
    link.classList.add('bc-wait');
    fetch('/api/notifications/start-token', { method: 'POST', headers: _bcHeaders(), body: '{}' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.ok || !d.deep_link) throw new Error(d.error || 'нет ссылки');
        link.href = d.deep_link;
        link.textContent = 'Подключить Telegram';
        link.dataset.ready = '1';
        link.classList.remove('bc-wait');
        var qr = document.getElementById('bc-qr');
        if (qr && d.qr) { qr.querySelector('img').src = d.qr; qr.style.display = ''; }
      })
      .catch(function () {
        link.textContent = 'Повторить';
        link.dataset.ready = 'err';
        link.classList.remove('bc-wait');
        _bcStatus('Не удалось получить ссылку на бота — попробуйте ещё раз.');
      });
  }

  function _bcPollStop() { if (_bcPollTimer) { clearInterval(_bcPollTimer); _bcPollTimer = null; } }
  function _bcPollStart() {
    _bcPollStop();
    _bcPollFrom = Date.now();
    var sec = Math.max(1, ((_botInfo() || {}).poll_sec) || 3);
    _bcPollTimer = setInterval(_bcCheck, sec * 1000);
  }
  function _bcOpen() {
    var ov = document.getElementById('nw-overlay');
    var step = document.getElementById('nw-step-connect');
    return !!(ov && ov.classList.contains('open') && step && step.style.display !== 'none');
  }
  function _bcCheck() {
    if (!_bcOpen() || _bcDone) { _bcPollStop(); return; }
    if (Date.now() - _bcPollFrom > _BC_POLL_MAX_MS) {
      _bcPollStop();
      _bcStatus('Уже нажали «Старт» в боте? Обновите страницу.');
      return;
    }
    fetch('/api/notifications/settings', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d && d.linked) _bcLinked(); })
      .catch(function () {});
  }
  // Вернулись во вкладку из Telegram — проверяем сразу, не дожидаясь следующего опроса.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && _bcPollTimer) _bcCheck();
  });

  // Экран после первого входа больше не нужен — сообщаем серверу (признак в сессии).
  function _bcOnboardSeen() {
    var b = _botInfo();
    if (!b || !b.onboard_due) return;
    b.onboard_due = false;
    fetch('/api/bot/onboard-seen', { method: 'POST', headers: _bcHeaders(), body: '{}' }).catch(function () {});
  }

  // Лёгкое обновление статуса (без пересинхронизации настроек и перезагрузки ленты, как в refreshAuthState):
  // после подключения меняются бот, начисления и, бывает, тариф (бонус Premium).
  function _bcRefreshStatus() {
    var oldTier = _authState && _authState.tier;
    return fetch('/api/auth/status', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        _authState = d;
        updateAuthUI();
        if (oldTier && d.tier !== oldTier && typeof fetchAndRender === 'function') fetchAndRender();
        return d;
      });
  }

  function _bcLinked() {
    _bcPollStop();
    if (_bcDone) return;
    _bcDone = true;
    _bcOnboardSeen();
    _bcRefreshStatus().then(_bcRenderDone, _bcRenderDone);
  }

  // «Telegram подключён»: что будет приходить и следующий шаг (одно действие на экране).
  function _bcRenderDone() {
    var step = _bcStep();
    if (!step) return;
    var b = _botInfo() || {};
    var g = _authState && _authState.grants;
    // Бонус без «— за подключение Telegram» и сетапы без «в момент появления»: окно и так об этом
    // (правка владельца 01.10.2026).
    var bonus = (g && g.reason === 'bot_connect')
      ? '<div class="bc-bonus">🎁 ' + _refEsc(g.short || g.main) + (g.sub ? '<span>' + _refEsc(g.sub) + '</span>' : '') + '</div>' : '';
    if (bonus) _grantSeen();
    var text, actions;
    if (b.access) {
      // Без точки в конце и с неразрывными пробелами после предлогов (правка владельца 01.10.2026).
      text = b.delivery
        ? 'Сетапы ' + (b.blue_chips_only ? 'по\u00a0голубым фишкам' : 'по\u00a0вашим фильтрам') + ' будут приходить в\u00a0Telegram'
        : 'Включите рассылку сетапов в\u00a0настройках\u00a0— и\u00a0они начнут приходить в\u00a0Telegram';
      actions = '<button class="nw-btn nw-btn-primary" type="button" id="bc-ok">Готово</button>'
        + '<button class="bc-later" type="button" id="bc-next">Настроить, какие сетапы присылать</button>';
    } else {
      text = 'Пришлём подарки, напоминания о\u00a0подписке и\u00a0по\u00a0пятницам подборку лучших сетапов недели. '
        + 'Все сетапы\u00a0— по\u00a0подписке';
      actions = '<button class="nw-btn nw-btn-primary" type="button" id="bc-next">Купить подписку</button>'
        + '<button class="bc-later" type="button" id="bc-ok">Не сейчас</button>';
    }
    step.innerHTML = '<div class="nw-success-ico">&#10004;</div>'
      + '<div class="nw-title" style="text-align:center">Telegram подключён</div>'
      + bonus + '<div class="nw-success-text">' + text + '</div>'
      + '<div class="bc-actions">' + actions + '</div>';
    document.querySelectorAll('.nw-step').forEach(function (s) { s.style.display = 'none'; });
    step.style.display = 'block';
    var ok = document.getElementById('bc-ok'), nx = document.getElementById('bc-next');
    if (ok) ok.onclick = closeNotifWizard;
    if (nx) nx.onclick = b.access ? nwGoToFiltersFromSuccess : function () { nwOpenPricingStep('notif'); };
  }

  // После резолва статуса: экран после первого входа (один раз за загрузку страницы) или предпросмотр.
  function _maybeBotOnboard() {
    if (_bcAuto || _authState.is_anon) return;
    var b = _botInfo();
    if (!b) return;
    var p = null;
    try { p = new URLSearchParams(window.location.search).get('bot_onboard'); } catch (e) {}
    if (p) {
      _bcAuto = true;
      try {
        var q = new URLSearchParams(window.location.search);
        q.delete('bot_onboard');
        var qs = q.toString();
        window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
      } catch (e) {}
      nwOpenConnectStep('onboard', { preview: true });
      if (p === 'done') { _bcDone = true; _bcRenderDone(); }
      return;
    }
    if (!b.onboard_due || b.linked) return;
    _bcAuto = true;
    // Не перебиваем окно, открытое по ссылке (?notify=1, ?paywall=…).
    if (document.querySelector('#nw-overlay.open, #paywall-overlay.open')) return;
    nwOpenConnectStep('onboard');
  }

  // «Получать такие сразу» на карточках — тем, кому сетапы в Telegram ещё не приходят. Других значений в нижней строке
  // нет (16.10.2026): кому сетапы уже приходят, строки с линией над ней нет вовсе (класс tc-no-foot). Пока ответа
  // о входе нет, строку держим — иначе у анонима подсказка появлялась бы со сдвигом середины карточки.
  function _syncBotCardHints() {
    var b = _botInfo();
    var on = !!(b && !(b.linked && b.access && b.delivery));
    document.querySelectorAll('#top-cards-light .tc-card').forEach(function (card) {
      var f = card.querySelector('.tc-footer');
      if (!f) return;
      card.classList.toggle('tc-no-foot', !!b && !on);
      var h = f.querySelector('.tc-bot');
      if (on && !h) {
        h = document.createElement('span');
        h.className = 'tc-bot';
        h.textContent = '🔔 Получать такие сразу';
        h.title = 'Сетапы в Telegram в момент появления';
        h.onclick = function (e) { e.stopPropagation(); openNotifWizard('card'); };
        f.appendChild(h);
      } else if (!on && h) {
        h.remove();
      }
    });
  }

  // Строка в окне «Подарок»: о подарке сообщим в Telegram.
  function _refBotLine() {
    var b = _botInfo();
    if (!b || _authState.is_anon) return '';
    if (b.linked) return '<div class="ref-bot ok">🔔 Сообщим в Telegram, как только друг оплатит</div>';
    return '<div class="ref-bot">🔔 Подключите Telegram — сообщим, как только друг оплатит. '
      + '<a href="#" onclick="closeReferralModal(); nwOpenConnectStep(\'ref\'); return false;">Подключить</a></div>';
  }

  // Уведомление о начисленном Premium (подарок рефералки, бонус за подключение): показывается до закрытия.
  function _syncGrantNotice() {
    var g = _authState && !_authState.is_anon && _authState.grants;
    var el = document.getElementById('grant-banner');
    if (!g || !g.main) { if (el) el.style.display = 'none'; return; }
    if (!el) {
      var anchor = document.getElementById('anon-banner');
      if (!anchor || !anchor.parentNode) return;
      el = document.createElement('div');
      el.className = 'anon-banner tone-accent grant-banner';
      el.id = 'grant-banner';
      el.innerHTML = '<div class="anon-banner-text"><span class="anon-banner-lock">🎁</span>'
        + '<span class="anon-banner-lines"><span class="anon-banner-main"></span>'
        + '<span class="anon-banner-sub"></span></span></div>'
        + '<button class="grant-close" type="button" aria-label="Закрыть">&times;</button>';
      anchor.parentNode.insertBefore(el, anchor.nextSibling);
      el.querySelector('.grant-close').onclick = function (e) { e.stopPropagation(); _grantSeen(); };
    }
    el.querySelector('.anon-banner-main').textContent = g.main;
    var sub = el.querySelector('.anon-banner-sub');
    sub.textContent = g.sub || '';
    sub.style.display = g.sub ? '' : 'none';
    el.style.display = 'flex';
  }
  function _grantSeen() {
    var g = _authState && _authState.grants;
    var el = document.getElementById('grant-banner');
    if (el) el.style.display = 'none';
    if (!g || !g.ids) return;
    _authState.grants = null;
    fetch('/api/grants/seen', { method: 'POST', headers: _bcHeaders(), body: JSON.stringify({ ids: g.ids }) })
      .catch(function () {});
  }

  function _syncBotUI() {
    _syncBotCardHints();
    _syncGrantNotice();
  }

  // ── «Не торгуем»: переключатель «Только торгуемые / Все» (20.10.2026, setup_gates; решение владельца) ─────────────
  // Режим — __SETUPS_CFG__.gatedMode (settings.SETUPS_GATED_MODE): 'admin' — только админский вид, 'on' — все вошедшие
  // (роль до ответа /api/auth/status — из __SETUPS_CFG__.boot); сервер проверяет его сам.
  function _gatedAllowed() {
    // Модельный портфель показывает торгуемые сделки; старое «Все» здесь не действует.
    if (_portfolioTableView()) return false;
    var cfg = window.__SETUPS_CFG__ || {};
    var m = cfg.gatedMode || 'off';
    if (m === 'admin') return _adminView();
    if (m === 'on') return !!((_authState && !_authState.is_anon) || (cfg.boot && cfg.boot.authed));
    return false;
  }
  // Вид «Сетапы» (27.10.2026, решение владельца): правила витрины — только для портфеля, снятые ими сетапы сервер отдаёт
  // в «Сетапы» сам (как все) — переключателя там нет, параметр show_gated не шлём
  function _gatedOn() { return !!STATE.showGated && _gatedAllowed() && !_setupsView(); }
  function _syncGatedUI() {
    var w = document.getElementById('gated-toggle-wrap');
    if (w) w.style.display = (_gatedAllowed() && !_setupsView()) ? 'flex' : 'none';
    var tg = document.getElementById('gated-toggle');
    if (tg) tg.querySelectorAll('.units-btn').forEach(function (b) {
      b.classList.toggle('active', (b.getAttribute('data-gated') === '1') === !!STATE.showGated);
    });
  }
  (function () {
    var tg = document.getElementById('gated-toggle');
    if (!tg) return;
    tg.querySelectorAll('.units-btn').forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('data-gated') === '1';
        if (!!STATE.showGated === on) return;
        STATE.showGated = on;
        _syncGatedUI();
        savePrefs('setups.ui', extractUIForPrefs());
        onFilterChange();
      });
    });
  })();

  // ── «Правила сейчас» и окно «рынок против открытых сделок» (20.10.2026, market_now.py; решения владельца) ─────────
  // Строка «Сейчас» над списком: какие правила витрины в эту минуту не дают открыть сетап («IMOEX открылся +1,04 % →
  // лонги пока не торгуем»). Первый кадр рисует сервер, здесь — обновление раз в __SETUPS_CFG__.marketNow.poll с.
  // Окно справа внизу: вечером и утром до основной сессии IMOEX от закрытия основной ушёл на порог правила «Вечер против»
  // и больше, а у человека на счёте витрины есть открытые сделки против хода — их страница считает по своему счёту
  // (_openOnAccount). Один раз на ступень хода: «Понятно» помним в localStorage. Режимы 'off' / 'admin' / 'on' —
  // settings.SETUPS_RULES_NOW_MODE / SETUPS_EVENING_ALERT_MODE (сервер проверяет их сам).
  // без начальных значений: объявление ниже по файлу, чем вызовы из updateAuthUI / applyMode, — присваивание здесь
  // затёрло бы то, что они успели выставить при загрузке
  var _mnData, _mnTimer, _mnAuthReady;
  var _MN_SEEN_KEY = 'moex.mktAlertSeen';
  function _mnCfg() { return (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.marketNow) || {}; }
  function _mnAllowed(mode) {
    if (mode === 'admin') return _adminView();
    if (mode === 'on') return !!(_authState && !_authState.is_anon);
    return false;
  }
  /** Позиция строки открыта на счёте витрины сейчас: счёт её открыл (не пропуск, капитала хватило), сам не закрыл
   *  (встречным, переносом стопа) и у модели выхода её ещё нет. */
  function _openOnAccount(mi) {
    const n = mi && mi.net;
    if (!n || n.status !== 'opened' || _noCap(n) || n.exit_date) return false;
    return mi.realized_r == null && mi.r_outcome == null && !(mi.result && mi.result.net_pct != null);
  }
  function _mnOpenAgainst(side) {
    const d = _liveDataCache;
    let n = 0, rub = 0;
    ((d && d.table) || []).forEach(function (mi) {
      if (!_openOnAccount(mi)) return;
      const dir = String((mi.best && mi.best.final_direction) || (mi.trigger && mi.trigger.direction) || '').toUpperCase();
      if (dir !== side) return;
      n += 1;
      if (mi.rub && mi.rub.invested) rub += Number(mi.rub.invested) || 0;
    });
    return { n: n, rub: rub, known: !!d };
  }
  function _mnPct(x) {
    return (x >= 0 ? '+' : '−') + Math.abs(Number(x)).toFixed(2).replace('.', ',') + ' %';
  }
  function _mnHost(u) {
    try { return new URL(u).hostname.replace(/^www\./, ''); } catch (e) { return 'источник'; }
  }
  function _mnRenderRules() {
    var el = document.getElementById('rules-now');
    var pn = document.getElementById('mkt-panel');
    // Панель «Рынок сейчас» (20.10.2026): под графиком и та же разметка над списком (узкий экран, раскрытый вид) —
    // какой из двух блоков виден, решают стили по классу body.mkt-panel-on. Разметку присылает сервер
    // (market_now.panel_html / rules_block_html — тот же рендер, что у первого кадра).
    var panelOn = _mnAllowed(_mnCfg().panel);
    document.body.classList.toggle('mkt-panel-on', panelOn);
    var h = _mnData && (panelOn ? _mnData.panel_html : (_mnAllowed(_mnCfg().rules) ? _mnData.rules_html : null));
    // перерисовка — только если разметка сменилась: сравнение с прошлой строкой сервера, а не с innerHTML (браузер
    // отдаёт неразрывный пробел как &nbsp;, и сравнение с innerHTML перерисовывало блок на каждом опросе — подсказка
    // под курсором пропадала)
    if (pn) {
      var ph = (panelOn && h) ? h : '';
      if (pn._mnH !== ph) { pn.innerHTML = ph; pn._mnH = ph; }
    }
    if (!el) return;
    if (!h) { el.style.display = 'none'; return; }
    if (el._mnH !== h) { el.innerHTML = h; el._mnH = h; }
    el.style.display = 'block';
  }
  function _mnSeenKey(ev) { return [ev.day, ev.against, ev.level].join('|'); }
  function _mnRenderEvening() {
    var ev = _mnData && _mnData.evening;
    var box = document.getElementById('mkt-alert');
    var show = !!(ev && ev.active && _mnAllowed(_mnCfg().evening));
    var cnt = show ? _mnOpenAgainst(ev.against) : null;
    if (show && !cnt.n) show = false;
    if (show) {
      var seen = null;
      try { seen = localStorage.getItem(_MN_SEEN_KEY); } catch (e) {}
      if (seen === _mnSeenKey(ev)) show = false;
    }
    if (!show) { if (box) box.style.display = 'none'; return; }
    if (!box) {
      box = document.createElement('div');
      box.id = 'mkt-alert'; box.className = 'mkt-alert';
      box.setAttribute('role', 'status');
      document.body.appendChild(box);
    }
    var isShort = ev.against === 'SHORT';
    var noun = isShort ? _refPlural(cnt.n, 'шорт', 'шорта', 'шортов') : _refPlural(cnt.n, 'лонг', 'лонга', 'лонгов');
    var asof = String(ev.asof || '').slice(11, 16);
    var rub = (_adminView() && cnt.rub > 0) ? ' на ' + Math.round(cnt.rub).toLocaleString('ru-RU') + ' ₽' : '';
    var h = '<div class="mkt-alert-head">Рынок против ваших открытых сделок</div>'
      + '<div class="mkt-alert-body">IMOEX ' + _mnPct(ev.move) + ' с закрытия основной сессии'
      + (asof ? ' (к ' + asof + ')' : '') + '. Против этого движения у вас открыто ' + cnt.n + ' ' + noun + rub + '.</div>'
      + '<div class="mkt-alert-note" title="Оповещение, а не совет: на истории закрывать такие сделки по правилу было невыгодно">'
      + 'Новые ' + (isShort ? 'шорты' : 'лонги') + ' витрина сейчас не открывает (правило «Вечер против»). '
      + 'Что делать с открытыми — решаете вы.</div>';
    if (ev.reason && ev.reason.text) {
      var src = (ev.reason.sources || []).slice(0, 2).map(function (u) {
        return '<a href="' + _esc(u) + '" target="_blank" rel="noopener nofollow">' + _esc(_mnHost(u)) + '</a>';
      }).join(' · ');
      h += '<div class="mkt-alert-reason">Причина по новостям: ' + _esc(ev.reason.text) + (src ? ' ' + src : '') + '</div>';
    }
    h += '<button type="button" class="mkt-alert-ok">Понятно</button>';
    box.innerHTML = h;
    box.querySelector('.mkt-alert-ok').onclick = function () {
      try { localStorage.setItem(_MN_SEEN_KEY, _mnSeenKey(ev)); } catch (e) {}
      box.style.display = 'none';
    };
    box.style.display = 'block';
  }
  function _mnPoll() {
    if (document.hidden) return;
    if (!_mnAllowed(_mnCfg().rules) && !_mnAllowed(_mnCfg().evening) && !_mnAllowed(_mnCfg().panel)) {
      _mnData = null; _mnRenderRules(); _mnRenderEvening(); return;
    }
    var q = (_authState && _authState.is_admin && !_adminView()) ? '?view_as=user' : '';
    fetch('/api/setups/market-now' + q, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (!j) return; _mnData = j; _mnRenderRules(); _mnRenderEvening(); })
      .catch(function () {});
  }
  /** Роль или вид сменились: опрос — пока что-то из трёх (строка «Сейчас», окно, панель «Рынок сейчас») разрешено
   *  этому виду; иначе всё скрыто. */
  function _mnSync() {
    if (!_mnAuthReady) return;             // роль ещё не пришла: первый кадр строки «Сейчас» — от сервера, не прячем
    var on = _mnAllowed(_mnCfg().rules) || _mnAllowed(_mnCfg().evening) || _mnAllowed(_mnCfg().panel);
    if (!on) {
      if (_mnTimer) { clearInterval(_mnTimer); _mnTimer = null; }
      _mnData = null; _mnRenderRules(); _mnRenderEvening();
      return;
    }
    _mnPoll();
    if (!_mnTimer) _mnTimer = setInterval(_mnPoll, Math.max(15, Number(_mnCfg().poll) || 60) * 1000);
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden && _mnTimer) _mnPoll(); });
  // ── Кнопки «Лонги» / «Шорты» в строке панели «Рынок сейчас» (21.10.2026, side_switch) ─────────────────────────────
  // Команда, а не фильтр: с момента нажатия новые сделки стороны не открываются (у админа — бот и его счёт, у вошедшего —
  // свой счёт). Текст подтверждения присылает сервер (data-confirm), после ответа — свежая панель (_mnPoll); прошлое не
  // меняется, поэтому витрину не перезагружаем — новый ключ кэша она возьмёт со следующим запросом.
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest('.mkt-side') : null;
    if (!b || b.disabled) return;
    ev.preventDefault();
    var turnOn = b.getAttribute('data-on') !== '1';
    var msg = b.getAttribute('data-confirm') || '';
    if (msg && !window.confirm(msg)) return;
    b.disabled = true;
    var headers = { 'Content-Type': 'application/json' };
    if (_csrfToken) headers['X-CSRF-Token'] = _csrfToken;
    var body = { side: b.getAttribute('data-side'), on: turnOn };
    if (_authState && _authState.is_admin && !_adminView()) body.view_as = 'user';
    fetch('/api/setups/side-switch', { method: 'POST', credentials: 'same-origin', headers: headers,
                                       body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return null; }); })
      .then(function (j) {
        if (!j || !j.ok) window.alert('Не получилось переключить: ' + ((j && j.error) || 'ошибка сервера'));
        _mnPoll();
      })
      .catch(function () { window.alert('Не получилось переключить: нет связи с сервером'); })
      .then(function () { b.disabled = false; });
  });

  function nwLoadSettingsIntoForm() {
    nwBuildTriggerChecks();
    // Если кэш есть — применяем сразу. Параллельно подтягиваем актуальные.
    if (_nwSettings) nwApplySettingsToForm(_nwSettings);
    fetch('/api/notifications/settings').then(function(r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function(d) {
      _nwSettings = d;
      nwApplySettingsToForm(d);
    }).catch(function() {});
  }

  // Рендерит чекбоксы типов сетапов в wizard'е (один раз при открытии).
  // Источник — TRIGGER_TYPES_ACTIVE (тот же, что в сайдбаре): только АКТИВНЫЕ
  // сетапы. Не хардкодим — при активации нового сетапа (добавлении в
  // TRIGGER_TYPES_ACTIVE) он автоматически появится и здесь, и в сайдбаре.
  function nwBuildTriggerChecks() {
    const ctr = document.getElementById('nw-triggers');
    if (!ctr || ctr.dataset.built === '1') return;
    ctr.innerHTML = '';
    // Раскладка как в сайдбаре (23.08): столбец названий, слева свои
    // чекбоксы 1ч/4ч, подписи ТФ один раз в шапке. Источник типов —
    // TRIGGER_TYPES_ACTIVE (тот же, что в сайдбаре): новый сетап появится
    // здесь автоматически.
    const tfs = TIMEFRAMES_ALL.slice();
    const head = document.createElement('div');
    head.className = 'sb-tt-head nw-tt-head';
    head.innerHTML = tfs.map(function (tf) {
      return '<span class="sb-tt-h">' + (TF_LABEL[tf] || tf) + '</span>';
    }).join('') + '<span></span>';
    // Сетка — две колонки (.nw-checks-grid): шапка ТФ над КАЖДОЙ, иначе единственная шапка
    // занимала первую ячейку левой колонки, и правая начиналась строкой выше (26.09.2026).
    ctr.appendChild(head);
    ctr.appendChild(head.cloneNode(true));
    TRIGGER_TYPES_ACTIVE.forEach(function (tt) {
      // Связки, скрытые у пользователя, — не предлагаем НИКОМУ, админу тоже: в Telegram уходит только то, что видно
      // на пользовательской витрине (catalog_matcher.showcase_keys), эти сетапы не придут (04.10.2026).
      const visTfs = tfs.filter(function (tf) { return !USER_HIDDEN_PAIRS.has(tt + ':' + tf) && _pairExists(tt, tf); });
      if (!visTfs.length) return;
      const row = document.createElement('div');
      row.className = 'sb-tt-row nw-tt-row';
      const dbTt = _UI_TO_DB_TT_MAP[tt] || tt;
      const color = SETUP_NAME_COLOR[dbTt] || 'var(--text)';
      row.innerHTML = tfs.map(function (tf) {
        if (visTfs.indexOf(tf) < 0) return '<span class="sb-tf-cell"></span>';
        return '<span class="sb-tf-cell">'
             + '<input type="checkbox" data-tt="' + tt + '" data-tf="' + tf + '"'
             + ' title="' + (TF_LABEL[tf] || tf) + '"/></span>';
      }).join('')
      + '<span class="sb-tt-name" style="color:' + color + '">'
      + (TRIGGER_RU[tt] || tt) + '</span>';
      ctr.appendChild(row);
    });
    ctr.dataset.built = '1';
  }

  function nwUpdateToggleLabel() {
    // Подпись не зависит от состояния (вкл/выкл показывает сам переключатель) — только от
    // того, есть ли второй источник рассылки.
    _nwSyncSources();
  }

  // Источники рассылки (26.09.2026, решение владельца): «Системные сетапы» имеют смысл, только
  // когда есть второй источник — пресеты из лаборатории. Без пресетов тот же переключатель
  // (bot_trigger_settings.enabled) остаётся единственным способом включить и выключить рассылку —
  // в боте выключателя нет, — поэтому он не прячется, а подписан как общий выключатель.
  function _nwSyncSources() {
    var hasPresets = (STATE._presets || []).length > 0;
    var lbl = document.getElementById('nw-enabled-label');
    if (lbl) lbl.textContent = hasPresets ? 'Системные сетапы' : 'Присылать сетапы в Telegram';
    var what = document.getElementById('nw-what-title');
    if (what) what.style.display = hasPresets ? '' : 'none';
    var ft = document.getElementById('nw-filters-title');
    if (ft) ft.textContent = hasPresets ? 'Фильтры системных сетапов' : 'Фильтры сетапов';
    var row = document.getElementById('nw-presets-row');
    if (row) row.style.display = hasPresets ? '' : 'none';
  }

  function nwApplySettingsToForm(d) {
    document.getElementById('nw-enabled').checked = !!d.enabled;
    nwUpdateToggleLabel();
    // Мин. оборот — шкала витрины (TURNOVER_VALUES, от 10 млн, 26.09.2026): ползунок хранит
    // индекс ступени. Сохранённое ниже пола (старые 2 млн по умолчанию) встаёт на первую
    // ступень — рассылка и так идёт только по сетапам витрины, а у неё тот же пол.
    var t = Math.max(parseInt(d.min_turnover) || 0, TURNOVER_VALUES[0]);
    var range = document.getElementById('nw-turnover');
    range.value = turnoverToIndex(t);
    document.getElementById('nw-turnover-label').textContent =
      _nwFmtRub(TURNOVER_VALUES[parseInt(range.value)]);
    // trigger_types — массив (или пусто = все)
    var tts = Array.isArray(d.trigger_types) ? d.trigger_types : [];
    document.querySelectorAll('#nw-triggers input[type=checkbox]').forEach(function(cb) {
      var _t = cb.dataset.tt, _f = cb.dataset.tf;
      // новый формат «ТИП:тф»; старый «ТИП» = все ТФ (настройки до 23.08)
      cb.checked = tts.indexOf(_t + ':' + _f) >= 0 || tts.indexOf(_t) >= 0;
    });
    // Отмеченные связки, скрытые у пользователя (чекбоксов нет), сохраняем как были — nwExtractFormToSettings.
    _nwKeptHidden = [];
    USER_HIDDEN_PAIRS.forEach(function (p) {
      if (tts.indexOf(p) >= 0 || tts.indexOf(p.split(':')[0]) >= 0) _nwKeptHidden.push(p);
    });
    // direction (LONG/SHORT checkboxes mirror sidebar logic: оба unchecked = all)
    var dir = d.direction || 'all';
    document.getElementById('nw-long').checked  = (dir === 'long');
    document.getElementById('nw-short').checked = (dir === 'short');
    var nwFav = document.getElementById('nw-favorites');
    if (nwFav) nwFav.checked = !!d.favorites_only;
    var nwBlue = document.getElementById('nw-blue');
    if (nwBlue) nwBlue.checked = !!d.blue_chips_only;
    // Источник «Мои пресеты» (фаза 2): чекбокс = presets_enabled (default TRUE);
    // строка видна только если у юзера есть пресеты (_nwSyncSources).
    var nwPre = document.getElementById('nw-presets');
    if (nwPre) nwPre.checked = (d.presets_enabled !== false);
    _nwSyncSources();
    // «Сила фундамента» убрана из попапа (2026-06-05) — fa_strength не
    // восстанавливаем/не редактируем (на сохранении уходит пустым = без фильтра).
    // Bot status hint
    var hint = document.getElementById('nw-bot-status');
    if (hint) {
      if (d.exists && d.enabled && !d.linked) {
        hint.style.display = 'flex';
        hint.querySelector('.nw-bot-text').innerHTML =
          'Чтобы начать получать сетапы, откройте бота и нажмите /start: '
          + '<a href="https://t.me/MOEXanalystBot?start=auth" target="_blank">@MOEXanalystBot →</a>';
      } else {
        hint.style.display = 'none';
      }
    }
  }

  var _nwKeptHidden = [];   // отмеченные связки, скрытые у пользователя (их чекбоксов в окне нет)

  /** Извлекает текущее состояние form'ы → объект для PUT. */
  function nwExtractFormToSettings() {
    var _on = Array.from(document.querySelectorAll('#nw-triggers input[type=checkbox]:checked'));
    var tts = _on.map(function (cb) {
      // «ТИП:тф» — у каждого сетапа свои чекбоксы 1ч/4ч (как в сайдбаре).
      // Старый формат (просто «ТИП») остаётся валидным = все ТФ.
      return cb.dataset.tf ? cb.dataset.tt + ':' + cb.dataset.tf : cb.dataset.tt;
    });
    _nwKeptHidden.forEach(function (p) { if (tts.indexOf(p) < 0) tts.push(p); });
    var long  = document.getElementById('nw-long').checked;
    var short = document.getElementById('nw-short').checked;
    var direction = 'all';
    if (long && !short) direction = 'long';
    else if (short && !long) direction = 'short';
    return {
      enabled:  document.getElementById('nw-enabled').checked,
      min_turnover: TURNOVER_VALUES[parseInt(document.getElementById('nw-turnover').value)] || TURNOVER_VALUES[0],
      direction: direction,
      timeframe: 'all',  // в сайдбаре нет; bot UI продолжает использовать как было
      variant_type: 'all',         // sym/asym из v7 UI убраны
      exclude_borderline: false,   // borderline из v7 UI убрано
      fa_strength: '',   // «Сила фундамента» убрана из попапа (2026-06-05) → без фильтра
      favorites_only: document.getElementById('nw-favorites').checked,
      blue_chips_only: (function(){ var e = document.getElementById('nw-blue'); return e ? e.checked : false; })(),
      presets_enabled: (function(){ var e = document.getElementById('nw-presets'); return e ? e.checked : true; })(),
      trigger_types: tts,
    };
  }

  function _nwFmtRub(n) {
    if (n >= 1e9) return (n/1e9).toFixed(1).replace('.0','') + ' млрд ₽';
    if (n >= 1e6) return (n/1e6).toFixed(1).replace('.0','') + ' млн ₽';
    if (n >= 1e3) return (n/1e3).toFixed(0) + ' тыс ₽';
    return n + ' ₽';
  }

  // Слайдер — шкала витрины (индексы TURNOVER_VALUES) + live label
  document.addEventListener('DOMContentLoaded', function() {
    var range = document.getElementById('nw-turnover');
    if (range) {
      range.min = '0';
      range.max = String(TURNOVER_MAX_IDX);
      range.step = '1';
      range.value = '0';
      document.getElementById('nw-turnover-label').textContent = _nwFmtRub(TURNOVER_VALUES[0]);
      range.addEventListener('input', function() {
        document.getElementById('nw-turnover-label').textContent =
          _nwFmtRub(TURNOVER_VALUES[parseInt(range.value)]);
      });
    }
  });

  function nwSaveSettings() {
    if (_nwLoading) return;
    var btn = document.getElementById('nw-save-btn');
    var msg = document.getElementById('nw-msg');
    var payload = nwExtractFormToSettings();

    _nwLoading = true;
    if (btn) { btn.disabled = true; btn.textContent = 'Сохранение…'; }
    if (msg) { msg.textContent = ''; msg.style.color = ''; }

    var headers = { 'Content-Type': 'application/json' };
    if (_csrfToken) headers['X-CSRF-Token'] = _csrfToken;
    fetch('/api/notifications/settings', {
      method: 'PUT', headers: headers, body: JSON.stringify(payload)
    }).then(function(r) {
      return r.json().then(function(j) { return { ok: r.ok, body: j }; });
    }).then(function(res) {
      _nwLoading = false;
      if (btn) { btn.disabled = false; btn.textContent = 'Сохранить'; }
      if (res.ok) {
        if (msg) { msg.textContent = '✓ Сохранено'; msg.style.color = 'var(--green)'; }
        // Обновляем CTA state и закрываем через 600ms
        refreshNotifCtaState();
        setTimeout(closeNotifWizard, 700);
      } else if (res.body && res.body.error === 'bot_not_linked') {
        // Не ошибка пользователя, а недостающий шаг: Telegram ещё не привязан к
        // аккаунту, а фильтры хранятся по telegram_id. Ведём на привязку вместо
        // технического кода. Сюда попадаем только гонкой — openNotifWizard
        // обычно ловит это раньше и сразу открывает Step D.
        if (msg) { msg.textContent = ''; msg.style.color = ''; }
        if (_botInfo()) nwOpenConnectStep('notif'); else nwOpenSuccessStep();
      } else {
        if (msg) {
          msg.textContent = 'Ошибка: ' + (res.body.error || 'не удалось сохранить');
          msg.style.color = 'var(--red)';
        }
      }
    }).catch(function() {
      _nwLoading = false;
      if (btn) { btn.disabled = false; btn.textContent = 'Сохранить'; }
      if (msg) { msg.textContent = 'Ошибка сети'; msg.style.color = 'var(--red)'; }
    });
  }

  // showAuthPopup(opts?) — opts.title задаёт заголовок под конкретное действие
  // (сетапы / избранное / фундамент). Премиум-подстрока (opts.text) по умолчанию
  // «...Premium на N дней бесплатно» — единая для всех anon-CTA. Число дней
  // server-side из auth_limits.TRIAL_DAYS (плейсхолдер TRIAL_PHRASE).
  function showAuthPopup(opts) {
    opts = opts || {};
    var _t = document.getElementById('auth-popup-title');
    var _x = document.getElementById('auth-popup-text');
    if (_t) _t.textContent = opts.title || 'Войти в MOEX Analyst';
    if (_x) _x.innerHTML = (opts.text != null) ? opts.text
                            : 'и получите <b>Premium на ' + __CFG_TRIAL + ' бесплатно</b>';
    var w = document.getElementById('auth-popup-tg');
    if (!_authPopupBuilt && w) {
      _authPopupBuilt = true;
      // Вход = редирект на Яндекс ID; страница вернётся уже авторизованной,
      // поэтому onSuccess-колбэк не нужен.
      var _go = function() { window.AuthBox.mount(w, {}); };
      if (window.AuthBox) { _go(); }
      else { var s = document.createElement('script'); s.src = '/static/js/auth-box.js?v=2'; s.onload = _go; document.head.appendChild(s); }
    }
    document.getElementById('auth-popup-overlay').classList.add('open');
  }

  function closeAuthPopup() {
    document.getElementById('auth-popup-overlay').classList.remove('open');
    var msg = document.getElementById('auth-popup-msg');
    if (msg) msg.textContent = '';
  }

  function doLogout(_retried) {
    var headers = { 'Content-Type': 'application/json' };
    if (_csrfToken) headers['X-CSRF-Token'] = _csrfToken;
    fetch('/api/auth/logout', { method: 'POST', headers: headers, body: '{}' })
      .then(function(r) {
        // 403 = токен разъехался с сессией. Один раз молча обновляем и повторяем,
        // иначе кнопка «Выйти» просто ничего не делает (так и было до фикса).
        if (r.status === 403 && !_retried) {
          return fetchCsrfToken().then(function() { doLogout(true); return null; });
        }
        return r.json();
      })
      .then(function(d) {
        if (!d) return;                       // ушли в повтор
        if (d.ok) {
          refreshAuthState();
          fetchCsrfToken();                   // токен сбрасывается вместе с сессией
          fetchAndRender();
        } else {
          alert('Не удалось выйти. Обновите страницу и попробуйте ещё раз.');
        }
      })
      .catch(function() {
        alert('Не удалось выйти: нет связи с сервером.');
      });
  }

  // Esc — закрыть auth-popup (existing keydown listener выше отвечает только за expand mode)
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var ov = document.getElementById('auth-popup-overlay');
      if (ov && ov.classList.contains('open')) {
        closeAuthPopup();
      }
    }
  });

  // ── Init ─────────────────────────────────────────
  // Роль и сохранённые на сервере настройки вошедшего — из разметки страницы (web_app._setups_boot, 02.10.2026):
  // раньше админский вид и настройки с сервера включались только после ответов /api/auth/status и /api/prefs —
  // у админа каждый визит шёл двумя-тремя запросами данных и двойной отрисовкой, у вошедшего на новом устройстве
  // сначала качалась и рисовалась витрина по умолчанию. is_anon до /api/auth/status не трогаем: по нему savePrefs
  // решает, писать ли настройки на сервер.
  var _boot = (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.boot) || {};
  if (_boot.is_admin) _authState.is_admin = true;
  if (_boot.prefs) Object.keys(_boot.prefs).forEach(function (ns) {
    if (_boot.prefs[ns] && typeof _boot.prefs[ns] === 'object') _localSetPrefs(ns, _boot.prefs[ns]);
  });
  buildTriggerFilters();
  _initPanelHeader();  // shared chart-header (ChartHeader.build)
  _initMobileChartHeader();  // mobile: TF 1H + одна кнопка-дропдаун + слои скрыты
  _initMobileRangeDropdown();  // mobile: окно (Последние 14 дней / История) → одна кнопка + поиск
  // Восстанавливаем сохранённые prefs из localStorage (мгновенно, без сервера)
  // Набор для анонима (anon_preset.py, решение владельца 19.09.2026): сервер подставляет его только
  // анониму (в режиме обкатки — только с ?anon_preset=1) — голубые фишки (и префы), связки «детектор × ТФ»,
  // размер сделки и депозит недельного снимка. Это значения ПО УМОЛЧАНИЮ: сохранённое в браузере
  // (человек сам менял фильтры или вид) важнее.
  // Вкладка из адреса (15.10.2026): /setups?view=weeks — сразу «История недель» (кнопка «Смотреть сделки» на
  // главной /about: рядом её снимок). Volatile — в настройки не пишется; первый ответ о входе (refreshAuthState)
  // её не сбрасывает — флаг снимается после него.
  var _viewFromUrl = (function () {
    try { return new URLSearchParams(location.search).get('view') === 'weeks' ? 'weeks' : null; }
    catch (e) { return null; }
  })();
  var _startFilters = FILTERS_DEFAULT, _startUI = UI_DEFAULT;
  var _anonPreset = (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.anonPreset) || null;
  if (_anonPreset && Array.isArray(_anonPreset.type_tf) && _anonPreset.type_tf.length) {
    var _apPairs = _anonPreset.type_tf.slice();
    _startFilters = Object.assign({}, FILTERS_DEFAULT, {
      trigger_types: Array.from(new Set(_apPairs.map(function(p) { return p.split(':')[0]; }))),
      timeframes: Array.from(new Set(_apPairs.map(function(p) { return p.split(':')[1]; }))),
      type_tf: _apPairs,
      blue_chips_only: true,
      blue_chips_prefs: !!_anonPreset.blue_chips_prefs,   // «Префы» в наборе (anon_preset, 15.10.2026)
    });
    _startUI = Object.assign({}, UI_DEFAULT, { posSize: _anonPreset.pos_size },
                             _anonPreset.deposit ? { rubDeposit: _anonPreset.deposit, depoAuto: false } : {});
  }
  applyFilters(loadPrefsLocal('setups.filters', _startFilters));
  applyUI(loadPrefsLocal('setups.ui', _startUI));
  // Админ: ₽-окно — до первого запроса, как его включает refreshAuthState (там вызов станет no-op).
  if (_authState.is_admin && !STATE.deals) _setRubWindow(true);
  // Мгновенный первый рендер из кэша прошлого визита: вместо пустых «загрузка…»
  // сразу данные (той же роли и настроек — кэш пер-браузер), свежие приедут
  // штатным fetchAndRender ниже. Чекбоксы уже восстановлены applyFilters —
  // клиентские фильтры (visibleItems/_filterByUi) применяются корректно.
  // Кэш прошлого визита рисует fetchAndRender — там известна подпись настроек,
  // и мы не покажем числа, снятые при другом депозите/размере позиции.
  // Переключатель вида Admin / User — bind click после applyUI (active state уже выставлен).
  // Persistence — savePrefs пишет в localStorage + PUT /api/prefs/setups.ui для logged-in.
  // Переключатель единиц «₽ / %» (22.09.2026, admin): меняет ленту на сервере,
  // поэтому setUnits перезапрашивает данные текущей вкладки.
  document.querySelectorAll('#units-toggle .units-btn:not([data-units="test"])').forEach(function (btn) {
    btn.addEventListener('click', function () { setUnits(this.getAttribute('data-units')); });
  });
  // Переключатель «Акции / Фьючи» (11.10.2026, admin). Галочки «Фьючи-ликвид» / «Фьючи-неликв» — в сайдбаре, обычные
  // фильтры (onFilterChange): сохраняются в наборе «Фьючей» и меняют подпись запроса данных.
  document.querySelectorAll('#fut-toggle .units-btn').forEach(function (btn) {
    btn.addEventListener('click', function () { setFut(this.getAttribute('data-fut') === '1'); });
  });
  document.querySelectorAll('.mode-toggle .mode-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var newMode = this.getAttribute('data-mode');
      // «Admin» соответствует двум внутренним режимам (admin/rubles): no-op только
      // если уже в своём, иначе возврат из User идёт в админский ₽-дефолт.
      if (newMode === STATE.mode) return;
      if (newMode === 'user') {
        if (STATE.weekly) {          // остаёмся в «Истории недель», меняем только вид
          applyMode('user');
          _setRangeActive();
          savePrefs('setups.ui', extractUIForPrefs());
          fetchWeekly();
          if (_panelTicker) loadChartInPanel(_panelTicker, _panelTf);
          return;
        }
        _exitWeekly();
        applyMode('user');
        _setRangeActive();
        savePrefs('setups.ui', extractUIForPrefs());
        fetchAndRender();                                           // выдача другая (view_as=user)
        if (_panelTicker) loadChartInPanel(_panelTicker, _panelTf); // и exit-маркеры на графике
        return;
      }
      if (newMode === 'admin') {
        if (STATE.mode === 'rubles') return;      // уже в админском виде
        // В «Истории недель» таблица строится по ВИДУ (у пользователя — проценты,
        // у админа — рубли + процент от депозита), поэтому её надо перезапросить:
        // иначе после возврата в Admin остаётся пользовательская разметка.
        if (STATE.weekly) {
          applyMode('rubles');
          _setRangeActive();
          fetchWeekly();
          if (_panelTicker) loadChartInPanel(_panelTicker, _panelTf);
          return;
        }
        _setRubWindow();         // вернуться в админский ₽-дефолт
        if (_panelTicker) loadChartInPanel(_panelTicker, _panelTf);
        return;
      }
    });
  });
  if (_viewFromUrl === 'weeks') setRangeWeekly(); else fetchAndRender();
  fetchCsrfToken();
  // refreshAuthState() — после возврата подтянет prefs с сервера для logged-in
  // через syncPrefsFromServer() и при расхождении применит applyFilters/applyUI + re-render.
  refreshAuthState();
  // wizard_resume=success — пользователь вернулся через Success URL после оплаты.
  // Ждём refreshAuthState внутри (он async), чтобы _authState уже был обновлён.
  nwCheckResumeSuccess();
  // Авторефреш — условный запрос с токеном версии ленты (B1, 09.09). Вкладке без задержки — раз в poll.fast
  // (settings.SETUPS_POLL_SEC, 27.09.2026): сервер пересчитывает ленту сразу после записи сетапа в журнал, и новый
  // сетап появляется за секунды, а не через минуту опроса. Раз в poll.slow (как было до 27.09) — анониму и
  // бесплатному (сетапы с задержкой 12 ч: частый опрос им ничего не даёт), фоновой вкладке и поиску по тикеру (там
  // полный рефетч двумя запросами без токена — втрое чаще качать его незачем).
  var _POLL = (window.__SETUPS_CFG__ && window.__SETUPS_CFG__.poll) || {};
  var _POLL_FAST_MS = (Number(_POLL.fast) || 60) * 1000;
  var _POLL_SLOW_MS = Math.max(_POLL_FAST_MS, (Number(_POLL.slow) || 60) * 1000);
  var _lastAutoPoll = Date.now();
  function _autoPollMs() {
    var d = STATE.data;
    if (!d || d.is_anon || d.free_tier || d.delayed || document.hidden) return _POLL_SLOW_MS;
    return (currentFilters() || {}).ticker ? _POLL_SLOW_MS : _POLL_FAST_MS;
  }
  setInterval(function(){
    // запас в секунду на неточность таймера: иначе медленный опрос уходил бы на такт позже (80 с вместо 60)
    if (Date.now() - _lastAutoPoll < _autoPollMs() - 1000) return;
    _lastAutoPoll = Date.now();
    fetchAndRender(true);                // true = авто (бэктест не трогаем)
  }, _POLL_FAST_MS);

  // Heart/Bell-chip — индикатор изменений скоров (тот же что на /fa).
  function _updateHeartChipSetups(){
    var el = document.getElementById('tb-changes');
    if(!el) return;
    fetch('/api/favorites/badge').then(function(r){return r.json();}).then(function(d){
      if(!d) return;
      var favCount = d.favorites_count || 0;
      var favCh    = d.favorites_changes || 0;
      var totalCh  = d.total_changes || 0;
      var has = favCount > 0;
      el.classList.toggle('has-favs', has);
      el.classList.toggle('empty', !has && totalCh === 0);
      el.classList.toggle('has-events', has || totalCh > 0);
      el.setAttribute('href', has ? '/watchlist?fav=1' : '/changes');
      var heartIco = '<svg width="13" height="12" viewBox="0 0 24 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 21s-7.5-4.5-9.5-9.5C1.2 7.6 4 4 7.5 4c2.1 0 3.5 1.3 4.5 2.6C13 5.3 14.4 4 16.5 4 20 4 22.8 7.6 21.5 11.5 19.5 16.5 12 21 12 21z"/></svg>';
      var bellIco = '<svg width="11" height="13" viewBox="0 0 12 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 0a1 1 0 0 1 1 1v.6c2.3.46 4 2.5 4 4.9V9l1 1.5v.5H0v-.5L1 9V6.5c0-2.4 1.7-4.44 4-4.9V1a1 1 0 0 1 1-1zm0 14c-.9 0-1.6-.7-1.6-1.5h3.2c0 .8-.7 1.5-1.6 1.5z"/></svg>';
      var cntHtml = has
        ? '<b>' + favCh + '</b><span class="tb-chg-sep">/</span><span class="tb-chg-total">' + totalCh + '</span>'
        : '<span class="tb-chg-count">' + totalCh + '</span>';
      el.innerHTML = (has ? heartIco : bellIco) + cntHtml;
    }).catch(function(){});
  }
  _updateHeartChipSetups();
  setInterval(_updateHeartChipSetups, 60_000);

  // ── Избранное (сквозное с /fa, см. static/js/favorites.js) ──
  // Тот же data-слой (localStorage 'fa.favorites' / /api/favorites/*), что и на
  // /fa → сердечко, поставленное там, видно здесь и наоборот.
  function _onFavChange(changedTicker) {
    // refreshHearts уже вызван внутри модуля. Здесь — обновить heart-chip в
    // топбаре + перезапросить выдачу, если активен фильтр «Только избранные»
    // (его выборка зависит от текущего набора избранных).
    if (typeof _updateHeartChipSetups === 'function') _updateHeartChipSetups();
    var favCb = document.getElementById('f-favorites');
    if (favCb && favCb.checked) fetchAndRender();
  }
  if (window.Favorites) {
    // Старт с anon (localStorage) — мгновенные сердечки; refreshAuthState ниже
    // переключит на серверный источник, когда узнает что юзер авторизован.
    // csrfToken — геттер (токен тянется async через fetchCsrfToken); нужен для
    // POST /api/favorites/toggle|sync (csrf_check в web_app.py отдаёт 403 без него).
    Favorites.init({
      isAnon: true,
      onChange: _onFavChange,
      csrfToken: function () { return _csrfToken; },
      // Anon-гейт: на /setups избранное требует регистрации (в отличие от /fa,
      // где анон копит локально). Клик по сердечку анонимом → попап регистрации.
      onAnonClick: function () {
        showAuthPopup({title: 'Зарегистрируйтесь, чтобы добавить в watchlist'});
      },
    });
  }

  // --cards-h: высота sticky-ряда TOP-карточек → sticky-шапки списка/таблицы садятся
  // ниже карточек (top: topbar + --cards-h). Обновляется при ре-рендере/смене режима/
  // ресайзе. На mobile карточки не sticky (свой layout) — шапки там на 33vh (не --cards-h).
  (function _initStickyCardsHeight() {
    var wrap = document.querySelector('.tc-row-wrap');
    if (!wrap) return;
    // Переменную пишем на колонку (.main), а не на корень документа, и только когда
    // высота изменилась: CPU-профиль 09.09 показал 0,6 с на десктопе и 3,2 с на
    // слабом телефоне в этой функции — forced layout из стартового скрипта плюс
    // пересчёт стилей всей страницы после записи на :root при каждом ре-рендере
    // карточек. Все потребители var(--cards-h) (sticky-шапки списка и таблицы,
    // .preset-info) лежат внутри .main. Первый замер — после первой раскладки
    // (ResizeObserver / rAF), не внутри стартового скрипта.
    var host = wrap.closest('.main') || document.documentElement;
    var last = null;
    function sync() {
      var h = wrap.offsetHeight || 0;
      if (h === last) return;
      last = h;
      host.style.setProperty('--cards-h', h + 'px');
    }
    if (typeof ResizeObserver !== 'undefined') { try { new ResizeObserver(sync).observe(wrap); } catch (e) {} }
    window.addEventListener('resize', sync);
    if (window.requestAnimationFrame) requestAnimationFrame(sync); else sync();
  })();
